var progress_loader_steps = 0;
var progress_loader_curr_step = 0;
var search_invoice_init_cont=0;
var search_invoice_init_archivated_cont=0;

var inv_manual_id_rematch = 0;
var order_manual_id_rematch = 0;
var mult_match_manual_id_rematch = 0;
var filter__array_to_keep = {};
var filter__array_to_keep_no_match = {};
var reset_filters_grid = true;

var update_progress_loader = function (message, steps) {
    var container = $('#progressloader');

    progress_loader_curr_step++;
    width = (progress_loader_curr_step / progress_loader_steps) * 100;
    container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
    if (steps === true) {
        message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
    }
    container.find('span').html(message + '...');
    if(progress_loader_steps <= progress_loader_curr_step)
        close_progress_loader();
};

var init_progress_loader = function (steps, message) {
    progress_loader_steps = steps;
    progress_loader_curr_step = 0;

    update_progress_loader(message);

    $('#progressloader').show();
};

var close_progress_loader = function () {
    progress_loader_steps = 0;
    progress_loader_curr_step = 0;
    $('#progressloader').hide();
};

if ($('#app-invoices').length) {
    var editing_row=false;
    var show_archived=false;
    var multiple_match=false;
    var invoice_manual_multiple_match=false;
    var manual_invoices_selected_global=[];
    var saved_one_at_least=false;
    var manual_grid_ready=false;

    var deletedItems = [];
    var invoice_to_copy= '';
    var buyLinesColSettings = [];
    var last_cell='';
    var last_simbol='';
    var invoice_maul_select_all;
    var array_invoice_no_match_id= {};
    var array_manual_invoice_no_match_id=[];

    var editing_row_imported_invo=false;
    var array_inv_imported_edited=[];
    var array_imp_all_cell_edited={};
    var reseting_grid= false;
    var data_zone_inv= false;

    var saved_data_global = false;

        form_validator('#app-new-invoice',
        {
            invoice_number: {
                required: true,
            },
            broadcast_month: {
                required: true,
            },
            invoice_date: {
                required: true,
                date: true
            },
            flight_days: {
                required: true,
            },
            /*account_executive: {
                required: true,
            },*/
            advertiser_new: {
                required: true,
            },
            /*product_new: {
                required: true,
            },*/
            station_new: {
                required: true,
            },
            due_by: {
                required: true,
            },
            media_type_new: {
                required: true,
            },

        },
       {}

    );
    var cont=1;
    var html_initial= '';
    var test=false;
    
    var cc=0;
    $(document).ready(function () {
        $('.dropdown-submenu > a').submenupicker();
       // get_from_field_new_invoice();
        init_search_buttons_both_tables();

        // $('.search_invoice_arrow_change').on('click', function(){
        //     if(search_invoice_init_cont === 0){
        //         init_invoice_search_fields();
        //         search_invoice_init_cont ++;
        //     }
        // });
        // $('#panel_click_invo_search').on('click', function(){
        //     if(search_invoice_init_archivated_cont === 0){
        //         init_invoice_search_arch_fields();
        //         search_invoice_init_archivated_cont ++;
        //     }
        // });

        //  $('#search_invoices').submit();
        //$('.send_form_archi').click();

        var d = new Date();

        var month = d.getMonth()+1;
        var day = d.getDate();


        var output = (month<10 ? '0' : '') + month + '/' +  (day<10 ? '0' : '') + day + '/' + d.getFullYear();

        var output_month= moment(output).add(1, 'M').format('L');

        var output_week= moment(output).add(5, 'days').format('L');

        var ouput_moth=(month<10 ? '0' : '') + month + '/' + d.getFullYear() ;


        $('#invoice_date').val(output);

        $('#due_by').val(output);
        $('#flight_days').val(output + ' - '+ output_month);
        $('#broadcast_month').val(ouput_moth);
        $('#line_flight_days').val(output + ' - '+ output_week);

        $('#nestable-menu').on('click', function(e)
        {
            var target = $(e.target),
                action = target.data('action');
            if (action === 'expand-all') {
                $('.dd').nestable('expandAll');
            }
            if (action === 'collapse-all') {
                $('.dd').nestable('collapseAll');
            }
            if (action === 'insert-line') {
                $('#newblinemodal').modal('show');
            }

            if (action === 're-match') {
                if (action === 're-match') {
                    var conf = confirm("Do you want to reset all matches?");
                    if(conf){
                        $("#espots").html("0");
                        $("#saveMachtModal").modal("hide");
                       if( $("#match-invoice-order").css('display') !='none' )
                           $("#match-invoice-order").click();
                       else
                           $("#match-invoice-order-multiple").click();
                    }
                }
            }
        });

        $("#re-match").on('click', function(){
            reset_filters_grid = false;
            if(editing_row_imported_invo== true) {
                swal({
                        title: "Warning",
                        text: "You have edited the invoice. Do you want to save the changes?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            init_progress_loader(2 , "This operation could take a few seconds. Please wait ...");
                            var params = {
                                datas: array_inv_imported_edited,
                                lines: [],
                            };
                              params.lines=array_imp_all_cell_edited;
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/invoices/save/imported_invoice/changes',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    editing_row_imported_invo=false;
                                    array_inv_imported_edited=[];
                                    array_imp_all_cell_edited={};

                                    $("#editMatchRules").modal("hide");
                                    $("#saveMachtModal").modal("hide");
                                    if( $("#match-invoice-order").css('display') !='none' )
                                        $("#match-invoice-order").click();
                                    else
                                        $("#match-invoice-order-multiple").click();
                                    saved_data_global = false;
                                  //
                                },
                                error: function (xhr) {
                                    close_progress_loader();
                                    debug(xhr.responseText);
                                }
                            });

                        }
                        else{
                            editing_row_imported_invo=false;
                            array_inv_imported_edited=[];
                            array_imp_all_cell_edited={};
                            $("#editMatchRules").modal("hide");
                            $("#saveMachtModal").modal("hide");
                            if ($("#match-invoice-order").css('display') != 'none')
                                $("#match-invoice-order").click();
                            else
                                $("#match-invoice-order-multiple").click();
                            saved_data_global = false;

                        }
                    });
            }
            else{
                swal({
                        title: "Warning",
                        text: "Do you want to reset all matches?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            if(manual_grid_ready== true) {
                                $("#editMatchRules").modal("hide");
                                $("#saveMachtModal").modal("hide");
                                searchManaualInvOrder(inv_manual_id_rematch,order_manual_id_rematch, mult_match_manual_id_rematch, $('#row_id_to_change').val())  ;
                            }
                            else{
                                $('#loading_match_2').css('display', 'inline');
                                show_overlay_loader( $('#saveMachtModal .modal-content'));
                                $('#invoice-verif').click();
                                $("#editMatchRules").modal("hide");
                              //  $("#saveMachtModal").modal("hide");
                                $('#loading_match_2').css('display', 'none');
                                if ($("#match-invoice-order").css('display') != 'none')
                                    $("#match-invoice-order").click();
                                else
                                    $("#match-invoice-order-multiple").click();
                                hide_overlay_loader( $('#saveMachtModal .modal-content'));

                            }
                            saved_data_global = false;
                        }
                    });

            }
        });

        $("#rematch").on('click', function(){
            /*var conf = confirm("Do you want to reset all matches?");
            if(conf){
                $("#editMatchRules").modal("hide");
                $("#saveMachtModal").modal("hide");
                if( $("#match-invoice-order").css('display') !='none' )
                    $("#match-invoice-order").click();
                else
                    $("#match-invoice-order-multiple").click();
            }*/
            if(editing_row_imported_invo== true) {
                swal({
                        title: "Warning",
                        text: "You have edited the invoice. Do you want to save the changes?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_overlay_loader( $('#editMatchRules .modal-content'));
                            var params = {
                                datas: array_inv_imported_edited,
                                lines: [],
                            };
                           params.lines=array_imp_all_cell_edited;
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/invoices/save/imported_invoice/changes',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    editing_row_imported_invo=false;
                                    array_inv_imported_edited=[];
                                    array_imp_all_cell_edited={};


                                    $("#editMatchRules").modal("hide");
                                    $("#saveMachtModal").modal("hide");
                                    if( $("#match-invoice-order").css('display') !='none' )
                                        $("#match-invoice-order").click();
                                    else
                                        $("#match-invoice-order-multiple").click();
                                    saved_data_global = false;
                                    hide_overlay_loader( $('#editMatchRules .modal-content'));
                                },
                                error: function (xhr) {
                                    hide_overlay_loader( $('#editMatchRules .modal-content'));
                                    debug(xhr.responseText);
                                }
                            });

                        }
                        else{
                            editing_row_imported_invo=false;
                            array_inv_imported_edited=[];
                            array_imp_all_cell_edited={};
                            $("#editMatchRules").modal("hide");
                            $("#saveMachtModal").modal("hide");
                            if( $("#match-invoice-order").css('display') !='none' )
                                $("#match-invoice-order").click();
                            else
                                $("#match-invoice-order-multiple").click();
                            saved_data_global = false;
                        }
                    });
            }
            else{
                swal({
                        title: "Warning",
                        text: "Do you want to reset all matches?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            if(manual_grid_ready === true) {
                                $("#editMatchRules").modal("hide");
                                $("#saveMachtModal").modal("hide");
                                // if ($("#match-invoice-order").css('display') != 'none')
                                //     $("#match-invoice-order").click();
                                // else
                                //     $("#match-invoice-order-multiple").click();
                                console.log('searchManaualInvOrder **', inv_manual_id_rematch, order_manual_id_rematch, mult_match_manual_id_rematch)
                                searchManaualInvOrder(inv_manual_id_rematch,order_manual_id_rematch, mult_match_manual_id_rematch, $('#row_id_to_change').val())  ;
                            }
                            else{
                                $('#loading_match_2').css('display', 'inline');
                                show_overlay_loader( $('#saveMachtModal .modal-content'));
                                if(multiple_match === false)
                                    $("#match-invoice-order").click();
                                else
                                    $('#match-invoice-order-multiple').click();

                                $("#editMatchRules").modal("hide");
                               // $("#saveMachtModal").modal("hide");
                                $('#loading_match_2').css('display', 'none');
                                hide_overlay_loader( $('#saveMachtModal .modal-content'));
                            }
                            saved_data_global = false;
                        }
                    });
            }
        });

        $("#min-max-rematch").on('click', function(){
            $("#minMaxRange").modal("show");
        });

        $("#fix_unmatch_spots").on('click', function(){
            $("#editMatchRules").modal("show");
            $("#editMatchRules").draggable({
                handle: ".modal-header"
            });
            reset_filters_grid = false;
        });

        $("#min-max-time-rematch").on('click', function() {
            reset_filters_grid = false;
            saved_data_global = false;
            $("#minMaxRange").modal("hide");
            var min_before_program = (typeof $('#min_max_range_form #min_before_program').val() !== 'undefined' && $('#min_max_range_form #min_before_program').val() >= 0 && $('#min_max_range_form #min_before_program').val() < 60) ? $('#min_max_range_form #min_before_program').val() : 0;
            var min_after_program = (typeof $('#min_max_range_form #min_after_program').val() !== 'undefined' && $('#min_max_range_form #min_after_program').val() >= 0 && $('#min_max_range_form #min_after_program').val() < 60) ? $('#min_max_range_form #min_after_program').val() : 0;
            var unmatchedRows = [];
            var week_counts = [];
            gridUnmatchOptions.api.forEachNode(function (unMatchNode, indexUnMatch) {
                $.each(match_result.olines, function (index1, val) {
                    var len1 = false;
                    var money1 = false;
                    var date1 = false;
                    var ran1 = true;
                    var time1 = false;
                    var ex1 = false;
                    var fit = false;
                    var week_id = null;

                    if (typeof match_result.match[index1] === 'undefined')
                        match_result.match[index1] = [];

                    if (typeof match_result.weeks_totals[index1] !== 'undefined' && typeof week_counts[index1] === 'undefined') {
                        week_counts[index1] = [];
                        for (var wind in match_result.weeks_totals[index1]) {
                            week_counts[index1][wind] = [];
                            week_counts[index1][wind]['fd_id'] = wind;
                            week_counts[index1][wind]['start'] = match_result.weeks[wind].start;
                            week_counts[index1][wind]['end'] = match_result.weeks[wind].end;
                            week_counts[index1][wind]['count'] = match_result.weeks_totals[index1][wind];

                            if (typeof match_result.match[index1][wind] === 'undefined')
                                match_result.match[index1][wind] = [];
                        }
                    }
                    for (var wind in  week_counts[index1]) {
                        var wval = week_counts[index1][wind];
                        var start = moment(moment(wval.start).format('YYYY-MM-DD'));
                        var end = moment(moment(wval.end).format('YYYY-MM-DD'));
                        var d = moment(moment(unMatchNode.data.date).format('YYYY-MM-DD'));
                        var max = wval.count;

                        if (moment(d).isBetween(start, end) || moment(d).isSame(start) || moment(d).isSame(end)) {
                            date1 = true;
                            week_id = wind;
                            if (typeof match_result.match !== 'undefined' && typeof match_result.match[index1] !== 'undefined' && typeof match_result.match[index1][wind] !== 'undefined' && match_result.match[index1][wind].length < max)
                                fit = true;

                        }
                    }

                    if (parseInt(unMatchNode.data.length) === parseInt(val.length))
                        len1 = true;

                    if (parseFloat(unMatchNode.data.rate) === parseFloat(val.cost))
                        money1 = true;

                    var stime = moment(val.start, "HH:mm A").subtract(min_before_program, 'minutes');
                    var etime = moment(val.end, "HH:mm A").add(min_after_program, 'minutes');
                    var rtime = moment(unMatchNode.data.time, "HH:mm A");
                    if (!rtime.isBetween(stime, etime, null, "[]")) {
                    } else
                        time1 = true;

                    if (typeof match_result.manual === "undefined") {
                        if ((!val.t && unMatchNode.data.day === 'T') || (!val.m && unMatchNode.data.day === 'M') || (!val.w && unMatchNode.data.day === 'W') || (!val.r && unMatchNode.data.day === 'R') || (!val.f && unMatchNode.data.day === 'F') || (!val.s && unMatchNode.data.day === 'S') || (!val.u && unMatchNode.data.day === 'U')) {
                        } else
                            ex1 = true;
                    } else {
                        if ((!val.t && unMatchNode.data.day === 'Tue') || (!val.m && unMatchNode.data.day === 'Mon') || (!val.w && unMatchNode.data.day === 'Wed') || (!val.r && unMatchNode.data.day === 'Thu') || (!val.f && unMatchNode.data.day === 'Fri') || (!val.s && unMatchNode.data.day === 'Sat') || (!val.u && unMatchNode.data.day === 'Sun')) {
                        } else
                            ex1 = true;
                    }
                    if (fit && date1 && time1 && ran1 && len1 && money1 && ex1) {
                        console.log("FIT");
                        if (week_id !== null) {
                            match_result.match[index1][week_id].push(match_result.no_match[unMatchNode.data.num]);
                            match_result.no_match[unMatchNode.data.num] = null;
                        } else {
                            var l = 99999;
                            var wl = -1;
                            var week = match_result.match[index1];
                            for (var index2 in week) {
                                var arr = week[index2];
                                if (arr.length < l) {
                                    l = arr.length;
                                    wl = index2;
                                }
                            }
                            match_result.match[index1][wl].push(match_result.no_match[unMatchNode.data.num]);
                            match_result.no_match[unMatchNode.data.num] = null;
                        }
                        unmatchedRows.push(unMatchNode)
                        return false;
                    }
                });
            });
            gridUnmatchOptions.api.removeItems(unmatchedRows);
            gridUnmatchOptions.api.refreshView();
            $("#orderlines").html("");
            drawBuyLines();
        });

        var flightWeeks = function(){
            var weeks = [];
            for(var ind in match_result.olines){
                weeks[ind] = [];
                for(var wind in match_result.olines[ind].counts){
                    var fd = match_result.olines[ind].counts[wind].flight_date;
                    weeks[ind][fd.id] = {
                        'start': fd.start,
                        'end': fd.end,
                        'count': match_result.olines[ind].counts[wind].count,
                    };
                }
            }
            return weeks;
        };

        var getDayFromOline = function(oline){
            var days = "";
            days += (oline.m) ? "M" : "-";
            days += (oline.t) ? "T" : "-";
            days += (oline.w) ? "W" : "-";
            days += (oline.r) ? "R" : "-";
            days += (oline.f) ? "F" : "-";
            days += (oline.s) ? "S" : "-";
            days += (oline.u) ? "U" : "-";
            return days;
        };

        var res = null;

        $("#show-preview").on('click', function(){
            var vis = $("#save-revised").css('display');
            if(saved_one_at_least==false && vis=='none'){
                swal({
                        title: "Warning!",
                        text: "Please Save Items first.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });

            }else {
                swal({
                        title: "Warning!",
                        text: "Are you sure to approve the reconciliation?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $("#loading_match_2").css("display", "block");
                            var vis = $("#save-revised").css('display');
                            if (vis !== "none") {
                                $("#loading_match_2").css("display", "block");
                                var sel = $("#invoice_id").val();
                                var params = {
                                    match: match_result,
                                };
                                $.ajax({
                                    type: 'POST',
                                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                    url: "/invoices/manual_match/save-items",
                                    data: JSON.stringify(params),
                                    contentType: "application/json",
                                    dataType: 'json',
                                    encode: true,
                                    success: function (data) {
                                        $.ajax({
                                            type: 'GET',
                                            url: '/invoices/manual/save/' + sel,
                                            dataType: 'json',
                                            encode: true,
                                            success: function (data) {
                                                global_notification("success", "Reconciliation created!");
                                                $("#loading_match_2").css("display", "none");
                                                saved_data = true
                                                $("#saveMachtModal").modal("hide");
                                                saved_data_global= true;
                                            },
                                            error: function (xhr) {
                                                $("#loading_match_2").css("display", "none");
                                                debug(xhr);
                                            }
                                        });

                                    },
                                    error: function (xhr) {
                                        $("#loading_match_2").css("display", "none");
                                        ajax_error();
                                        debug(xhr.responseText);
                                    }
                                });

                            } else {
                                var sdata = summaryData();
                                var ls = sdata.not_ordered;
                                var mgls = true;
                                var es = sdata.forced;
                                var mges = true;
                                var ow = 0;
                                var mgow = true;
                                var us = sdata.missed;
                                var mgus = true;
                                /*var ls = parseInt($("#lspots").html()); var mgls = true;
                                var es = parseInt($("#espots").html()); var mges = true;
                                var ow = parseInt($("#oweeks").html()); var mgow = true;
                                var us = parseInt($("#uspots").html()); var mgus = true;*/

                                if (ls > 0 && $('.checkbox1').is(':checked') === false)
                                    mgls = confirm("There are " + ls + " spots left to match. Do you want to save?");
                                if (es > 0 && mgls && $('.checkbox3').is(':checked') === false)
                                    mges = confirm("There are " + es + " 'Forced' spots. Do you want to save?");
                                if (ow > 0 && mges && mgls && $('.checkbox2').is(':checked') === false)
                                    mgow = confirm("There are " + ow + " 'Overload' weeks.Do you want to save?");
                                if (us > 0 && mges && mgls && mgow && $('.checkbox4').is(':checked') === false)
                                    mgus = confirm("There are " + us + " 'Un-matched' spots. Do you want to save?");
                                if (mgus && mges && mgls && mgow) {
                                    var forced_lines = [];
                                    var overl_weeks = [];
                                    var unmatch_spots = [];
                                    var match = [];
                                    var icomp_weeks = [];
                                    var weeks = flightWeeks();
                                    for (var oind in match_result.olines) {
                                        var oline = {
                                            'id': oind,
                                            'start': match_result.olines[oind].start,
                                            'end': match_result.olines[oind].end,
                                            'days': getDayFromOline(match_result.olines[oind]),
                                            'daypart': match_result.olines[oind].daypart,
                                            'cost': match_result.olines[oind].cost,
                                            'length': match_result.olines[oind].length,
                                            'weeks': []
                                        };
                                        if (typeof match_result.match[oind] !== 'undefined') {
                                            for (var wind in match_result.match[oind]) {
                                                var week = {
                                                    'id': wind,
                                                    'start': weeks[oind][wind].start,
                                                    'end': weeks[oind][wind].end,
                                                    'count': weeks[oind][wind].count,
                                                    'matches': []
                                                };
                                                for (var rind in match_result.match[oind][wind]) {
                                                    var line = {
                                                        'id': match_result.match[oind][wind][rind].id,
                                                        'dayofweek': match_result.match[oind][wind][rind].day_of_week,
                                                        'rundate': match_result.match[oind][wind][rind].run_date,
                                                        'time': match_result.match[oind][wind][rind].time_of_day,
                                                        'length': parseInt(match_result.match[oind][wind][rind].type_spot_length),
                                                        'rate': !isNaN(parseFloat(match_result.match[oind][wind][rind].rate)) ? parseFloat(match_result.match[oind][wind][rind].rate) : 0.00,
                                                        'error': ""
                                                    };
                                                    week['matches'].push(line);
                                                    if (typeof match_result['forced'] !== 'undefined') {
                                                        if (match_result['forced'].indexOf(line.id) !== -1)
                                                            forced_lines.push(line);
                                                    }
                                                }
                                                if (match_result.match[oind][wind].length > parseInt(week['count'])) {
                                                    overl_weeks.push(week);
                                                } else if (match_result.match[oind][wind].length < parseInt(week['count'])) {
                                                    icomp_weeks.push(week);
                                                }
                                                oline['weeks'].push(week);
                                            }
                                        } else {

                                        }
                                        match.push(oline);
                                    }

                                    for (var uind in match_result.no_match) {
                                        if (match_result.no_match[uind] !== null) {
                                            var line = {
                                                'id': match_result.no_match[uind].id,
                                                'dayofweek': match_result.no_match[uind].day_of_week,
                                                'rundate': match_result.no_match[uind].run_date,
                                                'time': match_result.no_match[uind].time_of_day,
                                                'length': match_result.no_match[uind].type_spot_length,
                                                'rate': match_result.no_match[uind].rate,
                                                'error': match_result.error_codes[uind],
                                                'error-code': match_result.error_codes[uind]
                                            };
                                            unmatch_spots.push(line);
                                        }
                                    }
                                    var invoices_id_multiple = [];
                                    if (multiple_match == true) {
                                        $('.invoices_check input[type=checkbox]').each(function () {
                                            if (this.checked)
                                                invoices_id_multiple.push($(this).val());
                                        });
                                    }
                                    var arr = {
                                        'match': match,
                                        'unmatch_spots': unmatch_spots,
                                        'forced_lines': forced_lines,
                                        'icomp_weeks': icomp_weeks,
                                        'overl_weeks': overl_weeks,
                                        'comments': "",
                                        'order_id': $("#order_id").val(),
                                        'invoice_id': $("#invoice_id").val(),
                                        'invoices_id': invoices_id_multiple,
                                        'multiple': multiple_match,
                                    };

                                    console.log("arrr");
                                    console.log(arr);

                                    //console.log($("#matches").children());
                                    /*$.each($("#matches").children(), function(index, value){
                                        var week_id = $(value).attr('data-id').split('_')[1];
                                        var order_line = {
                                            'id': week_id,
                                            'start': $(value).attr('start'),
                                            'end':  $(value).attr('end'),
                                            'days':  $(value).attr('days'),
                                            'daypart':  $(value).attr('daypart'),
                                            'cost':  $(value).attr('cost'),
                                            'length':  $(value).attr('length'),
                                            'weeks': []
                                        };
                                        $.each($($(value).children()[3]).children(), function(index, value){
                                            var week = {
                                                'id': $(value).attr('data-id').split('_')[1],
                                                'start': $(value).attr('start'),
                                                'end': $(value).attr('end'),
                                                'count': $(value).attr('maxc'),
                                                'matches': []
                                            };
                                            if($(value).children().length === 1){
                                                icomp_weeks.push(week);
                                            }else{
                                                $.each($($(value).children()[3]).children(), function(index, value){
                                                    var line = {
                                                        'id': ($(value).attr('data-id') === 'b_newline') ? 'new_' + week['id'] : $(value).attr('data-id').split('_')[1],
                                                        'dayofweek': $(value).attr('day_of_week'),
                                                        'rundate': $(value).attr('run_date'),
                                                        'time': $(value).attr('time_of_day'),
                                                        'length': $(value).attr('type_spot_length'),
                                                        'rate': $(value).attr('rate'),
                                                        'error': $(value).attr('spot-error')
                                                    };
                                                    week['matches'].push(line);
                                                    if($(value).attr('spot-error') === 'true'){
                                                        forced_lines.push(line);
                                                    }
                                                });
                                                if($($(value).children()[3]).children().length > parseInt(week['count'])){
                                                    console.log($(value).children().length);
                                                    overl_weeks.push(week);
                                                }else if($($(value).children()[3]).children().length < parseInt(week['count'])){
                                                    icomp_weeks.push(week);
                                                }
                                            }
                                            order_line['weeks'].push(week);
                                        });
                                        match.push(order_line);
                                    });*/

                                    /*$.each($("#no_matches").children(), function(index, value){
                                        if($(value).attr('data-id') !== 'b_newline') {
                                            var line = {
                                                'id': $(value).attr('data-id').split('_')[1],
                                                'dayofweek': $(value).attr('day_of_week'),
                                                'rundate': $(value).attr('run_date'),
                                                'time': $(value).attr('time_of_day'),
                                                'length': $(value).attr('type_spot_length'),
                                                'rate': $(value).attr('rate'),
                                                'error': $(value).attr('spot-error'),
                                                'error-code': ($(value).attr('error-code') === "") ? "Manual" : $(value).attr('error-code')
                                            };
                                            unmatch_spots.push(line);
                                        }
                                    });*/

                                    /*var arr = {
                                        'match': match,
                                        'unmatch_spots': unmatch_spots,
                                        'forced_lines': forced_lines,
                                        'icomp_weeks': icomp_weeks,
                                        'overl_weeks': overl_weeks,
                                        'comments': $("#match_comments").html(),
                                        'order_id': $("#order_id").val(),
                                        'invoice_id': $("#invoice_id").val()
                                    };

                                    console.log("arrr");
                                    console.log(arr);*/
                                    res = arr;

                                    var html = '';
                                    $.each(match, function (index, value) {
                                        html += '<tr style="background-color: gray; color: white">';
                                        html += '<td height="20px">' + (index + 1) + '</td>';
                                        html += '<td></td>';
                                        html += '<td></td>';
                                        html += '<td>' + value['days'] + '</td>';
                                        html += '<td style="width: 17%; he">' + value['start'] + ' - ' + value['end'] + '</td>';
                                        html += '<td>' + value['length'] + '</td>';
                                        html += '<td></td>';
                                        html += '<td></td>';
                                        html += '<td>' + value['cost'] + '</td>';
                                        html += '<td></td>';
                                        html += '</tr>';

                                        $.each(value['weeks'], function (index, value) {
                                            $.each(value['matches'], function (index, value) {
                                                var remarks = (value['error'] === 'true') ? "Forced (Make good)" : '';
                                                /*if(typeof value['id'].split('_')[1] !== 'undefined')
                                                    remarks += "<br>New line (Make good)";*/
                                                html += '<tr>';
                                                html += '<td height="20px"></td>';
                                                html += '<td></td>';
                                                html += '<td>' + value['rundate'] + '</td>';
                                                html += '<td>' + value['dayofweek'] + '</td>';
                                                html += '<td style="width: 17%">' + value['time'] + '</td>';
                                                html += '<td>' + value['length'] + '</td>';
                                                html += '<td>S</td>';
                                                html += '<td></td>';
                                                html += '<td>' + value['rate'] + '</td>';
                                                html += '<td style="width: 20%">' + remarks + '</td>';
                                                html += '</tr>';
                                            });
                                        });

                                    });
                                    $("#tbl_content").html(html);
                                    html = '';
                                    $.each(unmatch_spots, function (index, value) {
                                        /*if(typeof value['id'].split('_')[1] !== 'undefined'){

                                        }else {*/
                                        html += '<tr>';
                                        html += '<td height="20px"></td>';
                                        html += '<td></td>';
                                        html += '<td>' + value['rundate'] + '</td>';
                                        html += '<td>' + value['dayofweek'] + '</td>';
                                        html += '<td>' + value['time'] + '</td>';
                                        html += '<td>' + value['length'] + '</td>';
                                        html += '<td>S</td>';
                                        html += '<td></td>';
                                        html += '<td>' + value['rate'] + '</td>';
                                        html += '<td>Ignored </td>';
                                        html += '<td>' + value['error-code'] + '</td>';
                                        html += '</tr>';
                                        //}
                                    });
                                    $("#tbl_content_un").html(html);
                                    $("#confirmMatch").modal('show');
                                }
                            }
                        }
                    });
            }
        });

        $("#save-match-result").on('click', function(index, value){
            var conf = confirm("Do you want to save the match result?");
            if(conf) {
                $("#loading_match_save").show();
                if (res !== null) {
                    console.log("res");
                    console.log(res);
                    $.ajax({
                        type: 'POST',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        url: $(this).attr('data-contact-url'),
                        data: JSON.stringify(res),
                        contentType: "application/json",
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            $("#confirmMatch").modal('hide');
                            saved_data = true
                            saved_data_global = true;
                            $("#saveMachtModal").modal('hide');
                            $("#searchOrdenToMach").modal('hide');
                            location.href = '/invoices';
                            global_notification('success', 'Reconciliation process created successfully...');
                            $("#loading_match_save").hide();
                        },
                        error: function (xhr) {
                            $("#loading_match_save").hide();
                            console.log(xhr);
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            }
                            else if (xhr.status === 504) {
                                global_notification('warning', "Sorry our server is running a little slow at the moment.");
                            }
                            else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        }
                    });
                }
            }
        });

        $("#save-line").on('click', function(e){
            if($("#linedate").val() === "" || $("#linetime").val() === "" || $("#linesec").val() === "" || $("#linecost").val() === "")
                global_notification('error', "Complete all form fields...");
            else{
                var html = "";
                html += '<li spot-error="false" data-level="3" class="dd-item" data-id="b_newline" rate="'+ $("#linecost").val() +'" day_of_week="'+ $("#dayofweek").val() +'" run_date="'+ $("#linedate").val() +'" time_of_day="'+ $("#linetime").val() +'" type_spot_length="'+ $("#linesec").val() +'">';
                html += '<div style="height: 30px;background-color: white;border: 1px solid darkred;color: black;" class="dd-handle">' + $("#dayofweek").val() + ' | ' + $("#linedate").val() + ' | ' + $("#linetime").val() + ' | ' + $("#linesec").val() + ' sec | $'+ $("#linecost").val()+'<div style="float: right">Make Good Spot</div></div>';
                html += '</li>';
                $('#no_matches').html(html + $('#no_matches').html());
                //var uspots = parseInt($("#uspots").html());
                //$("#uspots").html(uspots + 1);
                $('#newblinemodal').modal('hide');
                var nl = $("#count_newlines").html();
                $("#count_newlines").html(parseInt(nl) + 1);
            }
        });

        $("#del_new_spots_match").on('click', function(e){
            var res = confirm("Are you sure to delete all new broadcast lines from Match List?");
            if(res) {
                $("#matches").find('li').each(function (i, opt) {

                    if ($(opt).attr('data-id') === 'b_newline') {
                        var ms = $("#mspots").html();
                        if (ms > 0)
                            $("#mspots").html(parseInt(ms) - 1);
                        var cl = $("#count_newlines").html();
                        if (cl > 0)
                            $("#count_newlines").html(parseInt(cl) - 1);
                        if ($(opt).attr('spot-error') === 'true') {
                            var se = $("#espots").html();
                            if (se > 0)
                                $("#espots").html(parseInt(se) - 1);
                        }
                        var max = $(opt).parent().parent();
                        var chlds = $(max).children();
                        var c = 0;
                        if (chlds.length === 4) {
                            c = $(chlds[2]).attr('scount');
                        } else {
                            c = $(chlds[0]).attr('scount');
                        }
                        max = $(max).attr('maxc');
                        if (c > max) {
                            var ow = $("#oweeks").html();
                            if (ow > 0)
                                $("#oweeks").html(parseInt(ow) - 1);
                        }
                        if (chlds.length === 4) {
                            if (parseInt(c) >= 1) {
                                $(chlds[2]).attr('scount', parseInt(c) - 1);
                                var week = $(chlds[2]).children();
                                var arr = $(week[0]).html().split('(');
                                var arr1 = arr[1].split('of');
                                var res = arr[0] + "(" + (parseInt(c) - 1) + " of " + arr1[1];
                                $(week).html(res);
                            }
                        } else {
                            c = $(chlds[0]).attr('scount');
                            $(chlds[0]).attr('scount', parseInt(c) - 1);
                            var week = $(chlds[0]).children();
                            var arr = $(week[0]).html().split('(');
                            if (typeof arr[1] !== 'undefined') {
                                console.log("second1");
                                var arr1 = arr[1].split('of');
                                var res = arr[0] + "(" + (parseInt(c) - 1) + " of " + arr1[1];
                                $(week).html(res);
                            }
                        }
                        var ls = $("#lspots").html();
                        if (ls > 0)
                            $("#lspots").html(parseInt(ls) + 1);
                        $(opt).remove();
                        global_notification('success', "New broadcast lines deleted...");
                    }
                });
            }
        });

        $("#del_new_spots_no_match").on('click', function(e){
            var res = confirm("Are you sure to delete all new broadcast lines from Unmatched List?");
            if(res) {
                $("#no_matches").find('li').each(function (i, opt) {
                    if ($(opt).attr('data-id') === 'b_newline') {
                        var cl = $("#count_newlines").html();
                        if (cl > 0)
                            $("#count_newlines").html(parseInt(cl) - 1);
                        $(opt).remove();
                        global_notification('success', "New broadcast lines deleted...");
                    }
                });
            }
        });

        $("#linedate").on('change', function(e){
            var date = moment($(this).val());
            var dow = date.day();
            $("#dayofweek").find('option').each(function( i, opt ) {
                if( parseInt($(opt).attr('daynum')) == parseInt(dow) )
                    $(opt).attr('selected', 'selected');
            });
        });

    });

    var get_from_field_new_invoice= function () {
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/selects/new',
            dataType: 'json',
            encode: true,
            success: function (data) {

                var advertisers = [];
                $.each(data.advertiser, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name, 'title': value.name});
                    console.log(value.name);
                });

                var adv_new= $('#advertiser_new');
                if ($(adv_new).data('select2')) {
                    adv_new.select2('destroy');
                }
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select one..."
                });
                var adv_search= $('#advertiser_search');
                advertisers.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
                adv_search.select2({
                    'data': advertisers,
                    placeholder: "Select one..."
                });

                var stations = [];
               $.each(data.stations, function (index, value) {
                    stations.push({'id': value.id, 'text': value.name});
                });
                var state = $('#station_new');

                if ($(state).data('select2')) {
                    state.select2('destroy');
                }

                state.select2({
                    'data': stations,
                    maximumSelectionLength: 2,
                  //  minimumResultsForSearch: 2,
                    placeholder: "Select one"
                });

                var products = [];
                $.each(data.products, function (index, value) {
                    products.push({'id': value.name, 'text': value.name});
                });

                var select = $('#product_new');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }

                select.html('').select2({
                    'data': products,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select one "
                });

                var select = $('#media_type_new');

                if ($(select).data('select2')) {
                    select.select2('destroy');
                }
                 var media=[];
                media.push({'id': 1, 'text': 'Television'});
                media.push({'id': 2, 'text': 'Radio'});

                select.html('').select2({
                    'data': media,
                    minimumResultsForSearch: Infinity,
                    placeholder: "Select one "
                });

                var states= $('#agency_bill_state');

                states.select2({
                    maximumSelectionLength: 2
                });

                var states= $('#payee_bill_state');

                states.select2({
                    maximumSelectionLength: 2
                });

                var states= $('#station_bill_state');

                states.select2({
                    maximumSelectionLength: 2
                });
                hide_loader();

            },
            error: function (e) {
                console.log(e);
                debug(e.responseText);
                hide_loader();
            }
        });
    }
    $('#time_start').wickedpicker({
        now: "12:00",
        minutesInterval: 15
    }).click(function () {
        $('.white-box').click();
        $(this).focus();
        $('.wickedpicker').css({
            'z-index': $(this).css('z-index') + 1,
            position: 'absolute',
            left: $(this).offset().left,
            top: $(this).top + $('.wickedpicker').height() + 5
        });
        $('#time_end').attr('aria-showingpicker', false);
        $('#time_start').attr('tabindex', 0);
        $('#time_start').attr('aria-showingpicker', true);
        $('#time_start').attr('tabindex', -1);

    });
    $('#time_end').wickedpicker({
        now: "13:00",
        minutesInterval: 15
    }).click(function () {
        $('.white-box').click();
        $(this).focus();
        $('.wickedpicker').css({
            'z-index': $(this).css('z-index') + 1,
            position: 'absolute',
            left: $(this).offset().left,
            top: $(this).top + $('.wickedpicker').height() + 5
        });
        $('#time_start').attr('aria-showingpicker', false);
        $('#time_start').attr('tabindex', 0);
        $('#time_end').attr('aria-showingpicker', true);
        $('#time_start').attr('tabindex', -1);
    });

    $('.dow-container button').on('click', function () {
        if ($(this).hasClass('btn-default')) {
            $(this).removeClass('btn-default').addClass('btn-primary');
        } else {
            $(this).addClass('btn-default').removeClass('btn-primary');
        }

        set_dow_input($(this));
    });

    var set_dow_input = function (button) {
        var container = button.closest('.dow-container');
        var input = container.find('input');
        var buttons = container.find('button');

        var html = '';

        $.each(buttons, function (index, value) {
            if ($(value).hasClass('btn-primary')) {
                $(value).html($(value).attr('data-value'));
                html += $(value).attr('data-value');
            } else {
                $(value).html('-');
                html += '-';
            }
        });

        $(input).val(html);

    };

    $(".add_spots").on('click', function(){
        if($(this).val() === "Edit Spots")
            $(this).val('Hide Spots');
        else
            $(this).val('Edit Spots');
    });

    function removeLine(id) {
        var conf= confirm('Are you sure to delete the line?');
        if(conf) {
            $("#space_" + id + "").remove();
            $("#demo_" + id + "").remove();
            $("#box_" + id + "").remove();
        }

    }

    function changeDate(id){
        var fd = $("#line_flight_days").val();
        if(fd === ""){
            $("#run_date_" + id).val("");
            global_notification("warning", "Please select Line Dates first!");
        }else {
            var arr = fd.split(" - ");
            var start = new Date(arr[0]);
            var end = new Date(arr[1]);
            var rundate = new Date($("#run_date_" + id).val());
            console.log(start);
            console.log(end);
            console.log(rundate);
            if (rundate < start || rundate > end) {
                $("#run_date_" + id).val("");
                global_notification("warning", "Run Date should be between Line Flight Dates!");
            } else {
                var dow = new Date($("#run_date_" + id).val()).getDay();
                if (dow === 0)
                    dow = "Monday";
                else if (dow === 1)
                    dow = "Tuesday";
                else if (dow === 2)
                    dow = "Wednesday";
                else if (dow === 3)
                    dow = "Thursday";
                else if (dow === 4)
                    dow = "Friday";
                else if (dow === 5)
                    dow = "Saturday";
                else
                    dow = "Sunday";
                $("#day_week_" + id).val(dow);
                console.log($("#day_week_" + id).val());
            }
        }
    }
    function changeLineDate() {
         if(cc > 0) {
             var fd = $("#flight_days").val();

             console.log('entrando  ' + fd);
             if (fd === "")
             { global_notification("warning", "Please select Fligth Dates first!");
             test=true;}
             else {
                 var arr = fd.split(" - ");
                 var start = new Date(arr[0]);
                 var end = new Date(arr[1]);

                 var line_date = $('#line_flight_days').val();
                 console.log('el segundo  ' + $('#line_flight_days').val());

                 var arra_line = line_date.split(" - ");
                 var line_star = new Date(arra_line[0]);
                 var line_end = new Date(arra_line[1]);
                 if (line_star < start || line_star > end || line_end > end || line_end < start) {
                     console.log(line_star);
                     console.log(line_end);
                     console.log(start);
                     console.log(end);
                     global_notification("warning", "Line Date should be between Flight Dates!");
                     test=true;
                 }

             }
         }
         cc++;

}
    function changeTime(start, end, id, field){
         var time = new Date($("#run_time_" + id).val());
        var start1 = new Date(start);
        var end1 = new Date(end);
        if(time < start1 || time > end1){
            $("#run_time_" + id).val("");
            global_notification("warning", "Run Time should be into Line Time Period!");
        }else{

        }
    }

    $('#save_invoice').on('click', function () {
        var invoice_number = $("#invoice_number").val();
        var broadcast_month = $("#broadcast_month").val();
        var invoice_date = $("#invoice_date").val();
        var flight_days = $("#flight_days").val();
        var account_executive = $("#account_executive").val();
        var advertiser_new = $("#advertiser_new option:selected").val();
        var product_new = $("#product_new option:selected").val();
        var order_type = $("#order_type").val();
        var representative = $("#representative").val();
        var order_number = $("#order_number").val();
        var station_order = $("#station_order").val();
        var contact_number = $("#contact_number").val();
        var station_new = $("#station_new option:selected").val();
        var due_by = $("#due_by").val();
        var media_type_new = $("#media_type_new option:selected").val();
        var bill_intr = $("#bill_intr").val();
        var comments_new = $("#comments_new").val();

        var agency_bill_id= $("#agency_bill_id").val();
        var agency_bill_name= $("#agency_bill_name").val();
        var agency_bill_address= $("#agency_bill_address").val();
        var agency_bill_suite= $("#agency_bill_suite").val();
        var agency_bill_citi= $("#agency_bill_citi").val();
        var agency_bill_state= $("#agency_bill_state").val();
        var agency_bill_zip= $("#agency_bill_zip").val();


        var payee_bill_name=$("#payee_bill_name").val();
        var payee_bill_address=$("#payee_bill_address").val();
        var payee_bill_suite=$("#payee_bill_suite").val();
        var payee_bill_citi=$("#payee_bill_citi").val();
        var payee_bill_state=$("#payee_bill_state").val();
        var payee_bill_zip=$("#payee_bill_zip").val();

        var station_bill_name= $("#station_new option:selected").val();
        var station_bill_address=$("#station_bill_address").val();
        var station_bill_suite=$("#station_bill_suite").val();
        var station_bill_citi=$("#station_bill_citi").val();
        var station_bill_state=$("#station_bill_state").val();
        var station_bill_zip=$("#station_bill_zip").val();
        var line_flight_days = $("#line_flight_days");



        if(invoice_number !== "" && broadcast_month !== "" && invoice_date !== "" && flight_days !== "" && advertiser_new !== ""
          && station_new !== "" && media_type_new !== ""){
            show_loader();
            var val = true;
            var result = {
                invoice_number: invoice_number,
                broadcast_month: broadcast_month,
                invoice_date: invoice_date,
                flight_days: flight_days,
                account_executive: account_executive,
                advertiser_new: advertiser_new,
                order_type: order_type,
                representative: representative,
                order_number: order_number,
                station_order: station_order,
                station_new: station_new,
                due_by: due_by,
                media_type_new: media_type_new,
                product_new: product_new,
                contact_number: contact_number,
                agency_bill_id:agency_bill_id,
                agency_bill_name:agency_bill_name,
                agency_bill_address:agency_bill_address,
                agency_bill_suite:agency_bill_suite,
                agency_bill_citi:agency_bill_citi,
                agency_bill_zip:agency_bill_zip,
                payee_bill_name:payee_bill_name,
                payee_bill_address:payee_bill_address,
                payee_bill_suite:payee_bill_suite,
                payee_bill_citi:payee_bill_citi,
                payee_bill_state:payee_bill_state,
                payee_bill_zip:payee_bill_zip,
                station_bill_name:station_bill_name,
                station_bill_address:station_bill_address,
                station_bill_suite:station_bill_suite,
                station_bill_citi:station_bill_citi,
                station_bill_state:station_bill_state,
                station_bill_zip:station_bill_zip,
                bill_intr: bill_intr,
                comments_new: comments_new,
                lines: [],



            };
            $("#line_content").find(".invoice-spot-lines").each(function(index, value) {
                console.log($(value).html());
                if (typeof $(value).find(".tim_period").html() !== 'undefined') {
                    var ss = $(value).find(".tim_period").html().split(' to ')[0];
                    console.log(ss);
                    var sx = moment(ss, "h:mm A").format("HH:mm");
                    console.log(sx);

                    var sss = $(value).find(".tim_period").html().split(' to ')[1];
                    console.log(ss);
                    var sxx = moment(sss, "h:mm A").format("HH:mm");
                    console.log(sx);

                    var lines = {
                        line_flight_days: $(value).find(".line_flight_days").html(),
                        start: sx,
                        end: sxx,
                        line_days: $(value).find(".line_days").html(),
                        total_spot: parseInt($(value).find(".total_spot").html()),
                        rate_per_spot: !isNaN(parseFloat($(value).find(".rate_per_spot").html().split("$")[1])) ? parseFloat($(value).find(".rate_per_spot").html().split("$")[1]) : 0,
                        spot_length: parseInt($(value).find(".spots_length").html().split(" ")[0]),
                        spots: []
                    };

                    for (var i = 1; i <= lines.total_spot; i++) {
                        var run = $(value).find("#run_" + (index + 1) + "_" + i);
                        if (run.is(':checked'))
                            var rr = 1;
                        else
                            var rr = 0;
                        var run_date = $(value).find("#run_date_" + (index + 1) + "_" + i);
                        var program_descr = $(value).find("#program_descr_" + (index + 1) + "_" + i);
                        var run_time = $(value).find("#run_time_" + (index + 1) + "_" + i);
                        var spot_remark = $(value).find("#spot_remark_" + (index + 1) + "_" + i);
                        var spot_class = $(value).find("#spot_class_" + (index + 1) + "_" + i);
                        var spot_day = $(value).find("#day_week_" + (index + 1) + "_" + i);

                        if (typeof run_date.val() !== "undefined") {
                            if (run_date.val() !== "" && run_time.val() !== "") {
                                lines.spots.push({
                                    run: rr,
                                    run_date: run_date.val(),
                                    run_time: run_time.val(),
                                    program_descr: program_descr.val(),
                                    spot_remark: spot_remark.val(),
                                    spot_class: spot_class.val(),
                                    day_week: spot_day.val(),
                                });
                            } else {
                                val = false;
                                global_notification('error', 'Complete Run Date and Run Time from line #' + (index + 1) + ', Spot line #' + i);
                            }
                        } else {
                            val = false;
                            console.log(run);
                            console.log(spot_class);
                            console.log(run_date);
                            console.log(run_time);
                            global_notification('error', 'Please add all spots from Line #' + (index + 1) + ' or delete the line!');
                        }
                    }
                    if (val && lines.spots.length > 0)
                        result.lines.push(lines);
                    else {
                        global_notification('error', 'Please add all spots from Line #' + (index + 1) + ' or delete the line!');
                    }
                }
            });

            if(val){
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    url: $(this).attr('data-contact-url'),
                    data: JSON.stringify(result),
                    contentType: "application/json",
                    dataType: 'json',
                    encode: true,
                    success: function (data) {
                        console.log(data);
                        hide_loader();
                        global_notification('success', 'Invoice created...');
                    },
                    error: function (e) {
                        console.log(e);
                        debug(e.responseText);
                        hide_loader();
                    }
                });
            }else{
                hide_loader();
            }
        }else{
            global_notification('error', 'Complete all form invoice\'s fields');
        }

    });


    $('#add_line').on('click', function () {

        if($('#daypart_dows').val()!=='-------'  &&  $('#total_spot').val() !== 0 &&  $('#total_spot').val() !== '' && $('#rate_per_spot').val() !== '' && $('#line_flight_days')!== "") {

            $('#line_flight_days').trigger('change');

            if(test===false) {
                var spot_lines = "";
                spot_lines += "<div class='row' style='padding: 15px; background-color: white'>";
                spot_lines += '<table class="table-bordered" style="width: 100%; font-size: 12px">';
                spot_lines += "<thead>" +
                    "<tr>" +
                    "<th>Run</th>" +
                    "<th>Run Date</th>" +
                    "<th>Time</th>" +
                    "<th>Day of Week</th>" +
                    "<th>Length/Rate</th>" +
                    "<th>Program description</th>" +
                    "<th>Class</th>" +
                    "<th>Remarks</th>" +
                    "</tr>" +
                    "</thead>" +
                    "<tbody>";
                for (var i = 0; i < $("#total_spot").val(); i++) {

                    spot_lines += "<tr id='spot_line_" + cont + "_" + (i + 1) + "'>";
                    spot_lines += '<td><input type="checkbox" class="form-control run_run"  id="run_' + cont + '_' + (i + 1) + '" name="run_' + cont + '" value="1" checked></td>';
                    spot_lines += '<td><input type="date" class="form-control run_date" onchange="changeDate(\'' + cont + '_' + (i + 1) + '\')" id="run_date_' + cont + '_' + (i + 1) + '" name="run_date_' + cont + '" ></td>';
                    spot_lines += '<td><input type="time" class="form-control run_time" onchange="changeTime(\'' + $('#time_start').val() + '\',\'' + $('#time_end').val() + '\', \'' + cont + '_' + (i + 1) + '\', this)" id="run_time_' + cont + '_' + (i + 1) + '" name="run_time_' + cont + '" ></td>';
                    spot_lines += '<td><input type="text" class="form-control day_week" id="day_week_' + cont + '_' + (i + 1) + '" name="day_week_' + cont + '" disabled value="-" ></td>';
                    spot_lines += '<td><input type="text" id="spots_length_' + cont + '_' + (i + 1) + '" name="spots_length_' + cont + '_' + (i + 1) + '" disabled class="form-control spots_length" value="' + $('#spots_length').val() + ' sec/$' + $('#rate_per_spot').val() + '"></td>';
                    spot_lines += '<td><input type="text" class="form-control "  name="program_descr_' + cont + '" id="program_descr_' + cont + '_' + (i + 1) + '" placeholder="Description" ></td>';
                    spot_lines += '<td><input type="text" class="form-control " name="spot_class_' + cont + '" id="spot_class_' + cont + '_' + (i + 1) + '" maxlength="3" ></td>';
                    spot_lines += '<td><input type="text" class="form-control " name="spot_remark_' + cont + '" id="spot_remark_' + cont + '_' + (i + 1) + '" placeholder="Remarks" ></td>';
                    spot_lines += "</tr>";

                }
                spot_lines += "</tbody>";
                spot_lines += '</table>';
                spot_lines += "</div>";

                var html = $('#line_content').html();
                var hh = 20 * parseInt($('#rate_per_spot').val());
                var html_dos = '<div class="invoice-spot-lines"><div class="form-group col-sm-12" id="space_' + cont + '" style="background-color: #f8ab91; padding: 0.2%" >' +
                    '               <h5 class="box-title invoice-title" >Line No.' + cont + '</h5> ' +
                    '            </div>' +
                    '                              <div class="white-box" style="height: 110px" id="box_' + cont + '" >' +
                    '                              <div class="form-inline row " id="desplegable_' + cont + '">' +
                    '                               <div class="form-group col-sm-2 ">' +
                    '                                      <h5 class="box-title invoice-title" >Line Date</h5>' +
                    '                                      <div class="form-group line_flight_days " >' + $('#line_flight_days').val() + ' </div>' +
                    '                                  </div>' +
                    '                                  <div class="form-group col-sm-2 ">' +
                    '                                      <h5 class="box-title invoice-title" >Time Period</h5>' +
                    '                                      <div class="form-group tim_period " >' + $('#time_start').val() + '  to  ' + $('#time_end').val() + '</div>' +
                    '                                  </div>' +
                    '                                  <div class="form-group col-sm-2 ">' +
                    '                                      <h5 class="box-title invoice-title" >Days</h5>' +
                    '                                      <div class="form-group  line_days">' + $('#daypart_dows').val() + '</div>' +
                    '                                  </div>' +
                    '                                  <div class="form-group col-sm-1 ">' +
                    '                                      <h5 class="box-title invoice-title ">Total Spot</h5>' +
                    '                                      <div class="form-group  total_spot"  >' + $('#total_spot').val() + '</div>' +
                    '                                  </div>' +
                    '                                  <div class="form-group col-sm-1 ">' +
                    '                                      <h5 class="box-title invoice-title " >Rate per Spot</h5>' +
                    '                                      <div class="form-group rate_per_spot" >$' + $('#rate_per_spot').val() + '</div>' +
                    '                                  </div>' +
                    '                                    <div class="form-group col-sm-1 ">' +
                    '                                      <h5 class="box-title invoice-title " >Spot Length</h5>' +
                    '                                      <div class="form-group spots_length" >' + $('#spots_length').val() + '</div>' +
                    '                                  </div>' +
                    '                                  <div class="form-group col-sm-1 ">' +
                    '                                       <h5 class="box-title invoice-title" > </h5>' +
                    '                                       <div class="form-group add_spot" >' +
                    '                                            <input type="button" class="btn btn-primary add_spots" id="add_spots_' + cont + '"   value="Edit Spots" data-toggle="collapse" data-target="#demo_' + cont + ' ">' +
                    '                                       </div>' +
                    '                                   </div>      ' +

                    '                                   <div class="form-group col-sm-2 ">' +
                    '                                       <h5 class="box-title invoice-title" > </h5>' +
                    '                                       <div class="form-group col-sm-12  remove" >' +
                    '                                           <input type="button" class="btn btn-primary remove_line"  onclick="removeLine(' + cont + ')" value="Remove Line" id="remove_line_' + cont + '">' +
                    '                                      </div>' +
                    '                                   </div>' +
                    '                              </div>' +
                    '                               </div> ' +
                    '                               <div id="demo_' + cont + '" class="collapse line-spot-list">' + spot_lines +

                    '</div></div>';


                $('#line_content').append(html_dos);

                console.log('despeggable_' + cont + ', space_' + cont);
                $('#line_content').css("display", "block");
                cont++;
            }
            test=false;
        }else{
            if($('#daypart_dows').val()==='-------' )
               global_notification('warning', 'Field DOWs is required.');
            else if($('#line_flight_days')=== "")
                global_notification('warning', 'Field Line Date is required.');
            else if( $('#total_spot').val() ==='')
                global_notification('warning', 'Field Total Spots can not be zero.');
            else if($('#total_spot').val() ==0 )
                global_notification('warning', 'Field Total Spots can not be zero.');
            else if($('#rate_per_spot').val() ==='')
                global_notification('warning', 'Field Rate per Spot is required.');

        }


    });

    // var init_invoice_search_fields = function () {
    //     show_loader();
    //     $.ajax({
    //         type: 'GET',
    //         url: '/invoices/selects',
    //         dataType: 'json',
    //         encode: true,
    //         success: function (data) {
    //             console.log('data ****', data);
    //             var numbers = [];
    //             var advertisers = [];
    //             var products = [];
    //             var payees = [];
    //             var stations = [];
    //
    //             var num_exist=[];
    //             var adv_exist=[];
    //             var prod_exist=[];
    //             var pay_exist=[];
    //             var sta_exist=[];
    //             for(var ind in data.advertisers)
    //                 advertisers.push({'id': data.advertisers[ind].id, 'text': data.advertisers[ind].name});
    //
    //             $.each(data, function (index, value) {
    //                 if(num_exist.indexOf(value.invoice_number) === -1){
    //                     numbers.push({'id': value.invoice_number, 'text': value.invoice_number});
    //                     num_exist.push(value.invoice_number);
    //                 }
    //
    //                 // if(sta_exist.indexOf(value.station_name) === -1) {
    //                 //     stations.push({'id': value.station_name, 'text': value.station_name});
    //                 //     sta_exist.push(value.station_name);
    //                 // }
    //             });
    //             //regular invoices
    //             $('#invoice-number-search').select2({
    //                 'data': numbers,
    //                 minimumResultsForSearch: 5,
    //                 placeholder: "Select zero or more"
    //             });
    //             $('#invoice-advertiser-search').select2({
    //                 'data': advertisers,
    //                 minimumResultsForSearch: 5,
    //                 placeholder: "Select zero or more"
    //             });
    //
    //             $('#invoice-stations-search').select2({
    //                 'data': stations,
    //                 minimumResultsForSearch: 5,
    //                 placeholder: "Select zero or more"
    //             });
    //             hide_loader();
    //         },
    //         error: function (e) {
    //             console.log(e);
    //             debug(e.responseText);
    //             hide_loader();
    //         }
    //     });
    //
    // };
    // var init_invoice_search_arch_fields = function () {
    //     show_loader();
    //     $.ajax({
    //         type: 'GET',
    //         url: '/invoices/selects/archivate',
    //         dataType: 'json',
    //         encode: true,
    //         success: function (data) {
    //             console.log('data ****', data);
    //             var numbers = [];
    //             var advertisers = [];
    //             var products = [];
    //             var payees = [];
    //             var stations = [];
    //
    //             var num_exist=[];
    //             var adv_exist=[];
    //             var prod_exist=[];
    //             var pay_exist=[];
    //             var sta_exist=[];
    //             $.each(data, function (index, value) {
    //                 if(num_exist.indexOf(value.invoice_number) === -1){
    //                     numbers.push({'id': value.invoice_number, 'text': value.invoice_number});
    //                     num_exist.push(value.invoice_number);
    //                 }
    //                 if(adv_exist.indexOf(value.advertiser_name) === -1) {
    //                     advertisers.push({'id': value.advertiser_name, 'text': value.advertiser_name});
    //                     adv_exist.push(value.advertiser_name);
    //                 }
    //                 if(prod_exist.indexOf(value.product_name) === -1) {
    //                     products.push({'id': value.product_name, 'text': value.product_name});
    //                     prod_exist.push(value.product_name);
    //                 }
    //                 if(pay_exist.indexOf(value.payee_name) === -1) {
    //                     payees.push({'id': value.payee_name, 'text': value.payee_name});
    //                     pay_exist.push(value.payee_name);
    //                 }
    //                 if(sta_exist.indexOf(value.station_name) === -1) {
    //                     stations.push({'id': value.station_name, 'text': value.station_name});
    //                     sta_exist.push(value.station_name);
    //                 }
    //             });
    //             //archivated invoices
    //             $('#invoice-number-search-archived').select2({
    //                 'data': numbers,
    //                 minimumResultsForSearch: Infinity,
    //                 placeholder: "Select zero or more"
    //             });
    //             $('#invoice-advertiser-search-archived').select2({
    //                 'data': advertisers,
    //                 minimumResultsForSearch: Infinity,
    //                 placeholder: "Select zero or more"
    //             });
    //
    //             $('#invoice-product-search-archived').select2({
    //                 'data': products,
    //                 minimumResultsForSearch: Infinity,
    //                 placeholder: "Select zero or more"
    //             });
    //
    //             $('#invoice-payees-search-archived').select2({
    //                 'data': payees,
    //                 minimumResultsForSearch: Infinity,
    //                 placeholder: "Select zero or more"
    //             });
    //
    //             $('#invoice-stations-search-archived').select2({
    //                 'data': stations,
    //                 minimumResultsForSearch: Infinity,
    //                 placeholder: "Select zero or more"
    //             });
    //             hide_loader();
    //         },
    //         error: function (e) {
    //             console.log(e);
    //             debug(e.responseText);
    //             hide_loader();
    //         }
    //     });
    // };

    // var input = $("#flight_days");
    //
    // if (input.data('daterangepicker')) {
    //     input.data('daterangepicker').remove();
    // }
    //
    // input.daterangepicker({
    //     "showWeekNumbers": true,
    //     "autoApply": true,
    //     "linkedCalendars": false,
    //     "locale": {
    //         "format": "MM/DD/YYYY",
    //         "separator": " - ",
    //         "applyLabel": "Apply",
    //         "cancelLabel": "Cancel",
    //         "fromLabel": "From",
    //         "toLabel": "To",
    //         "customRangeLabel": "Custom",
    //         "weekLabel": "#",
    //         "daysOfWeek": [
    //             "U",
    //             "M",
    //             "T",
    //             "W",
    //             "R",
    //             "F",
    //             "S"
    //         ],
    //         "firstDay": 1
    //     }
    // }).val('');
    // var input = $("#line_flight_days");
    //
    // if (input.data('daterangepicker')) {
    //     input.data('daterangepicker').remove();
    // }
    //
    // input.daterangepicker({
    //     "showWeekNumbers": true,
    //     "autoApply": true,
    //     "linkedCalendars": false,
    //     "locale": {
    //         "format": "MM/DD/YYYY",
    //         "separator": " - ",
    //         "applyLabel": "Apply",
    //         "cancelLabel": "Cancel",
    //         "fromLabel": "From",
    //         "toLabel": "To",
    //         "customRangeLabel": "Custom",
    //         "weekLabel": "#",
    //         "daysOfWeek": [
    //             "U",
    //             "M",
    //             "T",
    //             "W",
    //             "R",
    //             "F",
    //             "S"
    //         ],
    //         "firstDay": 1
    //     }
    // }).val('');

    $('#app-invoices-table thead tr')
        .clone(true)
        .addClass('filters')
        .appendTo('#app-invoices-table thead');
   var app_invoices_table = $('#app-invoices-table').DataTable({
        // orderCellsTop: true,
        //   fixedHeader: true,
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/invoices',
            dataSrc: 'data'
        },
        columns: [
            {data: 'match_id'},//0
            {data: 'match_id'},//1
            {data: 'invoice_number'},//2
            {data: 'advertiser_name'},//3
            {data: 'campaign_name'},//4
            {data: 'full_market'},//5
            {data: 'inv_type'},//6
            {data: 'station_name'},//7
            {data: 'total'},//8
            {data: 'invoice_period_start_date'},//9
            {data: 'invoice_date'},//10
            {data: 'status'},//11
            {data: 'created_at_format'},//12
            {data: 'estimate_number'},//13
            {data: 'id'},//14
            {data: 'multiple_match'},//15
            {data: 'broadcast_month'},//16
            {data: 'match_id'},//17
            {data: 'match_net_rate'},//18

        ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 18,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 16,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 17,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 1,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData rowData', rowData);
                    // if(cellData <= 0)
                    if(typeof rowData.order_revision_id !== 'undefined')
                        var or_rev = rowData.order_revision_id;
                    else
                        var or_rev = 0;
                    var html = ' <div class="checkbox checkbox-danger invoices_check">' +
                        ' <input class="checkbox input_checkbook_invo" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_invoices[]" ' +
                        'value="' + rowData.id + '" data-campaign="' + rowData.campaign_id + '" data-month="' + rowData.broadcast_month + '" data-row="' + row + '" data-order-rev="'+or_rev+'"' +
                        'data-total-only ="'+rowData.total_only+'" data-match_type = "'+ rowData.match_net_rate+'">' +
                        '<label for="' + rowData.id + '"> </label></div>';

                    $(td).html(html);
                }
            },
            {
                "targets": 3,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                }
            },
            {
                "targets": 4,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                }
            },
            {
                "targets": 8,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(parseFloat(cellData).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        //minimumFractionDigits: 2
                    }));
                }
            },
            {
                "targets": 9,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '';
                    if(rowData.invoice_period_start_date !== null && rowData.invoice_period_end_date !== null && rowData.invoice_period_start_date !== '' && rowData.invoice_period_end_date !== '') {
                        var start = moment(rowData.invoice_period_start_date);
                        var end = moment(rowData.invoice_period_end_date);
                        html = start.format('MM/DD/YY') + ' to ' + end.format('MM/DD/YY');
                    }
                    else
                        html = moment(rowData.broadcast_month).startOf('month').format('MM/DD/YY') + ' to ' + moment(rowData.broadcast_month).endOf('month').format('MM/DD/YY');


                    $(td).html(html);
                }
            },
            {
                "targets": [10],
                "createdCell": function (td, cellData, rowData, row, col) {
                    var date = moment(cellData);
                    html = '';
                    html = date.format('MM/DD/YY');

                    $(td).html(html);
                }
            },
            {
                "targets": [11],
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '';
                    if (cellData == 'Parsed')
                        html = 'Entered';
                    else
                        html = cellData;

                    $(td).html(html);

                }
            },
            {
                "targets": 12,
                "createdCell": function (td, cellData, rowData, row, col) {
                    // var date = moment(cellData);
                    // html = '';
                    // html = date.format('MM/DD/YY hh:mm:ss a');
                    //
                    // $(td).html(html);
                },
             //   "visible": false,
            },
            {
                "targets": 14,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData_rowData_rowData_ ', rowData)
                    html = '';
                    var status = rowData.status;
                    var aux_top = 202;
                    if (status !== "Matched" && status !== "Pending Approval")
                        aux_top -= 25;
                    if (rowData.match_id > 0)
                        aux_top -= 55;
                    if(rowData.match_id.toString().indexOf('m_') !== -1)
                        aux_top -= 85;
                    html += '<div class="dropdown pull-right" x-placement="top-start">' +
                        '<button data-id="' + cellData + '" class="btn btn-outline-primary btn-sm" type="button" data-toggle="dropdown">' +
                        '                                            <i class="fa fa-list">    </i> Actions' +
                        '                                            <span class="caret"></span>' +
                        '                                        </button>' +
                        '                                        <ul style="z-index: 9999999;position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-46px, -' + aux_top + 'px, 0px);" class="dropdown-menu" role="menu" x-placement="top-end">';
                    if(rowData.id.toString().indexOf('m_') !== -1){
                        html += '<li> <a href="javascript:void(0)" role="button"  id=""  class="invoice_preview_manual" ><i class="fa fa-eye">  </i> Preview </a></li>'
                        + '<li><a href="javascript:void(0)"  class="invoice_print_standar" data-id=" ' + rowData.id.toString().split('m_')[1] + '" onclick="printManualInvoice(' + rowData.id.toString().split('m_')[1] + ')"><i class="fa fa-print">  </i> Print </a></li>';
                        if (status === "Matched") {
                            html += '<li><a href="javascript:void(0)"  class="invoice_archive_manual" data-id=" ' + cellData + '" onclick="archiveInvoiceManual(' + rowData.id.toString().split('m_')[1] + ')"><i class="fa fa-archive">  </i> Archive </a></li>';
                        }
                        if (!rowData.total_only) {
                            html += '<li><a href="javascript:void(0)" role="button"  id="search_order_manual" row-id="' + row + '" multiple_match="'+ rowData.multiple_match +'" onclick="searchManaualInvOrder('+rowData.id.toString().split('_')[1]+', '+ rowData.order_revision_id +', '+ rowData.multiple_match+', '+ row +')" data-invoice-num="' + rowData.invoice_number + '" data-invoice-id="' + rowData.id.toString().split('_')[1] + '"><i class="ti-check">  </i> Match </a></li>';
                            html += '<li><a href="javascript:void(0)" role="button"  class="invoice_print_manual_sh_table" data-id="' + rowData.id.toString().split('_')[1] + '" data-row="' + row + '"> <i class="fa fa-calendar">  </i> Schedule Match </a></li>';

                        }else
                            html += '<li><a href="javascript:void(0)" role="button" id="schedule_match_manual" onclick="scheduleMatch('+ rowData.id.toString().split('_')[1] +')" row-id="' + row + '"><i class="fa fa-calendar">  </i> Schedule Match </a></li>';

                        html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_delete_manual" data-id="' + rowData.id.toString().split('_')[1] + '" data-row="' + row + '"><i class="fa fa-trash-o">  </i> Delete </a></li>';
                        html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_change_order_revision_manual" data-totals-only ="'+ rowData.total_only+'" data-id="' + rowData.id.toString().split('_')[1] + '" data-row="' + row + '"><i class="fa fa-pencil-square">  </i> Edit </a></li>';
                        html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_manual_attachments_dt" data-totals-only ="'+ rowData.total_only+'" data-id="' + rowData.id.toString().split('_')[1] + '" data-number="' + rowData.invoice_number + '"><i class="fa fa-paperclip">  </i> Attachments </a></li>';

                        }
                    else {
                        if (status === "Matched" || status === "Pending Approval" || status == 'Entered') {
                            html += '<li><a href="javascript:void(0)"  class="invoice_archive_standar" data-id=" ' + cellData + '" onclick="archiveInvoice(' + cellData + ')"><i class="fa fa-archive">  </i> Archive </a></li>';
                        }
                        html += '<li> <a href="javascript:void(0)" role="button"  id=""  class="invoice_preview" ><i class="fa fa-eye">  </i> Preview </a></li>' +
                            '<li><a href="javascript:void(0)"  class="invoice_print_standar" data-id=" ' + cellData + '" onclick="printInvoice(' + cellData + ')"><i class="fa fa-print">  </i> Print </a></li>' +
                            '<li><a href="javascript:void(0)" role="button" data-target="searchOrdenToMach"  id="search_order" row-id="' + row + '"  data-invoice-num="' + rowData.invoice_number + '"  data-invoice-id="' + rowData.id + '" class="order-button-search" data-match_type="'+ rowData.match_net_rate +'"><i class="ti-check">  </i> Match </a></li>';
                        html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_delete" data-id="' + rowData.id + '" data-row="' + row + '"><i class="fa fa-trash-o">  </i> Delete </a></li>';

                        var start = moment(rowData.invoice_period_start_date).format('MM/DD/YY');
                        var end = moment(rowData.invoice_period_end_date).format('MM/DD/YY');

                        html += '<li><a href="javascript:void(0)" role="button"  data-start-date="' + start + '"  data-end-date="' + end + '"  class="invoice_split" data-row="' + cellData + '"><i class="ti-split-h">  </i> Split </a></li>';
                        if (rowData.match_id > 0)
                            html += '<li><a href="javascript:void(0)" role="button" data-match=" '+rowData.match +' " id="" data-id="' + rowData.id + '" class="invoice_print_imported_sh_table" data-row="' + row + '"> <i class="fa fa-calendar">  </i> Schedule Match</a></li>';

                        html += '<li class="dropdown-submenu pull-left">' +
                            '    <a tabindex="0" data-toggle="dropdown"><i class="fa fa-pencil-square"></i> Edit</a>';
                        html += '<ul class="dropdown-menu pull-left">' +
                            '<li> <a href="#" class="invoice_change_camp" data-id=" ' + rowData.id + '" data-row="' + cellData + '" ><i class="fa fa-television fa-fw"></i> Adv/Camp</a></li>' +
                            '<li> <a href="#" class="invoice_change_lines" data-id=" ' + rowData.id + '" data-row="' + row + '"><i class="fa fa-list"></i> Invoice Lines</a></li>' +
                            '    </ul></li>';

                        // html += '<li><a href="javascript:void(0)" role="button"  class="invoice_change_camp" data-id="' + rowData.id + '" data-row="' + cellData + '"><i class="fa fa-pencil-square">  </i> Change Campaign </a></li>';
                        // html += '<li><a href="javascript:void(0)" role="button"  class="invoice_change_lines" data-id="' + rowData.id + '" data-row="' + cellData + '"><i class="fa fa-pencil-square">  </i> Edit </a></li>';
                    }
                    html += '</ul>';
                    html += '</div>';
                    $(td).html(html);
                }
            },
            {
                "targets": 15,
                "visible": false,
                "searchable": false,
            },
        ],
        "createdRow": function (row, data, dataIndex) {
            $(row).attr('data-invoice-id', data.id);
        },
       orderCellsTop: true,
       initComplete: function () {
           var api = this.api();

           // For each column
           api
               .columns()
               .eq(0)
               .each(function (colIdx) {
                   // Set the header cell to contain the input element
                   var cell = $('#app-invoices-table .filters th').eq(
                       $(api.column(colIdx).header()).index()
                   );
                   var title = $(cell).text();
                   if (title !== '' && title !== null && title.indexOf('Print') === -1) {
                       if (title === 'Flight Dates' || title === 'Invoice Date' || title === 'Last Accessed' || title === 'Due Date' || title === 'Exported') {
                           $(cell).html('<input style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input datepicker" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text" />');
                       } else if (title === 'Type') {
                           $(cell).html('<select style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text"><option value=""></option><option value="Manual">Manual</option><option value="Imported">Imported</option></select>');
                       } else {
                           $(cell).html('<input style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text" />');
                       }
                   } else {
                       $(cell).html('');
                   }

                   // On every keypress in this input
                   $(
                       'input,select',
                       $('#app-invoices-table .filters th').eq($(api.column(colIdx).header()).index())
                   )
                       .off('keyup change')
                       .on('keyup change', function (e) {
                           e.stopPropagation();

                           // Get the search value
                           $(this).attr('title', $(this).val());
                           var regexr = '{search}'; //$(this).parents('th').find('select').val();

                           var cursorPosition = this.selectionStart;
                           // Search the column for that value
                           api
                               .column(colIdx)
                               .search(
                                   this.value != ''
                                       ? regexr.replace('{search}', this.value)
                                       : '',
                                   this.value != '',
                                   this.value == ''
                               )
                               .draw();

                           $(this)
                               .focus()[0]
                               .setSelectionRange(cursorPosition, cursorPosition);
                       });
               });
               $('#app-invoices-table .table-column-search-input.datepicker').each(function(){
                    $(this).datepicker({
                       format: "mm/dd/yyyy",
                       autoclose: true,
                       clearBtn: true,
                       orientation: "bottom"
                   });
               });
               $('[data-toggle="tooltip"]').tooltip();
           app_invoices_table.columns(12).visible(false);
       }

    });


    // $('#app-invoices-table-archived thead tr').clone(true).appendTo( '#app-invoices-table-archived thead' );
    // $('#app-invoices-table-archived thead tr:eq(1) th').each( function (i) {
    //     if(i > 1 && i < 11) {
    //         var title = $(this).text();
    //         $(this).html('<input style="width: 100%" type="text" />');
    //
    //         $('input', this).on('keyup change', function () {
    //             if (app_invoices_table_archived.column(i).search() !== this.value) {
    //                 app_invoices_table_archived
    //                     .column(i)
    //                     .search(this.value)
    //                     .draw();
    //             }
    //         });
    //     }
    // } );
    $('#app-invoices-table-archived thead tr')
        .clone(true)
        .addClass('filters')
        .appendTo('#app-invoices-table-archived thead');
    var app_invoices_table_archived = $('#app-invoices-table-archived').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: "/invoices/archivated?view_type=" + $('.invoices_filters').attr('data-value'),
            dataSrc: 'data'
        },
        columns: [
            {data: 'rec'},//0
            {data: 'rec'},//1
            {data: 'invoice_number'},//2
            {data: 'advertiser_name'},//3
            {data: 'campaign_name'},//4
            {data: 'full_market'},//5
            {data: 'inv_type'},//6
            {data: 'station_name'},//7
            {data: 'total'},//8
            {data: 'invoice_period_start_date'},//9
            {data: 'invoice_date'},//10
            {data: 'due_date'},//11
            {data: 'created_at_format'},//12
            {data: 'exported_string'},//13
            {data: 'id'},//14
            {data: 'multiple_match'},//15
            {data: 'broadcast_month'},//16
            {data: 'match_id'},//17


        ],
        // order: [ 0, "asc" ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
              //  "visible": false,
                "searchable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData_archived', rowData)
                    if(rowData.rec > 0 || rowData.id.toString().indexOf('m_') !== -1) {
                        var html = '<div class="checkbox checkbox-danger invoices_arch_check"> ' +
                            '<input class="checkbox" class="form-control" type="checkbox"  id="sel_ar_' + cellData + '" name="selected_invooices_check[]" value="' + rowData.id + '" data-row="'+ row +'"><label for="sel_ar_' + cellData + '"> </label></div>';
                        $(td).html(html);
                    }
                    else
                        $(td).html('');
                }
            },
            {
                "targets": 13,
                "searchable": false,
            },
            {
                "targets": 15,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 16,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 17,
                "visible": false,
                "searchable": false,
            },
            {
                "targets": 8,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(parseFloat(cellData).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        //minimumFractionDigits: 2
                    }));
                }
            },
            {
                "targets": 1,
                "orderable": false,
                "visible": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    if(cellData > 0)
                        var html = ' <div class="checkbox checkbox-danger invoices_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_invoices[]" value="' + rowData.id + '"   data-row="'+row+'"><label for="'+rowData.id+'"> </label></div>';
                    else
                        var html = ' <div class="checkbox checkbox-danger invoices_check"> <input class="checkbox"  disabled class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_invoices[]" value="' + rowData.id + '"  data-row="'+row+'"><label for="'+rowData.id+'"> </label></div>';

                    $(td).html(html);
                }
            },
            {
                "targets": 3,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                }
            },
            {
                "targets": 4,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                }
            },
            {
                "targets": 9,
                "createdCell": function (td, cellData, rowData, row, col) {
                    html = '';
                    var start = moment(rowData.invoice_period_start_date);
                    var end = moment(rowData.invoice_period_end_date);
                    html = start.format('MM/DD/YY') + ' to ' + end.format('MM/DD/YY');
                    $(td).html(html);
                }
            }, {
                "targets": [10, 11],
                "createdCell": function (td, cellData, rowData, row, col) {
                    html = '';
                    if(typeof cellData !== "undefined" && cellData !== "" && cellData !== null) {
                        var date = moment(cellData);
                        html = date.format('MM/DD/YY');
                    }
                    $(td).html(html);
                }
            }, {
                "targets": 12,
                "createdCell": function (td, cellData, rowData, row, col) {
                    // var date = moment(cellData);
                    // html = '';
                    // html = date.format('MM/DD/YY hh:mm:ss a');
                    // $(td).html(html);
                },
                "visible": true,
            },
            {
                "targets": 14,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html_export = '';
                    if(rowData.exported_string.indexOf('Quickbooks Online') !== -1)
                        html_export += '<li><a href="javascript:void(0)" role="button"  id="invoice_accounting_info"  class="invoice_accounting_info" data-id="' + cellData + '"><i class="ti-help-alt "></i> Accounting Info</a></li>';

                    html='';
                    html += '<div class="dropdown pull-right" x-placement="top-start">' +
                        '<button data-id="' + cellData + '" class="btn btn-outline-primary btn-sm" type="button" data-toggle="dropdown">' +
                        '                                            <i class="fa fa-list">    </i> Actions' +
                        '                                            <span class="caret"></span>' +
                        '                                        </button>' +
                        '                                        <ul style="z-index: 9999999;position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-100px, -100px, 0px);" class="dropdown-menu" role="menu" x-placement="top-end">';
                    if(rowData.id.toString().indexOf('m_') === -1) {
                        html += '<li><a href="javascript:void(0)" role="button" class="invoice_preview" id="" tabindex="0"><i class="fa fa-eye"></i> Preview</a></li>\n';
                        html += '<li><a href="javascript:void(0)"  class="invoice_print" data-id=" ' + cellData + '" onclick="printInvoice(' + cellData + ')"><i class="fa fa-print"></i> Print </a></li>';

                        if (rowData.rec > 0) {
                            html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_active_reconciled" data-id="' + cellData + '"><i class="ti-check"></i> Activate </a></li>';

                            html += '<li class="dropdown-submenu pull-left">' +
                                '    <a tabindex="0" data-toggle="dropdown"><i class="fa fa-print fa-fw"></i> Reports</a>';
                            html += '<ul class="dropdown-menu pull-left">' +
                                '<li> <a href="#" class="print_rec_archivated" data-id=" ' + rowData.rec + '" row-id="' + row + '" ><i class="fa fa-list"></i> Invoice-Schedule Matching</a></li>' +
                                '<li> <a href="#" class="weekly_breakout_archivated" data-id="' + rowData.rec + '" row-id="' + row + '"><i class="fa fa-calendar"></i> Weekly Breakout Report</a></li>' +
                                '<li> <a href="#" class="rotation_analysis_archivated" data-id="' + rowData.rec + '" row-id="' + row + '"><i class="fa fa-barcode"></i> Rotation Analysis</a></li>' +
                                '<li> <a href="#" class="spot_rotation_archivated" data-id="' + rowData.rec + '" row-id="' + row + '"><i class="fa fa-pagelines"></i> Spot Pattern </a></li>' ;
                              html += html_export;
                             html +=   '    </ul></li>';
                        } else {
                            html += '<li><a href="javascript:void(0)"  id=""  class="invoice_active" data-id="' + cellData + '"><i class="ti-check"></i> Activate</a></li>';
                        }
                    }else{
                        html += '<li> <a href="javascript:void(0)" role="button"  id=""  class="invoice_preview_manual" ><i class="fa fa-eye">  </i> Preview </a></li>'
                            + '<li><a href="javascript:void(0)"  class="invoice_print_standar" data-id=" ' + rowData.id.toString().split('m_')[1] + '" onclick="printManualInvoice(' + rowData.id.toString().split('m_')[1] + ')"><i class="fa fa-print">  </i> Print </a></li>';
                        html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_active" data-id="' + rowData.id + '"><i class="ti-check"></i> Activate </a></li>';
                        if (!rowData.total_only) {
                            html += '<li class="dropdown-submenu pull-left">' +
                                '    <a tabindex="0" data-toggle="dropdown"><i class="fa fa-print fa-fw"></i> Reports</a>';
                            html += '<ul class="dropdown-menu pull-left">' +
                                '<li> <a href="#" class="print_rec_archivated_man" data-id=" ' + rowData.id + '" row-id="' + row + '" data-multiple-match="'+rowData.multiple_match+'"><i class="fa fa-list"></i> Invoice-Schedule Matching</a></li>' +
                                '<li> <a href="#" class="weekly_breakout_archivated_man" data-id="' + rowData.id + '" row-id="' + row + '" data-multiple-match="'+rowData.multiple_match+'"><i class="fa fa-calendar"></i> Weekly Breakout Report</a></li>' +
                                '<li> <a href="#" class="rotation_analysis_archivated_man" data-id="' + rowData.id + '" row-id="' + row + '" data-multiple-match="'+rowData.multiple_match+'"><i class="fa fa-barcode"></i> Rotation Analysis</a></li>' +
                                '<li> <a href="#" class="spot_rotation_archivated_man" data-id="' + rowData.id + '" row-id="' + row + '" data-multiple-match="'+rowData.multiple_match+'"><i class="fa fa-pagelines"></i> Spot Pattern </a></li>' +
                                '    </ul></li>';
                        }else
                            html += '<li><a href="javascript:void(0)" role="button" id="schedule_match_manual" onclick="scheduleMatch('+ rowData.id.toString().split('_')[1] +')" row-id="' + row + '"><i class="fa fa-calendar">  </i> Schedule Match </a></li>';

                        html += html_export;
                        html += '<li><a href="javascript:void(0)" role="button"  id=""  class="invoice_manual_attachments_dt_ar" data-totals-only ="'+ rowData.total_only+'" data-id="' + rowData.id.toString().split('_')[1] + '" data-number="' + rowData.invoice_number + '"><i class="fa fa-paperclip">  </i> Attachments </a></li>';
                    }
                    if(rowData.completed === 0 )
                        html += '<li><a href="javascript:void(0)"  id=""  class="invoice_move_to_complete" data_completed="'+ rowData.completed +'" data-id="' + cellData + '"><i class="fa fa-suitcase fa-fw"></i> Complete</a></li>';
                    else
                        html += '<li><a href="javascript:void(0)"  id=""  class="invoice_move_to_complete" data_completed="'+ rowData.completed +'" data-id="' + cellData + '"><i class="fa fa-suitcase fa-fw"></i> Archive</a></li>';

                    html+=   '</ul></div>';
                    $(td).html(html);
                }
            }
        ],
        "createdRow": function (row, data, dataIndex) {
            $(row).attr('data-invoice-id', data.id);
        },
        orderCellsTop: true,
        initComplete: function () {
            var api = this.api();

            // For each column
            api
                .columns()
                .eq(0)
                .each(function (colIdx) {
                    // Set the header cell to contain the input element
                    var cell = $('#app-invoices-table-archived .filters th').eq(
                        $(api.column(colIdx).header()).index()
                    );
                    var title = $(cell).text();
                    if (title !== '' && title !== null && title.indexOf('Print') === -1) {
                        if (title === 'Flight Dates' || title === 'Invoice Date' || title === 'Last Accessed' || title === 'Due Date' || title === 'Exported') {
                            $(cell).html('<input style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input datepicker" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text" />');
                        } else if (title === 'Type') {
                            $(cell).html('<select style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text"><option value=""></option><option value="Manual">Manual</option><option value="Imported">Imported</option></select>');
                        } else {
                            $(cell).html('<input style="width: 100%;margin-bottom: 10px;" class="form-control input-sm table-column-search-input" data-toggle="tooltip" data-placement="top" data-original-title="Search ' + title + '" type="text" />');
                        }
                    } else {
                        $(cell).html('');
                    }

                    // On every keypress in this input
                    $(
                        'input,select',
                        $('#app-invoices-table-archived .filters th').eq($(api.column(colIdx).header()).index())
                    )
                        .off('keyup change')
                        .on('keyup change', function (e) {
                            e.stopPropagation();
                            var url = encodeURI("/invoices/archivated?view_type=" + $('.invoices_filters').attr('data-value'));
                            $('#app-invoices-table-archived').DataTable().ajax.url(url);

                            // Get the search value
                            $(this).attr('title', $(this).val());
                            var regexr = '{search}'; //$(this).parents('th').find('select').val();

                            var cursorPosition = this.selectionStart;
                            // Search the column for that value
                            api
                                .column(colIdx)
                                .search(
                                    this.value != ''
                                        ? regexr.replace('{search}', this.value)
                                        : '',
                                    this.value != '',
                                    this.value == ''
                                )
                                .draw();

                            $(this)
                                .focus()[0]
                                .setSelectionRange(cursorPosition, cursorPosition);
                        });
                });
            $('#app-invoices-table-archived .table-column-search-input.datepicker').each(function(){
                $(this).datepicker({
                    format: "mm/dd/yyyy",
                    autoclose: true,
                    clearBtn: true,
                    orientation: "bottom"
                });
            });
            $('[data-toggle="tooltip"]').tooltip();
            app_invoices_table_archived.columns(12).visible(false);
            },
        headerCallback: function(row, data, start, end, display) {
            console.log('footerCallback data', row, data);
            var total = 0;
            for (var i in data)
                total += !isNaN(parseFloat(data[i].total)) ? parseFloat(data[i].total) : 0;
            total = parseFloat(total).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            });
            console.log('invoiced_header_invoiced_header_invoiced_header_', $('#app-invoices-table-archived thead  tr:not(.filters) .invoiced_header').html())
            var html = 'Invoiced: <span style="color: #F47A51">' + total + '</span>';
            $('#app-invoices-table-archived thead tr:not(.filters) .invoiced_header').html(html);

        },

    });

    //Grids to export Accounting Systems
    var columnInvExportWork = [
        {
            headerName: "Invoice Number",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Vendor ID",
            field: 'vendor_code',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Date Received",
            field: 'created_at',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Due Date",
            field: 'invoice_due_date',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Invoice Date",
            field: 'invoice_date',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "AP Account",
            field: 'ap_account',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: SelectCellEditor,
            cellEditorParams: {
                values: agency_ap_accounts,
            },
        },
        {
            headerName: "Approved By",
            field: 'approver_name',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Approved",
            field: 'approved',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Project Number",
            field: 'project_number',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Project Number (Line)",
            field: 'project_number_line',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Client ID (Line)",
            field: 'advertiser_code',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Gross Cost",
            field: 'gross_cost',
            width: 100,
            cellStyle: {'text-align': "right"},
        }, {
            headerName: "Net Cost",
            field: 'net_cost',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Item ID",
            field: 'media_type',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        // {
        //     headerName: "Project Number",
        //     field: 'project_number',
        //     width: 130,
        //     cellStyle: {'text-align': "right"}
        // },
        {
            headerName: "Quantity",
            field: 'line_quantity',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Posting Date",
            field: 'posting_day',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "GL Account",
            field: 'gl_account',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: SelectCellEditor,
            cellEditorParams: {
                values: agency_gl_accounts,
            },
        },
        {
            headerName: "Billable",
            field: 'billable',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Purchase Order Number",
            field: 'order_number',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Purchase Order Line Number",
            field: 'line_number',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Close",
            field: 'close',
            width: 130,
            cellStyle: {'text-align': "right"},
        },

    ];
    var gridInvExportWork = {
        columnDefs: columnInvExportWork,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },

    };
    var columnInvExportWorkbook = [
        {
            headerName: "Status 40",
            field: 'status',
            width: 100,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Order Number",
            field: 'order_number',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Line Number",
            field: 'line_number',
            width: 100,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Spot Link ID",
            field: 'spot_link_id',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Supplier (Name)",
            field: 'vendor_name',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Supplier ID",
            field: 'vendor_code',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Invoice Number",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Invoice Date",
            field: 'invoice_date',
            width: 220,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Currency",
            field: 'currency',
            width: 100,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Total Invoice Amount",
            field: 'total_invoice_amount',
            width: 200,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Job Number",
            field: 'job_number',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Activity",
            field: 'media_type',
            width: 150,
            cellStyle: {'text-align': "right"},

        },
        {
            headerName: "Total Amount",
            field: 'gross_approved',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Net Amount",
            field: 'net_approved',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
    ];
    var gridInvExportWorkbook = {
        columnDefs: columnInvExportWorkbook,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },

    };
    var columnInvExportWorkAPI = [
        {
            headerName: "orderLinkID",
            field: 'orderLinkID',
            width: 170,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "appliedCost",
            field: 'cost',
            width: 120,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "amountToBill",
            field: 'gross',
            width: 120,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Invoice Date",
            field: 'invoice_date',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Invoice Number",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"},
            rowGroupIndex: 0,
            hide: true,
            suppressMovable: true,
        },
        {
            headerName: "Link ID",
            field: 'link_id',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Plan ID",
            field: 'plan_id',
            width: 120,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Spot Link ID",
            field: 'spot_link_id',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Vendor ID",
            field: 'station_id',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Action",
            field: 'action',
            width: 120,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Description",
            field: 'description',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Last Invoice",
            field: 'last_invoice',
            width: 120,
            cellStyle: {'text-align': "right"},
        },

    ];
    var gridInvExportWorkAPI = {
        columnDefs: columnInvExportWorkAPI,
        defaultColDef: {
            suppressToolPanel: true
        },
        autoGroupColumnDef: {
            headerName: 'Invoice',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            cellRendererParams: {
                suppressCount: false,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
            }
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        groupRowAggNodes: function (nodes) {
            return WMJAPIAggFunction(nodes);
        },

    };
    var WMJAPIAggFunction = function (nodes){
        var result = {};
        if (nodes[0] != undefined) {
            if (nodes[0].level === 1) {
                console.log('level 1', nodes);
                result['gross'] = 0;
                result['cost'] = 0;

                $.each(nodes, function (index, value) {
                    result['gross'] += value['data']['gross'];
                    result['cost'] += value['data']['cost'];

                });
                console.log('results ', result)
            }
            result['gross'] = Number(Math.round((result['gross']) + 'e2') + 'e-2')
            result['cost'] = Number(Math.round((result['cost']) + 'e2') + 'e-2')
            return result;
        }
        else
            return false;

    };

    var columnInvExportQuick = [
        {
            headerName: "Date",
            field: 'invoice_date',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Ref. No",
            field: 'invoice_number',
            width: 200,
            cellStyle: {'text-align': "left"}
        }, {
            headerName: "Vendor",
            field: 'vendor_code',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Terms",
            field: 'terms',
            width: 100,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Bill Due",
            field: 'due_date',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Account",
            field: 'adv_gl_account',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Amount",
            field: 'gross_cost',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Memo",
            field: 'memo',
            width: 80,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Billable?",
            field: 'billable',
            width: 100,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Class",
            field: 'class',
            width: 100,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Customer Job",
            field: 'advertiser_code',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Item",
            field: 'media_type',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Cost",
            field: 'gross_cost',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Qty",
            field: 'qty',
            width: 80,
            cellStyle: {'text-align': "left"}
        },
    ];
    var gridInvExportQuick = {
        columnDefs: columnInvExportQuick,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
        },

    };

    var columnInvExportQuickRegular = [
        {
            headerName: "Supplier",
            field: 'supplier',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Terms",
            field: 'terms',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Bill Date",
            field: 'invoice_date',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Due Date",
            field: 'due_date',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Bill Number",
            field: 'invoice_number',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Account",
            field: 'advertiser_name',
            width: 200,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Line Amount",
            field: 'net_approved',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Line Tax Code",
            field: 'line_tax_code',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
    ];
    var gridInvExportQuickRegular = {
        columnDefs: columnInvExportQuickRegular,
        defaultColDef: {
            suppressToolPanel: true
        },
        defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
        },
    };

    var columnInvExportQuickAPIRegular = [
        {
            headerName: "Campaign/Vendor/Month",
            field: 'group_text',
            width: 450,
            cellStyle: {'text-align': "left"},
            rowGroupIndex: 0,
            hide: true,
            suppressMovable: true,
            groupSelectsChildren: true,
        },
        {
            headerName: "Billable",
            field: 'billable_status',
            width: 80,
            cellStyle: {'text-align': "center"},
            pinnedRowCellRenderer: BlankFormatRenderer,
            cellRenderer: CheckboxCellRenderer,
            editable: true,
        },
        {
            headerName: "Bill Number",
            field: 'invoice_number',
            width: 120,
            cellStyle: {'text-align': "left"},
            pinnedRowCellRenderer: BlankFormatRenderer,
        },
        {
            headerName: "MDF Supplier",
            field: 'supplier',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Quickbook Supplier",
            field: 'displayNameVendor',
            width: 150,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Bill Date",
            field: 'invoice_date',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Due Date",
            field: 'due_date',
            width: 120,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Advertiser",
            field: 'advertiser_name',
            width: 200,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Quickbooks Client",
            field: 'displayName',
            width: 200,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Description",
            field: 'description',
            width: 300,
            cellStyle: {'text-align': "left"}
        },
        {
            headerName: "Qty",
            field: 'qty',
            width: 80,
            cellStyle: {'text-align': "right"},
            pinned: 'right',
        },
        {
            headerName: "Amount",
            field: 'amount',
            width: 120,
            cellStyle: {'text-align': "left"},
            pinned: 'right',
            cellRenderer: CurrencyFormatRenderer,
        },
        {
            headerName: "Inv type",
            field: 'inv_type',
            width: 300,
            cellStyle: {'text-align': "left"},
            hide: true,
        },
        {
            headerName: "Inv Id",
            field: 'inv_id',
            width: 300,
            cellStyle: {'text-align': "left"},
            hide: true,
        },
    ];
    var gridInvExportQuickAPIRegular = {
        columnDefs: columnInvExportQuickAPIRegular,
        autoGroupColumnDef: {
            headerName: 'Campaign/ Vendor/ Month',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            cellRendererParams: {
                suppressCount: true,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
                cellRenderer:'agGroupCellRenderer',
            }
        },
        defaultColDef: {
            // width: 150,
            suppressToolPanel: true
        },
        enableColResize: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        toolPanelSuppressValues: true,
        defaultToolPanel: '',
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        groupSelectsChildren: true,
        suppressRowClickSelection: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        marryChildren: true,
        groupRowAggNodes: function (nodes) {
            return QuickbookAggNodes(nodes);
        },
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuInvoiceOrder,
    };
    function CheckboxCellRenderer() {}
    CheckboxCellRenderer.prototype.init = function(params) {
        var node = params.node;
        var colId = params.column.colId;

        if(typeof node.level !== 'undefined' && node.level !== 0) {
            // Create the cell.
            this.eGui = document.createElement('span');
            this.eGui.classList.add("ag-icon");
            console.log('bookend params', params);

            // Set the "editable" property to false so it won't open the default cell editor from AG Grid.
            if (params.colDef.editableAux == undefined)
                params.colDef.editableAux = params.colDef.editable;
            params.colDef.editable = false;

            // Configure it accordingly if it is editable.
            if (params.colDef.editableAux) {
                // Set the type of cursor.
                this.eGui.style["cursor"] = "pointer";

                // Add the event listener to the checkbox.
                function toggle() {
                    var currentValue = node.data[colId];
                    node.setDataValue(colId, !currentValue);


                    // TODO: Delete this log.
                    console.log(node.data);
                    console.log('currentValue ', currentValue);
                }

                this.eGui.addEventListener("click", toggle);
            }
        }
        else
            this.eGui = '';

        // Set if the checkbox is checked.
        this.refresh(params);
    };
    CheckboxCellRenderer.prototype.getGui = function() {
        return this.eGui;
    };
    CheckboxCellRenderer.prototype.refresh = function(params) {
        var node = params.node;
        var colId = params.column.colId;

        if(typeof node.level !== 'undefined' && node.level !== 0) {
            var checkedClass = "ag-icon-checkbox-checked";
            var uncheckedClass = "ag-icon-checkbox-unchecked";

            // Add or remove the classes according to the value.
            if (params.value) {
                this.eGui.classList.remove(uncheckedClass);
                this.eGui.classList.add(checkedClass);
            } else {
                this.eGui.classList.remove(checkedClass);
                this.eGui.classList.add(uncheckedClass);
            }
            console.log('checkedClass', checkedClass);
        }

        // Return true to tell the grid we refreshed successfully
        return true;
    }
    var QuickbookAggNodes  = function(nodes){
        var result = {};
        result['qty'] = 0;
        result['amount'] = 0;
        console.log('nodes ', nodes);
        if(typeof nodes[0] !== 'undefined' && nodes[0].level === 1){
            $.each(nodes, function (index_0, value_1) {
                for (var index in value_1.data) {
                    var data = value_1.data[index];
                    if (index !== 'invoice_date' && index !== 'invoice_number' && index !== 'due_date' && index !== 'qty' && index !== 'amount' && index !== 'billable_status')
                        result[index] = data;
                    else if (index === 'qty')
                        result[index] += !isNaN(parseInt(data)) ? parseInt(data) : 0;
                    else if (index === 'amount')
                        result[index] += !isNaN(parseFloat(data)) ? parseFloat(data) : 0;
                }
            });
            console.log('result ', result);
            return result;
        }
        else
            return false;
    }


    var columnInvExportAdvantage = [
        {
            headerName: "VN_CODE",
            field: 'vendor_code',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "VN_NAME",
            field: 'vendor_name',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "INV_NUMBER",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "INV_DESC",
            field: 'invoice_description',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "INV_DATE",
            field: 'invoice_date',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "INVOICE_TOTAL_NET",
            field: 'invoice_total_net',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "INVOICE_TOTAL_TAX",
            field: 'invoice_total_tax',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "OFFICE_CODE",
            field: 'office_code',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "CLIENT",
            field: 'client',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "CLIENT_NAME",
            field: 'client_name',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "DIVISION",
            field: 'divison',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "DIVISION_NAME",
            field: 'divison_name',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "PRODUCT",
            field: 'product',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "PRODUCT_NAME",
            field: 'product_name',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "MEDIA_TYPE",
            field: 'media_type',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "ORDER_ID",
            field: 'order_id',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "ORDER_NUMBER",
            field: 'order_number',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "MONTH",
            field: 'month',
            width: 180,
            cellStyle: {'text-align': "right"},
            hide: false,
        },
        {
            headerName: "YEAR",
            field: 'year',
            width: 180,
            cellStyle: {'text-align': "right"},
            hide: false,
        },
        {
            headerName: "SALES_CLASS",
            field: 'sales_class',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "ORDER_LINE_ID",
            field: 'order_line_id',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "ORDER_LINE_NUMBER",
            field: 'order_line_id',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "LINE_DATE",
            field: 'line_date',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "MEDIA_QTY",
            field: 'media_qty',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "MEDIA_NET",
            field: 'media_net',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "MEDIA_VN_TAX",
            field: 'media_vn_tax',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "MEDIA_NET_CHARGE",
            field: 'media_net_charge',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "MEDIA_MARKUP_PCT",
            field: 'media_markup_pct',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "MEDIA_ADD_AMT",
            field: 'media_add_amt',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "PO_NBR",
            field: 'po_nbr',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "PO_LINE",
            field: 'po_line',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "JOB_NBR",
            field: 'job_nbr',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "COMP_NBR",
            field: 'comp_nbr',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "FNC_CODE",
            field: 'fnc_code',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "JOB_QTY",
            field: 'job_qty',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "JOB_NET",
            field: 'job_net',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "JOB_VN_Tax",
            field: 'job_vn_tax',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "JOB_COMMENT",
            field: 'job_comment',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "GL_ACCOUNT",
            field: 'gl_account',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "GL_NET",
            field: 'gl_net',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "GL_COMMENT",
            field: 'gl_comment',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },
        {
            headerName: "SOURCE_CODE",
            field: 'source_code',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable:true,
        },

    ];
    var gridInvExportAdvantage = {
        columnDefs: columnInvExportAdvantage,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuInvoiceOrder,
    };
    var columnInvExportInfo = [
        {
            headerName: "Vendor",
            field: 'vendor',
            width: 150,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Invoice Number",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Invoice Date",
            field: 'date',
            width: 130,
            cellStyle: {'text-align': "right"}
        },{
            headerName: "Month",
            field: 'month',
            width: 100,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Invoice Amount",
            field: 'invoice_gross',
            width: 150,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Order Number",
            field: 'order_number',
            width: 180,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Line Number",
            field: 'line_number',
            width: 120,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Spots",
            field: 'num_spots',
            width: 100,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Spot Rate",
            field: 'spot_rate',
            width: 100,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Agency Comission",
            field: 'agency_comision',
            width: 100,
            cellStyle: {'text-align': "right"}
        }, {
            headerName: "Total Net",
            field: 'total_net',
            width: 150,
            cellStyle: {'text-align': "right"}
        },

    ];
    var gridInvExportInfo = {
        columnDefs: columnInvExportInfo,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
    };

    var columnInvExportXero = [
        {
            headerName: "ContactName",
            field: 'contact_name',
            width: 160,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "InvoiceNumber",
            field: 'order_number',
            width: 150,
            cellStyle: {'text-align': "left"},
        },

        {
            headerName: "InvoiceDate",
            field: 'order_date',
            width: 120,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "DueDate",
            field: 'due_date',
            width: 120,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "InventoryItemCode",
            field: 'media_type',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Description",
            field: 'description',
            width: 300,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Quantity",
            field: 'quantity',
            width: 120,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "UnitAmount",
            field: 'gross_cost',
            width: 140,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
       
        {
            headerName: "AccountCode",
            field: 'advertiser_code',
            width: 120,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Currency",
            field: 'currency',
            width: 110,
            cellStyle: {'text-align': "right"}
        },
       
    ];
    var gridInvExportXero = {
        columnDefs: columnInvExportXero,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
    };

    function SelectCellEditor() {
    }

    SelectCellEditor.prototype.init = function (params) {

        this.eInput = document.createElement('select');
        var vendor_cell_input = $(this.eInput);

        vendor_cell_input.addClass('form-control ws-custom-select');

        if (typeof params.values.length == 0) {
            vendor_cell_input.append('<option value="-"></option>');
        }
        $.each(params.values, function (index, value) {
            var selected='';
            if(index === 0)
                selected='selected';
            vendor_cell_input.append('<option value="' + value + '" '+selected+'>' + value + '</option>');
        });

        if (typeof params.value !== 'undefined') {
            vendor_cell_input.val(params.value);
        } else {
            vendor_cell_input.val('-');
        }
    };

    SelectCellEditor.prototype.getGui = function () {
        return this.eInput;

    };

    SelectCellEditor.prototype.afterGuiAttached = function () {
        this.eInput.focus();
    };

    SelectCellEditor.prototype.getValue = function () {
        return this.eInput.value;

    };

    SelectCellEditor.prototype.destroy = function () {

    };

    SelectCellEditor.prototype.isPopup = function () {
        return false;
    };

    //Export Imported Invoices to Accounting
    $('#workamajig_exp_multiple').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Pleaset select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            $('#expor_work').show();
            $('#expor_manual_work').hide();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    console.log('response', response);
                    gridInvExportWork.rowData=[];
                    gridInvExportWork.rowData=response;

                    $('#invoiceExportInfoGridWork').html("");
                    var gridInvExportWorkGrid = document.querySelector('#invoiceExportInfoGridWork');
                    var g5 = new agGrid.Grid(gridInvExportWorkGrid, gridInvExportWork);
                    $('#InvoiceExportInfoWork').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoWork').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    var invoice_button_line_possible = [];
    var inv_selected_to_update_datatable = [];
    var inv_selected_to_update_datatable_exported = '';
    $('#workamajig_api_exp_multiple').on('click', function(){
        inv_selected_to_update_datatable = [];
        console.log('get in', 'get inn');
        invoice_button_line_possible = [];
        var url= $(this).attr('data-url');
        console.log('get in', 'url');
        var selectedItems = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        console.log('get in selectedItems', 'selectedItems');
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    console.log('response', response);
                    if(typeof response.text !== 'undefined'){
                        var text = "Some of the Invoice(s) you are trying to send are attached to Orders that have not been sent to Workamajig: \n"
                        for(var ind in response.text)
                            text += response.text[ind] + '\n';
                        text += 'Please send the Order(s) and try again.';
                        var type = 'warning';
                        var title = 'Warning!';
                        swal({
                                title: title,
                                text: text,
                                type: type,
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Ok",
                                cancelButtonText: "Cancel",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                }
                            });
                    }
                    else {
                        invoice_button_line_possible = response.invoice_button_line_possible;
                        gridInvExportWorkAPI.rowData = [];
                        var order_by = ['invoice_number', 'spot_link_id']
                        var sorted = multisort(response.grid_lines, order_by)
                        gridInvExportWorkAPI.rowData = sorted;

                        $('#invoiceExportInfoGridWorkAPI').html("");
                        var gridInvExportWorkGrid = document.querySelector('#invoiceExportInfoGridWorkAPI');
                        var g5 = new agGrid.Grid(gridInvExportWorkGrid, gridInvExportWorkAPI);
                        $('#InvoiceExportInfoWorkAPI').modal({backdrop: 'static', keyboard: false})
                        $('#InvoiceExportInfoWorkAPI').modal('show');
                    }
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    $('#advantage_exp_multiple').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            $('#expor_advantage').show();
            $('#expor_manual_advantage').hide();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    gridInvExportAdvantage.rowData=[];
                    gridInvExportAdvantage.rowData=response;

                    $('#invoiceExportInfoGridAdvantage').html("");
                    var gridInvExportWorkGrid = document.querySelector('#invoiceExportInfoGridAdvantage');
                    var g5 = new agGrid.Grid(gridInvExportWorkGrid, gridInvExportAdvantage);
                    $('#InvoiceExportInfoAdvantage').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoAdvantage').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    $('#expor_advantage').on('click', function(){
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "AP_Import_Generic_Media_Various",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        params.fileName = 'AP_Import_Generic_Media_Various.csv';
        gridInvExportAdvantage.api.exportDataAsCsv(params);
        save_exported_date('Advantage');
    });
    var invoices_exported_workbook_general = [];
    $('#workbook_exp_multiple').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    console.log('response', response);
                    gridInvExportWorkbook.rowData=[];
                    gridInvExportWorkbook.rowData=response.data;
                    invoices_exported_workbook_general = response.modify_invoices;

                    $('#invoiceExportInfoGridWorkbook').html("");
                    var gridInvExportWorkGrid = document.querySelector('#invoiceExportInfoGridWorkbook');
                    var g5 = new agGrid.Grid(gridInvExportWorkGrid, gridInvExportWorkbook);
                    $('#InvoiceExportInfoWorkbook').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoWorkbook').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });

    $('#expor_work').on('click', function() {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        params.fileName = 'export.csv';
        gridInvExportWork.api.exportDataAsCsv(params);
        save_exported_date('Workamajig');

    });
    $('#expor_workbook').on('click', function() {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        params.fileName = 'export.csv';
        gridInvExportWorkbook.api.exportDataAsCsv(params);
        save_exported_date('WorkBook');

    });
    $('#expor_work_api').on('click', function() {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
        };
        params.fileName = 'export.csv';
        gridInvExportWorkAPI.api.exportDataAsCsv(params);


    });
    var invButtonLineColumnDeft = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Invoice ID",
            field: 'inv_id',
            width: 150,
            cellStyle: {'text-align': "right"},
            hide: true
        },
        {
            headerName: "Invoice Number",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Invoice Month",
            field: 'invoice_month',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Invoice Type",
            field: 'invoice_type',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
    ];
    var gridInvButtonLine = {
        columnDefs: invButtonLineColumnDeft,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },

    };

    $('#sent_to_workamajig').on('click',  function(){
        // if(invoice_button_line_possible.length > 0){
        //     gridInvButtonLine.rowData = [];
        //     gridInvButtonLine.rowData = invoice_button_line_possible;
        //     $('#invoiceButtonLineGrid').html("");
        //     var gridInvButtonLineGrid = document.querySelector('#invoiceButtonLineGrid');
        //     var g5 = new agGrid.Grid(gridInvButtonLineGrid, gridInvButtonLine);
        //     $('#InvoiceButtonLineModal').modal('show');
        // }
        // else
            send_to_WMJ([]);
    });
    $('#sent_to_workamajig_json').on('click',  function() {
        send_to_WMJ({download: "json"});
    });
    $('#select_all_inv_button_line').on('click', function (e) {
        gridInvButtonLine.api.selectAll();
    });
    $('#deselect_all_inv_button_line').on('click', function (e) {
        gridInvButtonLine.api.deselectAll();
    });

    $('#sent_to_workamajig_next').on('click',  function(){
        var params = gridInvButtonLine.api.getSelectedNodes();
        var array = [];

        for(var ind in params)
            array.push(params[ind].data['type_inv_id']);

        send_to_WMJ(array);
        $('#InvoiceButtonLineModal').modal('hide');
    });

   function send_to_WMJ(button_line){
       init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
       var url= '/invoices/send/workamajig/api/info';
       var selectedItems = [];
       $('.invoices_arch_check input[type=checkbox]').each(function () {
           if (this.checked)
               selectedItems.push($(this).val());
       });
       var params = {
           invoices: selectedItems,
           button_line: button_line,
           download: typeof button_line['download'] !== 'undefined' && button_line['download'] === 'json' ? true : false,
       };

       $.ajax({
           type: 'POST',
           headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
           data: JSON.stringify(params),
           url: url,
           dataType: "json",
           contentType: "application/json",
           success: function (data) {
               if(typeof data.download !== 'undefined') {
                   var element = document.createElement('a');
                   element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data.json));
                   element.setAttribute('download', 'WMJ_json');

                   element.style.display = 'none';
                   document.body.appendChild(element);

                   element.click();
                   close_progress_loader();
               }
               else {
                   var type = '';
                   var title = '';
                   if (typeof data.text !== 'undefined') {
                       var text = "Some of the Invoice(s) you are trying to send are attached to Orders that have not been sent to Workamajig: \n"
                       for (var ind in data.text)
                           text += data.text[ind] + '\n';
                       text += 'Please send the Order(s) and try again.';
                       var type = 'warning';
                       var title = 'Warning!';
                   } else if (data === false) {
                       var text = "Your user has no integration with Workamajig, please go to Agency Settings and make the integration.";
                       var type = 'warning';
                       var title = 'Warning!';
                   } else if (data == 400) {
                       var text = "An error has happened! Please contact GaleForceMedia support team.";
                       var type = 'error';
                       var title = 'Error!';
                   } else {
                       var time = 'Workamajig API ' + moment().format('MMM D, YYYY');
                       for (var i in inv_selected_to_update_datatable)
                           app_invoices_table_archived.cell(inv_selected_to_update_datatable[i], 13).data(time);

                       var text = "The Invoice(s) have been sent successfully!";
                       var type = 'success';
                       var title = 'Success!';
                   }
                   close_progress_loader();
                   swal({
                           title: title,
                           text: text,
                           type: type,
                           showCancelButton: true,
                           confirmButtonClass: "btn-danger",
                           confirmButtonText: "Ok",
                           cancelButtonText: "Cancel",
                           closeOnConfirm: true,
                           closeOnCancel: true
                       },
                       function (isConfirm) {
                           if (isConfirm) {
                           }
                       });
               }

               },
           error: function (xhr) {
               ajax_error();
               debug(xhr.responseText);
               close_progress_loader();
           }
       });
   }

    $('#quickbooks_exp_multiple').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    gridInvExportQuick.rowData=[];
                    gridInvExportQuick.rowData = response;

                    $('#invoiceExportInfoGridQuick').html("");
                    var gridInvExportQuickGrid = document.querySelector('#invoiceExportInfoGridQuick');
                    var g5 = new agGrid.Grid(gridInvExportQuickGrid, gridInvExportQuick);
                    $('#InvoiceExportInfoQuick').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoQuick').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    $('#expor_quick').on('click', function() {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "quickbooks",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        // params.fileName = 'quickbooks.csv';
        // gridInvExportQuick.api.exportDataAsCsv(params);

        var content = gridInvExportQuick.api.getDataAsExcel(params);
        var workbook = XLSX.read(content, {type: 'binary'});
        var xlsxContent = XLSX.writeFile(workbook, 'QuickBooks Enterprise Invoice Export ' + moment().format('MM-DD-YYYY') + ' .xlsx', {
            bookType: 'xlsx',
            type: 'base64'
        });
        save_exported_date('QuickBooks Enterprise ');

    });

    $('#xero_exp_multiple').on('click', function(){
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }else {
            init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/export/multiple/xero/info',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('data gridInvExportXero', data)
                    gridInvExportXero.rowData = [];
                    gridInvExportXero.rowData = data;
                    $('#invoiceExportInfoGriXero').html("");
                    var gridInvExportXeroGrid = document.querySelector('#invoiceExportInfoGriXero');
                    var g5 = new agGrid.Grid(gridInvExportXeroGrid, gridInvExportXero);
                    $('#InvoiceexportXeroModal').modal('show');
                    close_progress_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                    close_progress_loader();
                }
            });
        }
    });
    $('#expor_xero').on('click', function() {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        params.fileName = 'Xero Export Invoices.csv';
        gridInvExportXero.api.exportDataAsCsv(params);
        save_exported_date('Xero');
    });


    $('#quickbooks_exp_multiple_regular').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    gridInvExportQuickRegular.rowData = [];
                    gridInvExportQuickRegular.rowData = response;

                    $('#invoiceExportInfoGridQuickRegular').html("");
                    var gridInvExportQuickGrid = document.querySelector('#invoiceExportInfoGridQuickRegular');
                    var g5 = new agGrid.Grid(gridInvExportQuickGrid, gridInvExportQuickRegular);
                    $('#InvoiceExportInfoQuickRegular').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoQuickRegular').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    $('#quickbooks_api_exp_multiple_regular').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {

                    if(response.length === 0) {
                        $('#expor_quick_api_regular_copy').attr('disabled', 'disabled');
                        $('#generalWarningModalDiv').html('Invoices selected belong to an advertiser or vendor without Intuit Quickbooks integration.');
                        $('#generalWarningModal').modal('show');
                    }else {
                        $('#expor_quick_api_regular_copy').removeAttr('disabled');
                    }

                    gridInvExportQuickAPIRegular.rowData = [];
                    gridInvExportQuickAPIRegular.rowData = response;

                    $('#invoiceExportInfoGridQuickAPIRegular').html("");
                    var gridInvExportQuickAPIGrid = document.querySelector('#invoiceExportInfoGridQuickAPIRegular');
                    var g5 = new agGrid.Grid(gridInvExportQuickAPIGrid, gridInvExportQuickAPIRegular);
                    $('#InvoiceExportInfoQuickAPIRegular').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoQuickAPIRegular').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });

    $('#expor_quick_api_regular_copy').on('click',  function(){
        $('#selectAccountModal').modal('show');
    });

    $('#AccountBasedExpenseLine').on('click',  function(){
        if($('#AccountBasedExpenseLine').is(':checked')) {
            $('#divAccounts').show();
            fillQuickbooksAccount();
        }else{
            $('#divAccounts').hide();
        }
    });

    $('#ItemBasedExpenseLine').on('click',  function(){
        if($('#ItemBasedExpenseLine').is(':checked')) {
            $('#divAccounts').hide();
        }else{
            $('#divAccounts').show();
            fillQuickbooksAccount();
        }
    });

    $('.send_invoice_quickbook_online').on('click',  function(){
        var type = $(this).attr('id');
        var ok = true;
        if(type === 'q_onli_tog') {
            gridInvExportQuickAPIRegular.api.forEachNode(function (node) {
                if(node.level === 0 && node.childrenAfterFilter.length > 1) {
                    var checked = {billable: 0, not_billable: 0};
                    console.log('node_node', node)
                    $.each(node.childrenAfterFilter, function (index, value_1) {
                        console.log('value_1', value_1)
                        for (var index in value_1.data) {
                            if (index === 'billable_status') {
                                var data = value_1.data[index];
                                console.log('billable_status', data)
                                if (data === 1)
                                    checked.billable++;
                                else
                                    checked.not_billable++;
                            }
                        }

                    });
                    console.log('checked' , checked);
                    if( checked.not_billable > 0 &&  checked.billable > 0)
                        ok = false;
                }
            });
        }
        if(ok === false){
            swal({
                    title: "Warning!",
                    text: 'Some of the invoices you are trying to send  "Together as one" has different Billing Status',
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else {
            if ($('#ItemBasedExpenseLine').is(':checked')) {
                init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
                var url = $(this).attr('data-url-item');
                var selectedItems = [];
                inv_selected_to_update_datatable = [];
                $('.invoices_arch_check input[type=checkbox]').each(function () {
                    if (this.checked) {
                        selectedItems.push($(this).val());
                        inv_selected_to_update_datatable.push($(this).attr('data-row'));
                    }
                });
                if (type === 'q_onli_ind') {
                    var rows = [];
                    var invoices = {manual: [], imported: []};
                    gridInvExportQuickAPIRegular.api.forEachNode(function (node) {
                        if (node.level === 1) {
                            rows.push(node.data);
                            invoices[node.data.inv_type].push(node.data.inv_id);
                        }
                    });
                } else {
                    var rows = [];
                    var invoices = {};
                    gridInvExportQuickAPIRegular.api.forEachNode(function (node) {
                        if (node.level === 0) {
                            console.log('node level 0 ', node)
                            var result = {
                                qty: 0,
                                amount: 0,
                            };
                            $.each(node.childrenAfterFilter, function (index, value_1) {
                                if (typeof invoices[value_1.data.group_text] === 'undefined')
                                    invoices[value_1.data.group_text] = {manual: [], imported: []};
                                invoices[value_1.data.group_text][value_1.data.inv_type].push(value_1.data.inv_id);
                                for (var index in value_1.data) {
                                    var data = value_1.data[index];
                                    if (index !== 'qty' && index !== 'amount')
                                        result[index] = data;
                                    else if (index === 'qty')
                                        result[index] += !isNaN(parseInt(data)) ? parseInt(data) : 0;
                                    else if (index === 'amount')
                                        result[index] += !isNaN(parseFloat(data)) ? parseFloat(data) : 0;
                                }
                            });
                            console.log('result', result);
                            rows.push(result);
                        }
                    });
                }
                console.log('rowdata: ', rows);
                var params = {
                    invoices: rows,
                    invoices_id: invoices,
                    type: type,
                };

                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: url,
                    dataType: "json",
                    contentType: "application/json",
                    success: function (data) {
                        console.log(data);
                        if (typeof data['error'] !== 'undefined') {
                            global_notification('error', data['error']['Fault']['Error'][0]['Message']);
                            if (data['error']['Fault']['Error'][0]['Detail'])
                                global_notification('error', 'Detail: ' + data['error']['Fault']['Error'][0]['Detail']);
                        } else {
                            global_notification('success', 'Invoices sent to Quickbooks successsfully.');
                            $('#selectAccountModal').modal('hide');
                            $('#InvoiceExportInfoQuickAPIRegular').modal('hide');
                            save_exported_date('Quickbooks Online');
                        }

                        close_progress_loader();
                    },
                    error: function (xhr) {
                        $('#selectAccountModal').modal('hide');
                        ajax_error();
                        debug(xhr.responseText);
                        close_progress_loader();
                    }
                });
            }
            else if ($('#AccountBasedExpenseLine').is(':checked')) {
                init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
                var url = $(this).attr('data-url-account');
                var selectedItems = [];
                inv_selected_to_update_datatable = [];
                $('.invoices_arch_check input[type=checkbox]').each(function () {
                    if (this.checked) {
                        selectedItems.push($(this).val());
                        inv_selected_to_update_datatable.push($(this).attr('data-row'));
                    }
                });
                if (type === 'q_onli_ind') {
                    var rows = [];
                    var invoices = {manual: [], imported: []};
                    gridInvExportQuickAPIRegular.api.forEachNode(function (node) {
                        if (node.level === 1) {
                            rows.push(node.data);
                            invoices[node.data.inv_type].push(node.data.inv_id);
                        }
                    });
                } else {
                    var rows = [];
                    var invoices = {};
                    gridInvExportQuickAPIRegular.api.forEachNode(function (node) {
                        if (node.level === 0) {
                            console.log('node level 0 ', node)
                            var result = {
                                qty: 0,
                                amount: 0,
                            };
                            $.each(node.childrenAfterFilter, function (index, value_1) {
                                if (typeof invoices[value_1.data.group_text] === 'undefined')
                                    invoices[value_1.data.group_text] = {manual: [], imported: []};
                                invoices[value_1.data.group_text][value_1.data.inv_type].push(value_1.data.inv_id);
                                for (var index in value_1.data) {
                                    var data = value_1.data[index];
                                    if (index !== 'qty' && index !== 'amount')
                                        result[index] = data;
                                    else if (index === 'qty')
                                        result[index] += !isNaN(parseInt(data)) ? parseInt(data) : 0;
                                    else if (index === 'amount')
                                        result[index] += !isNaN(parseFloat(data)) ? parseFloat(data) : 0;
                                }
                            });
                            console.log('result', result);
                            rows.push(result);
                        }
                    });
                }
                console.log('rowdata: ', rows);
                var params = {
                    invoices: rows,
                    account: $('#quickbooksAccount').val(),
                    invoices_id: invoices,
                    type: type,
                };

                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: url,
                    dataType: "json",
                    contentType: "application/json",
                    success: function (data) {
                        console.log(data);

                        if (typeof data['error'] !== 'undefined') {
                            global_notification('error', data['error']['Fault']['Error'][0]['Message']);
                            if (data['error']['Fault']['Error'][0]['Detail'])
                                global_notification('error', 'Detail: ' + data['error']['Fault']['Error'][0]['Detail']);
                        } else {
                            global_notification('success', 'Invoices sent to Quickbooks successsfully.');
                            $('#selectAccountModal').modal('hide');
                            $('#InvoiceExportInfoQuickAPIRegular').modal('hide');
                            save_exported_date('Quickbooks Online');
                        }
                        close_progress_loader();
                    },
                    error: function (xhr) {
                        $('#selectAccountModal').modal('hide');
                        ajax_error();
                        debug(xhr.responseText);
                        close_progress_loader();
                    }
                });
            }
            else
                global_notification('warning', 'Please select the format to send the Order/s to Quickbooks.');
        }
    });

    function fillQuickbooksAccount() {
        show_overlay_loader('#selectAccountModal');
        $.ajax({
            type: 'GET',
            url: '/analytics/quickbooks/accounts',
            dataType: 'json',
            encode: true,
            success: function (data) {
                if (typeof data['error'] !== 'undefined')
                    global_notification('error', JSON.parse(data['error'])['Fault']['Error'][0]['Message']);
                else {
                    console.log('data: ', data);
                    var html = "";
                    for (var id in data) {
                        for (var j in data[id]) {
                            if (data[id][j]['Active'])
                                html += '<option value="' + id + '_' + data[id][j]['Id'] + '_' + data[id][j]['Name'] + '">' + data[id][j]['Name'] + ' (' + data[id][j]['Classification'] + ')' + '</option>';
                        }
                    }
                    if (html === "") {
                        global_notification('error', "None of your linked Quickbooks account has valid Accounts.");
                    } else {
                        $('#quickbooksAccount').html(html);
                        $('#quickbooksAccount').select2();
                    }
                }
                hide_overlay_loader('#selectAccountModal');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_overlay_loader('#selectAccountModal');
            }
        });
    }

    $('#expor_quick_regular').on('click', function() {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "quickbooks",
            suppressTextAsCDATA: false,
            // excelStyles: excelStyles,
        };
        // params.fileName = 'quickbooks.csv';
        // gridInvExportQuick.api.exportDataAsCsv(params);

        var content = gridInvExportQuickRegular.api.getDataAsExcel(params);
        var workbook = XLSX.read(content, {type: 'binary'});
        var xlsxContent = XLSX.writeFile(workbook, 'QuickBooks Invoice Export ' + moment().format('MM-DD-YYYY') + ' .xlsx', {
            bookType: 'xlsx',
            type: 'base64'
        });
        save_exported_date('QuickBooks ');

    });


    var columnInvExportWorkCSVEpic = [
        {
            headerName: "Invoice Number",
            field: 'invoice_number',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Vendor ID",
            field: 'vendor_code',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Date Received",
            field: 'created_at',
            width: 150,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Due Date",
            field: 'invoice_due_date',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Invoice Date",
            field: 'invoice_date',
            width: 130,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "AP Account",
            field: 'ap_account',
            width: 150,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: SelectCellEditor,
            cellEditorParams: {
                values: agency_ap_accounts,
            },
        },
        {
            headerName: "Approved By",
            field: 'approver_name',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Approved",
            field: 'approved',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Project Number",
            field: 'project_number',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Project Number (Line)",
            field: 'project_number_line',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Client ID (Line)",
            field: 'advertiser_code',
            width: 180,
            cellStyle: {'text-align': "right"},
            editable: true,
        },
        {
            headerName: "Gross Cost",
            field: 'gross_cost',
            width: 100,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Net Cost",
            field: 'net_cost',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Item ID",
            field: 'media_type',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Quantity",
            field: 'line_quantity',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Posting Date",
            field: 'posting_day',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "GL Account",
            field: 'gl_account',
            width: 130,
            cellStyle: {'text-align': "right"},
            editable: true,
            cellEditor: SelectCellEditor,
            cellEditorParams: {
                values: agency_gl_accounts,
            },
        },
        {
            headerName: "Billable",
            field: 'billable',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Description (line)",
            field: 'order_number',
            width: 180,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Close",
            field: 'close',
            width: 130,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Department",
            field: 'deparment',
            width: 130,
            cellStyle: {'text-align': "right"},
        },

    ];
    var gridInvExportWorkCSVEpic = {
        columnDefs: columnInvExportWorkCSVEpic,
        defaultColDef: {
            suppressToolPanel: true
        },
        autoGroupColumnDef: {
            headerName: 'Invoice',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            cellRendererParams: {
                suppressCount: false,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
            }
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
    };
    $('#workamajig_api_exp_epic').on('click', function(){
        inv_selected_to_update_datatable = [];
        var url= $(this).attr('data-url');
        var selectedItems = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    gridInvExportWorkCSVEpic .rowData = [];
                    // var order_by = ['invoice_number']
                    // var sorted = multisort(response.grid_lines, order_by)
                    gridInvExportWorkCSVEpic.rowData = response.grid_lines;

                    $('#invoiceExportInfoGridWorkCSVEpic').html("");
                    var gridInvExportWorkCSVEpicGrid = document.querySelector('#invoiceExportInfoGridWorkCSVEpic');
                    var g5 = new agGrid.Grid(gridInvExportWorkCSVEpicGrid, gridInvExportWorkCSVEpic);
                    $('#InvoiceExportInfoWorkCSVEpic').modal({backdrop: 'static', keyboard: false})
                    $('#InvoiceExportInfoWorkCSVEpic').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    $('#export_work_api_csv_epic').on('click', function () {
        var params = {
            skipHeader: false,
            columnGroups: false,
            skipFooters: false,
            skipGroups: true,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
            suppressTextAsCDATA: false,
        };
        params.fileName = 'Workamajig CSV (EPIC).csv';
        gridInvExportWorkCSVEpic.api.exportDataAsCsv(params);
        save_exported_date('Workamajig CSV (Epic)');
    })


    //Select/Descelect all
    $('#select_all_inv_archi').on('click', function (e) {
        $('#app-invoices-table-archived input:checkbox').each(function () {
            $(this).prop('checked', true);
        });
    });
    $('#deselect_all_inv_archi').on('click', function (e) {
        $('#app-invoices-table-archived input:checkbox').prop('checked', false);
    });
    var clickFunction = function(link){
        $(link).printPage();
    }

    function printInvoice(id){
       //this.href= '/download/invoices/ '+ id;
        var id= id;
        var link = document.createElement('a');
        link.href = "/download/invoices/"+ id;
        link.onclick = clickFunction(link);
        console.log(link);
        $(link).click();
    }

    function printManualInvoice(id){
        var link = document.createElement('a');
        link.href = "/download/invoices/manual/" + id;
        link.onclick = clickFunction(link);
        console.log(link);
        $(link).click();
    }

    function archiveInvoiceConfirmedManual(){
        var id = $('#archiveInvoiceConfirmedManual').attr('data-id');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/manual/totalsonly/archive/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                global_notification('success', 'Invoice archived...');
                location.reload();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    function archiveInvoice(id){
        $('#hidden_id_to_archive').val(id)
        $('#archiveInvoiceConfirmed').show();
        $('#archiveInvoiceConfirmed').attr('data-id', id);
        $('#archiveInvoiceConfirmedManual').hide();
        $('#generalWarningModalArchiveInvoice').modal('show');
    }
    function archiveInvoiceManual(id){
        $('#hidden_id_to_archive').val(id);
        $('#archiveInvoiceConfirmed').hide();
        $('#archiveInvoiceConfirmedManual').show();
        $('#archiveInvoiceConfirmedManual').attr('data-id', id);
        $('#generalWarningModalArchiveInvoice').modal('show');
    }

    function archiveInvoiceConfirmed() {
        var id = $('#archiveInvoiceConfirmed').attr('data-id');
        var selectedItems = [id];
        var url = '/invoices/archive_multiple_invoice';
        show_loader();
        var params = {
            invoices: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                global_notification('success', 'Invoice archived...');
                window.location.href = data.redirect;
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });

    }

    $('#export_invoice_pdf').on('click', function (e) {
        var id = $(this).attr('data-invoice-id');
        var link = document.createElement('a');
        if(id.toString().indexOf('m_') === -1) {
            link.href = "/download/invoices/" + id + "/download";
        }else{
            link.href = "/download/invoices/manual/" + id.toString().split('m_')[1] + "/download";
        }
        console.log( link.href);
        $(link).attr('target', '_blank');
        link.click();
    });

    var modal = $('#invoice_display');
    modal.on('show.bs.modal', function () {
        var closeModalBtns = modal.find('button[data-custom-dismiss="modal"]');
        closeModalBtns.one('click', function () {
            modal.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (evt) {
                modal.modal('hide');
            });
            modal.removeClass('slideInUp').addClass('slideOutDown');
        })
    });

    modal.on('hide.bs.modal', function (evt) {
        var closeModalBtns = modal.find('button[data-custom-dismiss="modal"]');
        modal.removeClass('slideOutDown');
        modal.off('webkitAnimationEnd oanimationend msAnimationEnd animationend')
        closeModalBtns.off('click');
    });

    var modal1 = $('#searchOrdenToMach');
    modal1.on('show.bs.modal', function () {
        var closeModalBtns = modal1.find('button[data-custom-dismiss="modal"]');
        closeModalBtns.one('click', function () {
            modal1.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (evt) {
                modal1.modal('hide');
            });
            modal1.removeClass('slideInUp').addClass('slideOutDown');
        })
        $("#advertiser_search").val("");
        $("#advertiser_search").select2({
            placeholder: "Select one...",
        });
        $("#display_campaign_s").hide();
       // $("#display_order_s").hide();
        modal1.find('#app-orders-search-table-station tbody').html("");
    });

    modal1.on('hide.bs.modal', function (evt) {
        var closeModalBtns = modal1.find('button[data-custom-dismiss="modal"]');
        modal1.removeClass('slideOutDown');
        modal1.off('webkitAnimationEnd oanimationend msAnimationEnd animationend')
        closeModalBtns.off('click');
    });

    function getDays(value){
        var res = "";
        if(value['m'])
            res += "M";
        else
            res += '-';
        if(value['t'])
            res += "T";
        else
            res += '-';
        if(value['w'])
            res += "W";
        else
            res += '-';
        if(value['r'])
            res += "R";
        else
            res += '-';
        if(value['f'])
            res += "F";
        else
            res += '-';
        if(value['s'])
            res += "S";
        else
            res += '-';
        if(value['u'])
            res += "U";
        else
            res += '-';
        return res;
    }

    var week_aux = null;
    var columnOLinesDefs = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Line #",
            field: 'line_num',
            width: 65,
        },
        {
            headerName: "Network",
            field: 'network',
            width: 100,
        },
        {
            headerName: "Zone",
            field: 'zone',
            width: 100,
        },
        {
            headerName: "Program",
            field: 'program',
            width: 100,
        },
        ,{
            headerName: "M",
            field: 'm',
            width: 50,
        }, {
            headerName: "T",
            field: 't',
            width: 50,
        }, {
            headerName: "W",
            field: 'w',
            width: 50,
        }, {
            headerName: "R",
            width: 50,
            field: 'r',
        }, {
            headerName: "F",
            field: 'f',
            width: 50,
        }, {
            headerName: "S",
            field: 's',
            width: 50,
        }, {
            headerName: "U",
            field: 'u',
            width: 50,
        }, {
            headerName: "Start Time",
            field: 'start',
            width: 100,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':'); var arr2 = timeB.split(':');

                    if(parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        }, {
            headerName: "End Time",
            field: 'end',
            width: 100,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':');
                    var arr2 = timeB.split(':');

                    if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        }, {
            headerName: "Length",
            field: 'length',
            width: 100,
        }, {
            headerName: "Type",
            field: 'type',
            width: 150,
            hide: true,
        }, {
            headerName: "Avail Comments",
            field: 'tag',
            width: 150,
        }, {
            headerName: "Rating",
            field: 'rating',
            width: 80,
            hide:true,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                var auxA = parseFloat(valueA);
                var auxB = parseFloat(valueB);
                if(auxA === auxB)
                    return 0;
                else if (auxA > auxB)
                    return 1;
                else
                    return -1;
            }
        }, {
            headerName: "Rate",
            field: 'rate',
            width: 80,
            cellClassRules : {
                'ag-cell-color-background': function (params) {
                    if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                        return true;
                    return false;
                }
            },
            cellRenderer: function (params) {
                if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                    return 'TR';
                else
                    return params.data.rate;
                },
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                var auxA = parseFloat(valueA);
                var auxB = parseFloat(valueB);
                if(auxA === auxB)
                    return 0;
                else if (auxA > auxB)
                    return 1;
                else
                    return -1;
            }
        }, {
            headerName: "tiered",
            field: 'tiered',
            width: 80,
            hide: true,
        },{
            headerName: "Spots",
            field: 'spots',
            width: 80,
        }, {
            headerName: "Verified",
            field: 'verified',
            width: 100,
        }, {
            headerName: "Difference",
            field: 'difference',
            width: 100,
            cellClassRules :  {
                'ag-cell-color-difference-less': function(params) {
                    if(parseFloat(params.value) < 0 && params.node.rowPinned !== 'top')
                        return true;
                    else
                        return false;
                },
                'ag-cell-color-difference-more': function(params) {
                    if(parseFloat(params.value) > 0 && params.node.rowPinned !== 'top')
                        return true;
                    else
                        return false;
                }
            },
        },{
            headerName: "BK",
            field: 'bookend',
            width: 80,
            hide:true,
        },
        {
            headerName: "BK Length",
            field: 'bookend_length',
            width: 100,
            hide: true,
        },
        {
            headerName: "BK Length 1",
            field: 'bookend_length_1',
            width: 100,
            hide: true,
        },
        {
            headerName: "BK Length 2",
            field: 'bookend_length_2',
            width: 100,
            hide: true,
        },
        {
            headerName: "Bonus",
            field: 'bonus',
            width: 100,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                var auxA = parseFloat(valueA);
                var auxB = parseFloat(valueB);
                if(auxA === auxB)
                    return 0;
                else if (auxA > auxB)
                    return 1;
                else
                    return -1;
            }
        },
        {
            headerName: "Line Id",
            field: 'line_id',
            width: 100,
        },
    ];

    var columnMatchDefs = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "ID",
            field: 'id',
            width: 40,
            hide:true,
        },
        {
            headerName: "Network",
            field: 'cable_network',
            width: 85,
        },{
            headerName: "Date",
            field: 'date',
            width: 80,
        }, {
            headerName: "Day",
            field: 'day',
            width: 80,
        }, {
            headerName: "Time",
            field: 'time',
            width: 80,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':');
                    var arr2 = timeB.split(':');

                    if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        }, {
            headerName: "Type",
            field: 'type',
            width: 120,
            hide: true,
        }, {
            headerName: "Length",
            field: 'length',
            width: 80,
        },  {
            headerName: "Rate",
            field: 'rate',
            width: 100,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                var auxA = parseFloat(valueA);
                var auxB = parseFloat(valueB);
                if(auxA === auxB)
                    return 0;
                else if (auxA > auxB)
                    return 1;
                else
                    return -1;
            }
        }, {
            headerName: "Apvd Rate",
            field: 'apvd_rate',
            width: 120,
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                var auxA = parseFloat(valueA);
                var auxB = parseFloat(valueB);
                if(auxA === auxB)
                    return 0;
                else if (auxA > auxB)
                    return 1;
                else
                    return -1;
            }
        }, {
            headerName: "User Remarks",
            field: 'remark',
            width: 150,
        },
        {
            headerName: "Comm. ID",
            field: 'commercial_id',
            width: 100,
        },
        {
            headerName: "Invoice Comments",
            field: 'comments',
            width: 200,
        },
        {
            headerName: "Inv id",
            field: 'invoice_id',
            width: 200,
            editable: false,
            hide:true,
        },
        {
            headerName: "BK",
            field: 'bookend',
            width: 80,
            editable: false,
            hide:true,
        },
    ];
    var gridUnmatchOptions = '';
    
    function initializegridUnmatchOptions(type) {
        var columnUnmatchDefs = [ //num
                {
                    headerName: '',
                    headerTooltip: '',
                    field: 'row_select',
                    pinned: 'left',
                    width: 50,
                    editable: false,
                    cellRenderer: 'agGroupCellRenderer',
                    checkboxSelection: true,
                    cellRendererParams: {
                        //checkbox: true
                    },
                    suppressFilter: true,
                    suppressMovable: true,
                    suppressResize: true,
                    suppressNavigable: true,
                    suppressSorting: true,
                    required: true,
                    headerClass: 'fixedHeaderCellClass'
                },

                {
                    headerName: "Num.",
                    field: 'num',
                    width: 40,
                }, {
                    headerName: "ID",
                    field: 'id',
                    width: 40,
                    hide: false,
                },
                {
                    headerName: "Network",
                    field: 'cable_network',
                    width: 85,
                },
                {
                    headerName: "Zone",
                    field: 'zone',
                    width: 80,
                    editable: false,
                    hide: !multiple_match
                },
                {
                    headerName: "Date",
                    field: 'date',
                    width: 80,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: DateCellEditor,
                    comparator: function (valueA, valueB, nodeA, nodeB, isInverted) {
                        if (((valueA == '') || (valueA == null)) && ((valueB == '') || (valueB == null))) {
                            return 0;
                        }
                        if ((valueA == '') || (valueA == null)) {
                            return -1;
                        }
                        if ((valueB == '') || (valueB == null)) {
                            return 1;
                        }

                        // Convert to moment objects then properly compare.
                        return moment(valueA, 'MM/DD/YYYY').format('X') - moment(valueB, 'MM/DD/YYYY').format('X');
                    }

                }, {
                    headerName: "Day",
                    field: 'day',
                    width: 80,
                    editable: false,
                }, {
                    headerName: "Time",
                    field: 'time',
                    width: 80,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: TimeCellEditor,
                    comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                        if (valueA.includes('PM') && valueB.includes('AM')) {
                            return 1;
                        } else if (valueA.includes('AM') && valueB.includes('PM')) {
                            return -1;
                        } else {
                            var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                            var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                            var arr1 = timeA.split(':');
                            var arr2 = timeB.split(':');

                            if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                                return 0;
                            else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                                return 1;
                            else
                                return -1;
                        }
                    }
                }, {
                    headerName: "Type",
                    field: 'type',
                    width: 120,
                    hide: true,
                    editable: true,
                }, {
                    headerName: "Length",
                    field: 'length',
                    width: 80,
                    editable: true,
                    cellRenderer: IntegerFormatRenderer,
                    cellEditor: IntegerCellEditor,
                }, {
                    headerName: "Rate",
                    field: 'rate',
                    width: 100,
                    editable: true,
                    cellRenderer: CurrencyFormatRenderer,
                    cellEditor: CurrencyCellEditor,
                }, {
                    headerName: "Apvd Rate",
                    field: 'apvd_rate',
                    width: 120,
                    editable: true,
                    cellRenderer: CurrencyFormatRenderer,
                    cellEditor: CurrencyCellEditor,
                },{
                    headerName: "Program",
                    field: 'program_description',
                    width: 120,
                    editable: false,
                    cellRenderer: StringFormatRenderer,
                }, {
                    headerName: "Error Codes",
                    field: 'error_codes',
                    width: 150,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                }, {
                    headerName: "User Remarks",
                    field: 'remark',
                    width: 150,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                },
                {
                    headerName: "Comm. ID",
                    field: 'commercial_id',
                    width: 100,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                }, {
                    headerName: "Tag",
                    field: 'tag',
                    width: 150,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    hide:true,
                },
                {
                    headerName: "Invoice Comments",
                    field: 'comments',
                    width: 200,
                    editable: true,
                },
                {
                    headerName: "Inv id",
                    field: 'invoice_id',
                    width: 200,
                    editable: false,
                    hide: true,
                },
            ];
        gridUnmatchOptions = {
            columnDefs: columnUnmatchDefs,
            defaultColDef: {
                suppressToolPanel: true
            },
            toolPanelSuppressValues: true,defaultToolPanel: '',
            stopEditingWhenGridLosesFocus: true,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            enableColResize: true,
            //suppressMenuColumnPanel: true,
            suppressTouch: true,
            headerHeight: 20,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onGridReady: function (e) {
            },
            onCellValueChanged: function (e) {
                editing_row_imported_invo = true;
                array_imp_all_cell_edited[e.node.data.id] = [];
                array_imp_all_cell_edited[e.node.data.id] = e.node.data;
                console.log('dev-4041 field', e.colDef.field );
                console.log('dev-4041  array_imp_all_cell_edited', e);
                console.log('dev-4041 match_result', match_result);
                var node_id = parseInt(e.node.data.id);

                for (var ind in match_result.no_match){
                    if( match_result.no_match[ind] !== null && typeof match_result.no_match[ind].id !== 'undefined') {
                        if (parseInt(match_result.no_match[ind].id) === parseInt(e.node.data.id)) {
                            console.log('dev-4041 match_result id', match_result.no_match[ind].id);
                            if(e.colDef.field !== 'apvd_rate')
                                 match_result.no_match[ind][e.colDef.field] = e.node.data[e.colDef.field];
                            else{
                                if(typeof match_result.no_match[ind]['approved_rate'] !== 'undefined')
                                    match_result.no_match[ind]['approved_rate'] = e.node.data.apvd_rate;
                                if(typeof match_result.no_match[ind]['apvd_rate'] !== 'undefined')
                                    match_result.no_match[ind]['apvd_rate'] = e.node.data.apvd_rate;
                            }
                        }
                    }
                }
            },
            onCellEditingStarted: function (e) {
               //  editing_row_imported_invo = true;
               // // if(array_inv_imported_edited.indexOf(e.node.data.id))
               //  array_imp_all_cell_edited[e.node.data.id] = [];
               //  array_imp_all_cell_edited[e.node.data.id] = e.node.data;
               //  console.log('start editing ^^^^^^^^^^^^^^');
               //  console.log('array_imp_all_cell_edited ', array_imp_all_cell_edited);
              },
            onFilterChanged: function () {
                if (this.api.isAnyFilterPresent()) {
                    filter__array_to_keep_no_match = gridUnmatchOptions.api.getFilterModel();
                    $('#reset_filter_sall_lines_no_match').show();
                }
                else {
                    filter__array_to_keep_no_match = {};
                    $('#reset_filter_sall_lines_no_match').hide();
                }

            }
        };

        $('#reset_filter_sall_lines_no_match').on('click', function () {
            $.each(gridUnmatchOptions.api.getFilterModel(), function (index, value) {
                gridUnmatchOptions.api.destroyFilter(index);
            });
            filter__array_to_keep_no_match = {};
        });


        function TimeCellEditor() {
        }

        TimeCellEditor.prototype.init = function (params) {
            console.log('get in Time CellEditor');
            console.log(params);
            this.eInput = document.createElement('input');
            if (typeof params.value == 'undefined') {
                params.value = '';
            }
            this.tabbed = false;
            $(this.eInput).mask('ABBBC', {
                'translation': {
                    A: {pattern: /\d/},
                    B: {pattern: /\d/, optional: true},
                    C: {pattern: /a|A|p|P/}
                },
                "oncomplete": function () {
                    $(this).attr('data-completed', 'true');
                },
                "onincomplete": function () {
                    $(this).attr('data-completed', 'false');
                },
                showMaskOnHover: false
            });

            loop_start = moment().hour(0).minute(0).second(0);
            var current_value = params.value;

            /// If a "printable key" is pressed.
            if (params.charPress !== null) {
                number = parseInt(params.charPress);
                // If a number, set that value.
                if (!isNaN(number)) {
                    this.eInput.value = number;
                    $(this.eInput).attr('data-completed', 'true');
                } else {
                    if (params.value !== '') {
                        $(this.eInput).attr('data-completed', 'true');
                    } else {
                        $(this.eInput).attr('data-completed', 'false');
                    }
                    if (params.charPress === "+" && params.value.indexOf("AM")) {
                        this.eInput.value = params.value.replace('AM', 'PM');
                    } else if (params.charPress === "-" && params.value.indexOf("PM")) {
                        this.eInput.value = params.value.replace('PM', 'AM');
                    } else
                        this.eInput.value = params.value;
                }
            } else {
                // Remove value on delete/backspace
                if ((params.keyPress == 8) || (params.keyPress == 46)) {
                    this.eInput.value = '';
                    $(this.eInput).attr('data-completed', 'false');
                    // Otherwise set the params value.
                } else {
                    if (params.value !== '') {
                        current_value = moment(current_value, 'h:mmA');

                        //  input.val(current_value.format('hmmA').substring(0, current_value.format('hmmA').length - 1));
                        //this.eInput.value= current_value.format('hmmA').substring(0, current_value.format('hmmA').length - 1);
                        this.eInput.value = current_value.format('LT')//.substring(0, current_value.format('LT').length - 1);

                        $(this.eInput).attr('data-completed', 'true');
                    }
                    this.eInput.value = params.value;
                    if (params.keyPress == null) {
                        this.tabbed = true;
                    }
                }
            }
            $(this.eInput).bind('keyup', function (e) {
                var key = e.which || e.keyCode;
                if ((!e.shiftKey) && ((key === 37) || (key === 39))) {
                    return true;
                }

                if (key == 8) {
                    return true;
                }


            });
            $(this.eInput).bind('change', function (e) {
                result = grid_time_period_range_change(this);

                if (result !== false) {
                    grid_time_period_range_set(this, result);
                } else {
                    $(this.eInput).val('');
                }

                e.preventDefault();
            });

        };

        function grid_time_period_range_change(select) {
            container = $(select);
            var start = $(select).val();

            if (start !== '') {
                start = moment(start, 'h:mm A');

                return [start];
            }

            return false;
        }

        function grid_time_period_range_set(select, result) {
            container = $(select).closest('.grid-popup-container');
            str_start = result[0].format('LT').substring(0, result[0].format('LT').length - 1);

            $(select).val(str_start);

        }

        function grid_time_period_parse(part) {
            var currentCell = gridUnmatchOptions.api.getFocusedCell();
            console.log('focus cellll');
            console.log(currentCell);
            var p, time, time_int;
            var moment_obj = moment().hour(0).minute(0).second(0);

            if ((part.indexOf('a') >= 0) || (part.indexOf('A') >= 0)) {
                p = 'a';
            }

            if ((part.indexOf('p') >= 0) || (part.indexOf('P') >= 0)) {
                p = 'p';
            }
            if (p != 'p' && p != 'a') {
                var currentCell = gridUnmatchOptions.api.getFocusedCell();
                if (currentCell.rowIndex > 0) {
                    var index = currentCell.rowIndex - 1;
                    var previewsCell = '';
                    gridUnmatchOptions.api.forEachNode(function (node) {
                        if (node.rowIndex == index) {
                            previewsCell = node;
                            var previws = node.data.time;
                            if (previws.indexOf('P') >= 0)
                                p = 'p';
                            if (previws.indexOf('A') >= 0)
                                p = 'a';
                        }
                    });

                }
            }

            time = part.toLowerCase().replace(p, '').replace(':', '');
            time_int = parseInt(time);

            // First check the length of the string, then parse if given proper values.
            if (time.length == 1) {
                if (p == 'p') {
                    moment_obj.hour(time_int + 12);
                } else {
                    moment_obj.hour(time_int);
                }
            } else if (time.length == 2) {
                if ((time_int > 9) && (time_int < 13)) {
                    if (p == 'p') {
                        if (time_int !== 12) {
                            moment_obj.hour(time_int + 12);
                        } else {
                            moment_obj.hour(12);
                        }
                    } else {
                        if (time_int !== 12) {
                            moment_obj.hour(time_int);
                        } else {
                            moment_obj.hour(0);
                        }
                    }
                } else {
                    if (p == 'p') {
                        moment_obj.hour(parseInt(time[0]) + 12).minute(parseInt(time[1] + '0'));
                    } else {
                        moment_obj.hour(parseInt(time[0])).minute(parseInt(time[1] + '0'));
                    }
                }
            } else if (time.length == 3) {
                if (p == 'p') {
                    moment_obj.hour(parseInt(time[0]) + 12).minute(parseInt(time[1] + time[2]));
                } else {
                    moment_obj.hour(parseInt(time[0])).minute(parseInt(time[1] + time[2]));
                }
            } else if (time.length == 4) {
                temp = parseInt(time[0]);

                if (temp > 2) {
                    return false;
                }

                if (p == 'p') {
                    if (parseInt(time[0] + time[1]) !== 12) {
                        moment_obj.hour(parseInt(time[0] + time[1]) + 12).minute(parseInt(time[2] + time[3]));
                    } else {
                        moment_obj.hour(12).minute(parseInt(time[2] + time[3]));
                    }
                } else {
                    if (parseInt(time[0] + time[1]) !== 12) {
                        moment_obj.hour(parseInt(time[0] + time[1])).minute(parseInt(time[2] + time[3]));
                    } else {
                        moment_obj.hour(0).minute(parseInt(time[2] + time[3]));
                    }

                }
            }

            return moment_obj;
        }

        TimeCellEditor.prototype.getGui = function () {
            if (this.tabbed == true) {
                console.log('getGui');
                $(this.eInput).addClass('ws-tabbed-input');
                $(this.eInput).setCursorPosition(0);
            }
            $(this.eInput).bind('keydown', function (e) {
                var key = e.which || e.keyCode;
                // Let arrow keys through
                if ((!e.shiftKey) && (key > 36) && (key < 41)) {
                    e.stopPropagation();
                    return true;
                } else if (key === 107) {
                    $(this).val($(this).val().replace('PM', '').replace('AM', ''))
                    $(this).val($(this).val() + 'PM')
                } else if (key === 109) {
                    $(this).val($(this).val().replace('PM', '').replace('AM', ''))
                    $(this).val($(this).val() + 'AM')
                }
            });

            return this.eInput;

        };

        TimeCellEditor.prototype.afterGuiAttached = function () {
            this.eInput.focus();
            if (this.tabbed) {
                console.log('afterGuiAttached');
                $(this.eInput).setCursorPosition(0);
                $(this.eInput).select();
            }
        };

        TimeCellEditor.prototype.getValue = function () {
            if ($(this.eInput).attr('data-completed') == 'true') {
                var moment_start = grid_time_period_parse($(this.eInput).val());
                if ((moment_start == false)) {
                    return '00:00';
                }
                //   var str_start = moment_start.format('h:mmA').substring(0, moment_start.format('h:mmA').length - 1);
                var str_start = moment_start.format('LT')//.substring(0, moment_start.format('h:mmA').length - 1);
                $(this.eInput).val(str_start);
                return this.eInput.value;

            } else {
                return '00:00';
            }

        };

        TimeCellEditor.prototype.destroy = function () {
            $(this.eInput).unbind('keydown');
            $(this.eInput).inputmask('remove');
        };

        TimeCellEditor.prototype.isPopup = function () {
            return false;
        };
    }
    var gridMatchOptions = {
        columnDefs: columnMatchDefs,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        }
    };

    var weeks_column_def =  {
        headerName: '',
        headerTooltip: 'Ads in Week of ',
        field: 'week_',
        editable: true,
        cellEditor: IntegerCellEditor,
        cellRenderer: IntegerFormatRenderer,
        filter: 'number',
        minWidth: 35,
        width: 100,
        required: false,

    }
    var weeks_rate_column_def =  {
        headerName: '',
        field: 'w_',
        width: 100,
        cellStyle: {'text-align': "left"},
        editable: true,
     //   pinnedRowCellRenderer: BlankFormatRenderer,
        cellRenderer: TiredRateFormatRendererInvoice,
        cellEditor: TiredRateCellEditorInvoice,
        cellClassRules :  {
            'ag-cell-color-background': function(params) {
                var index = params.colDef.field;
                index = index.toString().split('_')[1];
                if (params.node.rowPinned != 'top' ) {
                    if(typeof params.data['w_'+ index +'_tired'] !== 'undefined' &&  params.data['w_'+ index +'_tired'] !== null &&  params.data['w_'+ index +'_tired'] !== '' ) {
                        console.log('rated tired value ', params.data['w_'+ index +'_tired']);
                        return true;
                    }
                    else
                        return false;
                }
                return false;
            }
        },
    }
    function getContextMenuItemsOrderLine(params){
        var result = [
            {
                name: 'New Line',
                icon: '<i class="fa fa-plus fa-fw"></i>',
                disabled: ( (params.node.rowPinned !== 'bottom') && (params.node.rowPinned !== 'top') ) ? false : true,
                action: function() {
                    var node = params.node;
                    new_order_line('new', node);
                },
                cssClasses: ['redFont', 'bold']
            },
            {
                name: 'Edit Line',
                icon: '<i class="fa fa-pencil-square"></i>',
                disabled: ( (params.node.rowPinned !== 'bottom') && (params.node.rowPinned !== 'top') ) ? false : true,
                action: function() {
                    var node = params.node;
                    new_order_line('edit', node);
                },
                cssClasses: ['redFont', 'bold']
            },
            // {
            //     name: 'Send to WMJ',
            //     icon: '<i class="fa fa-paper-plane-o"></i>',
            //     disabled: ( (params.node.rowPinned !== 'bottom') && (params.node.rowPinned !== 'top') && (accounting_packages.indexOf('workamajig_api')!== -1 || user_role === true)) ? false : true,
            //     action: function() {
            //         var params_new = {
            //             orders: [match_result.revision.order_id],
            //         };
            //         $.ajax({
            //             type: 'POST',
            //             headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            //             data: JSON.stringify(params_new),
            //             url: '/orders/export/workamajig/api/multiple/info/',
            //             dataType: "json",
            //             contentType: "application/json",
            //             success: function (data) {
            //                 var columnOrderExportWorkApi = [
            //                     {
            //                         headerName: "Plan ID",
            //                         field: 'plan_id',
            //                         width: 180,
            //                         cellStyle: {'text-align': "left"},
            //                     },
            //                     {
            //                         headerName: "Order Link ID",
            //                         field: 'orderLinkID',
            //                         width: 180,
            //                         cellStyle: {'text-align': "left"},
            //                     },
            //                     {
            //                         headerName: "Plan Name",
            //                         field: 'plan_name',
            //                         width: 200,
            //                         cellStyle: {'text-align': "left"},
            //                         editable: true,
            //                     },
            //                     {
            //                         headerName: "Project Number",
            //                         field: 'project_number',
            //                         width: 150,
            //                         cellStyle: {'text-align': "left"},
            //                     },
            //                     {
            //                         headerName: "Spot Link ID",
            //                         field: 'spot_id',
            //                         width: 180,
            //                         cellStyle: {'text-align': "right"},
            //                     },
            //                     {
            //                         headerName: "Station ID",
            //                         field: 'station_id',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"},
            //                         editable: true,
            //                     },
            //                     {
            //                         headerName: "Action",
            //                         field: 'action',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"},
            //                     },
            //                     {
            //                         headerName: "Item ID",
            //                         field: 'media_type',
            //                         width: 130,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Amount to Bill",
            //                         field: 'gross',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Commission",
            //                         field: 'commission',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Cost",
            //                         field: 'cost',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Gross",
            //                         field: 'gross',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"},
            //                         cellClassRules: {
            //                             'ag-cell-client_rate': function (params) {
            //                                 if (params.node.rowPinned != 'top') {
            //                                     if (typeof params.data['amount_to_bill'] !== 'undefined' && params.data['amount_to_bill'] !== params.value)
            //                                         return true;
            //                                     else
            //                                         return false;
            //                                 }
            //                                 return false;
            //                             },
            //                         },
            //                     },
            //                     {
            //                         headerName: "Client Gross %",
            //                         field: 'client_gross_comm',
            //                         width: 120,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Client Gross Applied",
            //                         field: 'client_gross_type',
            //                         width: 160,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Quantity",
            //                         field: 'quantity',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Description",
            //                         field: 'description',
            //                         width: 200,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //
            //                     {
            //                         headerName: "Start Date",
            //                         field: 'start_date',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "End Date",
            //                         field: 'end_date',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Archive",
            //                         field: 'archive',
            //                         width: 150,
            //                         cellStyle: {'text-align': "right"},
            //                         hide:true
            //                     },
            //                     {
            //                         headerName: "Days",
            //                         field: 'orderDays',
            //                         width: 80,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Time",
            //                         field: 'orderTime',
            //                         width: 80,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Length ",
            //                         field: 'orderLength',
            //                         width: 80,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Materials Due",
            //                         field: 'materialsDue',
            //                         width: 100,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //                     {
            //                         headerName: "Space Close",
            //                         field: 'spaceClose',
            //                         width: 100,
            //                         cellStyle: {'text-align': "right"}
            //                     },
            //
            //                 ];
            //                 var gridOrderExportWorkAPI = {
            //                     columnDefs: columnOrderExportWorkApi,
            //                     defaultColDef: {
            //                         suppressToolPanel: true
            //                     },
            //                     rowSelection: 'single',
            //                     suppressRowClickSelection: false,
            //                     enableColResize: true,
            //                     suppressMenuColumnPanel: true,
            //                     suppressTouch: true,
            //                     headerHeight: 20,
            //                     suppressDragLeaveHidesColumns: true,
            //                     enableCellChangeFlash: true,
            //                     rowHeight: 20,
            //                     suppressRowHoverClass: true,
            //                     suppressParentsInRowNodes: true,
            //                     toolPanelSuppressValues: true,
            //                     toolPanelSuppressRowGroups: true,
            //                     groupUseEntireRow: false,
            //                     groupDefaultExpanded: 1,
            //                     marryChildren: true,
            //                     suppressAggFuncInHeader: true,
            //                     enableFilter: true,
            //                     enableSorting: true,
            //                     animateRows: true,
            //                     icons: {
            //                         groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            //                         groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            //                         menu: '<i class="fa fa-bars fa-lg"/>',
            //                         sortAscending: '<i class="fa fa-caret-down"/>',
            //                         sortDescending: '<i class="fa fa-caret-up"/>',
            //                         columnMoveMove: '<i class="fa fa-arrows"></i>',
            //                         columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            //                         columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            //                         columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            //                         columnMoveHide: '<i class="fa fa-remove"/>'
            //                     },
            //                 };
            //                 gridOrderExportWorkAPI.rowData = [];
            //                 gridOrderExportWorkAPI.rowData = data.grid_lines;
            //                 $('#orderExportInfoGridWorkAPI').html("");
            //                 var gridOrderExportWorkAPID = document.querySelector('#orderExportInfoGridWorkAPI');
            //                 var g5 = new agGrid.Grid(gridOrderExportWorkAPID, gridOrderExportWorkAPI);
            //                 $('#OrderExportInfoWorAPIkOrder').modal({backdrop: 'static', keyboard: false})
            //                 global_sent_api = false;
            //                 if(data.disclaimer == 1)
            //                     $('.work_disclaimer_div').show()
            //                 else
            //                     $('.work_disclaimer_div').hide()
            //
            //                 $('#sent_to_workamajig_order').attr('data-order-id', match_result.revision.order_id)
            //                 $('#OrderExportInfoWorAPIkOrder').modal('show');
            //                 hide_loader();
            //                 close_progress_loader();
            //                 $('#expor_work_api_order').on('click', function() {
            //                     var params = {
            //                         skipHeader: false,
            //                         columnGroups: false,
            //                         skipFooters: false,
            //                         skipGroups: true,
            //                         skipPinnedTop: false,
            //                         skipPinnedBottom: false,
            //                         allColumns: false,
            //                         onlySelected: false,
            //                         suppressQuotes: false,
            //                         fileName: "export",
            //                         suppressTextAsCDATA: false,
            //                         // excelStyles: excelStyles,
            //                     };
            //                     params.fileName = 'export.csv';
            //                     gridOrderExportWorkAPI.api.exportDataAsCsv(params);
            //                 });
            //             },
            //             error: function (xhr) {
            //                 hide_loader();
            //                 ajax_error();
            //                 debug(xhr.responseText);
            //                 close_progress_loader();
            //             }
            //         });
            //     },
            //     cssClasses: ['redFont', 'bold']
            // },
            //  'copy',
            // 'paste',
           //   'export',
            'separator',
        ];

        return result;
    }


    var init_progress_loader_wmj = function (steps, message) {
        progress_loader_steps = steps;
        progress_loader_curr_step = 0;
        update_progress_loader_wmj(message);
        $('#progressloaderWMJ').show();
    };
    var update_progress_loader_wmj = function (message, steps) {
        var container = $('#progressloaderWMJ');

        progress_loader_curr_step++;
        width = (progress_loader_curr_step / progress_loader_steps) * 100;
        container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
        if (steps === true) {
            message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
        }
        container.find('span').html(message + '');
        if(progress_loader_steps <= progress_loader_curr_step)
            close_progress_loader_wmj();
    };
    var close_progress_loader_wmj = function () {
        progress_loader_steps = 0;
        progress_loader_curr_step = 0;
        $('#progressloaderWMJ').hide();
    };

    var global_revise_order_change = false;
    var newOrderLineColumnDef = [];
    var newOrderLineGrid =  {
        columnDefs: [],
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: false,
        stopEditingWhenGridLosesFocus: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onCellValueChanged: function (e) {
            console.log('params e', e)
            global_revise_order_change = true;
            if (e.node.rowPinned !== 'top' && e.colDef.field === 'gross_cpa') {
                console.log('get inside', e.node.data.net_cpa);
                if(typeof e.node.data.digital_commission !== 'undefined' && !isNaN(parseFloat(e.node.data.digital_commission)) && typeof e.node.data.lineable_type !== 'undefined' && (e.node.data.lineable_type === "App\Entities\LineOOH" || e.node.data.lineable_type === "App\Entities\LLineDigital"))
                    e.node.data.net_cpa = !isNaN(parseFloat(e.node.data.gross_cpa)) ? e.node.data.gross_cpa * (1 - (e.node.data.digital_commission / 100)) : 0;
                 else
                    e.node.data.net_cpa = !isNaN(parseFloat(e.node.data.gross_cpa)) ? e.node.data.gross_cpa * (1 - (ws_agency_commission_new_line / 100)) : 0;
                 e.api.refreshCells({rowNodes: [e.node], columns: ['net_cpa'], force: true});
            }
            if (e.node.rowPinned !== 'top' && e.colDef.field.indexOf('w_') !== -1) {
                var line_tired = 0;
                for (var ind in camp_fd_ordered_edit) {
                    if (typeof e.node.data['w_' + ind + '_tired'] !== 'undefined' && !isNaN(parseFloat(e.node.data['w_' + ind + '_tired'])))
                        line_tired = 1;
                }
                console.log('line_tired', line_tired);
                e.node.data['tiered_rate'] = line_tired;
                this.api.refreshCells({
                    rowNodes: [e.node],
                    columns: ['gross_cpa', 'net_cpa', 'tiered_rate'],
                    force: true
                });
            }
            if (e.node.rowPinned !== 'top' && e.colDef.field === 'gross_cost') {
                if(!isNaN(parseFloat(e.node.data.gross_cost)) && typeof e.node.data.digital_commission !== 'undefined' && !isNaN(parseFloat(e.node.data.digital_commission)))
                    e.node.data.net_cost = e.node.data.gross_cost * (1 - (e.node.data.digital_commission / 100));
                else
                    e.node.data.net_cost = 0;
                console.log('get inside', e.node.data.net_cost);
                e.api.refreshCells({rowNodes: [e.node], columns: ['net_cost'], force: true});
            }
        }
    };
    var ws_agency_commission_new_line = 0;
    var camp_fd_ordered_edit = [];
    function new_order_line(function_type, current_node){
        global_revise_order_change = false;
        $('#editOrderNewLinesNoBr').hide();
        $('#saveOrderNewLinesNoBr').hide();
        if(match_result.lineable_type === 'App\\Entities\\LineRadio')
            $('#addNewBonusLine').attr('media', 'radio')
        else
            $('#addNewBonusLine').attr('media', 'tv')

        if(function_type == 'edit'){
            $('#addNewBonusLine').hide();
            $('#removeNewBonusLine').hide();
            $('#saveOrderNewLines').hide();
            $('#editOrderNewLines').show();
        }
        else{
            $('#addNewBonusLine').show();
            $('#removeNewBonusLine').show();
            $('#saveOrderNewLines').show();
            $('#editOrderNewLines').hide();
        }
        var line =  match_result.olines[current_node.data.line_id];
        var params = {
            rev_id: match_result.revision.id,
            lineable_type: match_result.lineable_type,
            campaign_id: match_result.invoice.campaign_id,
            order_line_id : line.line_id,
            lineable_id : line.lineable_id,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/edit_add/order/line/get_weeks',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                console.log('response', response)
                newOrderLineColumnDef = [
                    {
                        headerName: "Time Period",
                        width: 100,
                        editable: true,
                        field: 'time_period',
                        cellEditor: TimePeriodCellEditorInvoice,
                        cellRenderer: StringFormatRenderer,
                    },
                    {
                        headerName: "Days Of Week",
                        field: 'dow',
                        width: 100,
                        cellEditor: DOWCellEditorInvoice,
                        cellRenderer: StringFormatRenderer,
                        editable: true
                    },{
                        headerName: "Length",
                        field: 'length',
                        width: 100,
                        editable: true,
                        cellRenderer: LengthFormatRendererInvoice,
                        cellEditor: IntegerCellEditor,
                    },
                    {
                        headerName: "Daypart",
                        field: 'day_part',
                        width: 100,
                        editable: true,
                        cellRenderer: UppercaseFormatRendererInvoice,
                        cellEditor: StringCellEditor,
                        cellEditorParams: {
                            string_max: 3
                        },
                    },
                    {
                        headerName: "Network",
                        field: 'network',
                        width: 100,
                        editable: true,
                        hide: (match_result.lineable_type.indexOf('LineTelevision') !== -1) ? false : true,
                    },
                    {
                        headerName: "Gross Rate",
                        field: 'gross_cpa',
                        width: 100,
                        editable: true,
                        cellRenderer: CurrencyFormatRendererInvoice,
                        cellEditor: CurrencyCellEditorInvoice,
                        cellEditorParams: {
                            'commission': (typeof match_result.commissions[match_result.lineable_type] !== 'undefined') ? match_result.commissions[match_result.lineable_type]: 0,
                        },
                        cellClassRules :  {
                            'ag-cell-color-background': function(params) {
                                if(typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                    return true;
                                else
                                    return false;
                            }
                        },
                        editable: function (params) {
                            if (typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                return false;
                            else
                                return true;
                        },
                    },
                    {
                        headerName: "Net Rate",
                        field: 'net_cpa',
                        width: 100,
                        editable: false,
                        cellRenderer: CurrencyFormatRendererInvoice,
                        cellEditor: CurrencyCellEditorInvoice,
                        cellEditorParams: {
                            'commission': (typeof match_result.commissions[match_result.lineable_type] !== 'undefined') ? match_result.commissions[match_result.lineable_type]: 0,
                        },
                        cellClassRules :  {
                            'ag-cell-color-background': function(params) {
                                if(typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                    return true;
                                else
                                    return false;
                            }
                        },
                        // editable: function (params) {
                        //     if (typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                        //         return false;
                        //     else
                        //         return true;
                        // },
                    },
                    {
                        headerName: "Zone",
                        field: 'zone',
                        width: 100,
                        editable: true,
                        hide: (match_result.lineable_type.indexOf('LineTelevision') !== -1) ? false : true,
                    },
                    {
                        headerName: "Program",
                        field: 'program',
                        width: 100,
                        editable: true
                    },
                    {
                        headerName: "Rating",
                        field: 'rating',
                        width: 80,
                        editable: true,
                        cellEditor: FloatCellEditorInvoice,
                        cellRenderer: FloatFormatRendererInvoice,
                    },
                    {
                        headerName: "Impressions",
                        field: 'impressions',
                        width: 100,
                        editable: true,
                        cellEditor: FloatCellEditorInvoice,
                        cellRenderer: FloatFormatRendererInvoice,
                    },
                    {
                        headerName: "Comments",
                        field: 'comments',
                        width: 150,
                        editable: true
                    },

                ];
                ws_agency_commission_new_line = (typeof match_result.commissions[match_result.lineable_type] !== 'undefined') ? match_result.commissions[match_result.lineable_type]: 0;
                newOrderLineGrid.rowData = [];
                camp_fd_ordered_edit = match_result.weeks;
                for (var i in response.fd) {
                    var inv_mo = typeof match_result.invoice.month !== 'undefined' ? moment(match_result.invoice.month).format('MMM, YYYY') : moment(match_result.invoice.broadcast_month).format('MMM, YYYY');
                    var text = typeof match_result.weeks[response.fd[i].id] === 'undefined' ? ' (This week does not belong to the invoice month: '+ inv_mo +')' : '';
                    var tiered_weeks = {
                        headerName: 'Week: ' + moment(response.fd[i].start).format('MM/DD'),
                        headerTooltip: "Week: " + moment(response.fd[i].start).format('MM/DD') +'  '+ text,
                        groupId: moment(response.fd[i].start).format('MM/DD'),
                        children: [],
                        headerClass: 'group-header'
                    };

                    var week = $.extend({}, weeks_column_def);
                    week.headerTooltip = 'Ads for ' + moment(response.fd[i].start).format('MM/DD');
                    week.headerName = 'Ads ';
                    week.field +=  response.fd[i].id;
                    week.hide = typeof match_result.weeks[response.fd[i].id] === 'undefined' ? true : false;
                    tiered_weeks.children.push(week);

                    var week = $.extend({}, weeks_rate_column_def);
                    week.headerTooltip = 'Rate for ' + moment(response.fd[i].start).format('MM/DD');
                    week.headerName = 'Rate ';
                    week.field = 'w_' + response.fd[i].id + '_tired';
                    week.hide = typeof match_result.weeks[response.fd[i].id] === 'undefined' ? true : false;
                    tiered_weeks.children.push(week);

                    newOrderLineColumnDef.push(tiered_weeks);
                }

                newOrderLineGrid.columnDefs = newOrderLineColumnDef;
                if(function_type == 'edit'){
                    var row = [];
                    var line =  match_result.olines[current_node.data.line_id];
                    var dow ='';
                    dow += (line.m === 1)? 'M' : '-';
                    dow += (line.t === 1)? 'T' : '-';
                    dow += (line.w === 1)? 'W' : '-';
                    dow += (line.r === 1)? 'R' : '-';
                    dow += (line.f === 1)? 'F' : '-';
                    dow += (line.s === 1)? 'S' : '-';
                    dow += (line.u === 1)? 'U' : '-';

                    var start = moment('2021-01-01 ' + line.start).format('h:mmA');
                    start = start.replace('M', '');
                    var end = moment('2021-01-01 ' + line.end).format('h:mmA');
                    end = end.replace('M', '');
                    row.push({
                        'time_period' : start + '-' + end,
                        'dow' : dow,
                        'length' : line.length,
                        'day_part' : line.daypart,
                        'network' : typeof line.network === 'undefined' ? '' : line.network,
                        'zone' : typeof line.zone === 'undefined' ? '' : line.zone,
                        'gross_cpa' : !isNaN(parseFloat(line.cost)) ? line.cost : 0,
                        'net_cpa' : !isNaN(parseFloat(line.cost))? line.cost * (1 - (ws_agency_commission_new_line / 100)) : 0,
                        'rating' : !isNaN(parseFloat(line.rating)) ? line.rating : 0,
                        'impressions' : !isNaN(parseFloat(line.impressions)) ? line.impressions : 0,
                        'comments': line.comments,
                        'lineable_id':  line.lineable_id,
                        'lineable_type':  line.lineable_type,
                        'tiered_rate':  line.tiered_rate,
                        'manual' : line.manual,
                        'program' : typeof line.program !== 'undefined' ? line.program : ''
                    });
                    for (var i in response.fd) {
                        row[0]['week_'+ response.fd[i].id] = typeof response.counts[response.fd[i].id] !== 'undefined' ? response.counts[response.fd[i].id][0].count : 0;
                        var w_id = response.fd[i].id;
                        if(typeof line.tiered_rate !== 'undefined' && line.tiered_rate === 1 && typeof response.counts[response.fd[i].id] !== 'undefined' && response.counts[response.fd[i].id][0].rate !== null )
                          row[0]['w_'+ response.fd[i].id + '_tired'] = response.counts[response.fd[i].id][0].rate;
                    }
                    console.log('current_node row', row);
                    newOrderLineGrid.rowData = row;
                }

                $('#newOrderLineGriddiv').html("");
                var newOrderLineGridDiv = document.querySelector('#newOrderLineGriddiv');
                var g5 = new agGrid.Grid(newOrderLineGridDiv, newOrderLineGrid);

                var med = (match_result.lineable_type.indexOf('LineTelevision') !== -1)  ? 'Television' : 'Radio';
                $('.vendor_bonus_div').html('<b>Vendor:</b> '+ match_result.vendor.name +' ('+ med+ ')' );
                $('.order_bonus_div').html('<b>Order:</b> '+ match_result.order.reference_number +' (Rev #: '+ match_result.revision.revision_number+')' );
                var col_to_hide = [];
                var col_to_show = [];
                if(med === 'Radio'){
                    col_to_hide.push('zone');
                    col_to_hide.push('network');
                    newOrderLineGrid.api.getColumnDef("impressions").headerName = "Hundreds";
                    newOrderLineGrid.api.refreshHeader();
                }
                else{
                    col_to_show.push('zone');
                    col_to_show.push('network');
                    newOrderLineGrid.api.getColumnDef("impressions").headerName = "Thousands";
                    newOrderLineGrid.api.refreshHeader();
                }
                newOrderLineGrid.rowData = [];
                newOrderLineGrid.columnApi.setColumnsVisible(col_to_hide, false);
                newOrderLineGrid.columnApi.setColumnsVisible(col_to_show, true);
                $('#showEntireFD').show();
                $('#newOrderLineModal').modal({backdrop: 'static', keyboard: false})
                $('#newOrderLineModal').draggable({
                    handle: ".modal-header"
                });
                console.log('current_node', current_node);

                $('#newOrderLineModal').modal('show');

                $('#showEntireFD').on('click', function(){
                    var col_to_show_new = [];
                    for (var i in response.fd) {
                        col_to_show_new.push('week_' + response.fd[i].id);
                        col_to_show_new.push('w_' + response.fd[i].id + '_tired');
                    }
                    newOrderLineGrid.columnApi.setColumnsVisible(col_to_show_new, true);
                });
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });

    }


    $("#addNewBonusLine").on("click", function(){
        var index= newOrderLineGrid.api.getModel().rowsToDisplay.length;
        if(typeof newOrderLineGrid.api.getFocusedCell() !== 'undefined' && newOrderLineGrid.api.getFocusedCell() !== null){
            var rowIndex= newOrderLineGrid.api.getFocusedCell().rowIndex;
            var selectedNodes = newOrderLineGrid.api.getSelectedNodes();

        }

        newOrderLineGrid.api.stopEditing(true);
        if($("#addNewBonusLine").attr('media') === 'tv' || $("#addNewBonusLine").attr('media') === 'radio') {
            newOrderLineGrid.api.updateRowData({
                add: [{
                    int_id: "-",
                    time_period: "",
                    dow: "",
                    length: 0,
                    network: "",
                    zone: "",
                    program: "",
                    rating: "0.0",
                    impressions: "0.0",
                    comments: "",
                }], addIndex: index
            });
            newOrderLineGrid.api.ensureColumnVisible('time_period')
            newOrderLineGrid.api.ensureIndexVisible(index);
            newOrderLineGrid.api.setFocusedCell(index, 'time_period', null);
        }else if($("#addNewBonusLine").attr('media') !== 'ott' ){
            newOrderLineGrid.api.updateRowData({
                add: [{
                    int_id: "-",
                    date_range: "",
                    date_print_mail: "",
                    camp_id: $("#addNewBonusLine").attr('campaign_id'),
                    rev_id: $("#addNewBonusLine").attr('rev_id'),
                    media: $("#addNewBonusLine").attr('media'),
                    ad_count: 0,
                    impressions: "0.0",
                    comments: "",
                    digital_commission: 0,
                    gross_cpa: 0,
                    mail_type: '',
                    custom_type: '',
                    format: '',
                    material_due: '',
                    space_due: '',
                    ooh_address: '',
                    ooh_direction: '',
                    print_ad_unit: '',
                    print_ad_color: '',
                    print_ad_size: '',
                    file_format: '',
                    file_size: '',
                    space_closing: '',
                    material_closing: '',
                    print_issue: '',
                    gross_cost: '',
                }], addIndex: index
            });
            newOrderLineGrid.api.ensureColumnVisible('date_rate')
            newOrderLineGrid.api.ensureIndexVisible(index);
            newOrderLineGrid.api.setFocusedCell(index, 'date_rate', null);
        }else {
            newOrderLineGrid.api.updateRowData({
                add: [{
                    int_id: "-",
                    date_range: "",
                    date_print_mail: "",
                    camp_id: $("#addNewBonusLine").attr('campaign_id'),
                    rev_id: $("#addNewBonusLine").attr('rev_id'),
                    media: $("#addNewBonusLine").attr('media'),
                    time_period: "",
                    day_part: "",
                    dow: "",
                    ad_count: 0,
                    length: 0,
                    impressions: "0.0",
                    comments: "",
                    gross_cpa: 0,
                }], addIndex: index
            });
            newOrderLineGrid.api.ensureColumnVisible('date_print_mail')
            newOrderLineGrid.api.ensureIndexVisible(index);
            newOrderLineGrid.api.setFocusedCell(index, 'date_print_mail', null);
        }
    });
    $('#saveOrderNewLines').on("click", function(){
        var cont = 0 ;
        var no_valid = 0;
        newOrderLineGrid.api.forEachNode(function (node) {
            if(node.data.time_period !== '' && node.data.dow !== '' && node.data.dow !== '-------')
                cont ++;
            else
                no_valid++;

        });
        $('#removeLinesOrder').hide();
        $('#closeLinesOrder').hide();
        $('#saveNewLinesOrder').hide();
        $('#editLinesOrder').hide();
        $('#saveNewLinesOrderOkButton').hide();
        if(no_valid > 0) {
            var html = 'Some of the avail lines are not complete.  Please add “Time Period” and “Days of Week” to continue.';
            $('#saveNewLinesOrderOkButton').show();
        }
        else if(cont > 0) {
            var tx = (cont > 1) ? 'lines' : 'line';
            var html = 'You are about to add <b>' + cont + '</b> '+ tx +' to the Order. Do you wish to continue?';
            $('#saveNewLinesOrder').show();
        }
        else {
            var html = 'Please add some line before save.';
            $('#saveNewLinesOrderOkButton').show();
        }
        $('.update_worksheet_line_div').hide();
        $('#div_warning_add_lines_to_order').html(html);
        $('#WarningSaveNeworEditedLineModal').modal('show');
    });
    $('#saveOrderNewLinesNoBr').on("click", function(){
        var cont = 0 ;
        var no_valid = 0;
        var media = '';
        newOrderLineGrid.api.forEachNode(function (node) {
            console.log('node_node', node);
            media = node.data.media;
          if(node.data.media === 'ott' ){
               current_value = node.data.date_range.split(' - ');
                current_value = typeof current_value[0] !== 'undefined' && moment(current_value[0], 'MM/DD/YYYY').isValid();

              if(typeof current_value[0] === 'undefined')
                  current_value = moment(node.data.date_range, 'MM/DD/YYYY').isValid();

                if (node.data.time_period !== '' && current_value === true && !isNaN(parseInt(node.data.ad_count)) && parseInt(node.data.ad_count) > 0)
                    cont++;
                else
                    no_valid++;
            }
            else{
                var date_range = node.data.media === 'print' || node.data.media === 'mail' ? node.data.date_print_mail : node.data.date_range;
                current_value = date_range.split(' - ');
                current_value = typeof current_value[0] !== 'undefined' && moment(current_value[0], 'MM/DD/YYYY').isValid();

                if(typeof current_value[0] === 'undefined')
                    current_value = moment(date_range, 'MM/DD/YYYY').isValid();

                if (node.data.time_period !== '' && current_value === true && !isNaN(parseInt(node.data.ad_count)) && parseInt(node.data.ad_count) > 0)
                    cont++;
                else
                    no_valid++;
            }
        });
        $('#removeLinesOrder').hide();
        $('#closeLinesOrder').hide();
        $('#saveNewLinesOrder').hide();
        $('#editLinesOrder').hide();
        $('#saveNewLinesOrderOkButton').hide();
        if(no_valid > 0) {
            if(media === 'ott')
                var html = 'Some of the avail lines are not complete. Please add “Time Period”, “Date” , and "Ad Count" to continue.';
            else
                var html = 'Some of the avail lines are not complete. Please add  “Date” and "Ad Count" to continue.';
            $('#saveNewLinesOrderOkButton').show();
        }
        else if(cont > 0) {
            var tx = (cont > 1) ? 'lines' : 'line';
            var html = 'You are about to add <b>' + cont + '</b> '+ tx +' to the Order. Do you wish to continue?';
            $('#saveNewLinesOrder').show();
        }
        else {
            var html = 'Please add some line before save.';
            $('#saveNewLinesOrderOkButton').show();
        }
        $('.update_worksheet_line_div').hide();
        $('#div_warning_add_lines_to_order').html(html);
        $('#WarningSaveNeworEditedLineModal').modal('show');
    });

    $('#editOrderNewLines').on("click", function(){
        var cont = 0 ;
        var no_valid = 0;
        newOrderLineGrid.api.forEachNode(function (node) {
            if(node.data.time_period !== '' && node.data.dow !== '' && node.data.dow !== '-------')
                cont ++;
            else
                no_valid++;

        });
        $('#removeLinesOrder').hide();
        $('#closeLinesOrder').hide();
        $('#saveNewLinesOrder').hide();
        $('#editLinesOrder').hide();
        $('#saveNewLinesOrderOkButton').hide();
        if(no_valid > 0) {
            var html = 'Some of the avail lines are not complete.  Please add “Time Period” and “Days of Week” to continue.';
            $('#saveNewLinesOrderOkButton').show();
            $('.update_worksheet_line_div').hide();
        }
        else if(cont > 0) {
            var tx = (cont > 1) ? 'lines' : 'line';
            var html = 'You are about to edit <b>' + cont + '</b> '+ tx +'. Do you wish to continue?';
            $('#editLinesOrder').show();
            $('.update_worksheet_line_div').show();
        }
        if(match_result.lineable_type === 'App\\Entities\\LineTelevision')
            $('#editLinesOrder').attr('media', 'tv');
        else
            $('#editLinesOrder').attr('media', 'radio');

        $('#div_warning_add_lines_to_order').html(html);
        $('#WarningSaveNeworEditedLineModal').modal('show');
    });
    $('#editOrderNewLinesNoBr').on("click", function(){
        var cont = 0 ;
        var no_valid = 0;
        var media = '';
        newOrderLineGrid.api.forEachNode(function (node) {
            console.log('node_node', node);
            media = node.data.media;
            if(node.data.media === 'ott' ){
                current_value = node.data.date_range.split(' - ');
                current_value = typeof current_value[0] !== 'undefined' && moment(current_value[0], 'MM/DD/YYYY').isValid();

                if(typeof current_value[0] === 'undefined')
                    current_value = moment(node.data.date_range, 'MM/DD/YYYY').isValid();

                if (node.data.time_period !== '' && current_value === true && !isNaN(parseInt(node.data.ad_count)) && parseInt(node.data.ad_count) > 0)
                    cont++;
                else
                    no_valid++;
            }
            else{
                var date_range = node.data.media === 'print' || node.data.media === 'mail' ? node.data.date_print_mail : node.data.date_range;
                current_value = date_range.split(' - ');
                current_value = typeof current_value[0] !== 'undefined' && moment(current_value[0], 'MM/DD/YYYY').isValid();

                if(typeof current_value[0] === 'undefined')
                    current_value = moment(date_range, 'MM/DD/YYYY').isValid();

                if (node.data.time_period !== '' && current_value === true && !isNaN(parseInt(node.data.ad_count)) && parseInt(node.data.ad_count) > 0)
                    cont++;
                else
                    no_valid++;
            }
        });
        $('#editLinesOrder').attr('media', media);
        $('#removeLinesOrder').hide();
        $('#closeLinesOrder').hide();
        $('#saveNewLinesOrder').hide();
        $('#editLinesOrder').hide();
        $('#saveNewLinesOrderOkButton').hide();
        $('.update_worksheet_line_div').hide();
        if(no_valid > 0) {
            if(media === 'ott')
                var html = 'Some of the avail lines are not complete. Please add “Time Period”, “Date” , and "Ad Count" to continue.';
            else
                var html = 'Some of the avail lines are not complete. Please add  “Date” and "Ad Count" to continue.';
        }
        else if(cont > 0) {
            var tx = (cont > 1) ? 'lines' : 'line';
            var html = 'You are about to edit <b>' + cont + '</b> '+ tx +' to the Order. Do you wish to continue?';
            $('#editLinesOrder').show();
            $('.update_worksheet_line_div').show();
        }

        $('#div_warning_add_lines_to_order').html(html);
        $('#WarningSaveNeworEditedLineModal').modal('show');
    });
    var gloabal_params_edit_line = [];
    $('#editLinesOrder').on("click", function() {
        $('#editLinesOrder').hide();
        if( $('#editLinesOrder').attr('media') === 'tv' || $('#editLinesOrder').attr('media') === 'radio' ) {
            var params = {
                media_type: match_result.lineable_type,
                lines: [],
                order_revision: match_result.revision,
                match_result: match_result.weeks,
                update_worksheet: ($("input:checkbox[name=update_worksheet_line]").prop('checked') === true) ? 1 : 0,
            };
            newOrderLineGrid.api.forEachNode(function (node) {
                params.lines.push(node.data);
            });
            gloabal_params_edit_line = params;
            if ($("input:checkbox[name=update_worksheet_line]").prop('checked') === true) {
                show_overlay_loader('#newOrderLineModal');
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    data: JSON.stringify(params),
                    url: '/reconciliation/edit/lines/to_order/exist_ws_line',
                    dataType: "json",
                    contentType: "application/json",
                    success: function (data) {
                        if (data.no_exist_ws_line === true) {
                            $('#noLineWarningEditedLineModal').modal('show');
                            hide_overlay_loader('#newOrderLineModal');

                        } else
                            update_order(params);
                    },
                    error: function (xhr) {
                        hide_overlay_loader('#newOrderLineModal');
                        debug(xhr.responseText);
                        ajax_error();
                        hide_loader();
                    }
                });
            } else
                update_order(params);
        }else {
            var params = {
                media_type: '',
                rev_id: 0,
                camp_id: 0,
                lines: [],
                update_worksheet: ($("input:checkbox[name=update_worksheet_line]").prop('checked') === true) ? 1 : 0,
            };
            newOrderLineGrid.api.forEachNode(function (node) {
                params.lines.push(node.data);
                params.rev_id = node.data.rev_id;
                params.camp_id = node.data.camp_id;
                params.media_type = node.data.media;
            });
            gloabal_params_edit_line = params;
            show_overlay_loader('#newOrderLineModal');
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/reconciliation/edit/lines/to_order/no_br',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    $('#order-details').click();
                    hide_overlay_loader('#newOrderLineModal');
                    global_notification('success', 'Order line updated...')
                    displayOrdersInvoices(global_way_to_search_manual_invoices);
                    if($('#send_to_wmj_checkbox').is(":checked"))
                        send_order_to_wmj(data);

                },
                error: function (xhr) {
                    hide_overlay_loader('#newOrderLineModal');
                    debug(xhr.responseText);
                    ajax_error();
                    hide_loader();
                }
            });

        }
    });

    $('.confirmAffterMessage').on("click", function() {
        if($(this).attr('data-value') === 'no')
            update_order(gloabal_params_edit_line);
        else
            createNewLinesOrder(gloabal_params_edit_line);
    });

    function createNewLinesOrder(gloabal_params_edit_line) {
        show_overlay_loader('#newOrderLineModal');
        var params = gloabal_params_edit_line;
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/reconciliation/add/new/lines/to_ws',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                update_order(gloabal_params_edit_line);
                },
            error: function (xhr) {
                hide_overlay_loader('#newOrderLineModal');
                debug(xhr.responseText);
                ajax_error();
                hide_loader();
            }
        });
    }
    function update_order(params){
        show_overlay_loader('#newOrderLineModal');
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/reconciliation/edit/lines/to_order',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                if(data.no_exist_ws_line === true){

                }
                else {
                    console.log('data ', data);
                    var ordered_spots = data.olines_weeks[data.lineable_id];
                    if (typeof match_result.ordered_spots[data.lineable_id] === 'undefined')
                        match_result.ordered_spots[data.lineable_id] = [];

                    if (typeof match_result.weeks_totals[data.lineable_id] === 'undefined')
                        match_result.weeks_totals[data.lineable_id] = [];

                    for (var week_id in  ordered_spots) {
                        if (typeof match_result.ordered_spots[data.lineable_id][week_id] === 'undefined')
                            match_result.ordered_spots[data.lineable_id][week_id] = [];
                        match_result.ordered_spots[data.lineable_id][week_id][0] = ordered_spots[week_id][0];
                        match_result.ordered_spots[data.lineable_id][week_id][1] = ordered_spots[week_id][1];

                        if (typeof match_result.weeks_totals[data.lineable_id][week_id] === 'undefined')
                            match_result.weeks_totals[data.lineable_id][week_id] = [];
                        match_result.weeks_totals[data.lineable_id][week_id] = ordered_spots[week_id][1];
                    }
                    console.log('match_result after update', match_result);

                    for (var line_id in  data.olines_added) {
                        if (typeof match_result.olines[line_id] !== 'undefined')
                            match_result.olines[line_id] = data.olines_added[line_id];
                        else {
                            match_result.olines[line_id] = [];
                            match_result.olines[line_id] = data.olines_added[line_id];
                        }
                    }
                    for (var line_id in  data.olines_spots) {
                        if (typeof match_result.oline_spots[line_id] !== 'undefined')
                            match_result.oline_spots[line_id] = data.olines_spots[line_id];
                        else {
                            match_result.oline_spots[line_id] = [];
                            match_result.oline_spots[line_id] = data.olines_spots[line_id];
                        }
                    }

                    if (typeof match_result.tiered_rates[data.lineable_id] !== 'undefined')
                        match_result.tiered_rates[data.lineable_id] = data.tired_rates;
                    else {
                        match_result.tiered_rates[data.lineable_id] = [];
                        match_result.tiered_rates[data.lineable_id] = data.tired_rates;
                    }

                    if (data.tiered_rates_lines !== '')
                        match_result.tiered_rates_lines.push(data.tiered_rates_lines);
                    else if (match_result.tiered_rates_lines.indexOf(data.lineable_id) !== -1) {
                        var ind = match_result.tiered_rates_lines.indexOf(data.lineable_id);
                        match_result.tiered_rates_lines.splice(ind, 1);
                    }

                    if ($("#orderlines").css('display') !== 'none') {
                        $("#orderlines").html("");
                        drawBuyLines();
                    }
                    if($('#send_to_wmj_checkbox').is(":checked"))
                        send_order_to_wmj();
                    $('#newOrderLineModal').modal('hide');
                }
                hide_overlay_loader('#newOrderLineModal');

            },
            error: function (xhr) {
                hide_overlay_loader('#newOrderLineModal');
                debug(xhr.responseText);
                ajax_error();
                hide_loader();
            }
        });
    }

    $('#removeNewBonusLine').on("click", function(){
        $('#removeLinesOrder').hide();
        $('#saveNewLinesOrderOkButton').hide();
        $('#saveNewLinesOrder').hide();
        $('#editLinesOrder').hide();
        $('#closeLinesOrder').hide();
        $('.update_worksheet_line_div').hide();
        if(newOrderLineGrid.api.getSelectedNodes().length > 0){
            var tx = (newOrderLineGrid.api.getSelectedNodes().length > 1) ? 'lines' : 'line';
            var html = 'You are about to delete ' + newOrderLineGrid.api.getSelectedNodes().length +' '+ tx +'. Do you wish to continue?';
            $('#removeLinesOrder').show();
            $('#div_warning_add_lines_to_order').html(html);
            $('#WarningSaveNeworEditedLineModal').modal('show');
        }
        else{
            var html = 'Please select at least 1 line to Remove.';
            $('#saveNewLinesOrderOkButton').show();
            $('#div_warning_add_lines_to_order').html(html);
            $('#WarningSaveNeworEditedLineModal').modal('show');
        }
    });

    function removeLinesOrder() {
        newOrderLineGrid.api.removeItems(newOrderLineGrid.api.getSelectedNodes());
        newOrderLineGrid.api.refreshView();
    }

    function saveNewLinesOrder(){
        if($('#addNewBonusLine').attr('media') === 'tv' || $('#addNewBonusLine').attr('media') === 'radio') {
            var params = {
                media_type: match_result.lineable_type,
                lines: [],
                order_revision: match_result.revision,
                match_result: match_result.weeks,
            };
            newOrderLineGrid.api.forEachNode(function (node) {
                params.lines.push(node.data);
            });
            show_overlay_loader('#newOrderLineModal');
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/reconciliation/add/new/lines/to_order',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    for (var line_id in data.olines_weeks) {
                        match_result.weeks_totals[line_id] = [];
                        match_result.ordered_spots[line_id] = [];

                        for (var wk in data.olines_weeks[line_id]) {
                            match_result.weeks_totals[line_id][wk] = 0;
                            match_result.weeks_totals[line_id][wk] = data.olines_weeks[line_id][wk];

                            match_result.ordered_spots[line_id][wk] = [];
                            match_result.ordered_spots[line_id][wk][0] = moment(match_result.weeks[wk]['start']).format('YYYY-MM-DD');
                            match_result.ordered_spots[line_id][wk][1] = data.olines_weeks[line_id][wk];
                        }
                    }
                    for (var line_id in data.olines_added) {
                        match_result.olines[line_id] = [];
                        match_result.olines[line_id] = data.olines_added[line_id];
                    }
                    for (var line_id in data.olines_spots) {
                        match_result.oline_spots[line_id] = [];
                        match_result.oline_spots[line_id] = data.olines_spots[line_id];
                    }
                    for (var line_id in data.tired_rates) {
                        match_result.tiered_rates[line_id] = [];
                        match_result.tiered_rates[line_id] = data.tired_rates[line_id];
                    }
                    for (var ind in data.tiered_rates_lines)
                        match_result.tiered_rates_lines.push(data.tiered_rates_lines[ind])
                    if ($("#orderlines").css('display') !== 'none') {
                        $("#orderlines").html("");
                        drawBuyLines();
                    }
                    global_revise_order_change = false;
                    if ($('#send_to_wmj_checkbox').is(":checked"))
                        send_order_to_wmj();
                    $('#newOrderLineModal').modal('hide');
                    hide_overlay_loader('#newOrderLineModal');

                },
                error: function (xhr) {
                    hide_overlay_loader('#newOrderLineModal');
                    debug(xhr.responseText);
                    ajax_error();
                    hide_loader();
                }
            });
        }
        else {
            var params = {
                media_type: $('#addNewBonusLine').attr('media'),
                lines: [],
                order_revision: $('#addNewBonusLine').attr('rev_id'),
                campaign_id: $('#addNewBonusLine').attr('campaign_id'),
            };
            newOrderLineGrid.api.forEachNode(function (node) {
                params.lines.push(node.data);
            });
            show_overlay_loader('#newOrderLineModal');
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/reconciliation/add/new/lines/to_order/no_broadcast',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    global_revise_order_change = false;
                    $('#order-details').click();
                    displayOrdersInvoices(global_way_to_search_manual_invoices);
                    if ($('#send_to_wmj_checkbox').is(":checked"))
                        send_order_to_wmj(data);
                    $('#newOrderLineModal').modal('hide');


                },
                error: function (xhr) {
                    hide_overlay_loader('#newOrderLineModal');
                    debug(xhr.responseText);
                    ajax_error();
                    hide_loader();
                }
            });
        }
    }

    $('.cancel_new_lines_button').on('click', function(){
        $('#removeLinesOrder').hide();
        $('#saveNewLinesOrderOkButton').hide();
        $('#saveNewLinesOrder').hide();
        $('#editLinesOrder').hide();
        $('#closeLinesOrder').hide();
        var cont = 0;
        newOrderLineGrid.api.forEachNode(function (node){
            cont ++;
        });

        if(cont > 0){
            $('#closeLinesOrder').show();
            $('#div_warning_add_lines_to_order').html('The unsaved changes will be lost. Are you sure you want to continue?');
            $('#WarningSaveNeworEditedLineModal').modal('show');
        }
        else
            $('#newOrderLineModal').modal('hide');

    });
    $('#closeLinesOrder').on('click', function(){
        $('#newOrderLineModal').modal('hide');
    });

    $('#show_wmj_modal_order').on('click', function(){
        var params_new = {
            orders: [match_result.revision.order_id],
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params_new),
            url: '/orders/export/workamajig/api/multiple/info/',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                var columnOrderExportWorkApi = [
                    {
                        headerName: "Plan ID",
                        field: 'plan_id',
                        width: 180,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: "Order Link ID",
                        field: 'orderLinkID',
                        width: 180,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: "Plan Name",
                        field: 'plan_name',
                        width: 200,
                        cellStyle: {'text-align': "left"},
                        editable: true,
                    },
                    {
                        headerName: "Project Number",
                        field: 'project_number',
                        width: 150,
                        cellStyle: {'text-align': "left"},
                    },
                    {
                        headerName: "Spot Link ID",
                        field: 'spot_id',
                        width: 180,
                        cellStyle: {'text-align': "right"},
                    },
                    {
                        headerName: "Station ID",
                        field: 'station_id',
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        editable: true,
                    },
                    {
                        headerName: "Action",
                        field: 'action',
                        width: 150,
                        cellStyle: {'text-align': "right"},
                    },
                    {
                        headerName: "Item ID",
                        field: 'media_type',
                        width: 130,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Amount to Bill",
                        field: 'gross',
                        width: 150,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Commission",
                        field: 'commission',
                        width: 150,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Cost",
                        field: 'cost',
                        width: 150,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Gross",
                        field: 'gross',
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        cellClassRules: {
                            'ag-cell-client_rate': function (params) {
                                if (params.node.rowPinned != 'top') {
                                    if (typeof params.data['amount_to_bill'] !== 'undefined' && params.data['amount_to_bill'] !== params.value)
                                        return true;
                                    else
                                        return false;
                                }
                                return false;
                            },
                        },
                    },
                    {
                        headerName: "Client Gross %",
                        field: 'client_gross_comm',
                        width: 120,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Client Gross Applied",
                        field: 'client_gross_type',
                        width: 160,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Quantity",
                        field: 'quantity',
                        width: 150,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Description",
                        field: 'description',
                        width: 200,
                        cellStyle: {'text-align': "right"}
                    },

                    {
                        headerName: "Start Date",
                        field: 'start_date',
                        width: 150,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "End Date",
                        field: 'end_date',
                        width: 150,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Archive",
                        field: 'archive',
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        hide:true
                    },
                    {
                        headerName: "Days",
                        field: 'orderDays',
                        width: 80,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Time",
                        field: 'orderTime',
                        width: 80,
                        cellStyle: {'text-align': "right"},
                        comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                            if (valueA.includes('PM') && valueB.includes('AM')) {
                                return 1;
                            } else if (valueA.includes('AM') && valueB.includes('PM')) {
                                return -1;
                            } else {
                                var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                                var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                                var arr1 = timeA.split(':');
                                var arr2 = timeB.split(':');

                                if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                                    return 0;
                                else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                                    return 1;
                                else
                                    return -1;
                            }
                        }
                    },
                    {
                        headerName: "Length ",
                        field: 'orderLength',
                        width: 80,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Materials Due",
                        field: 'materialsDue',
                        width: 100,
                        cellStyle: {'text-align': "right"}
                    },
                    {
                        headerName: "Space Close",
                        field: 'spaceClose',
                        width: 100,
                        cellStyle: {'text-align': "right"}
                    },

                ];
                var gridOrderExportWorkAPI = {
                    columnDefs: columnOrderExportWorkApi,
                    defaultColDef: {
                        suppressToolPanel: true
                    },
                    rowSelection: 'single',
                    suppressRowClickSelection: false,
                    enableColResize: true,
                    suppressMenuColumnPanel: true,
                    suppressTouch: true,
                    headerHeight: 20,
                    suppressDragLeaveHidesColumns: true,
                    enableCellChangeFlash: true,
                    rowHeight: 20,
                    suppressRowHoverClass: true,
                    suppressParentsInRowNodes: true,
                    toolPanelSuppressValues: true,
                    toolPanelSuppressRowGroups: true,
                    groupUseEntireRow: false,
                    groupDefaultExpanded: 1,
                    marryChildren: true,
                    suppressAggFuncInHeader: true,
                    enableFilter: true,
                    enableSorting: true,
                    animateRows: true,
                    icons: {
                        groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                        groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                        menu: '<i class="fa fa-bars fa-lg"/>',
                        sortAscending: '<i class="fa fa-caret-down"/>',
                        sortDescending: '<i class="fa fa-caret-up"/>',
                        columnMoveMove: '<i class="fa fa-arrows"></i>',
                        columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                        columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                        columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                        columnMoveHide: '<i class="fa fa-remove"/>'
                    },
                };
                gridOrderExportWorkAPI.rowData = [];
                gridOrderExportWorkAPI.rowData = data.grid_lines;
                $('#orderExportInfoGridWorkAPI').html("");
                var gridOrderExportWorkAPID = document.querySelector('#orderExportInfoGridWorkAPI');
                var g5 = new agGrid.Grid(gridOrderExportWorkAPID, gridOrderExportWorkAPI);
                $('#OrderExportInfoWorAPIkOrder').modal({backdrop: 'static', keyboard: false})
                global_sent_api = false;
                if(data.disclaimer == 1)
                    $('.work_disclaimer_div').show()
                else
                    $('.work_disclaimer_div').hide()

                $('#sent_to_workamajig_order').attr('data-order-id', match_result.revision.order_id)
                $('#OrderExportInfoWorAPIkOrder').modal('show');
                hide_loader();
                close_progress_loader();
                $('#expor_work_api_order').on('click', function() {
                    var params = {
                        skipHeader: false,
                        columnGroups: false,
                        skipFooters: false,
                        skipGroups: true,
                        skipPinnedTop: false,
                        skipPinnedBottom: false,
                        allColumns: false,
                        onlySelected: false,
                        suppressQuotes: false,
                        fileName: "export",
                        suppressTextAsCDATA: false,
                        // excelStyles: excelStyles,
                    };
                    params.fileName = 'export.csv';
                    gridOrderExportWorkAPI.api.exportDataAsCsv(params);
                });
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
                close_progress_loader();
            }
        });

    });

    // $('#sent_to_workamajig_order').on('click',  function(){
    //     if(global_revise_order_change === false)
    //         send_order_to_wmj();
    //     else{
    //         swal({
    //                 title: 'Warning',
    //                 text: "The have unsaved changes, they won't be send to WMJ. Are you sure you want to continue?",
    //                 type: "warning",
    //                 showCancelButton: true,
    //                 confirmButtonClass: "btn-danger",
    //                 confirmButtonText: "OK",
    //                 cancelButtonText: "Close",
    //                 closeOnConfirm: true,
    //                 closeOnCancel: true
    //             },
    //             function (isConfirm) {
    //                if(isConfirm){
    //                    send_order_to_wmj();
    //                }
    //
    //
    //             });
    //     }
    // });
    function send_order_to_wmj(order_id = null){
        order_id = order_id === null ? match_result.order.id : order_id;
        var url = $('#sent_to_workamajig_order').attr('data-url');
        init_progress_loader_wmj(2, 'Waiting for response from Workamajig.');
        var params = {
            orders: [order_id],
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                var type = '';
                var title ='';
                if(data === '060606'){
                    var text = "The domain you are using to integrate with Workamajig is incorrect. ";
                    var type = 'warning';
                    var title = 'Warning!';
                }else if(data === '000'){
                    var text = "The selected Order has been Archived, you can't send Archived Orders to Workamajig.";
                    var type = 'warning';
                    var title = 'Warning!';
                }
                else if (data === false) {
                    var text = "Your user has no integration with Workamajig, please go to Agency Settings and make the integration.";
                    var type = 'warning';
                    var title = 'Warning!';
                }
                else if(data == 400) {
                    var text = "An error has happened sending to Workamajig! Please contact support if the issue persists."
                    var type = 'error';
                    var title = 'Error!';
                }
                else if(data == 'success'){
                    var text = "The Order(s) have been sent successfully!";
                    var type = 'success';
                    var title = 'Success!';
                }
                else{
                    var text = "An error has happened sending to Workamajig! Please contact support if the issue persists.";
                    var type = 'error';
                    var title = 'Error!';
                }
                close_progress_loader_wmj();
                swal({
                        title: title,
                        text: text,
                        type: type,
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Ok",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });

            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                close_progress_loader_wmj();
            }
        });
    }

   var gridOlinesOptions = {
        columnDefs: columnOLinesDefs,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
       getContextMenuItems : getContextMenuItemsOrderLine,
        onGridReady: function () {
            if(buyLinesColSettings.length > 0)
                gridOlinesOptions.columnApi.setColumnState(buyLinesColSettings);
        },
        onColumnResized: function(params) {
            buyLinesColSettings = gridOlinesOptions.columnApi.getColumnState();
        },
        onFilterChanged: function () {
           if (this.api.isAnyFilterPresent()) {
               filter__array_to_keep = gridOlinesOptions.api.getFilterModel();
               console.log('getFilterModel .... ', filter__array_to_keep);
               $('#reset_filters_buy_line').show();
           }
           else {
               filter__array_to_keep = {};
               $('#reset_filters_buy_line').hide();
           }

        }
    };
    $('#reset_filters_buy_line').on('click', function () {
        $.each(gridOlinesOptions.api.getFilterModel(), function (index, value) {
            gridOlinesOptions.api.destroyFilter(index);
        });
    });
   var gridOSinglelinesOptions = {
        columnDefs: columnOLinesDefs,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onGridReady: function () {
            if(buyLinesColSettings.length > 0)
                gridOSinglelinesOptions.columnApi.setColumnState(buyLinesColSettings);
        },
        onColumnResized: function(params) {
            buyLinesColSettings = gridOSinglelinesOptions.columnApi.getColumnState();
        }
    };
   var monthly_data=[];
   var columnMonthlyInvoiceInfo = [
            {
                headerName: "Month",
                field: 'month',
                width: 150,
                editable: true,
                cellEditor: MonthSelectCellEditor,
                cellRenderer: StringFormatRenderer,
                cellStyle: {'text-align': "right"}
            },
          {
                headerName: "Advertiser",
                field: 'advertiser',
                width: 250,
                cellStyle: {'text-align': "right"}
            },
            {
                headerName: "Campaign",
                field: 'campaign',
                width: 300,
                cellStyle: {'text-align': "right"}
            },
           {
               headerName: "Market",
               field: 'market',
               width: 300,
               cellStyle: {'text-align': "right"}
           },
            {
                headerName: "Media",
                field: 'media',
                width: 100,
                cellStyle: {'text-align': "right"}
            },
            {
                headerName: "Flight Dates",
                field: 'flight_date',
                width: 220,
                cellStyle: {'text-align': "right"}
            },
            {
                headerName: "Revision ID",
                field: 'revision_id',
                width: 220,
                hide:true,
                cellStyle: {'text-align': "right"}
            },
            {
                headerName: "Market",
                field: 'market',
                width: 250,
                cellStyle: {'text-align': "right"}
            },
           {
               headerName: "Order Number",
               field: 'order_number',
               width: 200,
               editable: false,
               cellStyle: {'text-align': "right"}
           },
            {
                headerName: "Station",
                field: 'station',
                width: 150,
                cellStyle: {'text-align': "right"}
            },
            {
                headerName: "Status",
                field: 'status',
                width: 120,
                cellStyle: {'text-align': "right"}
            },
           {
               headerName: "Invoice <br> Numbers ",
               field: 'invoice_number',
               width: 150,
               cellStyle: {'text-align': "right"},
               hide: false,
           },
            {
                headerName: "Invoice <br> Gross ",
                field: 'invoice_gross',
                width: 105,
                cellRenderer: CurrencyFormatRenderer,
                cellEditor: CurrencyCellEditor,
                cellStyle: {'text-align': "right"}
            },
           {
               headerName: "Invoice <br> Net ",
               field: 'invoice_net',
               width: 105,
               cellRenderer: CurrencyFormatRenderer,
               cellEditor: CurrencyCellEditor,
               cellStyle: {'text-align': "right"}
           },
            {
               headerName: "Invoice <br> Gross Approved",
               field: 'invoice_gross_approved',
               width: 105,
               cellRenderer: CurrencyFormatRenderer,
               cellEditor: CurrencyCellEditor,
               cellStyle: {'text-align': "right"}
            },

            {
               headerName: "Invoice <br> Net Approved",
               field: 'invoice_net_approved',
               width: 105,
               cellRenderer: CurrencyFormatRenderer,
               cellEditor: CurrencyCellEditor,
               cellStyle: {'text-align': "right"}
            },
           {
               headerName: "Invoice </br> Spots",
               field: 'invoice_spots',
               width: 80,
               cellRenderer: IntegerFormatRenderer,
               cellEditor: IntegerCellEditor,
               cellStyle: {'text-align': "right"}

           },
           {
               headerName: "Invoice </br> Impressions",
               field: 'impressions_invoiced',
               headerTooltip: 'The Invoice Impressions and Ordered Impressions are applicable to Digital media only.',
               width: 120,
               cellRenderer: IntegerFormatRenderer,
               cellEditor: IntegerCellEditor,
               cellStyle: {'text-align': "right"}

           },
            {
                headerName: "Ordered <br> Gross",
                field: 'order_gross',
                width: 125,
                cellRenderer: CurrencyFormatRenderer,
                cellEditor: CurrencyCellEditor,
                cellStyle: {'text-align': "right"}
            },

           {
               headerName: "Ordered <br> Net",
               field: 'order_net',
               width: 125,
               cellRenderer: CurrencyFormatRenderer,
               cellEditor: CurrencyCellEditor,
               cellStyle: {'text-align': "right"}
           },

            {
                headerName: "Order No",
                field: 'order_number',
                width: 150,
                cellStyle: {'text-align': "right"},
                hide: true,
            },


            {
                headerName: "Ordered <br> Spots",
                field: 'order_spots',
                width: 80,
                cellRenderer: IntegerFormatRenderer,
                cellEditor: IntegerCellEditor,
                cellStyle: {'text-align': "right"}
            },
            {
                   headerName: "Ordered </br> Impressions",
                   headerTooltip: 'The Invoice Impressions and Ordered Impressions are applicable to Digital media only.',
                   field: 'impressions_ordered',
                   width: 120,
                cellRenderer: IntegerFormatRenderer,
                cellEditor: IntegerCellEditor,
                   cellStyle: {'text-align': "right"}

            },
            {
                headerName: "Initial index ",
                field: 'initial_index',
                width: 150,
                hide: true,
            },
        ];
   var columnMonthlyInvoiceInfoTop = [{
        month: '',
        advertiser: '',
        campaign: '',
        media: '',
        market: '',
        station: '',
        status: '',
        invoice_gross: '',
        order_gross: '',
        order_net: '',
        order_number: '',
        invoice_spots: '',
        order_spots: '',
        invoice_number: '',
        initial_index:'',
    }];

   var gridMonthlyInfo = {
        columnDefs: columnMonthlyInvoiceInfo,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        pinnedTopRowData: columnMonthlyInvoiceInfoTop,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 30,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuMonthInfo,
        onGridReady: function (e) {

        },
        onFilterChanged: function (e) {
            //update flotting values
            var spot_order=0;
            var spot_invoice=0;
            var gross_order=0;
            var net_order=0;
            var gross_invoice=0;
            var net_invoice = 0;
            var invoice_gross_approved= 0;
            var invoice_net_approved= 0;
            var impressions_invoiced = 0;
            var impressions_ordered = 0;
            this.api.forEachNodeAfterFilterAndSort(function (node) {
                console.log('node ^^^^', node);
                if(!isNaN(parseFloat(node.data.order_gross)))
                    gross_order+=parseFloat(node.data.order_gross);

                if(!isNaN(parseFloat(node.data.impressions_ordered)))
                    impressions_ordered+=parseFloat(node.data.impressions_ordered);

                if(!isNaN(parseFloat(node.data.impressions_invoiced)))
                    impressions_invoiced+=parseFloat(node.data.impressions_invoiced);

                if(!isNaN(parseFloat(node.data.order_net)))
                    net_order+=parseFloat(node.data.order_net);

                if(!isNaN(parseFloat(node.data.invoice_gross)))
                    gross_invoice+=parseFloat(node.data.invoice_gross);
                if(!isNaN(parseFloat(node.data.invoice_net)))
                    net_invoice+=parseFloat(node.data.invoice_net);
                if(!isNaN(parseFloat(node.data.invoice_gross_approved)))
                    invoice_gross_approved+=parseFloat(node.data.invoice_gross_approved);
                if(!isNaN(parseFloat(node.data.invoice_net_approved)))
                    invoice_net_approved+=parseFloat(node.data.invoice_net_approved);

                if(!isNaN(parseInt(node.data.order_spots)))
                    spot_order+=parseInt(node.data.order_spots);
                if(!isNaN(parseInt(node.data.invoice_spots)))
                    spot_invoice+=parseInt(node.data.invoice_spots);
            });
            var top_row_data_invoice = {
                order_gross: gross_order,
                order_net: net_order,
                order_spots:spot_order,
                invoice_spots:spot_invoice,
                invoice_gross: gross_invoice,
                invoice_net: net_invoice,
                invoice_gross_approved: invoice_gross_approved,
                invoice_net_approved: invoice_net_approved,
                impressions_ordered: impressions_ordered,
                impressions_invoiced: impressions_invoiced,
            };
            this.api.setPinnedTopRowData([top_row_data_invoice]);
        },
        onCellValueChanged: function (e) {
            if(e.colDef.field === 'month'){
                console.log('month changed ', e.node.data);
                console.log('month changed monthly_data', monthly_data);
               var order_number= e.node.data.revision_id;
              // var date= e.node.data.month;
               var month= e.node.data.month;
                for(var x in monthly_data){
                    if(monthly_data[x]["revision_id"] == order_number && monthly_data[x]["index"]== e.node.data.initial_index){
                        $.each(monthly_data[x]['months'], function (index, value) {
                           if(index== month || (index=='Total' && month=='All')){
                              // var oo= value["gross_order"];
                               e.node.data.order_gross= value["gross_order"];
                               e.node.data.order_net= value["net_order"];
                               e.node.data.order_spots= value["spots_order"];
                               e.node.data.invoice_number= (index== month) ? value["invoice_number"] : '-';
                               e.node.data.invoice_spots= value["spots_invoice"];
                               e.node.data.invoice_gross= value["gross_invoice"];
                               e.node.data.invoice_net= value["net_invoice"];
                               e.node.data.invoice_gross_approved= value["gross_invoice_approved"];
                               e.node.data.invoice_net_approved= value["net_invoice_approved"];
                               e.node.data.impressions_invoiced= value["impressions_invoiced"];
                               e.node.data.impressions_ordered= value["impressions_ordered"];
                               e.node.data.status= value["status"];
                               e.api.refreshCells([e.node], ['order_gross','order_net', 'order_spots', 'invoice_number', 'invoice_spots', 'invoice_gross', 'status', 'net_invoice',
                                   'invoice_net_approved', 'invoice_gross_approved', 'impressions_ordered', 'impressions_invoiced']);
                           }
                        });
                    }
                }
                //update flotting values
                var spot_order=0;
                var spot_invoice=0;
                var gross_order=0;
                var net_order=0;
                var gross_invoice=0;
                var net_invoice=0;
                var invoice_gross_approved= 0;
                var invoice_net_approved= 0;
                var impressions_ordered= 0;
                var impressions_invoiced= 0;
                this.api.forEachNodeAfterFilterAndSort(function (node) {
                    if(!isNaN(parseFloat(node.data.order_gross)))
                        gross_order+=parseFloat(node.data.order_gross);

                    if(!isNaN(parseFloat(node.data.order_net)))
                        net_order+=parseFloat(node.data.order_net);

                    if(!isNaN(parseFloat(node.data.impressions_ordered)))
                        impressions_ordered+=parseFloat(node.data.impressions_ordered);

                    if(!isNaN(parseFloat(node.data.impressions_invoiced)))
                        impressions_invoiced+=parseFloat(node.data.impressions_invoiced);

                    if(!isNaN(parseFloat(node.data.invoice_gross)))
                        gross_invoice+=parseFloat(node.data.invoice_gross);
                    if(!isNaN(parseFloat(node.data.invoice_net)))
                        net_invoice+=parseFloat(node.data.invoice_net);
                    if(!isNaN(parseFloat(node.data.invoice_gross_approved)))
                        invoice_gross_approved+=parseFloat(node.data.invoice_gross_approved);
                    if(!isNaN(parseFloat(node.data.invoice_net_approved)))
                        invoice_net_approved+=parseFloat(node.data.invoice_net_approved);

                    if(!isNaN(parseInt(node.data.order_spots)))
                       spot_order+=parseInt(node.data.order_spots);
                    if(!isNaN(parseInt(node.data.invoice_spots)))
                        spot_invoice+=parseInt(node.data.invoice_spots);
                });
               var top_row_data_invoice = {
                   order_gross: gross_order,
                   order_net: net_order,
                   order_spots:spot_order,
                   invoice_spots:spot_invoice,
                   invoice_gross: gross_invoice,
                   invoice_net: net_invoice,
                   invoice_gross_approved: invoice_gross_approved,
                   invoice_net_approved: invoice_net_approved,
                   impressions_ordered: impressions_ordered,
                   impressions_invoiced: impressions_invoiced,
                };
               console.log('top_row_data_invoice ', top_row_data_invoice);
                this.api.setPinnedTopRowData([top_row_data_invoice]);
            }
        },
    };
    function getContextMenuMonthInfo(params) {
        var result = [
            'export',
            'separator',
        ];
        return result;
    }
    $('#print_monthly_info').on('click', function () {
       $('#monthly_print_options').multiSelect({
           selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
           selectionHeader: "<div class='' style='height: 38px;'> <input type='button' class='btn btn-primary m-r-5 btn-sm btn-outline' value='Select All' id='select_all_fields_mi' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm btn-outline' value='Deselect All' id='deselect_all_fields_mi'> </div>",
           afterInit: function(ms){
               var that = this,
                   $selectableSearch = that.$selectableUl.prev(),
                   selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

               that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                   .on('keydown', function(e){
                       if (e.which === 40){
                           that.$selectableUl.focus();
                           return false;
                       }
                   });
           },
           afterSelect: function(values){
               this.qs1.cache();
           },
           afterDeselect: function(values){
               this.qs1.cache();
           }
       });
       var columns =  gridMonthlyInfoNew.columnApi.getColumnState();
       console.log('columns', columns);
       var html  = '';
        html += '<option value="order_number" selected>Order Number</option>';
        html += '<option value="month" selected>Month</option>';
       var array = { order_number: 'Order Number', month : 'Month', media: 'Media Type',};
       for(var ind in columns){
           if(typeof array[columns[ind].colId] === 'undefined') {
               var col_name = $('.monthly_inv_info_hide_show_columns .' + columns[ind].colId).html();
               var sel = columns[ind].hide === true ? '' : 'selected';
               if(typeof col_name !== 'undefined')
                 html += '<option value="' + columns[ind].colId + '" ' + sel + '>' + col_name + '</option>';
           }
           else if(columns[ind].colId === 'media_type'){
               var col_name = $('.monthly_inv_info_hide_show_columns .media_type').html();
               var sel = columns[ind].hide === true ? '' : 'selected';
               html += '<option value="media_type' + sel + '> Media Type </option>';
           }
       }
       console.log('html', html);
        $('#monthly_print_options').html(html).multiSelect('refresh');;

       $('#printMonthlyInfoOptios').modal('show');

        $('#select_all_fields_mi').on('click',function () {
            $('#monthly_print_options').multiSelect('select_all');
        });

        $('#deselect_all_fields_mi').on('click', function () {
            $('#monthly_print_options').multiSelect('deselect_all');
        });
    });



    $('#print_submit_monthly_op').on('click', function () {
        var selectedItems=[];
        $('.invoice_check_order input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });

        var params = {
            advertiser_id: $('#advertiser_to_monthly_info').val(),
            campaigns_id: $("#campaigns_to_monthly_info").val(),
            type: $('#invoice_type_monthly').val(),
            years: $('#search_years').val(),
            calendar_type: $("input:radio[name=type_monthly]:checked").attr('value'),
            calendar: $('#monthly_monthly').val(),
            only_invoce: selectedItems,
            lines: [],
            options: $('#monthly_print_options').val(),
            orientation: $("input:radio[name=orientation_type]:checked").attr('value'),
            report_name_custom: $('#report_name_custom').val(),
            columns_name: {},
        };
        var columns =  gridMonthlyInfoNew.columnApi.getColumnState();
        var columns_name = [];
        var row = {
            '0': "order_number",
            '1': "Order Number",
        }
        columns_name.push(row);
        var row = {
            '0': "month",
            '1': "Month",
        }
        columns_name.push(row);
        var row = {
            '0': "media",
            '1': "Media Type",
        }
        columns_name.push(row);
        for(var ind in columns){
            if(columns[ind].colId !== 'order_number' && columns[ind].colId !== 'month' && columns[ind].colId !== 'media') {
                var col_name = $('.monthly_inv_info_hide_show_columns .' + columns[ind].colId).html();
                columns_name[columns[ind].colId] = col_name;
                var row = {
                    '0': columns[ind].colId,
                    '1': col_name,
                }
                columns_name.push(row);
            }
        }

        var lines = [];
        var top_row = gridMonthlyInfoNew.api.pinnedRowModel.pinnedTopRows[0].data;
        lines.push(top_row);
        gridMonthlyInfoNew.api.forEachNode(function (node) {
            console.log('node ', node);
            if (node.level === 1)
                lines.push(node.data);
        });

        console.log('params_params lines', lines);
        console.log('params_params columns_name', columns_name);
        $('#hidden_lines').val( JSON.stringify(lines));
        $('#column_names_report_mi_hidden').val( JSON.stringify(columns_name));
        $('#print_monthly_form').submit();

    });

    $('#invoice_status_report').on('click', function () {
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/status_report/get_advertisers/',
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data['advertisers'], function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name});
                });
                advertisers.sort(function (a, b) {
                    if (a.text > b.text) {
                        return 1;
                    }
                    if (a.text < b.text) {
                        return -1;
                    }
                    return 0;
                });
                $('#campaigns_to_invoice_status').select2({
                    data: [],
                });
                $('#adv_to_invoice_status').select2({
                    data: advertisers,
                });
                $('#InvoiceStatusReport').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });

    });

    $('#adv_to_invoice_status').on('change', function(e){
        show_loader();
        var adv= $("#adv_to_invoice_status option:selected").val();
        $.ajax({
            type: 'GET',
            url: '/invoices/status_report/get_campaigns_2/' + adv,
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log(data);
                var campaigns = [];
                campaigns.push({'id': '', 'text': '', 'title': ''});
                $.each(data, function (index, value) {
                    campaigns.push({'id': value.id, 'text': value.name, 'title': value.name});
                });
                campaigns.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
                $('#campaigns_to_invoice_status').html('').select2({
                    'data': campaigns,
                    placeholder: "Select one...",
                });
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#send_invoice_status_report').on('click', function () {
        var campaign_id= $('#campaigns_to_invoice_status option:selected').val();
        if(typeof campaign_id !== 'undefined' && campaign_id !== '') {
            var orientation= $("input:radio[name=orientation_type_invoice_status]:checked").attr('value');
            var link = document.createElement('a');
            link.href = '/download/invoices/status_report/orientation/'+ orientation+ '/' + campaign_id + '/download';
            $(link).attr('target', '_blank');
            link.click();
        }
        else {
            $('#generalWarningModalDiv').html('Please select a campaign.');
            $('#generalWarningModal').modal('show');
        }
    });
    $('#show_archive_campaigns').on('change', function () {
        var show = $('#show_archive_campaigns').is(':checked');
        var sel_cam = $("#campaigns_to_monthly_info").val();
        var html = '';
        for (var ind in general_adv_camp) {
            var value = general_adv_camp[ind];
            if (value.deleted_at === null || value.archive_year > 0) {
                var arch = value.archive_year > 0 ? ' (Archive) ' : '';
                var selected = sel_cam.indexOf(value.id.toString()) !== -1 ? 'selected' : '';
                if (show === true || (show === false && value.archive_year === 0))
                    html += '<option value="' + value.id + '" archive="' + value.archive_year + '" ' + selected + '> ' + value.name + '' + arch + ' </option>'
            }
        }
        console.log('html sel_cam', sel_cam)
        console.log('html', html)
        $("#campaigns_to_monthly_info").html(html).select2({
            placeholder: "Select at least one ...",
            'allowClear': true,
        });

    });
     var general_adv_camp = [];
     $('#advertiser_to_monthly_info').on('change', function () {
         show_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
         //$('#campaigns_to_monthly_info_div').css("display", "none");
        // var adv= $("#advertiser_to_monthly_info option:selected").val();
         var params = {
             advertisers_id: $("#advertiser_to_monthly_info").val()
         };

         $.ajax({
             type: 'POST',
             headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
             data: JSON.stringify(params),
             url: '/invoices/search_campaign/multipleadvertiser',
             dataType: "json",
             contentType: "application/json",
             success: function (data) {
                 general_adv_camp = data;
                 var show = $('#show_archive_campaigns').is(':checked');
                 var html ='';
                 $.each(data, function (index, value) {
                     if(value.deleted_at === null || value.archive_year > 0) {
                         var arch = value.archive_year > 0 ? ' (Archive) ' : '';
                         if(show === true || (show === false && value.archive_year === 0))
                             html += '<option value="'+ value.id +'" archive="'+ value.archive_year +'" > '+ value.name +''+ arch+' </option>'
                     }
                 });

                 var adv_new = $('#campaigns_to_monthly_info');
                 adv_new.html('').html(html).select2({
                     placeholder: "Select at least one ...",
                     'allowClear': true,
                 });

                 hide_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
                 $('#campaigns_to_monthly_info_div').css("display", "block");
             },
             error: function (xhr) {
                 hide_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
                 debug(xhr.responseText);
             }
         });
     });

    $('#campaigns_to_monthly_info').on('change', function () {
        show_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
        var params = {
            campaign_id: $("#campaigns_to_monthly_info").val()
        };

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/search_campaign/multiplecampaign',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name});
                });

                var adv_new= $('#brand_to_monthly_info');
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select at least one ...",
                    'allowClear': true,
                });
                hide_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
                },
            error: function (xhr) {
                hide_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
                debug(xhr.responseText);
            }
        });
    });
    $('#brand_to_monthly_info').on('change', function () {
        show_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
        var params = {
            brands_id: $("#brand_to_monthly_info").val()
        };

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/search_campaign/multiplebrand',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name});
                });

                var adv_new= $('#product_to_monthly_info');
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select at least one ...",
                    'allowClear': true,
                });
                hide_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
                },
            error: function (xhr) {
                hide_overlay_loader( $('#InvoiceMonthyInfo .modal-content'));
                debug(xhr.responseText);
            }
        });
    });
    $('#radio_type_monthly input[type=radio]').on('change', function () {
        if($(this).val()=='anual')
            $('#monthly_monthly_div').css('display', 'none');
        if($(this).val()=='quarter'){
            var quarter = [];
            quarter.push({'id': '1', 'text': 'January-March'});
            quarter.push({'id': '2', 'text': 'April-June'});
            quarter.push({'id': '3', 'text': 'July-September'});
            quarter.push({'id': '4', 'text': 'October-December'});
            $('#monthly_monthly').html('').select2({
                'data': quarter,
                'allowClear': true,
                 closeOnSelect: false
            });
            $('#label_monthly_monthly').html('Quarters:');
            $('#monthly_monthly_div').css('display', 'block');
        }
        if($(this).val()=='monthly'){
            var quarter = [];
            quarter.push({'id': '1', 'text': 'January'});
            quarter.push({'id': '2', 'text': 'February '});
            quarter.push({'id': '3', 'text': 'March'});
            quarter.push({'id': '4', 'text': 'April'});
            quarter.push({'id': '5', 'text': 'May'});
            quarter.push({'id': '6', 'text': 'June'});
            quarter.push({'id': '7', 'text': 'July'});
            quarter.push({'id': '8', 'text': 'August'});
            quarter.push({'id': '9', 'text': 'September'});
            quarter.push({'id': '10', 'text': 'October'});
            quarter.push({'id': '11', 'text': 'November'});
            quarter.push({'id': '12', 'text': 'December'});
            $('#monthly_monthly').html('').select2({
                'data': quarter,
                'allowClear': true,
                 closeOnSelect: false
            });
            $('#label_monthly_monthly').html('Months:');
            $('#monthly_monthly_div').css('display', 'block');
        }

    });
    $('.reset_monthly_info').on('click', function () {
        var media_rp_html= $('#advertiser_to_monthly_info').html();
        $('#advertiser_to_monthly_info').html(media_rp_html);
        $('#campaigns_to_monthly_info').html('');
        $('#brand_to_monthly_info').html('');
        $('#product_to_monthly_info').html('');
        var year_html=  $('#search_years').html();
        $('#search_years').html(year_html);
        $('#radio_type_monthly input[type=radio]').each(function(){
            if ($(this).val()=='anual')
                $(this).prop('checked', true);
            $('#monthly_monthly_div').css('display', 'none');
        });

    });

    $('#invoice_monthly_info').on('click', function () {
        var media_rp_html= $('#advertiser_to_monthly_info').html();
        $('#advertiser_to_monthly_info').html(media_rp_html);
        $('#advertiser_to_monthly_info').select2({
            placeholder: "Select at least one ...",
            'allowClear': true,
             closeOnSelect: false
        });
        $('#campaigns_to_monthly_info').html('');
        $('#campaigns_to_monthly_info').select2({
            placeholder: "Select at least one ...",
            'allowClear': true,
            closeOnSelect: false
        });
        $('#brand_to_monthly_info').html('');
        $('#brand_to_monthly_info').select2({
            placeholder: "Select at least one ...",
            'allowClear': true,
            closeOnSelect: false
        });
        $('#product_to_monthly_info').html('');
        $('#product_to_monthly_info').select2({
            placeholder: "Select at least one ...",
            'allowClear': true,
            closeOnSelect: false
        });
        $('#search_years').select2({
            placeholder: "Select ...",
            closeOnSelect: false,
            'allowClear': true,
        });
        $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        $('#radio_type_monthly input[type=radio]').each(function(){
         if ($(this).val()=='anual')
             $(this).prop('checked', true);
            $('#monthly_monthly_div').css('display', 'none');
        });

        $('#invoiceMonthInfoGrid').html('');
        gridMonthlyInfoNew.rowData = [];
        var gridDet = document.querySelector('#invoiceMonthInfoGrid');
        var g4 = new agGrid.Grid(gridDet, gridMonthlyInfoNew);
        // gridMonthlyInfoNew.api.forEachNode(function (node) {
        //     node.setDataValue('month', "All");
        // });
        $('.monthly_inv_info_hide_show_columns a').each(function () {
            var hidden_val = $(this).attr('data-col') === 'media_type' ? 'media' : $(this).attr('data-col');
            var hide = monthly_info_default_view === false || monthly_info_default_view.indexOf(hidden_val) !== -1 ? false : true;
            if(hide === true){
                $(this).addClass('hidden-column');
                $(this).css('background-color', '#CCCCCC');
                gridMonthlyInfoNew.columnApi.setColumnsVisible([hidden_val], false);
            }
        });
        $('#InvoiceMonthyInfo').modal('show');
        $('#invoice_type_monthly').val('manual');

    });
    var columnDefgridMonthlyInfoNewNew = [
        {
            headerName: "Order Number",
            field: 'order_number',
            width: 130,
            rowGroupIndex: 0,
            suppressMovable: true,
            hide:true,
            cellRenderer: function(params) {
                var html = '';
                if (params.node.level === 0) {
                    $.each(params.node.childrenAfterGroup, function (index, value) {
                        if (index === 0) {
                            if (typeof value.data !== 'undefined' && value.data["line_through"] === 1 && value.data.order_number.indexOf('-') !== -1)
                                html = "  <span style='text-decoration: line-through; text-align: left; color:#B7432C'>" + params.value + "</span> ";
                            else if (typeof value.data !== 'undefined' && value.data["line_through"] === 1)
                                html = "  <span style='text-decoration: line-through; text-align: left'>" + params.value + "</span> ";
                            else if (typeof value.data !== 'undefined' && value.data.order_number.indexOf('-') !== -1)
                                html = "  <span style='color:#B7432C; text-align: left'>" + params.value + "</span> ";
                            else
                                html = "  <span style='text-align: left'>" + params.value + "</span> ";
                        }
                    });
                }
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
        {
            headerName: "Month",
            field: 'month',
            width: 150,
            cellStyle: {'text-align': "left"},
            pinned: 'left',
            suppressMovable: true,
        },
        {
            headerName: "Advertiser",
            field: 'advertiser',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('advertiser') !== -1 ? false : true,
        },
        {
            headerName: "Campaign",
            field: 'campaign',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('campaign') !== -1 ? false : true,
        },
        {
            headerName: "Market",
            field: 'market',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('market') !== -1 ? false : true,
        },
        {
            headerName: "Estimate #",
            field: 'estimate_number',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('estimate_number') !== -1 ? false : true,
        },
        {
            headerName: "Job #",
            field: 'job_number',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('job_number') !== -1 ? false : true,
        },
        {
            headerName: "Brand",
            field: 'brand_name',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('brand_name') !== -1 ? false : true,
        },
        {
            headerName: "Product",
            field: 'product_name',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('product_name') !== -1 ? false : true,
        },
        {
            headerName: "Vendor",
            field: 'station',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('station') !== -1 ? false : true,
        },
        {
            headerName: "Owner Group",
            field: 'owner',
            width: 130,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('owner') !== -1 ? false : true,
        },
        {
            headerName: "Media type",
            field: 'media',
            width: 120,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('media') !== -1 ? false : true,
        },
        {
            headerName: "Flight Date",
            field: 'flight_date',
            width: 160,
            cellStyle: {'text-align': "center"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('flight_date') !== -1 ? false : true,
        },
        {
            headerName: "Status",
            field: 'status',
            width: 100,
            cellStyle: {'text-align': "left"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('status') !== -1 ? false : true,
        },
        {
            headerName: "Invoice <br> Number",
            field: 'invoice_number',
            width: 120,
            cellStyle: {'text-align': "right"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('invoice_number') !== -1 ? false : true,
        },
        {
            headerName: "Invoice <br> Date",
            field: 'invoice_date',
            width: 120,
            cellStyle: {'text-align': "right"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('invoice_date') !== -1 ? false : true,
        },
        {
            headerName: "Invoice <br> Gross",
            field: 'gross_invoice',
            width: 100,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('gross_invoice') !== -1 ? false : true,
        },
        {
            headerName: "Invoice <br> Net",
            field: 'net_invoice',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('net_invoice') !== -1 ? false : true,
        },
        {
            headerName: "Invoice Spots",
            field: 'spots_invoice',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer:IntegerFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('spots_invoice') !== -1 ? false : true,
        },
        {
            headerName: "Invoice <br> Gross Approved",
            field: 'gross_invoice_approved',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('gross_invoice_approved') !== -1 ? false : true,
        },
        {
            headerName: "Invoice <br> Net Approved",
            field: 'net_invoice_approved',
            width: 100,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('net_invoice_approved') !== -1 ? false : true,
            tooltip: function (params) {
                if(typeof params.node !== 'undefined' &&  params.node.level === 1) {
                    console.log('params.data', params.data)
                    var html = '';
                    if (typeof params.data['taxes'] !== 'undefined' && params.data['taxes'] > 0)
                        html = "This field contains State sales tax for a value of: $" + params.data['taxes'] ;
                    if (html !== '')
                        return html;
                }
            },
        },
        {
            headerName: "Invoice <br> Spots Approved",
            field: 'spots_invoice_approved',
            width: 140,
            cellStyle: {'text-align': "right"},
            // cellRenderer: function (params){
            //     console.log('bookend_params ', params)
            //     console.log('bookend_params value', params.value)
            //     if(typeof params.value !== 'undefined' && isNaN(parseInt(params.value)) && params.value.indexOf('BK') !== -1) {
            //         var string = params.value.split(' (');
            //         var st = string[0] + '<span style="color:orangered">' + string[1] +'</span>';
            //         return  st;
            //     }
            //     else if(typeof params.value !== 'undefined' && !isNaN(parseInt(params.value)))
            //        return  params.value;
            //     else
            //        return  0;
            // },
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('spots_invoice_approved') !== -1 ? false : true,
        },{
            headerName: "Invoice <br> Spots Unmatched",
            field: 'spots_invoice_unmatched',
            width: 140,
            cellStyle: {'text-align': "right"},
            cellRenderer:IntegerFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('spots_invoice_unmatched') !== -1 ? false : true,
        },
        {
            headerName: "Ordered Gross",
            field: 'gross_order',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('gross_order') !== -1 ? false : true,
        },
        {
            headerName: "Ordered Net",
            field: 'net_order',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('net_order') !== -1 ? false : true,
        },
        {
            headerName: "Ordered Spots",
            field: 'spots_order',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer:IntegerFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('spots_order') !== -1 ? false : true,
        },
        {
            headerName: "Client Gross (WMJ)",
            field: 'client_gross',
            width: 120,
            hide: show_client_rate === true && (monthly_info_default_view === false || monthly_info_default_view.indexOf('client_gross') !== -1) ? false : true,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            tooltip: function (params) {
                if(typeof params.node !== 'undefined' &&  params.node.level === 1) {
                    var html = '';
                    if (typeof params.data['client_gross'] !== 'undefined' && params.data['gross_order'] !== params.value)
                        html = "Client Gross percentage applied: " + params.data.client_gross_value + '%. (' + params.data.client_gross_type + ')';
                    if (html !== '')
                        return html;
                }
            },
        },
        {
            headerName: "Difference Gross",
            field: 'difference_gross',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('difference_gross') !== -1 ? false : true,
            cellClassRules :  {
                'ag-cell-color-difference-less': function(params) {
                    if(!isNaN(parseFloat(params.value)) && params.node.rowPinned !== 'top') {
                        if(parseFloat(params.value) == parseFloat('6176.474999999999'))
                            params.value = 6176.48;
                        params.value = params.value.toString().indexOf('e') !== -1  ? parseFloat(params.value.toString().split('e')[0]) : parseFloat(params.value);
                        var v = Number(Math.round((parseFloat(params.value))+'e2')+'e-2')
                        if(v < 0)
                            return true;
                        return false;
                    }
                    else
                        return false;
                },
                'ag-cell-color-difference-more': function(params) {
                    if(!isNaN(parseFloat(params.value)) && params.node.rowPinned !== 'top'){
                        if(parseFloat(params.value) == parseFloat('6176.474999999999'))
                            params.value = 6176.48;
                        params.value = params.value.toString().indexOf('e') !== -1  ? parseFloat(params.value.toString().split('e')[0]) : parseFloat(params.value);
                        var v = Number(Math.round((parseFloat(params.value))+'e2')+'e-2')
                        console.log('ag-cell-color-difference-more params.value', params.value)
                        if(v > 0) {
                            console.log('ag-cell-color-difference-more', v)
                            return true;
                        }
                        return false;
                    }
                    else
                        return false;
                }
            },
            tooltip: function (params) {
                var html = '';
                if (parseFloat(params.value) < 0 && params.node.rowPinned !== 'top')
                    html += "This month contains less Gross Ordered than Invoiced Gross Approved."

                if (html !== '')
                    return html;
            },
        },
        {
            headerName: "Difference Net",
            field: 'difference_net',
            width: 120,
            cellStyle: {'text-align': "right"},
            cellRenderer: CurrencyFormatRenderer,
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('difference_net') !== -1 ? false : true,
            cellClassRules :  {
                'ag-cell-color-difference-less': function(params) {
                    if(!isNaN(parseFloat(params.value)) && params.node.rowPinned !== 'top') {
                        if(parseFloat(params.value) == parseFloat('6176.474999999999'))
                            params.value = 6176.48;
                        params.value = params.value.toString().indexOf('e') !== -1  ? parseFloat(params.value.toString().split('e')[0]) : parseFloat(params.value);
                        var v = Number(Math.round((parseFloat(params.value))+'e2')+'e-2')
                        if(v < 0)
                            return true;
                        return false;
                    }
                    else
                        return false;
                },
                'ag-cell-color-difference-more': function(params) {
                    if(!isNaN(parseFloat(params.value)) && params.node.rowPinned !== 'top'){
                        if(parseFloat(params.value) == parseFloat('6176.474999999999'))
                            params.value = 6176.48;
                        params.value = params.value.toString().indexOf('e') !== -1  ? parseFloat(params.value.toString().split('e')[0]) : parseFloat(params.value);
                        var v = Number(Math.round((parseFloat(params.value))+'e2')+'e-2')
                        if(v > 0)
                            return true;
                        return false;
                    }
                    else
                        return false;
                }
            },
            tooltip: function (params) {
                var html = '';
                if (parseFloat(params.value) < 0 && params.node.rowPinned !== 'top')
                    html += "This month contains less Net Ordered than Invoiced Net Approved."

                if (html !== '')
                    return html;
            },
        },
        {
            headerName: "Difference Spots",
            field: 'difference_spots',
            width: 120,
            cellStyle: {'text-align': "right"},
            hide: monthly_info_default_view === false || monthly_info_default_view.indexOf('difference_spots') !== -1 ? false : true,
            cellRenderer:IntegerFormatRenderer,
            cellClassRules :  {
                'ag-cell-color-difference-less': function(params) {
                    if(parseFloat(params.value) < 0 && params.node.rowPinned !== 'top')
                        return true;
                    else
                         return false;
                },
                'ag-cell-color-difference-more': function(params) {
                    if(parseFloat(params.value) > 0 && params.node.rowPinned !== 'top')
                        return true;
                    else
                         return false;
                }
            },
            tooltip: function (params) {
                var html = '';
                if (parseFloat(params.value) < 0  && params.node.rowPinned !== 'top')
                    html += "This month contains less Spots Ordered than Invoiced Spots Approved."

                if (html !== '')
                    return html;
            },
        },

    ];
    var gridMonthlyInfoNew = {
        columnDefs: columnDefgridMonthlyInfoNewNew,
        autoGroupColumnDef: {
            headerName: 'Order',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            cellRendererParams: {
                suppressCount: true,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
            }
        },
        defaultColDef: {
            width: 150,
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        enableColResize: true,
        suppressTouch: true,
        headerHeight: 30,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        groupRowAggNodes: function (nodes) {
           return MonthlyInfoAggFunction(nodes);
        },
        onGridReady: function (e) {
            fillTopLineMonthlyInvInfo(this)
        },
        // rowSelection: 'single',
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onFilterChanged: function (e) {
            fillTopLineMonthlyInvInfo(this)
        },
    };
    var MonthlyInfoAggFunction = function (nodes) {
        var result = {};
        var values_added = {};
        if (nodes[0] != undefined) {
            if (nodes[0].level === 1) {
                console.log('level 1', nodes);
                result['gross_order'] = 0;
                result['net_order'] = 0;
                result['spots_order'] = 0;
                result['spots_invoice'] = 0;
                result['gross_invoice'] = 0;
                result['net_invoice'] = 0;
                result['gross_invoice_approved'] = 0;
                result['net_invoice_approved'] = 0;
                result['spots_invoice_unmatched'] = 0;
                result['client_gross'] = 0;
                result['spots_invoice_approved'] = 0;
                result['difference_gross'] = 0;
                result['difference_net'] = 0;
                result['difference_spots'] = 0;

                $.each(nodes, function (index, value) {
                    for (var xx in result) {
                        if(global_show_invoice_breakout === true && (xx === 'gross_order' || xx === 'net_order' || xx === 'spots_order' || xx === 'client_gross') && typeof values_added[value.data.order_number] !== 'undefined' && typeof values_added[value.data.order_number][value.data.month] !== 'undefined' && values_added[value.data.order_number][value.data.month].indexOf(xx) !== -1)
                            result[xx] = 0;
                        else if (global_show_invoice_breakout === true && (xx === 'gross_order' || xx === 'net_order' || xx === 'spots_order' || xx === 'client_gross')) {
                            if (typeof values_added[value.data.order_number] === 'undefined')
                                values_added[value.data.order_number] = {};
                            if (typeof values_added[value.data.order_number][value.data.month] === 'undefined')
                                values_added[value.data.order_number][value.data.month] = [];

                            if( values_added[value.data.order_number][value.data.month].indexOf(xx) === -1)
                                values_added[value.data.order_number][value.data.month].push(xx);
                        }
                       if( xx !== 'spots_invoice' && xx !== 'spots_order' && xx !== 'spots_invoice_approved' && xx !== 'difference_spots')
                           result[xx] += !isNaN(parseFloat(value['data'][xx])) ? parseFloat(value['data'][xx]) : 0;
                       else
                           result[xx] += !isNaN(parseInt(value['data'][xx])) ? parseInt(value['data'][xx]) : 0;
                    }
                });
            }
            if(global_show_invoice_breakout === true){
                result['difference_gross'] = result['gross_invoice_approved'] - result['gross_order'];
                result['difference_net'] = result['net_invoice_approved'] - result['net_order'];
                result['difference_spots'] = result['spots_invoice_approved'] - result['spots_order'];
            }
            return result;
        }
        else
            return false;

    };

    $('.monthly_inv_info_hide_show_columns a').on('click', function(e){
        if ($(this).hasClass('hidden-column')) {
            $(this).removeClass('hidden-column');
            $(this).css('background-color', 'white');
            var hidden_val = $(this).attr('data-col') === 'media_type' ? 'media' : $(this).attr('data-col');
            gridMonthlyInfoNew.columnApi.setColumnsVisible([hidden_val], true);
        }else{
            $(this).addClass('hidden-column');
            $(this).css('background-color', '#CCCCCC');
            var hidden_val = $(this).attr('data-col') === 'media_type' ? 'media' : $(this).attr('data-col');
            gridMonthlyInfoNew.columnApi.setColumnsVisible([hidden_val], false);
        }
        e.stopPropagation();

    });

    function fillTopLineMonthlyInvInfo(grid){
        var floating_top_row_new = { };
        var result = {};
        var values_added = {};
        result['gross_order'] = 0;
        result['net_order'] = 0;
        result['spots_order'] = 0;
        result['spots_invoice'] = 0;
        result['gross_invoice'] = 0;
        result['net_invoice'] = 0;
        result['gross_invoice_approved'] = 0;
        result['net_invoice_approved'] = 0;
        result['spots_invoice_approved'] = 0;
        result['spots_invoice_unmatched'] = 0;
        result['difference_gross'] = 0;
        result['difference_net'] = 0;
        result['difference_spots'] = 0;
       // result['client_gross'] = 0;
        var client_gross = 0;

        grid.api.forEachNodeAfterFilterAndSort(function(value) {
            console.log('value ', value);
            console.log('values_added ', values_added);
            if (value.level === 1) {
                for (var xx in result) {
                    var add = true;
                    if (global_show_invoice_breakout === true && (xx === 'gross_order' || xx === 'net_order' || xx === 'spots_order' || xx === 'client_gross') && typeof values_added[value.data.order_number] !== 'undefined' && typeof values_added[value.data.order_number][value.data.month] !== 'undefined' && values_added[value.data.order_number][value.data.month].indexOf(xx) !== -1)
                        add = false;
                    else if (global_show_invoice_breakout === true && (xx === 'gross_order' || xx === 'net_order' || xx === 'spots_order' || xx === 'client_gross')) {
                        if (typeof values_added[value.data.order_number] === 'undefined')
                            values_added[value.data.order_number] = {};
                        if (typeof values_added[value.data.order_number][value.data.month] === 'undefined')
                            values_added[value.data.order_number][value.data.month] = [];

                        if( values_added[value.data.order_number][value.data.month].indexOf(xx) === -1)
                          values_added[value.data.order_number][value.data.month].push(xx);
                    }
                    if(add === true) {
                        if (xx !== 'spots_invoice' && xx !== 'spots_order' && xx !== 'spots_invoice_approved' && xx !== 'difference_spots')
                            result[xx] += !isNaN(parseFloat(value['data'][xx])) ? parseFloat(parseFloat(value['data'][xx]).toFixed(2)) : 0;
                        else
                            result[xx] += !isNaN(parseInt(value['data'][xx])) ? parseInt(value['data'][xx]) : 0;
                       if(xx === 'client_gross')
                         console.log('client_gross', xx,  value['data'][xx] , parseFloat(parseFloat(value['data'][xx]).toFixed(2)));
                    }
                }
            }
            else{
                client_gross += !isNaN(parseFloat(value.aggData['client_gross'])) ? parseFloat(parseFloat(value.aggData['client_gross']).toFixed(2)) : 0;
                // $.each(value.childrenAfterGroup, function (index, val) {
                //     client_gross += !isNaN(parseFloat(val['data']['client_gross'])) ? parseFloat(parseFloat(val['data']['client_gross']).toFixed(2)) : 0;
                //     console.log('client_gross', client_gross ,parseFloat(parseFloat(val['data']['client_gross']).toFixed(2)))
                // });
            }
        });
        result['client_gross'] = client_gross;
        if(global_show_invoice_breakout === true){
            result['difference_gross'] = result['gross_invoice_approved'] - result['gross_order'];
            result['difference_net'] = result['net_invoice_approved'] - result['net_order'];
            result['difference_spots'] = result['spots_invoice_approved'] - result['spots_order'];
        }
        floating_top_row_new = result;

        grid.api.setPinnedTopRowData(
            [ floating_top_row_new ]
        );
        console.log('floating_top_row filter ', floating_top_row_new);

    };

     var global_show_invoice_breakout = false;
    $('#monthly_invoice_info_send').on('click', function () {
          if($("input:radio[name=type_monthly]:checked").attr('value') === 'quarter' && $('#monthly_monthly').val().length == 0) {
              $('#generalWarningModalDiv').html('Please select at least a quarter.');
              $('#generalWarningModal').modal('show');
          } else  if($("input:radio[name=type_monthly]:checked").attr('value') == 'monthly' && $('#monthly_monthly').val().length == 0) {
              $('#generalWarningModalDiv').html('Please select at least a month.');
              $('#generalWarningModal').modal('show');
          }
          else {
                 if($('#advertiser_to_monthly_info').val().length === 0)
                    init_progress_loader(2, 'You have chosen no advertisers to search. This may take a few seconds to process.');
                  else
                      show_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
                  var selectedItems = [];
                  var selectedItems2 = [];
                  $('.invoice_check_order input[type=checkbox]').each(function () {
                      if (this.checked)
                          selectedItems.push($(this).val());
                  });
                  $('.invoice_check_order_recent input[type=checkbox]').each(function () {
                      if (this.checked)
                          selectedItems2.push($(this).val());
                  });
              $('.invoice_check_order_recent input[type=checkbox]').each(function () {
                  if (this.checked)
                      selectedItems2.push($(this).val());
              });
                  var params = {
                      advertiser_id: $('#advertiser_to_monthly_info').val(),
                      campaigns_id: $("#campaigns_to_monthly_info").val(),
                      brands_id: $("#brand_to_monthly_info").val(),
                      products_id: $("#product_to_monthly_info").val(),
                      type: $('#invoice_type_monthly').val(),
                      years: $('#search_years').val(),
                      calendar_type: $("input:radio[name=type_monthly]:checked").attr('value'),
                      calendar: $('#monthly_monthly').val(),
                      only_invoce: selectedItems,
                      recent_orders: selectedItems2,
                      invoice_breakout:  $("input:checkbox[name=show_invoice_breakout]:checked").attr('value'),
                      archive_campaigns:  $("input:checkbox[name=show_archive_campaigns]:checked").attr('value'),
                  };
                  $.ajax({
                      type: 'POST',
                      headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                      data: JSON.stringify(params),
                      url: '/campaign/invoices/month_info/by_campaign/multiple',
                      dataType: "json",
                      contentType: "application/json",
                      success: function (response) {
                          console.log('monthly_data results ', response);
                          global_show_invoice_breakout = response.detailed === 1 ? true : false;
                          var data = response.data;
                          if (data.length === 0) {
                              $('#generalWarningModalDiv').html('No data were returned matching your parameters. Please try to expand your search parameters.');
                              $('#generalWarningModal').modal('show');
                          }

                          $('#invoiceMonthInfoGrid').html('');
                          gridMonthlyInfoNew.rowData = data.filter( elem => (elem.spots_order !== null && parseInt(elem.spots_order) > 0) || (elem.gross_order !== null && parseFloat(elem.gross_order) > 0) || (elem.gross_invoice !== null && parseFloat(elem.gross_invoice) > 0) || (elem.spots_invoice !== null && parseFloat(elem.spots_invoice) > 0));
                          var gridDet = document.querySelector('#invoiceMonthInfoGrid');
                          var g4 = new agGrid.Grid(gridDet, gridMonthlyInfoNew);

                          var hidden_val = [];
                          $('.monthly_inv_info_hide_show_columns a').each( function(){
                              if ($(this).hasClass('hidden-column')) {
                                  var col = $(this).attr('data-col') === 'media_type' ? 'media' : $(this).attr('data-col');
                                  hidden_val.push(col);
                              }
                          });
                          gridMonthlyInfoNew.columnApi.setColumnsVisible(hidden_val, false);
                          if(typeof monthly_info_default_view !== 'undefined' && monthly_info_default_column_positions.length > 0)
                              gridMonthlyInfoNew.columnApi.setColumnState(monthly_info_default_column_positions);

                          if($('#advertiser_to_monthly_info').val().length === 0)
                               close_progress_loader();
                          else
                              hide_overlay_loader($('#InvoiceMonthyInfo .modal-content'));

                      },
                      error: function (xhr) {
                          close_progress_loader();
                          hide_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
                          ajax_error();
                          debug(xhr.responseText);

                      }
                  });


          }
    });
    $('#excel_monthly').on('click', function(){
        show_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
        var params = {
            skipHeader: false,
            columnGroups: true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export",
        };
        var selectedItems=[];
        $('.invoice_check_order input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var arr = {
            advertiser_id: $('#advertiser_to_monthly_info').val(),
            campaigns_id: $("#campaigns_to_monthly_info").val(),
            type: $('#invoice_type_monthly').val(),
            years: $('#search_years').val(),
            calendar_type: $("input:radio[name=type_monthly]:checked").attr('value'),
            calendar: $('#monthly_monthly').val(),
            only_invoce: selectedItems
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(arr),
            url: '/invoices/monthly_info/getParams/exportheader',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
                params.customHeader  = [
                    [],
                    [{
                        //styleId:'bigHeader',
                        data:{type:'String', value:'Monthly Invoice Information '}
                     }],
                    [
                        {data:{type:'String', value:'Advertisers: '}},
                        {data:{type:'String', value: response['advert_text'] }}],
                    [
                        {data:{type:'String', value:'Campaigns: '}},
                        {data:{type:'String', value: response['camp_text'] }}
                    ],
                    [
                        {data:{type:'String', value:'Years: '}},
                        {data:{type:'String', value:response['years_text']}}
                    ],
                    [
                        {data:{type:'String', value:'Calendar Type: '}},
                        {data:{type:'String', value: response['calendar_type'] }}
                    ],
                    [
                        {data:{type:'String', value: response['calendar_type'] +':'}},
                        {data:{type:'String', value: response['calendar']}}
                    ],
                    [],

                ];
                params.processHeaderCallback = function (params) {
                    if(params.column.colId=='invoice_number')
                        return 'Invoice Number';
                   else if(params.column.colId=='invoice_spots')
                        return 'Invoice Spots';
                   else if(params.column.colId=='order_spots')
                        return 'Ordered Spots';
                   else if(params.column.colId=='order_gross')
                        return 'Ordered Gross';
                   else if(params.column.colId=='order_number')
                        return 'Order Number';
                    else if(params.column.colId=='invoice_gross')
                        return 'Invoice Gross';
                    else if(params.column.colId=='invoice_net')
                        return 'Invoice Net';
                    else if(params.column.colId=='invoice_gross_approved')
                        return 'Invoice Gross Approved';
                    else if(params.column.colId=='invoice_net_approved')
                        return 'Invoice Net Approved';
                    else
                        return params.column.colDef.headerName;
                };
                params.processCellCallback = function (params) {
                    if(params.column.colId.indexOf("gross_order") !== -1 || params.column.colId.indexOf("net_order") !== -1 || params.column.colId.indexOf("gross_invoice") !== -1
                        || params.column.colId.indexOf("net_invoice") !== -1 || params.column.colId.indexOf("gross_invoice_approved") !== -1 || params.column.colId.indexOf("client_gross") !== -1
                        || params.column.colId.indexOf("net_invoice_approved") !== -1 || params.column.colId.indexOf("difference_gross") !== -1 || params.column.colId.indexOf("difference_net") !== -1){
                        var v = params.value;
                        if(parseFloat(params.value) == parseFloat('6176.474999999999'))
                            v = 6176.48;
                        return  parseFloat(v).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    return params.value;
                }
                //gridMonthlyInfo.api.exportDataAsExcel(params);
                var content = gridMonthlyInfoNew.api.getDataAsExcel(params);
                console.log(content);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'export.xlsx', {bookType: 'xlsx', type: 'base64'});
                console.log(xlsxContent);
            },
            error: function (xhr) {
                hide_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
                ajax_error();
                debug(xhr.responseText);

            }
        });
    });
    $('#csv_monthly').on('click', function(){
        show_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
        var params = {
            skipHeader: false,
            columnGroups: true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            allColumns: false,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "export.csv",
        };
        var selectedItems=[];
        $('.invoice_check_order input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var arr = {
            advertiser_id: $('#advertiser_to_monthly_info').val(),
            campaigns_id: $("#campaigns_to_monthly_info").val(),
            type: $('#invoice_type_monthly').val(),
            years: $('#search_years').val(),
            calendar_type: $("input:radio[name=type_monthly]:checked").attr('value'),
            calendar: $('#monthly_monthly').val(),
            only_invoce: selectedItems
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(arr),
            url: '/invoices/monthly_info/getParams/exportheader',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
                params.customHeader  = [
                    [],
                    [{
                        //styleId:'bigHeader',
                        data:{type:'String', value:'Montlhy Invoice Information '}
                    }],
                    [
                        {data:{type:'String', value:'Advertisers: '}},
                        {data:{type:'String', value: response['advert_text'] }}],
                    [
                        {data:{type:'String', value:'Campaigns: '}},
                        {data:{type:'String', value: response['camp_text'] }}
                    ],
                    [
                        {data:{type:'String', value:'Years: '}},
                        {data:{type:'String', value:response['years_text']}}
                    ],
                    [
                        {data:{type:'String', value:'Calendar Type: '}},
                        {data:{type:'String', value: response['calendar_type'] }}
                    ],
                    [
                        {data:{type:'String', value: response['calendar_type'] +':'}},
                        {data:{type:'String', value: response['calendar']}}
                    ],
                    [],

                ];
                params.processCellCallback = function (params) {
                    if(params.column.colId.indexOf("gross_order") !== -1 || params.column.colId.indexOf("net_order") !== -1 || params.column.colId.indexOf("gross_invoice") !== -1
                        || params.column.colId.indexOf("net_invoice") !== -1 || params.column.colId.indexOf("gross_invoice_approved") !== -1 || params.column.colId.indexOf("client_gross") !== -1
                        || params.column.colId.indexOf("net_invoice_approved") !== -1 || params.column.colId.indexOf("difference_gross") !== -1 || params.column.colId.indexOf("difference_net") !== -1){
                        return  parseFloat(params.value).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    return params.value;
                }
                gridMonthlyInfoNew.api.exportDataAsCsv(params);
            },
            error: function (xhr) {
                hide_overlay_loader($('#InvoiceMonthyInfo .modal-content'));
                ajax_error();
                debug(xhr.responseText);

            }
        });
    });
    $('#raw_data_monthly').on('click', function(){
        var all_columns = {order_number: 'Order Number'}
        for(var ind in gridMonthlyInfoNew.columnApi.getColumnState()){
            var col = gridMonthlyInfoNew.columnApi.getColumnState()[ind];
            console.log('gridMonthlyInfoNew.columnDefs[ind]', col)
            if(col.hide === false)
              all_columns[col.colId] = '';
        }
        for(var ind in gridMonthlyInfoNew.columnDefs){
            var col = gridMonthlyInfoNew.columnDefs[ind];
            if(typeof all_columns[col.field] !== 'undefined')
                all_columns[col.field] = col.headerName.replace('<br>', '');
        }
        var html = '<table style="width: 100%;" class="table-bordered table-striped table-condensed"><tr style="">';
        for(var ind in all_columns)
            html += '<td><b>'+ all_columns[ind] +'</b></td>';
        html += '</tr>';
        console.log('gridMonthlyInfoNew.columnDefs[ind] all_columns', all_columns)

        gridMonthlyInfoNew.api.forEachNodeAfterFilterAndSort(function(node) {
            if(typeof node.level !== 'undefined' && node.level === 1) {
                html += '<tr>';
                for (var col in all_columns) {
                    var v = node.data[col];
                    if (col === 'gross_order' || col === 'net_order' || col === 'gross_invoice' || col === 'gross_invoice' || col === 'net_invoice' || col === 'gross_invoice_approved'
                        || col === 'client_gross' || col === 'net_invoice_approved' || col === 'difference_gross' || col === 'difference_net') {
                        if (parseFloat(node.data[col]) == parseFloat('6176.474999999999'))
                            v = 6176.48;
                        v = parseFloat(v).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    html += '<td style="border: 1px solid #D3D3D3">' + v + '</td>';
                }
                html += '</tr>';
            }
        })
        html += '</table>';
        var a = document.createElement('a');
        var data_type = 'data:application/vnd.ms-excel';
        a.href = data_type + ', ' + encodeURIComponent(html);
        a.download =  'export.xls';
        a.click();
        if(typeof e !== 'undefined')
            e.preventDefault();
    });
    $('.apply_settings_monthly').on('click', function(){
        show_overlay_loader($('#InvoiceMonthyInfo'));
        var params = {
            visible_columns: [],
            positions: gridMonthlyInfoNew.columnApi.getColumnState(),
        };
        $('.monthly_inv_info_hide_show_columns a').each(function () {
            if (!$(this).hasClass('hidden-column')) {
                var hidden_val = $(this).attr('data-col') === 'media_type' ? 'media' : $(this).attr('data-col');
                params.visible_columns.push(hidden_val);
            }
        });
        console.log('visible_columns', params)
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/monthly_info/save/default_settings',
            dataType: "json",
            contentType: "application/json",
            success: function (dataX) {
                console.log('dataX', dataX);
                monthly_info_default_view = dataX;
                monthly_info_default_column_positions =  gridMonthlyInfoNew.columnApi.getColumnState();
                hide_overlay_loader($('#InvoiceMonthyInfo'));
                global_notification('success', 'Default View saved successfully.');
            },
            error: function (xhr) {
                hide_overlay_loader($('#InvoiceMonthyInfo'));
                debug(xhr.responseText);
            }
        });
    });


    function MonthSelectCellEditor() {
    }

    MonthSelectCellEditor.prototype.init = function (params) {
        console.log(params);
        this.eInput = document.createElement('select');
        var vendor_cell_input = $(this.eInput);

        vendor_cell_input.addClass('form-control ws-custom-select');
        var order_number= params.node.data.revision_id;
        var array=[];

        console.log('MOnthly cell editor')
        console.log('monthly_data ',monthly_data);
        console.log('params.node.data ',params.node.data);

        for(var x in monthly_data){
            if(monthly_data[x]["revision_id"]== order_number && monthly_data[x]["index"]== params.node.data.initial_index){
                console.log('get into the if');
                for( var z in monthly_data[x]["months_select"]) {
                    if (array.indexOf(monthly_data[x]["months_select"][z]) === -1) {
                        vendor_cell_input.append('<option value="' + monthly_data[x]["months_select"][z] + '">' + monthly_data[x]["months_select"][z] + '</option>');
                        console.log('vendor_cell_input ', vendor_cell_input);
                        array.push(monthly_data[x]["months_select"][z]);
                 }
                }
            }
        }
        if (typeof params.value !== 'undefined') {
            vendor_cell_input.val(params.value);
        } else {
            vendor_cell_input.val('');
        }
    };

    MonthSelectCellEditor.prototype.getGui = function () {
        return this.eInput;

    };

    MonthSelectCellEditor.prototype.afterGuiAttached = function () {
        this.eInput.focus();
    };

    MonthSelectCellEditor.prototype.getValue = function () {
        return this.eInput.value;

    };

    MonthSelectCellEditor.prototype.destroy = function () {

    };

    MonthSelectCellEditor.prototype.isPopup = function () {
        return false;
    };


    var matchCount = function(index){
        var count = 0;
        console.log(index);
        if(typeof match_result.match[index] !== 'undefined')
            $.each(match_result.match[index], function(ind,val){
                $.each(val, function(ind1, val1){
                    if (typeof val1 !== 'undefined' && val1 !== null) {
                        if (match_result.olines[index].bookend === 1 && parseInt(val1.bookend) === 1 ) {
                            count += 0.5;
                        } else {
                            count++;
                        }
                    }
                });
            });
        return count;
    };

    var getRowNode = function(options){
        var result = null;
        options.api.forEachNode(function (node) {
            var nodes = 0;
            $.each(match_result.olines, function(ind, val){
                if(nodes === (parseInt(node.data.line_num) - 1)){
                    result = [nodes, node];
                    return false;
                }
                nodes++;
            });
        });
        return result;
    };

    var totalSpots = function(index){
        var count = 0;
        $.each(match_result.olines[index].counts, function(ind,val){
            count += val.count;
        });
        return count;
    };

    var drawSingleBuyLines = function(row, nline, index){
        $('#reset_filters_buy_line').hide();
        var olines = [];
        var xradio=false;
        if(typeof row.dial_position !=='undefined')
            xradio=true;
        var verified=0;
        if(typeof match_result.match[index] !== 'undefined'){
            verified= matchCount(index);
            if(verified == 0){
                if(typeof match_result.match[index][-1] !== 'undefined')
                    verified= match_result.match[index][-1].length;
            }

        }
        var dif = typeof match_result.oline_spots[index] !== 'undefined' && !isNaN(parseInt(match_result.oline_spots[index]))  ? parseInt(verified) - parseInt(match_result.oline_spots[index]) : 0;
        dif = dif > 0 ? '+' + dif : dif;
        olines.push({
                line_num: nline,
                network: (typeof row.network !== 'undefined' && row.network !== null)? (row.network).toUpperCase(): row.network,
                zone: (typeof row.zone !== 'undefined' && row.zone !== null)? (row.zone).toUpperCase(): row.zone,
                program: (typeof row.program !== 'undefined' && row.program !== null)? (row.program).toUpperCase(): row.program,
                m: (row.m) ? "M" : "-",
                t: (row.t) ? "T" : "-",
                w: (row.w) ? "W" : "-",
                r: (row.r) ? "R" : "-",
                f: (row.f) ? "F" : "-",
                s: (row.s) ? "S" : "-",
                u: (row.u) ? "U" : "-",
                start: moment('2019-10-01 ' + row.start).format('hh:mm A'),
                end: moment('2019-10-01 ' + row.end).format('hh:mm A'),
                length: row.length,
                type: "",
                tag: row.comments,
                rating: !isNaN(parseFloat(row.rating).toFixed(1)) ? parseFloat(row.rating).toFixed(1) : 0,
                rate: (!isNaN(parseFloat(row.cost))) ? parseFloat(row.cost).toFixed(2) : 0.00,
                spots: match_result.oline_spots[index],//totalSpots(index),
                verified: (typeof match_result.match[index] !== 'undefined') ? verified : 0,
                difference: dif,
                mgs: 0,
                bonus: '0.00',
                line_id:index,
                bookend : (row.bookend === 0) ? "No" : "Yes",
             //   bookend_length : (row.bookend_length === null) ? "" : row.bookend_length,
                bookend_length_1 : (row.bookend_length_1 === null) ? ":0" : ':'+ row.bookend_length_1,
                bookend_length_2 : (row.bookend_length_2 === null) ? ":0" : ':'+ row.bookend_length_2,
        });

        gridOSinglelinesOptions.rowData = olines;
        var gridOSinglelineDiv = document.querySelector('#sel-order-line');
        var g3 = new agGrid.Grid(gridOSinglelineDiv, gridOSinglelinesOptions);

        gridOSinglelinesOptions.columnApi.setColumnVisible('bookend', match_result.bookend_show_hide);

        $('#hide_columns a').each(function () {
            if($(this).hasClass('hidden-column'))
                gridOSinglelinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), false);
            else
                gridOSinglelinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), true);
        });
        if(typeof row.dial_position !=='undefined') {
            gridOSinglelinesOptions.columnApi.setColumnVisible('network', false);
            $('#network_to_hide').css('display', 'none');
            $('#zone_to_hide').css('display', 'none');
            if(user_columns_settings.radio.length > 0){
                $('#hide_columns a').each(function () {
                    if(user_columns_settings.radio.indexOf($(this).attr('data-col')) !== -1){
                        gridOSinglelinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), true);
                        $(this).removeClass('hidden-column');
                    }
                    else{
                        gridOSinglelinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), false);
                        $(this).addClass('hidden-column');
                    }
                });
            }
            if (typeof user_columns_settings_new['radio'] !== 'undefined')
                gridOSinglelinesOptions.columnApi.setColumnState(user_columns_settings_new['radio']);
        }
        else {
            gridOSinglelinesOptions.columnApi.setColumnVisible('network', true);
            gridOSinglelinesOptions.columnApi.setColumnVisible('zone', true);
            $('#network_to_hide').css('display', 'inline');
            $('#zone_to_hide').css('display', 'inline');
            if(user_columns_settings.tv.length > 0){
                $('#hide_columns a').each(function () {
                    if(user_columns_settings.tv.indexOf($(this).attr('data-col')) !== -1){
                        gridOSinglelinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), true);
                        $(this).removeClass('hidden-column');
                    }
                    else{
                        gridOSinglelinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), false);
                        $(this).addClass('hidden-column');
                    }
                });
            }
            if (typeof user_columns_settings_new['tv'] !== 'undefined')
                gridOSinglelinesOptions.columnApi.setColumnState(user_columns_settings_new['tv']);
        }
        console.log(g3);
    };
    $('#hide_columns a').bind('click', function (e) {
        var colum= $(this).attr('data-col');
        if ($(this).hasClass('hidden-column')) {
            if($('#hide-matches').css('display') !='none')
                gridOSinglelinesOptions.columnApi.setColumnVisible(colum, true);
            else
                gridOlinesOptions.columnApi.setColumnVisible(colum, true);
            $(this).removeClass('hidden-column');
        } else {
            if($('#hide-matches').css('display') !='none')
                gridOSinglelinesOptions.columnApi.setColumnVisible(colum, false);
            else
                gridOlinesOptions.columnApi.setColumnVisible(colum, false);
            $(this).addClass('hidden-column');
        }
        e.stopPropagation();
    });

    var drawBuyLines = function(){
        if(parseInt($("input:checkbox[name=use_ordered_net_rate]:checked").attr('value')) === 1)
            $('#buy_line_text_h5').html('<b>(Using Ordered net rate to Match)</b>')
        else
            $('#buy_line_text_h5').html('')
        var olines = [];
        var i = 1;
        var xradio = false;
        var line_number = 1;
        $.each(match_result.olines, function(index, row) {
            if (typeof row.m === 'undefined')
                row = row.lineable
            if (i == 1) {
                if (typeof row.dial_position !== 'undefined')
                    xradio = true;
            }
            var verified = 0;
            if (typeof match_result.match[index] !== 'undefined') {
                verified = matchCount(index);
                if (verified == 0) {
                    if (typeof match_result.match[index][-1] !== 'undefined')
                        verified = match_result.match[index][-1].length;
                }
            }
            var dif = typeof match_result.oline_spots[index] !== 'undefined' && !isNaN(parseInt(match_result.oline_spots[index])) ? parseInt(verified) - parseInt(match_result.oline_spots[index]) : 0;
            dif = dif > 0 ? '+' + dif : dif;
            olines.push({
                line_num: parseInt(line_number),
                network: (typeof row.network !== 'undefined' && row.network !== null) ? (row.network).toUpperCase() : row.network,
                zone: (typeof row.zone !== 'undefined' && row.zone !== null) ? (row.zone).toUpperCase() : row.zone,
                program: (typeof row.program !== 'undefined' && row.program !== null) ? (row.program).toUpperCase() : row.program,
                m: (row.m) ? "M" : "-",
                t: (row.t) ? "T" : "-",
                w: (row.w) ? "W" : "-",
                r: (row.r) ? "R" : "-",
                f: (row.f) ? "F" : "-",
                s: (row.s) ? "S" : "-",
                u: (row.u) ? "U" : "-",
                start: moment('2019-10-01 ' + row.start).format('hh:mm A'),
                end: moment('2019-10-01 ' + row.end).format('hh:mm A'),
                length: row.length,
                type: "",
                tag: row.comments,
                rating: !isNaN(parseFloat(row.rating).toFixed(1)) ? parseFloat(row.rating).toFixed(1) : "0.0",
                rate: (!isNaN(parseFloat(row.cost))) ? parseFloat(row.cost).toFixed(2) : "0.00",
                spots: match_result.oline_spots[index], //totalSpots(index),
                verified: (typeof match_result.match[index] !== 'undefined') ? verified : 0,
                difference: dif,
                mgs: 0,
                bonus: '0.00',
                line_id: index,
                bookend: (row.bookend === 0) ? 'No' : 'Yes',
             //   bookend_length : (row.bookend_length === null) ? "" : row.bookend_length,
                bookend_length_1 : (row.bookend_length_1 === null) ? ":0" : ':'+ row.bookend_length_1,
                bookend_length_2 : (row.bookend_length_2 === null) ? ":0" : ':'+ row.bookend_length_2,
                tiered: (match_result['tiered_rates_lines'].indexOf(parseInt(index)) === -1) ? 0 : 1,
            });
            line_number++;
        });
        olines.sort(compareLineNumber);
        gridOlinesOptions.rowData = olines;
        $('#orderlines').html('');
        var gridOlinesDiv = document.querySelector('#orderlines');
        var g2 = new agGrid.Grid(gridOlinesDiv, gridOlinesOptions);

        gridOlinesOptions.columnApi.setColumnVisible('bookend', match_result.bookend_show_hide);

        $('#hide_columns a').each(function () {
            if($(this).hasClass('hidden-column'))
                gridOlinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), false);
            else
                gridOlinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), true);
        });

        if(xradio == true) {
            gridOlinesOptions.columnApi.setColumnVisible('network', false);
            gridOlinesOptions.columnApi.setColumnVisible('zone', false);
            $('#network_to_hide').css('display', 'none');
            $('#zone_to_hide').css('display', 'none');
            $('#view_settings_toltip').tooltip('hide').attr('data-original-title', 'Apply current settings for each Radio Buy lines grid.');

            $('#view_settings_toltip').attr('media-type', 'radio')
            console.log('user_columns_settings.radio', user_columns_settings.radio)
            if (user_columns_settings.radio.length > 0) {
                $('#hide_columns a').each(function () {
                    if (user_columns_settings.radio.indexOf($(this).attr('data-col')) !== -1) {
                        gridOlinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), true);
                        $(this).removeClass('hidden-column');
                    } else {
                        gridOlinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), false);
                        $(this).addClass('hidden-column');
                    }
                });
            }
            console.log('user_columns_settings_new', user_columns_settings_new);
            if (typeof user_columns_settings_new['radio'] !== 'undefined' && user_columns_settings_new['radio'].length > 0)
                gridOlinesOptions.columnApi.setColumnState(user_columns_settings_new['radio']);
        }
        else {
            gridOlinesOptions.columnApi.setColumnVisible('network', true);
            gridOlinesOptions.columnApi.setColumnVisible('zone', true);
            $('#zone_to_hide').css('display', 'inline');
            $('#network_to_hide').css('display', 'inline');
            $('#view_settings_toltip').tooltip('hide').attr('data-original-title', 'Apply current settings for each Television/Cable Buy lines grid.');
            $('#view_settings_toltip').attr('media-type', 'tv')
            console.log('view_settings_toltip', 'tv')
            console.log('user_columns_settings tv', user_columns_settings)
            if(user_columns_settings.tv.length > 0){
                $('#hide_columns a').each(function () {
                    if(user_columns_settings.tv.indexOf($(this).attr('data-col')) !== -1){
                        gridOlinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), true);
                        $(this).removeClass('hidden-column');
                    }
                    else{
                        gridOlinesOptions.columnApi.setColumnVisible($(this).attr('data-col'), false);
                        $(this).addClass('hidden-column');
                    }
                });
                if(typeof user_columns_settings_new['tv'] !== 'undefined' && user_columns_settings_new['tv'].length > 0)
                    gridOlinesOptions.columnApi.setColumnState(user_columns_settings_new['tv']);
            }
        }

        gridOlinesOptions.api.setFilterModel(filter__array_to_keep);
        console.log('filter__array_to_keep ', filter__array_to_keep);
        if(!jQuery.isEmptyObject(filter__array_to_keep))
            $('#reset_filters_buy_line').show();
        else
            $('#reset_filters_buy_line').hide();

    };
    function compareLineNumber(a, b)
    {
        if (a.line_num < b.line_num) return -1;
        if (a.line_num > b.line_num) return 1;
        return 0;
    }

    var drawMatchLines = function(oline_id){
        var match = [];
        for(var index in match_result.match) {
            var week = match_result.match[index];
            if (parseInt(index) === parseInt(oline_id)) {
               console.log('')
                for(var index in week) {
                    var row1 = week[index];
                    $.each(row1, function (index, row) {
                        console.log(row);
                           console.log('array_imp_all_cell_edited row 2', row);
                            var approved_rate = 0;
                            if(typeof row.apvd_rate !== 'undefined')
                                approved_rate = ((!isNaN(parseFloat(row.apvd_rate))) ? parseFloat(row.apvd_rate).toFixed(2) : 0.00);
                            else
                                approved_rate = ((!isNaN(parseFloat(row.approved_rate))) ? parseFloat(row.approved_rate).toFixed(2) : 0.00);

                            match.push({
                                id: row.id,
                                date: moment(row.run_date).format('L'),
                                day: row.day_of_week,
                                time: moment('2019-10-01 ' + row.time_of_day).format('hh:mm A'),
                                type: row.class,
                                cable_network: ( row.network_for_local_cable == null) ? '' : row.network_for_local_cable,
                                length: row.type_spot_length,
                                commercial_id: row.copy_id,
                                rate: (!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00,
                                apvd_rate:  approved_rate,
                                error_codes: '',
                                remark: (row.remark != null) ? row.remark : '',
                                comments: row.remark_no_match,
                                invoice_id: row.invoice_id,
                                bookend : typeof row.bookend !== 'undefined' && row.bookend === 1 ? 'Yes' : 'No',
                            });

                    });
                }

            }
        }

        gridMatchOptions.rowData = match;
        var gridMatchDiv = document.querySelector('#sel-line-matches');
        var g4 = new agGrid.Grid(gridMatchDiv, gridMatchOptions);
        console.log(g4);
        if(typeof data_zone_inv ==='undefined' || data_zone_inv == false )
            gridMatchOptions.columnApi.setColumnsVisible(['cable_network'], false);
        else
            gridMatchOptions.columnApi.setColumnsVisible(['cable_network'], true);

        gridMatchOptions.columnApi.setColumnsVisible(['bookend'], enviroment_bk);

    };

    var drawManualMatchLines = function(oline_id){
        var match = [];
        for(var index in match_result.match) {
            var week = match_result.match[index];
            if (parseInt(index) === parseInt(oline_id)) {
                for(var index in week) {
                    var row1 = week[index];
                    $.each(row1, function (index, row) {
                        if(editing_row_imported_invo === true) {
                            if (typeof array_imp_all_cell_edited[row.id] !== 'undefined' && array_imp_all_cell_edited[row.id] != null) {
                                console.log('draw mat array_imp_all_cell_edited', array_imp_all_cell_edited);
                                match.push({
                                    id: array_imp_all_cell_edited[row.id].id,
                                    date: moment(array_imp_all_cell_edited[row.id].date).format('L'),
                                    day: array_imp_all_cell_edited[row.id].day,
                                    time: moment('2019-10-01 ' + array_imp_all_cell_edited[row.id].time).format('hh:mm A'),
                                    type: '',
                                    length: array_imp_all_cell_edited[row.id].length,
                                    commercial_id: array_imp_all_cell_edited[row.id].commercial_id,
                                    cable_network: array_imp_all_cell_edited[row.id].cable_network,
                                    tag: "",
                                    rate: (!isNaN(parseFloat(array_imp_all_cell_edited[row.id].rate))) ? parseFloat(array_imp_all_cell_edited[row.id].rate).toFixed(2) : 0.00,
                                    apvd_rate: (!isNaN(parseFloat(array_imp_all_cell_edited[row.id].apvd_rate))) ? parseFloat(array_imp_all_cell_edited[row.id].apvd_rate).toFixed(2) : ((!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00),
                                    error_codes: '',
                                    remark: array_imp_all_cell_edited[row.id].remark,
                                    comments: array_imp_all_cell_edited[row.id].comments,
                                    invoice_id: array_imp_all_cell_edited[row.id].invoice_id,
                                    bookend : typeof row.bookend !== 'undefined' && row.bookend === 1 ? 'Yes' : 'No',
                                });
                            }
                            else {
                                match.push({
                                    id: row.id,
                                    cable_network: row.network,
                                    date: moment(row.run_date).format('L'),
                                    day: row.day_of_week,
                                    time: row.run_time,
                                    type: "",
                                    length: row.length,
                                    commercial_id: row.commercial_id,
                                    tag: "",
                                    rate: (!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00,
                                    apvd_rate: (!isNaN(parseFloat(row.approved_rate))) ? parseFloat(row.approved_rate).toFixed(2) : 0.00,
                                    error_codes: '',
                                    remark: (row.remark_no_match == null) ? '' : row.remark_no_match,
                                    comments: (row.comments == null) ? '' : row.comments,
                                    bookend : typeof row.bookend !== 'undefined' && row.bookend === 1 ? 'Yes' : 'No',
                                });
                            }
                        }
                        else {
                            match.push({
                                id: row.id,
                                cable_network: row.network,
                                date: moment(row.run_date).format('L'),
                                day: row.day_of_week,
                                time: row.run_time,
                                type: "",
                                length: row.length,
                                commercial_id: row.commercial_id,
                                tag: "",
                                rate: (!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00,
                                apvd_rate: (!isNaN(parseFloat(row.approved_rate))) ? parseFloat(row.approved_rate).toFixed(2) : 0.00,
                                error_codes: '',
                                remark: (row.remark_no_match == null) ? '' : row.remark_no_match,
                                comments: (row.comments == null) ? '' : row.comments,
                                bookend : typeof row.bookend !== 'undefined' && row.bookend === 1 ? 'Yes' : 'No',
                            });
                        }
                    });
                }
                //});
            } else {
                console.log("no: " + oline_id + " " + index);
            }
        }
        //});

        console.log("match");
        console.log(match);
        gridMatchOptions.rowData = match;
        var gridMatchDiv = document.querySelector('#sel-line-matches');
        var g4 = new agGrid.Grid(gridMatchDiv, gridMatchOptions);
        gridMatchOptions.columnApi.setColumnsVisible(['bookend'], enviroment_bk);
        console.log(g4);
    };

    var drawManualNoMatchLines = function(){
        var no_match = [];
        sortUnMatches();
        $.each(match_result.no_match, function(index, row){
            if(row !== null) {
                console.log('drawManualNoMatchLines ', row);
                if(typeof row.run_time !== 'undefined') {
                    var tt = row.run_time.split('M');
                    if(typeof tt[1] !=='undefined')
                        var tttt = row.run_time;
                    else
                        var tttt = moment('03-06-2019 '+row.run_time+'', 'DD-MMMM-YYYY, HH:mm:ss').format('LT');
                }else {
                    var tt = row.time.split('M');
                    if (typeof tt[1] !== 'undefined')
                        var tttt = row.time;
                    else
                        var tttt = moment('03-06-2019 ' + row.time + '', 'DD-MMMM-YYYY, HH:mm:ss').format('LT');
                }

                if(typeof array_manual_invoice_no_match_id[row.id] !=='undefined')
                    var com = array_manual_invoice_no_match_id[row.id];
                else
                    var com = row.remark_no_match;

                no_match.push({
                    num: index,
                    id: row.id,
                    cable_network: row.network,
                    date: moment(row.run_date).format('L'),
                    day: row.day_of_week,
                    time: tttt,
                    type: row.type,
                    length: row.length,
                    commercial_id: row.commercial_id,
                    tag: "",
                    rate: (!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00,
                    apvd_rate: (!isNaN(parseFloat(row.approved_rate))) ? parseFloat(row.approved_rate).toFixed(2) : 0.00,
                    error_codes: row.error_code,
                    remark: (typeof row.remark_no_match !== 'undefined' ) ?  row.remark_no_match : row.remark,
                    comments: (row.comments === null ) ? '' : row.comments,
                    zone: (typeof row.zone !== 'undefined') ? row.zone : '',
                    program_description: (typeof row.program_description !== 'undefined') ? row.program_description : '',
                });
            }
        });

        gridUnmatchOptions.rowData = no_match;
        var gridUnmatchDiv = document.querySelector('#unmatchedrows');
        var g1 = new agGrid.Grid(gridUnmatchDiv, gridUnmatchOptions);

        if(typeof data_zone_inv ==='undefined' || data_zone_inv === false || data_zone_inv === null)
            gridUnmatchOptions.columnApi.setColumnsVisible(['zone'], false);
        else
            gridUnmatchOptions.columnApi.setColumnsVisible(['zone'], true);

        gridUnmatchOptions.api.setFilterModel(filter__array_to_keep_no_match);
        console.log('filter__array_to_keep_no_match ', filter__array_to_keep_no_match);
        if(!jQuery.isEmptyObject(filter__array_to_keep_no_match))
            $('#reset_filter_sall_lines_no_match').show();
        else
            $('#reset_filter_sall_lines_no_match').hide();
    };

    var drawNoMatchLines = function(){
        var no_match = [];
        sortUnMatches();
        console.log('match_result.no_match ****', match_result.no_match);
        $.each(match_result.no_match, function(index, row){
            if(row !== null) {
                if(typeof row.time_of_day !=='undefined') {
                    var tt = row.time_of_day.split('M');
                    if (typeof tt[1] !== 'undefined')
                        var tttt = row.time_of_day;
                    else
                        var tttt = moment('03-06-2019 ' + row.time_of_day + '', 'DD-MMMM-YYYY, HH:mm:ss').format('LT');
                }
                else{
                    var tt = row.time.split('M');
                    if (typeof tt[1] !== 'undefined')
                        var tttt = row.time;
                    else
                        var tttt = moment('03-06-2019 ' + row.time + '', 'DD-MMMM-YYYY, HH:mm:ss').format('LT');
                }

                console.log('array_imp_all_cell_edited editing_row_imported_invo', editing_row_imported_invo);
                console.log('array_imp_all_cell_edited ', array_imp_all_cell_edited);

                if(editing_row_imported_invo == true){
                    if( typeof array_imp_all_cell_edited[row.id] !=='undefined' && array_imp_all_cell_edited[row.id]!= null){
                        console.log('draw no mat array_imp_all_cell_edited', array_imp_all_cell_edited);
                        var approv_rate = 0;
                        if(typeof row.approved_rate !== 'undefined')
                            approv_rate = (!isNaN(parseFloat(array_imp_all_cell_edited[row.id].approved_rate))) ? parseFloat(array_imp_all_cell_edited[row.id].approved_rate).toFixed(2) : ((!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00);
                        else
                            approv_rate = (!isNaN(parseFloat(array_imp_all_cell_edited[row.id].apvd_rate))) ? parseFloat(array_imp_all_cell_edited[row.id].apvd_rate).toFixed(2) : ((!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00);
                        no_match.push({
                            num: index,
                            id: array_imp_all_cell_edited[row.id].id,
                            date: moment(array_imp_all_cell_edited[row.id].date).format('L'),
                            day: array_imp_all_cell_edited[row.id].day,
                            time: moment('2019-10-01 ' + array_imp_all_cell_edited[row.id].time).format('hh:mm A'),
                            cable_network: array_imp_all_cell_edited[row.id].cable_network,
                            type: '',
                            length: array_imp_all_cell_edited[row.id].length,
                            commercial_id: array_imp_all_cell_edited[row.id].commercial_id,
                            tag: "",
                            rate: (!isNaN(parseFloat(array_imp_all_cell_edited[row.id].rate))) ? parseFloat(array_imp_all_cell_edited[row.id].rate).toFixed(2) : 0.00,
                            apvd_rate: approv_rate,
                            error_codes: '',
                            remark: array_imp_all_cell_edited[row.id].remark,
                            comments: array_imp_all_cell_edited[row.id].comments,
                            invoice_id: array_imp_all_cell_edited[row.id].invoice_id,
                            zone: (typeof row.zone !== 'undefined') ? row.zone : '',
                            program_description: (typeof row.program_description !== 'undefined') ? row.program_description : '',
                            invoice_schedule_line_id: row.invoice_schedule_line_id,
                        });
                    }
                    else{
                        var approv_rate = 0;
                        if(typeof row.approved_rate !== 'undefined')
                            approv_rate = (!isNaN(parseFloat(row.approved_rate))) ? parseFloat(row.approved_rate).toFixed(2) : 0.00;
                        else
                            approv_rate = (!isNaN(parseFloat(row.apvd_rate))) ? parseFloat(row.apvd_rate).toFixed(2) : 0.00;

                        console.log('draw no mat edited row', row);
                        no_match.push({
                            num: index,
                            id: row.id,
                            date: moment(row.run_date).format('L'),
                            day: row.day_of_week,
                            time: tttt,
                            cable_network: (row.network_for_local_cable == null) ? '' : row.network_for_local_cable ,
                            type: row.class,
                            length: row.type_spot_length,
                            commercial_id: row.copy_id,
                            tag: "",
                            rate: (!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00,
                            apvd_rate: approv_rate,
                            error_codes: row.error_code,
                            remark: row.remark,
                            comments: row.remark_no_match,
                            invoice_id: row.invoice_id,
                            zone: (typeof row.zone !== 'undefined') ? row.zone : '',
                            program_description: (typeof row.program_description !== 'undefined') ? row.program_description : '',
                            invoice_schedule_line_id: row.invoice_schedule_line_id,
                        });

                    }
                }
                else {
                    console.log('draw no mat row', row);
                    var approv_rate = 0;
                    if(typeof row.approved_rate !== 'undefined')
                        approv_rate = (!isNaN(parseFloat(row.approved_rate))) ? parseFloat(row.approved_rate).toFixed(2) : 0.00;
                    else
                        approv_rate = (!isNaN(parseFloat(row.apvd_rate))) ? parseFloat(row.apvd_rate).toFixed(2) : 0.00;
                    no_match.push({
                        num: index,
                        id: row.id,
                        date: moment(row.run_date).format('L'),
                        day: row.day_of_week,
                        time: tttt,
                        cable_network: (row.network_for_local_cable == null) ? '' : row.network_for_local_cable ,
                        type: row.class,
                        length: row.type_spot_length,
                        commercial_id: row.copy_id,
                        tag: "",
                        rate: (!isNaN(parseFloat(row.rate))) ? parseFloat(row.rate).toFixed(2) : 0.00,
                        apvd_rate: approv_rate,
                        error_codes: row.error_code,
                        remark: row.remark,
                        comments: row.remark_no_match,
                        invoice_id: row.invoice_id,
                        zone: (typeof row.zone !== 'undefined') ? row.zone : '',
                        program_description: (typeof row.program_description !== 'undefined') ? row.program_description : '',
                        invoice_schedule_line_id: row.invoice_schedule_line_id,
                    });
                }
            }
        });

        gridUnmatchOptions.rowData = no_match;
        var gridUnmatchDiv = document.querySelector('#unmatchedrows');
        var g1 = new agGrid.Grid(gridUnmatchDiv, gridUnmatchOptions);
        console.log(g1);
        if(typeof data_zone_inv ==='undefined' || data_zone_inv == false )
            gridUnmatchOptions.columnApi.setColumnsVisible(['cable_network'], false);
        else
            gridUnmatchOptions.columnApi.setColumnsVisible(['cable_network'], true);

        gridUnmatchOptions.api.setFilterModel(filter__array_to_keep_no_match);
        console.log('filter__array_to_keep_no_match ', filter__array_to_keep_no_match);
        if(!jQuery.isEmptyObject(filter__array_to_keep_no_match))
            $('#reset_filter_sall_lines_no_match').show();
        else
            $('#reset_filter_sall_lines_no_match').hide();
    };

    $("#spot-calendar").on('click', function(){
        var visible = $("#orderlines").css('display');
        var line_number = '';
        if (visible !== 'none') {
            var osel = gridOlinesOptions.api.getSelectedNodes();
            var oline = (osel.length !== 0) ? osel[0] : null;
            console.log('oline', oline);
            var ind = (osel.length !== 0) ? parseInt(oline.data.line_id) : -1;
            line_number = (osel.length !== 0) ? parseInt(oline.data.line_num) : '';
        } else {
            console.log(gridOSinglelinesOptions);
            var osel =  getRowNode(gridOSinglelinesOptions) ;
            console.log('osel', osel);
            var oline = osel[1];
            var ind = parseInt(oline.data.line_id)
            line_number = parseInt(oline.data.line_num) ;
        }

        if(ind === -1){
            swal({
                    title: "Oops!",
                    text: "Select the buy line first ...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }else {
            var html = '<table style="width: 100%; overflow-x: scroll; border 1px solid black">';
            html += '<thead><tr><th style="width: 200px; text-align:left"><b>Line # | ' + (line_number) + '&nbsp;&nbsp;</b></th>';
            var html2 = '';
            var html3 = '';
            var j = 0;
            console.log(' match_result.olines', ind, match_result.olines);
            console.log('console.log(match_result.match)',match_result.match);
            console.log('match_result.ordered_spots ', match_result.ordered_spots);
            var fd_id = [];
            var tr = typeof match_result['tiered_rates'][ind] !== 'undefined' ? 1 : 0;
            console.log('tr_first ', ind, match_result['tiered_rates'][ind])
            var tr_array = typeof match_result['tiered_rates'][ind] !== 'undefined' ? match_result['tiered_rates'][ind] : [];
            for (var oind in match_result.olines) {
                if (parseInt(oind) === parseInt(ind)) {
                    tr = match_result.olines[oind].tiered_rate === 1 && tr === 1 ? 1 : 0;
                    console.log('tr_second ', tr)
                  var OrdDates = match_result.ordered_spots[oind];
                    for (var i in OrdDates) {
                        console.log('day ', OrdDates[i][0]);
                        var d = moment(OrdDates[i][0]).format('MM/DD');
                        fd_id.push(i)
                        html += '<th style="text-align:center">&nbsp;&nbsp;<b>' + d + '</b>&nbsp;&nbsp;</th>';

                        var fd = moment(OrdDates[i][0]).format('YYYY-MM-DD');
                        var tr_string = (tr === 1 && typeof tr_array[fd] !== 'undefined') ?
                            tr_string = '<span style="color: darkred"> (' + parseFloat(tr_array[fd]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }) + ')</span>' : '';

                        html2 += '<td style="text-align:center">' + OrdDates[i][1] + ''+ tr_string +'</td>';
                    }
                    if (typeof match_result.match[oind] !== 'undefined') {
                        for (var ww in fd_id) {
                            if (typeof match_result.match[oind][fd_id[ww]] !== 'undefined') {
                                console.log('match_result.match[oind][fd_id[ww]]_match_result.match[oind][fd_id[ww]] ', match_result.match[oind][fd_id[ww]])
                                var spots_bookends = 0;
                                if(match_result.bookend_show_hide === true){
                                    for(var br_id in match_result.match[oind][fd_id[ww]]){
                                        var br = match_result.match[oind][fd_id[ww]][br_id];
                                        spots_bookends += typeof br['bookend'] !== 'undefined' ? 1 : 0;
                                    }
                                }
                                var bookedn_text = parseInt(spots_bookends) > 0 ? '<span style="color:#EB7148"> (' + parseInt(spots_bookends) + ' bookend)</span>' : '';
                                var invoiced = parseInt(match_result.match[oind][fd_id[ww]].length - (parseInt(spots_bookends) / 2));
                                html3 += '<td style="text-align:center">' + invoiced + bookedn_text + '</td>';
                            }else
                                html3 += '<td style="text-align:center">0</td>';
                        }
                    }else{
                        for (var ww in fd_id)
                            html3 += '<td style="text-align:center">0</td>';
                    }
                    html += '</tr></thead><tbody><tr>' +
                        '<td style="width: 200px; text-align:left"><b>Ordered Items&nbsp;&nbsp;</b></td>' + html2 + '</tr><tr><td style="width: 200px; text-align:left"><b>Approved Items&nbsp;&nbsp;</b>' +
                        '</td>' + html3 + '</tr></tbody></table>';
                    break;
                }
                j++;
            }

            $("#spotCalTable").html(html);
            $("#lineSpotCalendar").modal("show");
        }
    });
    $("#match-lines").on('click', function() {
        $("#loading_match_2").show();
        var um_sel = gridUnmatchOptions.api.getSelectedNodes();
        console.log('match_result ', match_result);

        if (um_sel.length !== 0) {
            saved_data_global = false;
            var visible = $("#orderlines").css('display');
            if (visible !== 'none') {
                var osel = gridOlinesOptions.api.getSelectedNodes();
                var oline = (osel.length !== 0) ? osel[0] : null;
                var ind = (osel.length !== 0) ? parseInt(oline.id) : -1;
            } else {
                var osel = '';
                gridOSinglelinesOptions.api.forEachNode(function (node) {
                    osel = node;
                });
                var oline = osel;
                var ind = parseInt(osel);
            }
            if (osel.length !== 0) {
                show_overlay_loader('#saveMachtModal');
                var array_yes = [];

                var time2 = false;
                var fit2 = false;
                var len2 = false;
                var money2 = false;
                var date2 = false;
                var ran2 = false;
                var day2 = false;
                var comm2 = false;
                $('#rules_content input[type=checkbox]').each(function () {
                    if (!$(this).is(":checked")) {
                        if ($(this).val() === 'rule_SD')
                            date2 = true;
                        else if ($(this).val() === 'rule_NR')
                            ran2 = true;
                        else if ($(this).val() === 'rule_WL')
                            len2 = true;
                        else if ($(this).val() === 'rule_SS')
                            money2 = true;
                        else if ($(this).val() === 'rule_WD')
                            day2 = true;
                        else if ($(this).val() === 'rule_WT')
                            time2 = true;
                        else if ($(this).val() === 'rule_EX')
                            fit2 = true;
                        else if ($(this).val() === 'rule_WC')
                            comm2 = true;

                    }
                    else
                        console.log("checked: " + $(this).checked);
                });

                var um_sel_not_matched = [];
                for (var i in um_sel) {
                    if (time2 == false && array_yes.indexOf('time') === -1) {
                        var sp_time = moment(um_sel[i].data.time, 'h:mm A');
                        var line_start = moment(oline.data.start, 'h:mm A');
                        var line_end = moment(oline.data.start, 'h:mm A');
                        if (sp_time.isBetween(line_start, line_end)) {
                            array_yes.push('time');
                            um_sel_not_matched.push(um_sel[i].id);
                        }
                    }
                    if (len2 == false ) {
                        if (oline.data.length != um_sel[i].data.length)
                            array_yes.push('length');
                    }
                    if (money2 == false) {
                        var fd =   moment(um_sel[i].data.date).weekday(1).format('YYYY-MM-DD')
                        var rx = (typeof match_result['tiered_rates'][oline.data.line_id] !== 'undefined' && typeof match_result['tiered_rates'][oline.data.line_id][fd] !== 'undefined') ? parseFloat(match_result['tiered_rates'][oline.data.line_id][fd]) : parseFloat(oline.data.rate);

                        if (rx != um_sel[i].data.rate && rx != um_sel[i].data.apvd_rate)
                            array_yes.push('rate');
                    }
                    if (day2 == false && array_yes.indexOf('day') === -1) {
                        if (oline.data[um_sel[i].data.day.toLowerCase()] == '-') {
                            array_yes.push('day');
                            um_sel_not_matched.push(um_sel[i].id);
                        }
                    }
                    if (fit2 == false && array_yes.indexOf('extra') === -1) {
                        if (oline.data.verified >= oline.data.spots)
                            array_yes.push('extra');
                    }
                    if (data_zone_inv !== false) {
                        if (oline.data.zone != '' && oline.data.zone !== null) {
                            var incl = oline.data.zone.includes(um_sel[i].data.zone);
                            if (incl == false) {
                                array_yes.push('zone');
                                um_sel_not_matched.push(um_sel[i].id);
                            }
                        }
                    }
                    if(comm2 == false && array_yes.indexOf('comm') === -1 && typeof oline.data.commercial_id !== 'undefined'){
                        if (oline.data.commercial_id != um_sel[i].data.commercial_id) {
                            array_yes.push('comm');
                            um_sel_not_matched.push(um_sel[i].id);
                        }
                    }
                }
                console.log('match_result_match_result_ ____ um_sel', um_sel);
                console.log('match_result_match_result_ ____ oline', oline);
                //Bookend Code
                var add_to_bookend_list = [];
                var add_to_bookend_list_matched = {};
                if(oline.data['bookend'] == 'Yes'){
                    var br_length = [];
                    var booked_added_ids = [];
                    var line_len = oline.data.length;
                    if(oline.data['bookend_length_1'] != ':0' && oline.data['bookend_length_2'] != ':0') {
                        var bk_one = oline.data['bookend_length_1'].replace(':', '')
                        var bk_two = oline.data['bookend_length_2'].replace(':', '')
                        br_length.push(parseInt(bk_one));
                        br_length.push(parseInt(bk_two));
                    }

                    for (var i in um_sel) {
                        var br = um_sel[i].data;
                        if(um_sel_not_matched.indexOf(br.id) === -1){
                            var fd = moment(br.date).weekday(1).format('YYYY-MM-DD');
                            var line_rate = (typeof match_result['tiered_rates'][oline.data.line_id] !== 'undefined' && typeof match_result['tiered_rates'][oline.data.line_id][fd] !== 'undefined') ? parseFloat(match_result['tiered_rates'][oline.data.line_id][fd]) : parseFloat(oline.data.rate);
                            for (var y in um_sel) {
                                var br_2 = um_sel[y].data;
                                var added = false;
                                if(booked_added_ids.indexOf(br.id) === -1 && booked_added_ids.indexOf(br_2.id) === -1 && br.id !== br_2.id && added == false){
                                    var bk_len_column_compatible = (br_length.indexOf(parseInt(br.length)) !== -1 && br_length.indexOf(parseInt(br_2.length)) !== -1) || br_length.length === 0 ? true : false;
                                    var bk_len_percent = parseInt(line_len) > 0 ? (br.length * 100) / parseInt(line_len) : 0;
                                    var bk_rate_percent = parseInt(line_rate) > 0 ? (br.apvd_rate * 100) / parseInt(line_rate) : 0;

                                    var bk_2_len_percent = parseInt(line_len) > 0 ? (br_2.length * 100) / parseInt(line_len) : 0;
                                    var bk_2_rate_percent = parseInt(line_rate) > 0 ? (br_2.apvd_rate * 100) / parseInt(line_rate) : 0;

                                    var percent_br = false;
                                    if (parseInt(bk_len_percent) === parseInt(bk_rate_percent))
                                        percent_br = true;
                                    else if (parseInt(bk_len_percent) + 1 == parseInt(bk_rate_percent) || parseInt(bk_len_percent) - 1 == parseInt(bk_rate_percent))
                                         percent_br = true;
                                    else if (parseInt(bk_rate_percent) + 1 == parseInt(bk_len_percent) || parseInt(bk_rate_percent) - 1 == parseInt(bk_len_percent))
                                         percent_br = true;

                                    var percent_br_2 = false;
                                    if (parseInt(bk_2_len_percent) === parseInt(bk_2_rate_percent))
                                        percent_br_2 = true;
                                    else if (parseInt(bk_2_len_percent) + 1 == parseInt(bk_2_rate_percent) || parseInt(bk_2_len_percent) - 1 == parseInt(bk_2_rate_percent))
                                        percent_br_2 = true;
                                    else if (parseInt(bk_2_rate_percent) + 1 == parseInt(bk_2_len_percent) || parseInt(bk_2_rate_percent) - 1 == parseInt(bk_2_len_percent))
                                       percent_br_2 = true;
                                     console.log('percent_br_percent_br_ percent_br ', percent_br, ' len percent ', bk_len_percent, 'percent rate ', bk_rate_percent);
                                     console.log('percent_br_percent_br_ percent_br_2 ', percent_br_2, ' len percent 2 ', bk_2_len_percent, 'percent rate 2 ', bk_2_rate_percent);


                                    if(percent_br === true && percent_br_2 === true && bk_len_column_compatible === true && parseInt(br.length) + parseInt(br_2.length) === parseInt(line_len) && parseFloat(br.apvd_rate) + parseFloat(br_2.apvd_rate) === parseFloat(line_rate) && br.date === br_2.date){
                                        add_to_bookend_list.push(br.num);
                                        add_to_bookend_list.push(br_2.num);

                                        booked_added_ids.push(br.id);
                                        booked_added_ids.push(br_2.id);
                                        var index = array_yes.indexOf('length');
                                        array_yes.splice(index, 1);
                                        index = array_yes.indexOf('length');
                                        array_yes.splice(index, 1);
                                        var index = array_yes.indexOf('rate');
                                        array_yes.splice(index, 1);
                                        index = array_yes.indexOf('rate');
                                        array_yes.splice(index, 1);

                                    }
                                }
                             }

                            if(booked_added_ids.indexOf(br.id) === -1 && typeof match_result['match'][oline.data.line_id] !== 'undefined'){
                                for(var week_id in match_result.match[oline.data.line_id]) {
                                    for (var br_index in match_result.match[oline.data.line_id][week_id]) {
                                        var br_2 = match_result.match[oline.data.line_id][week_id][br_index];
                                        var br_2_len = typeof br_2.type_spot_length !== 'undefined' ? br_2.type_spot_length : br_2.length ;
                                        var br_2_rate = typeof br_2.approved_rate !== 'undefined' ? br_2.approved_rate : br_2.apvd_rate ;
                                        var br_2_date = typeof br_2.run_date !== 'undefined' ? moment(br_2.run_date).format('MM/DD/YYYY') : br_2.date;
                                        var bk_len_column_compatible = (br_length.indexOf(parseInt(br.length)) !== -1 && br_length.indexOf(parseInt(br_2_len)) !== -1) || br_length.length === 0 ? true : false;

                                        var bk_len_percent = parseInt(line_len) > 0 ? (br.length * 100) / parseInt(line_len) : 0;
                                        var bk_rate_percent = parseInt(line_rate) > 0 ? (br.apvd_rate * 100) / parseInt(line_rate) : 0;

                                        var bk_2_len_percent = parseInt(line_len) > 0 ? (br_2_len * 100) / parseInt(line_len) : 0;
                                        var bk_2_rate_percent = parseInt(line_rate) > 0 ? (br_2_rate * 100) / parseInt(line_rate) : 0;

                                        var percent_br = false;
                                        if (parseInt(bk_len_percent) === parseInt(bk_rate_percent))
                                            percent_br = true;
                                        else if (parseInt(bk_len_percent) + 1 == parseInt(bk_rate_percent) || parseInt(bk_len_percent) - 1 == parseInt(bk_rate_percent))
                                            percent_br = true;
                                        else if (parseInt(bk_rate_percent) + 1 == parseInt(bk_len_percent) || parseInt(bk_rate_percent) - 1 == parseInt(bk_len_percent))
                                            percent_br = true;

                                        var percent_br_2 = false;
                                        if (parseInt(bk_2_len_percent) === parseInt(bk_2_rate_percent))
                                            percent_br_2 = true;
                                        else if (parseInt(bk_2_len_percent) + 1 == parseInt(bk_2_rate_percent) || parseInt(bk_2_len_percent) - 1 == parseInt(bk_2_rate_percent))
                                            percent_br_2 = true;
                                        else if (parseInt(bk_2_rate_percent) + 1 == parseInt(bk_2_len_percent) || parseInt(bk_2_rate_percent) - 1 == parseInt(bk_2_len_percent))
                                            percent_br_2 = true;


                                        if ((typeof br_2['bookend'] === 'undefined' || br_2['bookend'] === null || br_2['bookend'] === 0 ) && percent_br === true && percent_br_2 === true && bk_len_column_compatible === true && parseInt(br.length) + parseInt(br_2_len) === parseInt(line_len) && parseFloat(br.apvd_rate) + parseFloat(br_2_rate) === parseFloat(line_rate) && br.date === br_2_date) {
                                           // match_result.no_match[br.num]['bookend'] = 1;
                                          //  match_result.match[oline.data.line_id][week_id][br_index]['bookend'] = 1;
                                            add_to_bookend_list.push(br.num);
                                            add_to_bookend_list_matched[week_id] = br_index;
                                            var index = array_yes.indexOf('length');
                                            array_yes.splice(index, 1);
                                            var index = array_yes.indexOf('rate');
                                            array_yes.splice(index, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (array_yes.length > 0) {
                    var html_text = 'Some of the broadcast(s) do not match with the selected line:  \n';
                    if (array_yes.indexOf('rate') !== -1)
                        html_text += 'Different rate.\n';
                    if (array_yes.indexOf('length') !== -1)
                        html_text += 'Different length.\n';
                    if (array_yes.indexOf('day') !== -1)
                        html_text += 'Item ran on a not-scheduled or different day.\n';
                    if (array_yes.indexOf('extra') !== -1)
                        html_text += 'Item exceeds the total items ordered.\n';
                    if (array_yes.indexOf('time') !== -1)
                        html_text += 'Item ran out of the start/end time range.\n';
                    if (array_yes.indexOf('zone') !== -1)
                        html_text += 'Different zone.\n';
                    if (array_yes.indexOf('comm') !== -1)
                        html_text += 'Different Commercial ID.\n';
                    html_text += 'Are you sure to continue?';
                    hide_overlay_loader('#saveMachtModal');
                    swal({
                            title: "Warning",
                            text: html_text,
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "Continue",
                            cancelButtonText: 'No',
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                show_overlay_loader('#saveMachtModal')
                                if(add_to_bookend_list.length > 0){
                                    for(var ind in add_to_bookend_list)
                                        match_result.no_match[add_to_bookend_list[ind]]['bookend'] = 1;
                                    for(var week_id in add_to_bookend_list_matched)
                                        match_result.match[oline.data.line_id][week_id][add_to_bookend_list_matched[week_id]]['bookend'] = 1;
                                }
                                var unmatch_nodes_to_remove = [];
                                var match_nodes_to_refresh = [];
                                $.each(um_sel, function (index, value) {
                                    var week_id = null;
                                    if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                    } else
                                        match_result.match[oline.data.line_id] = [];
                                    var actual = moment(value.data.date).format('YYYY-MM-DD HH:mm:ss');
                                    actual = moment(actual);
                                    $.each(match_result.olines[oline.data.line_id]['counts'], function (index, fd) {
                                        var start = moment(fd.start).format('YYYY-MM-DD HH:mm:ss');
                                        start = moment(start);
                                        var end = moment(fd.end).format('YYYY-MM-DD HH:mm:ss');
                                        end = moment(end);

                                        if (actual.isBetween(start, end) || actual.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') || actual.format('YYYY-MM-DD') == end.format('YYYY-MM-DD'))
                                            week_id = fd.id;
                                    });

                                    if (week_id !== null) {
                                        if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                            if (typeof match_result.match[oline.data.line_id][week_id] !== 'undefined')
                                                match_result.match[oline.data.line_id][week_id].push(match_result.no_match[value.data.num]);
                                             else {
                                                match_result.match[oline.data.line_id][week_id] = [];
                                                match_result.match[oline.data.line_id][week_id].push(match_result.no_match[value.data.num]);
                                            }
                                        } else {
                                            match_result.match[oline.data.line_id][week_id] = match_result.no_match[value.data.num];
                                            match_result.match[oline.data.line_id][week_id] = match_result.no_match[value.data.num];
                                        }

                                        if (typeof match_result['forced'] === 'undefined')
                                            match_result['forced'] = [];
                                        match_result['forced'][match_result.no_match[value.data.num].id] = (match_result.no_match[value.data.num]);
                                        match_result.no_match[value.data.num] = null;
                                    }
                                    else {
                                        var l = 99999;
                                        var wl = -1;
                                        var week = match_result.match[oline.data.line_id];
                                        for (var index2 in week) {
                                            var arr = week[index2];
                                            if (arr.length < l) {
                                                l = arr.length;
                                                wl = index2;
                                            }
                                        }
                                        if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                            console.log('insideeeeeee', wl);
                                            if (typeof match_result.match[oline.data.line_id][wl] !== 'undefined')
                                                match_result.match[oline.data.line_id][wl].push(match_result.no_match[value.data.num]);
                                             else {
                                                match_result.match[oline.data.line_id][wl] = [];
                                                match_result.match[oline.data.line_id][wl].push(match_result.no_match[value.data.num]);
                                            }
                                        } else
                                            match_result.match[oline.data.line_id][wl] = match_result.no_match[value.data.num];

                                        if (typeof match_result['forced'] === 'undefined')
                                            match_result['forced'] = [];

                                        match_result['forced'][match_result.no_match[value.data.num].id] = (match_result.no_match[value.data.num]);
                                        match_result.no_match[value.data.num] = null;
                                    }

                                    unmatch_nodes_to_remove.push(value);
                                    if (visible !== 'none') {

                                    } else {
                                        oline.data.verified = parseInt(oline.data.verified) + 1;
                                        var dif = typeof oline.data.spots !== 'undefined' && !isNaN(parseInt(oline.data.spots))  ? parseInt(oline.data.verified) - parseInt(oline.data.spots) : 0;
                                        oline.data.difference = dif > 0 ? '+' + dif : dif;
                                        gridOSinglelinesOptions.api.refreshCells({
                                            rowNodes: [oline],
                                            columns: ['verified', 'difference'],
                                            force: true});
                                    }
                                });
                                if(unmatch_nodes_to_remove.length > 0){
                                    gridUnmatchOptions.api.removeItems(unmatch_nodes_to_remove);
                                    gridUnmatchOptions.api.refreshView();
                                }
                                if (visible !== 'none') {
                                    $("#orderlines").html("");
                                    drawBuyLines();
                                }else {
                                    var verified = 0;
                                    if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                        verified = matchCount(oline.data.line_id);
                                        if (verified == 0) {
                                            if (typeof match_result.match[oline.data.line_id][-1] !== 'undefined')
                                                verified = match_result.match[oline.data.line_id][-1].length;
                                        }
                                    }
                                    var dif = typeof match_result.oline_spots[oline.data.line_id] !== 'undefined' && !isNaN(parseInt(match_result.oline_spots[oline.data.line_id])) ? parseInt(verified) - parseInt(match_result.oline_spots[oline.data.line_id]) : 0;
                                    dif = dif > 0 ? '+' + dif : dif;
                                    oline.data.verified = verified;
                                    oline.data.difference = dif;
                                    gridOSinglelinesOptions.api.refreshCells({
                                        rowNodes: [oline],
                                        columns: ['verified', 'difference'],
                                        force: true
                                    });
                                }
                                $("#sel-line-matches").html("");
                                if (typeof match_result.manual !== "undefined")
                                    drawManualMatchLines(oline.data.line_id);
                                else
                                    drawMatchLines(oline.data.line_id);
                                hide_overlay_loader('#saveMachtModal');
                            }
                        });
                }
                 else {
                    show_overlay_loader('#saveMachtModal')
                    if(add_to_bookend_list.length > 0){
                        for(var ind in add_to_bookend_list)
                            match_result.no_match[add_to_bookend_list[ind]]['bookend'] = 1;
                        for(var week_id in add_to_bookend_list_matched)
                            match_result.match[oline.data.line_id][week_id][add_to_bookend_list_matched[week_id]]['bookend'] = 1;
                    }
                    $.each(um_sel, function (index, value) {
                        var week_id = null;
                        if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                        } else
                            match_result.match[oline.data.line_id] = [];
                        var actual = moment(value.data.date).format('YYYY-MM-DD HH:mm:ss');
                        actual = moment(actual);

                        $.each(match_result.olines[oline.data.line_id]['counts'], function (index, fd) {
                            var start = moment(fd.start);
                            var end = moment(fd.end);

                            if (actual.isBetween(start, end) || actual.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') || actual.format('YYYY-MM-DD') == end.format('YYYY-MM-DD'))
                                week_id = fd.id;
                        });

                        if (week_id !== null) {
                            if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                if (typeof match_result.match[oline.data.line_id][week_id] !== 'undefined')
                                    match_result.match[oline.data.line_id][week_id].push(match_result.no_match[value.data.num]);
                                 else {
                                    match_result.match[oline.data.line_id][week_id] = [];
                                    match_result.match[oline.data.line_id][week_id].push(match_result.no_match[value.data.num]);
                                }
                            } else {
                                match_result.match[oline.data.line_id][week_id] = match_result.no_match[value.data.num];
                                match_result.match[oline.data.line_id][week_id] = match_result.no_match[value.data.num];
                            }

                            if (typeof match_result['forced'] === 'undefined')
                                match_result['forced'] = [];
                            match_result['forced'][match_result.no_match[value.data.num].id] = (match_result.no_match[value.data.num]);
                            match_result.no_match[value.data.num] = null;
                        } else {
                            var l = 99999;
                            var wl = -1;
                            var week = match_result.match[oline.data.line_id];
                            for (var index2 in week) {
                                var arr = week[index2];
                                if (arr.length < l) {
                                    l = arr.length;
                                    wl = index2;
                                }
                            }
                            if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                if (typeof match_result.match[oline.data.line_id][wl] !== 'undefined')
                                    match_result.match[oline.data.line_id][wl].push(match_result.no_match[value.data.num]);
                                else {
                                    match_result.match[oline.data.line_id][wl] = [];
                                    match_result.match[oline.data.line_id][wl].push(match_result.no_match[value.data.num]);
                                }
                            } else
                                match_result.match[oline.data.line_id][wl] = match_result.no_match[value.data.num];

                            if (typeof match_result['forced'] === 'undefined')
                                match_result['forced'] = [];
                            match_result['forced'][match_result.no_match[value.data.num].id] = (match_result.no_match[value.data.num]);
                            match_result.no_match[value.data.num] = null;
                        }
                        gridUnmatchOptions.api.removeItems([value]);
                        gridUnmatchOptions.api.refreshView();
                        if (visible !== 'none') {
                            $("#orderlines").html("");
                            drawBuyLines();
                        } else {
                            var verified = 0;
                            if (typeof match_result.match[oline.data.line_id] !== 'undefined') {
                                verified = matchCount(oline.data.line_id);
                                if (verified == 0) {
                                    if (typeof match_result.match[oline.data.line_id][-1] !== 'undefined')
                                        verified = match_result.match[oline.data.line_id][-1].length;
                                }
                            }
                            var dif = typeof match_result.oline_spots[oline.data.line_id] !== 'undefined' && !isNaN(parseInt(match_result.oline_spots[oline.data.line_id])) ? parseInt(verified) - parseInt(match_result.oline_spots[oline.data.line_id]) : 0;
                            dif = dif > 0 ? '+' + dif : dif;
                            oline.data.verified = verified;
                            oline.data.difference = dif;
                            gridOSinglelinesOptions.api.refreshCells({
                                rowNodes: [oline],
                                columns: ['verified', 'difference'],
                                force: true});
                        }

                    });
                    $("#sel-line-matches").html("");
                    if (typeof match_result.manual !== "undefined")
                        drawManualMatchLines(oline.data.line_id);
                    else
                        drawMatchLines(oline.data.line_id);
                    hide_overlay_loader('#saveMachtModal')
                }
            } else {
                $('#generalWarningModalDiv').html('Please at least one buy line.');
                $('#generalWarningModal').modal('show');
            }
        } else {
            $('#generalWarningModalDiv').html('Please select at least one unmatched line.');
            $('#generalWarningModal').modal('show');
        }
        $("#loading_match_2").hide();
    });
    var placeUnMatchRow = function(row){
        var place = 0;
        for(var ind in match_result.no_match){
            if(match_result.no_match[ind] === null) {
                if(typeof row.bookend !== 'undefined' && row.bookend === 1)
                    row.bookend = 0;
                match_result.no_match[ind] = row;
                place = 1;
                break;
            }
        }
        var aux = [];
        if(typeof match_result['forced'] !== 'undefined') {
            for (var ind in match_result['forced']){
                if(match_result['forced'][ind].id !== row.id)
                    aux.push(match_result['forced'][ind]);
            }
            match_result['forced'] = aux;
        }
        if(place === 0){
            if(typeof row.bookend !== 'undefined' && row.bookend === 1)
                row.bookend = 0;
            match_result.no_match.push(row);
        }
    };

    var sortUnMatches = function(){
        for(var i=0; i < match_result.no_match.length - 1; i++){
            if(match_result.no_match[i] !== null) {
                for (var j = i + 1; j < match_result.no_match.length; j++) {
                    if (match_result.no_match[j] !== null) {
                        if(match_result.no_match[i].id > match_result.no_match[j].id){
                            var aux = match_result.no_match[i];
                            match_result.no_match[i] = match_result.no_match[j];
                            match_result.no_match[j] = aux;
                        }
                    }
                }
            }
        }
    };

    //select_descelect_all
    $('#select_all_lines').on('click', function(){
        gridUnmatchOptions.api.selectAllFiltered();
    });
    $('#deselect_all_lines_test').on('click', function(){
        gridUnmatchOptions.api.deselectAll();

    });
    var firstt = 0;
    $("#unmatch-all-lines").on('click', function(){
        swal({
                title: "Warning",
                text: "Are you sure?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "OK",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
              if(isConfirm){
                  show_overlay_loader($('#saveMachtModal'));
                  saved_data_global = false;
                  var visible = $("#orderlines").css('display');
                  if(visible !== 'none') {
                      gridOlinesOptions.api.forEachNode(function (node) {
                          for (var index in match_result.olines) {
                              if (parseInt(index) === parseInt(node.data.line_id)) {
                                  for (var ind1 in match_result.match[index]) {
                                      for (var rind in match_result.match[index][ind1])
                                          placeUnMatchRow(match_result.match[index][ind1][rind]);
                                      match_result.match[index][ind1] = [];
                                  }
                              }
                          }
                      });

                      $("#orderlines").html("");
                      drawBuyLines();

                      $("#unmatchedrows").html("");
                      if (typeof match_result.manual !== "undefined")
                          drawManualNoMatchLines();
                      else
                          drawNoMatchLines();

                      gridOlinesOptions.api.deselectAll();
                      hide_overlay_loader($('#saveMachtModal'));
                  }
                  else{
                      gridOSinglelinesOptions.api.selectAll();
                      var sel =  gridOSinglelinesOptions.api.getSelectedNodes()[0];
                      gridMatchOptions.api.selectAll();
                      var spots_matched = gridMatchOptions.api.getSelectedNodes();
                      var moves = [];
                      for (var oind in match_result.olines) {
                          if (oind === sel.data.line_id) {
                              for (var wind in match_result.match[oind]) {
                                  var final = [];
                                  for (var i in match_result.match[oind][wind]) {
                                      var f = false;
                                      $.each(spots_matched, function(index, node){
                                          if(parseInt(node.data.id) === parseInt(match_result.match[oind][wind][i].id)){
                                              f = true;
                                              return false;
                                          }
                                      });
                                      if(!f)
                                          final.push(match_result.match[oind][wind][i]);
                                      else if(moves.indexOf(match_result.match[oind][wind][i].id) === -1) {
                                          moves.push(match_result.match[oind][wind][i].id);
                                          placeUnMatchRow(match_result.match[oind][wind][i]);
                                      }
                                  }
                                  match_result.match[oind][wind] = final;
                              }
                          }
                      }

                      $("#unmatchedrows").html("");
                      if(typeof match_result.manual === 'undefined')
                          drawNoMatchLines();
                      else
                          drawManualNoMatchLines();

                      $("#sel-order-line").html("");
                      drawSingleBuyLines(match_result.olines[sel.data.line_id], sel.data.line_id , sel.data.line_id);

                      $("#sel-line-matches").html("");
                      if(typeof match_result.manual === 'undefined')
                          drawMatchLines(sel.data.line_id);
                      else
                          drawManualMatchLines(sel.data.line_id);
                      hide_overlay_loader($('#saveMachtModal'));
                  }
              }

            });

    });

    $("#unmatch-lines").on('click', function(){
        var visible = $("#orderlines").css('display');
        if(visible !== 'none'){
            var osel = gridOlinesOptions.api.getSelectedNodes();
            if(osel.length === 0){
                swal({
                        title: "Oops!",
                        text: "Select the buy line first ...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }else{
                saved_data_global = false;
                var line = osel[0];
                var indo = parseInt(line.data.line_id);
                for(var index in match_result.olines){
                    if(parseInt(index) === parseInt(indo)) {
                        for(var ind1 in match_result.match[index]){
                            for(var rind in match_result.match[index][ind1])
                                placeUnMatchRow(match_result.match[index][ind1][rind]);
                            match_result.match[index][ind1] = [];
                        }
                    }
                }

                $("#orderlines").html("");
                drawBuyLines();

                $("#unmatchedrows").html("");
                if (typeof match_result.manual !== "undefined")
                    drawManualNoMatchLines();
                else
                    drawNoMatchLines();
            }
        }else {
            var msel = gridMatchOptions.api.getSelectedNodes();
            if (msel.length === 0) {
                $('#generalWarningModalDiv').html('Select at least one match line.');
                $('#generalWarningModal').modal('show');
            } else {
                var sel = getRowNode(gridOSinglelinesOptions);
                gridOSinglelinesOptions.api.forEachNode(function(node){
                    sel =  node;
                });
                var nind = 0;
                var moves = [];
                for (var oind in match_result.olines) {
                    if (oind === sel.data.line_id) {
                        nind = oind;
                        for (var wind in match_result.match[oind]) {
                            var final = [];
                            for (var i in match_result.match[oind][wind]) {
                                var f = false;
                                $.each(msel, function(index, node){
                                     if(parseInt(node.data.id) === parseInt(match_result.match[oind][wind][i].id)){
                                         f = true;
                                         return false;
                                     }
                                });
                                if(!f) {
                                    final.push(match_result.match[oind][wind][i]);
                                }else {
                                    if(moves.indexOf(match_result.match[oind][wind][i].id) === -1) {
                                        moves.push(match_result.match[oind][wind][i].id);
                                        placeUnMatchRow(match_result.match[oind][wind][i]);
                                    }
                                }
                            }
                            match_result.match[oind][wind] = final;
                        }
                        break;
                    }
                }
                console.log('bookend_added sel', sel);
                if(typeof sel.data.bookend !== 'undefined' && sel.data.bookend === "Yes") {
                    oline = sel;
                    var br_length = [];
                    var booked_added_ids = [];
                    var line_len = oline.data.length;
                    if (oline.data['bookend_length_1'] != ':0' && oline.data['bookend_length_2'] != ':0') {
                        var bk_one = oline.data['bookend_length_1'].replace(':', '')
                        var bk_two = oline.data['bookend_length_2'].replace(':', '')
                        br_length.push(parseInt(bk_one));
                        br_length.push(parseInt(bk_two));
                    }
                    console.log('bookend_added br_length', br_length);
                    var bookend_added = [];
                    for (var week_id in match_result.match[sel.data.line_id]) {
                        for (var index in match_result.match[sel.data.line_id][week_id]) {
                            var br = match_result.match[sel.data.line_id][week_id][index];
                            if (br.bookend === 1) {
                                var fd = typeof br.date !== 'undefined' ? moment(br.date).weekday(1).format('YYYY-MM-DD') : moment(br.run_date).weekday(1).format('YYYY-MM-DD');
                                var line_rate = (typeof match_result['tiered_rates'][oline.data.line_id] !== 'undefined' && typeof match_result['tiered_rates'][oline.data.line_id][fd] !== 'undefined') ? parseFloat(match_result['tiered_rates'][oline.data.line_id][fd]) : parseFloat(oline.data.rate);
                                for (var week_id_2 in match_result.match[sel.data.line_id]) {
                                    for (var index_2 in match_result.match[sel.data.line_id][week_id_2]) {
                                        var br_2 = match_result.match[sel.data.line_id][week_id_2][index_2];

                                        var br_len = typeof br.type_spot_length !== 'undefined' ? br.type_spot_length : br.length ;
                                        var br_rate = typeof br.approved_rate !== 'undefined' ? br.approved_rate : br.apvd_rate ;
                                        var br_date = typeof br.run_date !== 'undefined' ? moment(br.run_date).format('MM/DD/YYYY') : br.date;

                                        var br_2_len = typeof br_2.type_spot_length !== 'undefined' ? br_2.type_spot_length : br_2.length ;
                                        var br_2_rate = typeof br_2.approved_rate !== 'undefined' ? br_2.approved_rate : br_2.apvd_rate ;
                                        var br_2_date = typeof br_2.run_date !== 'undefined' ? moment(br_2.run_date).format('MM/DD/YYYY') : br_2.date;

                                        if (br_2.bookend === 1 && bookend_added.indexOf(br.id) === -1 && bookend_added.indexOf(br_2.id) === -1 && br.id !== br_2.id) {
                                            var bk_len_percent = parseInt(line_len) > 0 ? (br_len * 100) / parseInt(line_len) : 0;
                                            var bk_rate_percent = parseInt(line_rate) > 0 ? (br_rate * 100) / parseInt(line_rate) : 0;
                                            var bk_2_len_percent = parseInt(line_len) > 0 ? (br_2_len * 100) / parseInt(line_len) : 0;
                                            var bk_2_rate_percent = parseInt(line_rate) > 0 ? (br_2_rate * 100) / parseInt(line_rate) : 0;

                                            var percent_br = false;
                                            if (parseInt(bk_len_percent) === parseInt(bk_rate_percent))
                                                percent_br = true;
                                            else if (parseInt(bk_len_percent) + 1 == parseInt(bk_rate_percent) || parseInt(bk_len_percent) - 1 == parseInt(bk_rate_percent))
                                                percent_br = true;
                                            else if (parseInt(bk_rate_percent) + 1 == parseInt(bk_len_percent) || parseInt(bk_rate_percent) - 1 == parseInt(bk_len_percent))
                                                percent_br = true;

                                            var percent_br_2 = false;
                                            if (parseInt(bk_2_len_percent) === parseInt(bk_2_rate_percent))
                                                percent_br_2 = true;
                                            else if (parseInt(bk_2_len_percent) + 1 == parseInt(bk_2_rate_percent) || parseInt(bk_2_len_percent) - 1 == parseInt(bk_2_rate_percent))
                                                percent_br_2 = true;
                                            else if (parseInt(bk_2_rate_percent) + 1 == parseInt(bk_2_len_percent) || parseInt(bk_2_rate_percent) - 1 == parseInt(bk_2_len_percent))
                                                percent_br_2 = true;

                                            var bk_len_column_compatible = (br_length.indexOf(parseInt(br_len)) !== -1 && br_length.indexOf(parseInt(br_2_len)) !== -1) || br_length.length === 0 ? true : false;
                                            if (percent_br === true && percent_br_2 === true && bk_len_column_compatible === true && parseInt(br_len) + parseInt(br_2_len) === parseInt(line_len) && parseFloat(br_rate) + parseFloat(br_2_rate) === parseFloat(line_rate) && br_date === br_2_date) {
                                                bookend_added.push(br.id);
                                                bookend_added.push(br_2.id);
                                            }
                                        }
                                    }
                                }
                                console.log('bookend_added ', bookend_added);
                                if(bookend_added.indexOf(br.id) === -1)
                                    match_result.match[oline.data.line_id][week_id][index]['bookend'] = 0;

                                console.log('bookend_added match_result.match[oline.data.line_id][week_id][index]', match_result.match[oline.data.line_id][week_id][index]);

                            }
                        }
                    }
                }


                $("#unmatchedrows").html("");
                if(typeof match_result.manual === 'undefined')
                    drawNoMatchLines();
                else
                    drawManualNoMatchLines();

                $("#sel-order-line").html("");
                drawSingleBuyLines(match_result.olines[nind], sel.data.line_id, nind);

                $("#sel-line-matches").html("");
                if(typeof match_result.manual === 'undefined')
                    drawMatchLines(nind);
                else
                    drawManualMatchLines(nind);
            }
        }
    });

    $("#clear-matches").on('click', function(){
        $("#loading_match_2").show();
        var visible = $("#orderlines").css('display');
        if(visible !== 'none'){
            var osel = gridOlinesOptions.api.getSelectedNodes();
            if(osel.length === 0){
                swal({
                        title: "Oops!",
                        text: "Select the buy line first ...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }else{
                saved_data_global = false;
                var line = osel[0];
                var indo = parseInt(line.data.line_num) - 1;
                var jj = 0;

                for(var index in match_result.olines){
                    if(jj === indo) {
                        console.log("thisone");
                        for(var ind1 in match_result.match[index]){
                            for(var rind in match_result.match[index][ind1])
                                placeUnMatchRow(match_result.match[index][ind1][rind]);
                            match_result.match[index][ind1] = [];
                        }
                    } else {
                        console.log("not: " + jj + " " + indo);
                    }
                    jj++;
                }

                $("#orderlines").html("");
                drawBuyLines();

                $("#unmatchedrows").html("");
                if(typeof match_result.manual === "undefined")
                    drawNoMatchLines();
                else
                    drawManualNoMatchLines();
            }
        } else {
            saved_data_global = false;
            var sel = getRowNode(gridOSinglelinesOptions);
            var j = 0;
            var nind = 0;
            for(var oind in match_result.olines){
                if(j === sel[0]){
                    console.log("yip: " + oind);
                    nind = oind;
                    for(var wind in match_result.match[oind]){
                        for(var rind in match_result.match[oind][wind])
                            placeUnMatchRow(match_result.match[oind][wind][rind]);
                        match_result.match[oind][wind] = [];
                    }
                    break;
                }else{
                    console.log("niet: " + j + " " + sel[0]);
                }
                j++;
            }

            $("#unmatchedrows").html("");
            if(typeof match_result.manual === "undefined")
                drawNoMatchLines();
            else
                drawManualNoMatchLines();

            $("#sel-order-line").html("");
            drawSingleBuyLines(match_result.olines[nind], j + 1, nind);

            $("#sel-line-matches").html("");
            if(typeof match_result.manual === "undefined")
                drawMatchLines(nind);
            else
                drawManualMatchLines(nind);
        }
        $("#loading_match_2").hide();
    });

    var summaryData = function(){
        var spots = 0;
        var ran = 0;
        var spots_aprv = 0;
        var tot_spots = 0;
        $.each(match_result.olines, function(ind, val){
            var lspots = 0;
            $.each(val.counts, function(ind1, val1){
                lspots += val1.count;
            });
            spots += lspots;
        });

        var missed = 0
        $.each(match_result.no_match, function(ind, val){
            if(val !== null) {
                ran += (val.run_code) ? 1 : 0;
                missed++
            }
        });

        $.each(match_result.match, function(ind, val){
            $.each(val, function(ind1, val1) {
                $.each(val1, function(ind2, val2) {
                    tot_spots++;
                    ran += (val2.run_code) ? 1 : 0;
                    spots_aprv ++;
                });
            });
        });

        //var missed = (spots - spots_aprv < 0) ? 0 : spots - spots_aprv;
        tot_spots += match_result.no_match.length;
        var nordered = (spots < tot_spots) ? (tot_spots - spots) : 0;

        var forced = 0;
        if(typeof match_result['forced'] !== 'undefined'){
            for(var i in match_result['forced'])
                forced++
        }

        return {
            ordered: spots,
            ran: ran,
            approved: spots_aprv,
            missed: missed,
            not_ordered: nordered,
            total: tot_spots,
            forced: forced,
        };
    };

    $("#match-summary").on('click', function(){
        console.log('match_result', match_result);
        if(match_result.lineable_type !== 'undefined')
            var com= match_result.lineable_type;
        else
            var com= 0;

        var spots = 0;
        var cost = 0;
        var ran = 0;
        var ran_cost = 0;
        var spots_aprv = 0;
        var spots_aprv_bookend = 0;
        var aprv_cost = 0;
        var tot_spots = 0;
        var net_cost = 0;
        var net_ran_cost = 0;
        var net_aprv_cost = 0;
        $.each(match_result.olines, function(ind, val){
            var lspots = 0;
            cost += parseFloat(val.gross_cost);
            spots += parseInt(match_result.oline_spots[ind]);//lspots;
            net_cost += (parseFloat((val.gross_cost)) * (100 - parseFloat(match_result.commissions[val.lineable_type]))/100)

        });

        $.each(match_result.no_match, function(ind, val){
            if(val !== null) {
                //ran += (val.run_code) ? 1 : 0;
                ran ++;
                ran_cost += (!isNaN(parseFloat(val.rate)) ? val.rate : 0);
                net_ran_cost += ((!isNaN(parseFloat(val.rate)) ? parseFloat(val.rate) : 0) * (100 - (!isNaN(parseFloat(match_result.commissions[match_result.lineable_type])) ? parseFloat(match_result.commissions[match_result.lineable_type]) : 0))/100)
            }
        });
        var all_matched = []; var kindof = '';
        console.log('(match_result.match new', match_result.match);
        $.each(match_result.match, function(ind, val){
            if(typeof  val !== 'undefined' && typeof  val[-1] !== 'undefined'){
                var auu = [];
                var dvg = val[-1];

                $.each(dvg, function(ind2, val2) {
                    if (typeof val2.commercial_id !== 'undefined' && val2.commercial_id !== null) {
                        kindof = 'commercial_id';
                        var copy = val2;
                        copy.commercial_id = copy.commercial_id.toUpperCase();
                        auu.push(copy);
                    } else {
                        kindof = 'copy_id';
                        var copy = val2;
                        copy.copy_id = (typeof copy.copy_id !== 'undefined' && copy.copy_id !== null) ? copy.copy_id.toUpperCase() : '';
                        auu.push(copy);
                    }
                    console.log('val[-1]', val2);

                    tot_spots++;
                    //ran += (val2.run_code) ? 1 : 0;
                    ran ++;
                    ran_cost +=   !isNaN(parseFloat(val2.rate)) ? parseFloat(val2.rate) : 0;
                    net_ran_cost += ((!isNaN(parseFloat(val2.rate)) ? parseFloat(val2.rate) : 0) * (100 - (!isNaN(parseFloat(match_result.commissions[match_result.lineable_type])) ? parseFloat(match_result.commissions[match_result.lineable_type]) : 0)) / 100);

                    spots_aprv += typeof val2.bookend !== 'undefined' && val2.bookend === 1 ? parseFloat(0.5) : parseInt(1);
                    spots_aprv_bookend += typeof val2.bookend !== 'undefined' && val2.bookend === 1 ? parseInt(1) : parseInt(0);
                    if (typeof val2.approved_rate !== 'undefined') {
                        aprv_cost += !isNaN(parseFloat(val2.approved_rate)) ? parseFloat(val2.approved_rate) : 0;
                        net_aprv_cost += !isNaN(parseFloat(val2.approved_rate)) ?  ((parseFloat(val2.approved_rate)) * (100 - parseFloat(match_result.commissions[match_result.lineable_type]))/100) : 0;
                    } else {
                        aprv_cost += !isNaN(parseFloat(val2.apvd_rate)) ? parseFloat(val2.apvd_rate) : 0;
                        net_aprv_cost += !isNaN(parseFloat(val2.apvd_rate)) ? ((parseFloat(val2.apvd_rate)) * (100 - parseFloat(match_result.commissions[match_result.lineable_type])) / 100) : 0;
                    }
                });
                all_matched = all_matched.concat(auu);
            }
            else if(typeof  val !== 'undefined') {
                $.each(val, function (ind1, val1) {
                    var auu = [];
                    $.each(val1, function (ind2, val2) {
                        console.log('val2val2val2 ', val2)
                        if (typeof val2.commercial_id !== 'undefined' && val2.commercial_id !== null) {
                            kindof = 'commercial_id';
                            var copy = val2;
                            copy.commercial_id = copy.commercial_id.toUpperCase();
                            auu.push(copy);
                        } else {
                            kindof = 'copy_id';
                            var copy = val2;
                            copy.copy_id = (typeof copy.copy_id !== 'undefined' && copy.copy_id !== null) ? copy.copy_id.toUpperCase() : '';
                            auu.push(copy);
                        }
                        console.log('val[-1]', val2);
                        tot_spots++;
                       // ran += (val2.run_code) ? 1 : 0;
                        ran ++;
                        ran_cost +=   !isNaN(parseFloat(val2.rate)) ? parseFloat(val2.rate) : 0;
                        net_ran_cost += ((!isNaN(parseFloat(val2.rate)) ? parseFloat(val2.rate) : 0) * (100 - (!isNaN(parseFloat(match_result.commissions[match_result.lineable_type])) ? parseFloat(match_result.commissions[match_result.lineable_type]) : 0)) / 100);
                        spots_aprv += typeof val2.bookend !== 'undefined' && val2.bookend === 1 ? parseFloat(0.5) : parseInt(1);
                        spots_aprv_bookend += typeof val2.bookend !== 'undefined' && val2.bookend === 1 ? parseInt(1) : parseInt(0);
                        if (typeof val2.approved_rate !== 'undefined') {
                            aprv_cost += !isNaN(parseFloat(val2.approved_rate)) ? parseFloat(val2.approved_rate) : 0;
                            net_aprv_cost += !isNaN(parseFloat(val2.approved_rate)) ?  ((parseFloat(val2.approved_rate)) * (100 - parseFloat(match_result.commissions[match_result.lineable_type]))/100) : 0;
                        } else {
                            aprv_cost += !isNaN(parseFloat(val2.apvd_rate)) ? parseFloat(val2.apvd_rate) : 0;
                            net_aprv_cost += !isNaN(parseFloat(val2.apvd_rate)) ? ((parseFloat(val2.apvd_rate)) * (100 - parseFloat(match_result.commissions[match_result.lineable_type])) / 100) : 0;
                        }
                    });
                    all_matched = all_matched.concat(auu);
                });
            }
        });
        if(kindof === 'commercial_id')
            all_matched = collect(all_matched).groupBy((item, key) => item.commercial_id).all();
        else
            all_matched = collect(all_matched).groupBy((item, key) => item.copy_id).all();
        console.log("all_matched: ", all_matched);

        var traffic = [];
        if(typeof match_result.traffic_instructions !== 'undefined' && match_result.traffic_length > 0){
            for(var period in match_result.traffic_instructions){
                var pstart = period.split(' ')[0];
                if(pstart.indexOf('/') !== -1) {
                    pstart = pstart.split('/');
                    pstart = pstart[2] + '-' + pstart[0] + '-' + pstart[1];
                }
                var pend = period.split(' ')[1];
                if(pend.indexOf('/') !== -1) {
                    pend = pend.split('/');
                    pend = pend[2] + '-' + pend[0] + '-' + pend[1];
                }
                traffic[period] = {
                    total: 0,
                    codes: [],
                    ordered: [],
                };
                var auxc = [];
                for(var ind in match_result.traffic_instructions[period]){
                    auxc.push(match_result.traffic_instructions[period][ind]['code'].toUpperCase());
                    if(typeof traffic[period].codes[match_result.traffic_instructions[period][ind]['code'].toUpperCase()] === 'undefined'){
                        traffic[period].codes[match_result.traffic_instructions[period][ind]['code'].toUpperCase()] = 0;
                        traffic[period].ordered[match_result.traffic_instructions[period][ind]['code'].toUpperCase()] = parseInt(match_result.traffic_instructions[period][ind]['pct']);
                    }
                    if(typeof all_matched[match_result.traffic_instructions[period][ind]['code'].toUpperCase()] !== 'undefined'){
                        var push = collect(all_matched[match_result.traffic_instructions[period][ind]['code'].toUpperCase()])
                            .where('run_date', '>=', pstart)
                            .where('run_date', '<=', pend)
                            .count();
                        traffic[period].codes[match_result.traffic_instructions[period][ind]['code'].toUpperCase()] += push;
                        traffic[period].total += push;
                    }
                }

                for(var indic in all_matched){
                    if(auxc.indexOf(indic) === -1){
                        traffic[period].codes[indic] = 0;
                        traffic[period].ordered[indic] = 0;
                        var push = collect(all_matched[indic])
                            .where('run_date', '>=', pstart)
                            .where('run_date', '<=', pend)
                            .count();
                        traffic[period].codes[indic] += push;
                        traffic[period].total += push;
                    }
                }
            }
        }
        console.log('traffic: ', traffic);
        $("#traffic_summary").html("");
        var html = '';
        if(match_result.traffic_length > 0){
            html += '<div class="row" style="height: 50vh; overflow-y: scroll"><div class="col-sm-12">'
            html += '<strong>Traffic Analysis</strong><br/>';
            for(var period in traffic){
                html += '<b style="font-size: 12px">Period: </b>' + moment(period.split(' ')[0]).format('MM/DD/YYYY') + ' to ' + moment(period.split(' ')[1]).format('MM/DD/YYYY');
                html += '<table class="table" style="width: 100%;border: 0.5px solid black">\n' +
                    '                <thead>\n' +
                    '                <tr style="text-align: center">\n' +
                    '                    <th>Commercial ID</th>\n' +
                    '                    <th>Delivered Spots</th>\n' +
                    '                    <th>Ordered Pct %</th>\n' +
                    '                    <th>Delivered Pct %</th>\n' +
                    '                </tr>\n' +
                    '                </thead>\n' +
                    '                <tbody>';
                for(var code in traffic[period].codes){
                    html += '<tr style="text-align: center">';
                    html += '<td>'+ code +'</td>';
                    html += '<td>'+ traffic[period].codes[code] +'</td>';
                    html += '<td>'+ traffic[period].ordered[code] +'%</td>';
                    html += '<td>'+ ((traffic[period].codes[code] > 0) ? (traffic[period].codes[code]*100/traffic[period].total).toFixed(2) : 0) +'%</td>';
                    html += '</tr>';
                }
                html += '</tbody>\n' +
                    '            </table>';
            }
            html += '</div></div>';
        }
        $("#traffic_summary").html(html);

        var missed = (spots - spots_aprv < 0) ? 0 : spots - spots_aprv;
        tot_spots += match_result.no_match.length;
        var nordered = (ran > spots) ? (ran - spots) : 0;

        $("#spots-ordered").html(spots);
        $("#gross-ordered").html("$ " + parseFloat(cost).toFixed(2));
        // $("#net-ordered").html("$ " + (parseFloat(cost).toFixed(2) * (100 - parseFloat(match_result.advertiser.agency_commission))/100).toFixed(2));
        $("#net-ordered").html("$ " + parseFloat(net_cost).toFixed(2))
        $("#spots-ran").html(ran);
        $("#gross-ran").html("$ " + parseFloat(ran_cost).toFixed(2));
        // $("#net-ran").html("$ " + (parseFloat(ran_cost).toFixed(2) * (100 - parseFloat(match_result.advertiser.agency_commission))/100).toFixed(2));
        $("#net-ran").html("$ " + (parseFloat(net_ran_cost).toFixed(2)))
        if(spots_aprv_bookend === 0)
          $("#spots-approved").html(spots_aprv);
        else
           $("#spots-approved").html(spots_aprv + '<span style="color:#EB7148"> (' + parseInt(spots_aprv_bookend) + ' BK)</span>');
        $("#gross-approved").html("$ " + parseFloat(aprv_cost).toFixed(2));
        // $("#net-approved").html("$ " + (parseFloat(aprv_cost).toFixed(2) * (100 - parseFloat(match_result.advertiser.agency_commission))/100).toFixed(2));
        $("#net-approved").html("$ " + (parseFloat(net_aprv_cost).toFixed(2)))
        $("#spots-missed").html(missed);
        $("#spots-not-ordered").html(nordered);


        $("#matchSummary").modal("show");
    });

    $("#display-matches").on('click', function(){
        var snodes = gridOlinesOptions.api.getSelectedNodes();
        if(snodes.length === 0){
            swal({
                    title: "Oops!",
                    text: "Select the buy line first ...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }else{
            show_overlay_loader();
            var node = snodes[0];
            console.log('node_node_node ', node);
            var oline; var j = 0; var oindex;
            $.each(match_result.olines, function(index, value){
                if(parseInt(node.data.line_id)  === parseInt(index)){
                    console.log('node_node_node value', index, value);
                    oline = value; oindex = index; j = node.data.line_num;
                    return false;
                }
            });
            console.log('node_node_node oline', oline);
            if(typeof oline !== 'undefined'){
                console.log(oline);
                $("#orderlines").html("");
                $("#orderlines").hide();

                $("#sel-order-line").html("");
                $("#sel-order-line").show();
                if(typeof oline.m === "undefined")
                    oline = oline.lineable
                drawSingleBuyLines(oline, j, oindex);

                $("#sel-line-matches").html("");
                $("#sel-line-matches").show();

                if(typeof match_result.manual === "undefined")
                    drawMatchLines(oindex);
                else
                    drawManualMatchLines(oindex);

                $("#hide-matches").show();
                $("#display-matches").hide();
            }
            hide_overlay_loader();
        }
    });

    $("#hide-matches").on('click', function(index, value){

        var snodes = gridOSinglelinesOptions.api.getSelectedNodes();

        $("#sel-order-line").html("");
        $("#sel-order-line").hide();

        $("#sel-line-matches").html("");
        $("#sel-line-matches").hide();

        $("#orderlines").html("");
        $("#orderlines").show();

        drawBuyLines();

        $("#hide-matches").hide();
        $("#display-matches").show();
    });

    var modal_hided = false;
    var saved_data = false;

    $('#close_main_modal').on('click', function (e) {
        should_close(e);
        reset_filters_grid = true;
      //  stopSave();
    });
    $('#close_main_modal_top').on('click', function (e) {
        should_close(e);
        reset_filters_grid = true;
      //  stopSave();
    });
    var should_close = function(e){
        if(editing_row_imported_invo == true || saved_data_global == false) {
            swal({
                    title: "Warning!",
                    text: "Are you sure you want to exit?\nAll changes will be lost.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        modal_hided = true;
                        $('#saveMachtModal').modal('hide')
                        saved_data = false
                        modal_hided = false;
                        saved_data_global = true;
                        editing_row_imported_invo = false;
                    }
                });
        }
        else
            $('#saveMachtModal').modal('hide');
    };
    var save_automatic;

    function callSave() {
        if($("#saveMachtModal").css("display") !='none' && $("#saveMachtModal").css("visibility") != 'hidden'){
            if($('#save-revised-imported').css('display') != 'none') {
                console.log('imported display imported', $('#save-revised-imported').css('display'))
                call_save_imported(true);
            }
             if($('#save-revised').css('display') != 'none') {
                 console.log('imported display manual', $('#save-revised').css('display'))
                 call_save_manual(true);
             }
        }
    }
    // function stopSave() {
    //     clearInterval(save_automatic);
    // }
    function call_save_imported(automatic) {
        show_overlay_loader('#saveMachtModal .modal-content')
        automatic = false;
        console.log('I am saving automatic imported', automatic, '   ', save_automatic);
        var min_before_program = (typeof $('#min_max_range_form #min_before_program').val() !== 'undefined' && $('#min_max_range_form #min_before_program').val() >= 0 && $('#min_max_range_form #min_before_program').val() < 60) ? $('#min_max_range_form #min_before_program').val() : 0;
        var min_after_program = (typeof $('#min_max_range_form #min_after_program').val() !== 'undefined' && $('#min_max_range_form #min_after_program').val() >= 0 && $('#min_max_range_form #min_after_program').val() < 60) ? $('#min_max_range_form #min_after_program').val() : 0;
        var selected = [];
        var search_by_match = 0;
        if ($("#match-invoice-order-multiple").css('display') != 'none') {
            var multiple = 1;
            $('.invoices_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selected.push($(this).val());
            });
            if (selected.length === 0)
                search_by_match = $('#multiple_match_number_new').val();
        } else
            var multiple = 0;
        var test_hiatus = {};
        console.log('match_result', match_result);
        for (var o_line in  match_result['match']) {
            for (var wid in  match_result['match'][o_line]) {
                if (wid == -1) {
                    test_hiatus[o_line] = []
                    test_hiatus[o_line].push(match_result['match'][o_line][wid]);
                }
            }
        }
        var mm = {};
        for(var line_id in match_result['match']){
            mm[line_id] = {};
            for(var week_id in match_result['match'][line_id])
                mm[line_id][week_id] = match_result['match'][line_id][week_id];
        }

        var match = {
            match : JSON.stringify(mm),
            invoice : match_result.invoice,
            order_id : match_result.order_id,
            no_match : [],
            test_hiatus: JSON.stringify(test_hiatus),
        };
        // for(var ind in match_result.no_match){
        //     if(match_result.no_match[ind] !== null)
        //         match['no_match'].push(match_result.no_match[ind]);
        // }
        gridUnmatchOptions.api.forEachNode(function(node){
            match['no_match'].push(node.data);
        });
        match['no_match'] = JSON.stringify(match['no_match'])

        var params = {
            match: match,
            min_before_program: min_before_program,
            min_after_program: min_after_program,
            remark_no_match: array_invoice_no_match_id,
            multiple: multiple,
            invoices_selected: selected,
          //  test_hiatus: JSON.stringify(test_hiatus),
            bottom_line: $('#check_as_button_line').is(':checked'),
            search_by_match: search_by_match,
            rate_type : $("input:checkbox[name=use_ordered_net_rate]:checked").attr('value'),
        };
        var rate_type = parseInt($("input:checkbox[name=use_ordered_net_rate]:checked").attr('value')) === 1 ? 1 : 0;
        console.log('params_params_params params', params)
        // if(automatic === false) {
        //     show_overlay_loader($('#saveMachtModal .modal-content'));
        //     stopSave();
        // }
        //save change in no match lines
        if (editing_row_imported_invo == true) {
            saved_one_at_least = true;
            saved_data_global = true;
            var paramsX = {
                datas: array_inv_imported_edited,
                lines: [],
            };
            paramsX.lines = array_imp_all_cell_edited;
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(paramsX),
                url: '/invoices/save/imported_invoice/changes',
                dataType: "json",
                contentType: "application/json",
                success: function (dataX) {
                    editing_row_imported_invo = false;
                    array_inv_imported_edited = [];
                    array_imp_all_cell_edited = {};
                    saved_data = true
                    $("#editMatchRules").modal("hide");

                },
                error: function (xhr) {
                    debug(xhr.responseText);
                }
            });
        }

        $("#loading_match_2").css("display", "block");
        console.log('params_params_params', params);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: "/invoices/imported_match/save-items",
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
             //   console.log('data inside the match ', multiple ,data);
                $("#loading_match_2").css("display", "none");
                if (typeof data.status !== 'undefined' && multiple === 0) {
                    app_invoices_table.cell($('#row_id_to_change').val(), 11).data(data.status);
                    app_invoices_table.cell($('#row_id_to_change').val(), 17).data(data.rec);
                    app_invoices_table.cell($('#row_id_to_change').val(), 15).data(0);
                    app_invoices_table.cell($('#row_id_to_change').val(), 18).data(rate_type);
                    app_invoices_table.cell($('#row_id_to_change').val(), 5).data(data.full_market);

                    var row_st = app_invoices_table.row($('#row_id_to_change').val()).data().station_name;
                    if(parseInt(data.trade) === 1 && row_st.indexOf(' - Trade') === -1)
                        app_invoices_table.cell($('#row_id_to_change').val(), 7).data(row_st + ' - Trade');
                    if(parseInt(data.trade) === 0 && row_st.indexOf(' - Trade') !== -1) {
                        var new_st = row_st.split(' - Trade')[0];
                        app_invoices_table.cell($('#row_id_to_change').val(), 7).data(new_st);
                    }

                    if(typeof data.delete_multiple_match !== 'undefined' && data.delete_multiple_match.length > 0){
                        for(var i in data.delete_multiple_match){
                            $('#app-invoices-table tr').each(function () {
                               // console.log('$(this).attr(data-invoice-id)    TTTT ' + $(this).attr('data-invoice-id') + '    -------------   i' + i + '   ------status ' + data.delete_multiple_match[i].id+' --------- '+ parseInt($(this).attr('data-invoice-id')) === parseInt(data.delete_multiple_match[i].id));
                                if (parseInt($(this).attr('data-invoice-id')) === parseInt(data.delete_multiple_match[i].id)) {
                                    app_invoices_table.cell(this, 15).data(0);
                                    console.log('$(this).attr(data-invoice-id)   inside ' + data.delete_multiple_match[i].id);
                                }
                            });
                        }
                    }
                } else {
                    if (typeof data.status_multiple !== 'undefined') {
                        for (var i in data.status_multiple) {
                            $('#app-invoices-table tr').each(function () {
                               // console.log('$(this).attr(data-invoice-id)    ' + $(this).attr('data-invoice-id') + '    -------------   i' + i + '   ------status ' + data.status_multiple[i]);
                                if ($(this).attr('data-invoice-id') == i) {
                                    app_invoices_table.cell(this, 11).data(data.status);
                                    app_invoices_table.cell(this, 15).data(data.multiple_match_id);
                                    app_invoices_table.cell(this, 18).data(rate_type);
                                    app_invoices_table.cell(this, 5).data(data.full_market);
                                    var row_st = app_invoices_table.row(this).data().station_name;
                                    if(parseInt(data.trade) === 1 && row_st.indexOf(' - Trade') === -1)
                                        app_invoices_table.cell(this, 7).data(row_st + ' - Trade');
                                    if(parseInt(data.trade) === 0 && row_st.indexOf(' - Trade') !== -1) {
                                        var new_st = row_st.split(' - Trade')[0];
                                        app_invoices_table.cell(this, 7).data(new_st);
                                    }
                                    $('.app-invoices-table #' + i).click();
                                }
                            });
                        }
                        $('#inv_sche_match_multiple').val(data.multiple_match_id);
                        $('#weekly_breakout_multiple').val(data.multiple_match_id);
                        $('#rotation_analysis_multiple').val(data.multiple_match_id);
                        $('#spot_rotation_multiple').val(data.multiple_match_id);
                        $('#reports_temp_multiple').show();
                    }
                }
                saved_data_global = true;
                hide_overlay_loader($('#saveMachtModal .modal-content'));
                // $('#save-revised-imported').show();
                // if(automatic === false)
                //     save_automatic = setInterval(callSave, 30000);
            },
            error: function (xhr) {
                $("#loading_match_2").css("display", "none");
                hide_overlay_loader($('#saveMachtModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    function call_save_manual(automatic) {
        show_overlay_loader('#saveMachtModal .modal-content')
        automatic = false;
        console.log('I am saving automatic manual', automatic, '   ', save_automatic);
        var selected = [];
        if (invoice_manual_multiple_match === true) {
            var multiple = 1;
            $('.invoices_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selected.push($(this).val());
            });
            if (selected.length == 0)
                selected = manual_invoices_selected_global;
            else
                manual_invoices_selected_global = selected;
        } else
            var multiple = 0;

        var min_before_program = (typeof $('#min_max_range_form #min_before_program').val() !== 'undefined' && $('#min_max_range_form #min_before_program').val() >= 0 && $('#min_max_range_form #min_before_program').val() < 60) ? $('#min_max_range_form #min_before_program').val() : 0;

        var min_after_program = (typeof $('#min_max_range_form #min_after_program').val() !== 'undefined' && $('#min_max_range_form #min_after_program').val() >= 0 && $('#min_max_range_form #min_after_program').val() < 60) ? $('#min_max_range_form #min_after_program').val() : 0;
        console.log('match_result', match_result);
        var test_hiatus = {};
        for (var o_line in  match_result['match']) {
            for (var wid in  match_result['match'][o_line]) {
                if (wid == -1) {
                    test_hiatus[o_line] = []
                    test_hiatus[o_line].push(match_result['match'][o_line][wid]);
                }
            }
        }
        var mm = {};
        for(var line_id in match_result['match']){
            mm[line_id] = {};
            for(var week_id in match_result['match'][line_id])
                mm[line_id][week_id] = match_result['match'][line_id][week_id];
        }

        var match = {
            match : JSON.stringify(mm),
            invoice : match_result.invoice,
            order_id : match_result.order_id,
            no_match : [],
            test_hiatus: JSON.stringify(test_hiatus),
        };
        gridUnmatchOptions.api.forEachNode(function(node){
            match['no_match'].push(node.data);
        });
        match['no_match'] = JSON.stringify(match['no_match'])


        var params = {
            match: match,
            min_before_program: min_before_program,
            min_after_program: min_after_program,
            remark_no_match: array_manual_invoice_no_match_id,
          //  test_hiatus: JSON.stringify(),
            selected: selected,
            bottom_line: $('#check_as_button_line').is(':checked'),
        };

       /* if (automatic === false) {
            show_overlay_loader($('#saveMachtModal .modal-content'));
          //  stopSave();
        }/* else
            $('#save-revised').hide();*/

        if (editing_row_imported_invo == true) {
            saved_one_at_least = true;
            saved_data_global = true;
            var paramsX = {
                datas: array_inv_imported_edited,
                lines: [],
            };
            paramsX.lines = array_imp_all_cell_edited;
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(paramsX),
                url: '/invoices/save/manual_invoice/changes',
                dataType: "json",
                contentType: "application/json",
                success: function (dataX) {
                    editing_row_imported_invo = false;
                    array_inv_imported_edited = [];
                    array_imp_all_cell_edited = {};
                    saved_data = true;
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                    hide_overlay_loader($('#saveMachtModal .modal-content'));
                }
            });
        }

        $("#loading_match_2").css("display", "block");
        if (multiple == 1)
            var url = "/invoices/multiple/manual_match/save-items";
        else
            var url = "/invoices/manual_match/save-items";

        console.log('manual_match url', url)
        console.log('manual_match multiple', multiple)
        console.log('manual_match params', params)

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: url,
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('manual_match data', data)
                saved_data_global = true;
                $("#loading_match_2").css("display", "none");
                saved_data = true
                //$("#saveMachtModal").modal("hide");
                if (multiple == 1) {
                    $('#inv_sche_match_multiple').val(data.minv_multiple_match);
                    $('#weekly_breakout_multiple').val(data.minv_multiple_match);
                    $('#rotation_analysis_multiple').val(data.minv_multiple_match);
                    $('#spot_rotation_multiple').val(data.minv_multiple_match);
                    $('#reports_temp').hide();
                    $('#reports_temp_multiple').show();
                    app_invoices_table.draw();
                }
                else{
                    console.log('row_id_to_change row_id_to_change', $('#row_id_to_change').val());
                    console.log('row_id_to_change data', data);
                    app_invoices_table.cell($('#row_id_to_change').val(), 11).data(data.status);
                    app_invoices_table.cell($('#row_id_to_change').val(), 15).data(0);
                }

                hide_overlay_loader($('#saveMachtModal .modal-content'));
                // $('#save-revised').show();
                // if (automatic === false)
                //     save_automatic = setInterval(callSave, 30000);
            },
            error: function (xhr) {
                console.log('manual_match error', xhr)
                $("#loading_match_2").css("display", "none");
                ajax_error();
                debug(xhr.responseText);
                hide_overlay_loader($('#saveMachtModal .modal-content'));
            }
        });

    }

    $("#match-invoice-order").on("click", function(e){
        $('#check_as_button_line').prop('checked', false);
        if(reset_filters_grid === true) {
            filter__array_to_keep = {};
            filter__array_to_keep_no_match = {};
        }
        reset_filters_grid  = true;
        manual_grid_ready = false;
        array_invoice_no_match_id={};
        editing_row_imported_invo=false;
        array_imp_all_cell_edited=[];
        invoice_maul_select_all='imported';
        $('#reports_temp').show();
        $('#reports_temp_multiple').hide();

        $('#report_parents').attr('invoice-type', 1);
        $("#loading_match").show();
        var sel = $("input:radio[name=sel_order]:checked").attr('id');
        $('#order-details-verif').attr('data-order-id', sel);
        var rules=[];
        $('#rules_content input:checked').each(function() {
            rules.push($(this).val());
        });
        if(typeof sel !== 'undefined') {
            //show_overlay_loader('#searchOrdenToMach');
            init_progress_loader(2 , "This operation could take a few seconds. Please wait ...");
            $('#hide_columns a').each(function () {
                if($(this).hasClass('hidden-column'))
                    $(this).removeClass('hidden-column');
            });

            var sp= sel.split('_');
            var position= sp.length - 1;
            var inv_id= sp[position];
            $('#inv_sche_match').val(inv_id);
            $('#weekly_breakout').val(inv_id);
            $('#rotation_analysis').val(inv_id);
            $('#spot_rotation').val(inv_id);
            $('#invoice_status_tm').val(inv_id);
            $("#loading_match").show();
            var arr = {
                'sel': sel,
                'rules': rules,
                'rate_type' : $("input:checkbox[name=use_ordered_net_rate]:checked").attr('value'),
            };

            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: $(this).attr('data-contact-url'),
                data: JSON.stringify(arr),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    if(data.invoice.bottom_line == 1)
                        $('#check_as_button_line').prop('checked', true);

                    $('#unmatchedrows').html('');
                    initializegridUnmatchOptions(false);
                    match_result = data;
                    $("#order_id").val(data.order_id);
                    $("#invoice_id").val(data.invoice_id);

                    $("#min_max_range_form #min_before_program").val(data.min_before_program)
                    $("#min_max_range_form #min_after_program").val(data.min_after_program)
                    $("#match_fdates").html(moment(match_result.invoice.broadcast_month).format('MMM YYYY'));

                    data_zone_inv = typeof data.zone !== 'undefined' ? data.zone : false;
                    var st = parseInt(data.order.trade) === 1 ?  match_result.vendor.name + ' - Trade' : match_result.vendor.name;
                    if(typeof data.zone !== 'undefined' && data.zone !== false && match_result.invoice.invoice_number !== 'Multiple' && match_result.invoice.invoice_number !== 'multiple')
                        $("#match_station").html(st +' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Zone: '+ data.zone);
                    else
                        $("#match_station").html(st);

                    $("#match_inv_number_s").html(match_result.invoice.invoice_number);

                    $("#unmatchedrows").html("");
                    $("#orderlines").html("");

                    $("#saveMachtModal").modal('show');
                    $("#loading_match").hide();

                    drawNoMatchLines();
                    drawBuyLines();

                    $("#sel-order-line").hide();
                    $("#sel-line-matches").hide();
                    $("#orderlines").show();
                    $("#hide-matches").hide();
                    $("#display-matches").show();
                    $("#save-revised").hide();
                    $("#save-revised-imported").show();
                    //hide_overlay_loader('#searchOrdenToMach');
                    close_progress_loader();
                },
                error: function (xhr) {
                    $("#loading_match").hide();
                    //hide_overlay_loader('#searchOrdenToMach');
                    close_progress_loader();
                    console.log(xhr);
                    if (xhr.status === 422) {
                        global_notification('warning', xhr.responseJSON.message);
                    }
                    else if (xhr.status === 504) {
                        global_notification('warning', "Sorry our server is running a little slow at the moment.");
                    }
                    else {
                        ajax_error();
                        debug(xhr.responseText);
                    }
                }
            });
        }
        else {
            $('#generalWarningModalDiv').html('Should select a Order to match.');
            $('#generalWarningModal').modal('show');
        }

    });
    var list = $('#EditRules');

    function IntegerFormatRenderer() {
    }

    IntegerFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        $(this.eGui).css('text-align', 'center');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                val = Number(Math.round(params.value +'e0')+'e-0');
                if (isNaN(val)) {
                    this.eGui.innerHTML = '0';
                } else {
                    this.eGui.innerHTML = val;
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '0';
        }

        if(params.colDef.field === 'pct'){
            this.eGui.innerHTML += ' %';
        }
        if(params.colDef.field === 'difference_spots'){
            if(this.eGui.innerHTML > 0)
                this.eGui.innerHTML =  '+'+this.eGui.innerHTML;
        }
    };

    IntegerFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function IntegerCellEditor() {
    }

    IntegerCellEditor.prototype.init = function (params) {
        if (params.column.colDef.field.match(/week/)) {
            params.api.gridOptionsWrapper.gridOptions.enableSorting = false;
        } else {
            params.api.gridOptionsWrapper.gridOptions.enableSorting = true;
        }
        if ((params.value === '') || (typeof params.value === 'undefined')) {
            params.value = 0;
        }
        this.eInput = document.createElement('input');
        $(this.eInput).mask("0#");
        this.tabbed = false;

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            number = parseInt(params.charPress);
            // If a number, set that value.
            if (!isNaN(number)) {
                this.eInput.value = number;
                // Otherwise set the params value.
            } else {
                this.eInput.value = params.value;
            }
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress == 8) || (params.keyPress == 46)) {
                this.eInput.value = 0;
                // Otherwise set the params value.
            } else {
                this.eInput.value = params.value;
            }
        }
        if (params.charPress === null) {
            this.tabbed = true;
        }
    };

    IntegerCellEditor.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };

    IntegerCellEditor.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && (key > 36 ) && (key < 41)) {
                e.stopPropagation();
                return true;
            }
        });
        this.eInput.focus();
        if (this.tabbed) {
            this.eInput.select();
        }
    };

    IntegerCellEditor.prototype.getValue = function () {
        return this.eInput.value;
    };

    IntegerCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };

    IntegerCellEditor.prototype.isPopup = function () {
        return false;
    };

    function DateCellEditor() {
    }

    DateCellEditor.prototype.init = function (params) {
        this.eInput = document.createElement('input');
        if (typeof params.value == 'undefined') {
            params.value = '';
        }
        this.tabbed = false;

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            number = parseInt(params.charPress);
            // If a number, set that value.
            if (!isNaN(number)) {
                this.eInput.value = number;
                $(this.eInput).attr('data-completed', 'false');
                // Otherwise set the params value.
            } else {
                if (params.value !== '') {
                    $(this.eInput).attr('data-completed', 'true');
                } else {
                    $(this.eInput).attr('data-completed', 'false');
                }
                this.eInput.value = params.value;
            }
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress == 8) || (params.keyPress == 46)) {
                this.eInput.value = '';
                $(this.eInput).attr('data-completed', 'false');
                // Otherwise set the params value.
            } else {
                if (params.value !== '') {
                    $(this.eInput).attr('data-completed', 'true');
                } else {
                    $(this.eInput).attr('data-completed', 'false');
                }
                this.eInput.value = params.value;
                if (params.keyPress == null) {
                    this.tabbed = true;
                }
            }
        }

        $(this.eInput).inputmask('mm/dd/yyyy',
            {
                "oncomplete": function () {
                    $(this).attr('data-completed', 'true');
                },
                "onincomplete": function () {
                    $(this).attr('data-completed', 'false');
                },
                showMaskOnHover: false
            });
    };

    DateCellEditor.prototype.getGui = function () {
        if (this.tabbed == true) {
            $(this.eInput).addClass('ws-tabbed-input');
            $(this.eInput).setCursorPosition(0);
        }
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && (key > 36 ) && (key < 41)) {
                e.stopPropagation();
                return true;
            }
        });

        return this.eInput;

    };

    DateCellEditor.prototype.afterGuiAttached = function () {
        this.eInput.focus();
        $(this.eInput).select();
        if (this.tabbed == true) {
            $(this.eInput).setCursorPosition(0);
        }
    };

    DateCellEditor.prototype.getValue = function () {
        if ($(this.eInput).attr('data-completed') == 'true') {
            return moment(this.eInput.value, 'MM/DD/YYYY').format('MM/DD/YYYY');
        } else {
            return '';
        }

    };

    DateCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
        $(this.eInput).inputmask('remove');
    };

    DateCellEditor.prototype.isPopup = function () {
        return false;
    };

    function StringFormatRenderer() {
    }

    StringFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (typeof params.value !== 'undefined') {
            this.eGui.innerHTML = params.value;
        } else {
            this.eGui.innerHTML = '';
        }
    };

    StringFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function CurrencyCellEditor() {
    }

    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };
    CurrencyCellEditor.prototype.init = function (params) {
        // Auto calculate Net/Gross Rate based off of eachother.
        if (params.value === '') {
            params.value = 0;
        }
        this.eInput = document.createElement('input');
        var el = new AutoNumeric(this.eInput,
            {
                minimumValue: 0,
                selectOnFocus: false,
                caretPositionOnFocus: null,
                digitGroupSeparator: ',',
                digitalGroupSpacing: '3',
                decimalCharacter: '.',
                allowDecimalPadding: true,
                showOnlyNumbersOnFocus: true,
                showWarnings: false,
            });
        this.tabbed = false;
        if (params.charPress === null) {
            this.tabbed = true;
        }

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat(params.charPress);
            if(!isNaN(vv))
                el.set(params.charPress);
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(parseFloat(0));
                // Otherwise set the params value.
            } else {
                el.set(parseFloat(params.value).toFixed(2));
                if (params.charPress === null) {
                    this.tabbed = true;
                }
            }
        }
    };

    CurrencyCellEditor.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };

    CurrencyCellEditor.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && (key > 37 ) && (key < 39)) {
                e.stopPropagation();
                return true;
            }
            // Ignore commas.
            if(key === 188){
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        this.eInput.focus();
        if (this.tabbed) {
            $(this.eInput).select();
        }else{
            $(this.eInput).setCursorPosition(1);
        }
    };

    CurrencyCellEditor.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };

    CurrencyCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };

    CurrencyCellEditor.prototype.isPopup = function () {
        return false;
    };

    function CurrencyFormatRenderer() {
    }

    CurrencyFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');

        //if (params.node.rowPinned !== 'top') {
        //    $(this.eGui).css('text-align', 'right');
        //}

        $(this.eGui).css('text-align', 'right');

        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                if(parseFloat(params.value) == parseFloat('6176.474999999999'))
                    params.value = 6176.48;
                params.value = params.value.toString().indexOf('e') !== -1  ? parseFloat(params.value.toString().split('e')[0]) : parseFloat(params.value);
                var v = Number(Math.round((parseFloat(params.value))+'e2')+'e-2')
                param_val = parseFloat(v).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    //minimumFractionDigits: 2
                });
                if (isNaN(parseFloat(params.value))) {
                    console.log("NAN: " + parseFloat(params.value));
                    this.eGui.innerHTML = '$0.00';
                } else {
                    this.eGui.innerHTML = param_val;
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '$0.00';
        }
        if(params.colDef.field === 'difference_gross' || params.colDef.field ==='difference_net'){
            if(this.eGui.innerHTML !== '$0.00'){
                var amount = this.eGui.innerHTML;
                amount = amount.replace('$', '');
                amount = amount.replace(/,/g, '');
                this.eGui.innerHTML = parseFloat(amount) > 0 ? '+'+this.eGui.innerHTML : this.eGui.innerHTML;
            }
        }
    };

    CurrencyFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };


    function StringCellEditor() { }
    StringCellEditor.prototype.init = function (params) {
        this.eInput = document.createElement('input');
        this.params = params;
        if (typeof params.value !== 'undefined') {
            this.eInput.value = params.value;
        }
    };
    var create_new_row_from_tab = false;
    StringCellEditor.prototype.getGui = function () {
        create_new_row_from_tab = false;
        /*if(this.params.node.lastChild) {
            $(this.eInput).bind('keydown', function (e) {
                var key = e.which || e.keyCode;
                if (key === 9) {
                    e.stopPropagation();
                    create_new_row_from_tab = true;
                    return true;
                }
            });
        }*/
        return this.eInput;
    };
    StringCellEditor.prototype.afterGuiAttached = function () {
        this.eInput.focus();
    };
    StringCellEditor.prototype.getValue = function () {
        return this.eInput.value;
    };
    StringCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };

    var input = $("#inv_month");

    if (input.data('datepicker')) {
        input.datepicker('remove');
    }

    input.datepicker({
        format: "mm/yyyy",
        startView: "months",
        minViewMode: "months",
        autoclose: true,
        clearBtn: true,
        orientation: "bottom"
    });

    var columnInvOrdDefs = [
        {
            headerName: "bottom_line",
            field: 'bottom_line',
            width: 150,
            hide: true,
        },
        {
            headerName: "camp Id",
            field: 'camp_id',
            width: 150,
            hide: true,
        },
        {
            headerName: "camp name",
            field: 'camp_name',
            width: 150,
            hide: true,
        },
        {
            headerName: "Station",
            field: 'station',
            width: 150,
            cellRenderer: function(params) {
                var html = '';
                if (params.value.indexOf(' - Trade') !== -1) {
                    var text = params.value.split(' - Trade')[0] ;
                    html = "<div>  <span>" + text + "</span><span style='color: black; text-align: left'><b> - Trade</b></span></div>";
                }else
                    html = "  <span style='text-align: left'>" + params.value + "</span> ";
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
        {
            headerName: "Current Ref. #",
            field: 'reference_number',
            width: 200,
            cellRenderer: function(params) {
                var html = '';
                if (typeof params.data !== 'undefined' && params.data["multi_market"] === 1)
                    html = "  <span style='color: #B7432C; text-align: left'><b>" + params.value + "</b></span> ";
                else
                    html = "  <span style='text-align: left'>" + params.value + "</span> ";
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
        {
            headerName: "Month",
            field: 'revision_month',
            width: 150,
            cellStyle: {'font-weight': "bold"},
        },
        {
            headerName: "Month Year",
            field: 'month_year',
            width: 150,
            hide: true,
        },
       {
            headerName: "Flight Dates",
            field: 'revision_fd',
            width: 140,
        }, {
            headerName: "Market",
            field: 'revision_market',
            width: 140,
        },
        {
            headerName: "Created",
            field: 'created',
            width: 120,
        }, {
            headerName: " Ord. ADS",
            field: 'spots',
            width: 80,
            cellStyle: {'text-align': "center"},
            // cellClassRules :  {
            //     'ag-cell-spot-static': function(params) {
            //         if(typeof params.node.data.spot_static !== 'undefined' && (params.node.data.spot_static === true || params.node.data.spot_static === 1))
            //             return true;
            //         else
            //             return false;
            //     }
            // },
        }, {
            headerName: "Ord. Gross",
            field: 'gross_cpa',
            width: 100,
        }, {
            headerName: "Ord. Net",
            field: 'net_cpa',
            width: 100,
        }, {
            headerName: "Invoice#",
            field: 'inv_num',
            width: 150,
        },
        {
            headerName: "Inv. Status",
            field: 'inv_status',
            width: 100,
        },
        {
            headerName: "Inv. ID",
            field: 'inv_id',
            width: 100,
            hide: true,
        }, {
            headerName: "Date",
            field: 'inv_date',
            width: 100,
        },
        {
            headerName: "Due Date",
            field: 'inv_due_date',
            width: 100,
            hide: true,
        },
        {
            headerName: "Cam start",
            field: 'inv_due_date',
            width: 100,
            hide: true,
        },
        {
            headerName: "Month",
            field: 'inv_month',
            width: 100,
            hide: true,
        }, {
            headerName: "Inv. Spots",
            field: 'spots_inv',
            width: 80,
        }, {
            headerName: "Inv. Gross",
            field: 'schedule',
            width: 100,
        },
        {
            headerName: "Matched saved",
            field: 'matched_saved',
            width: 50,
            hide: true,
        },
        {
            headerName: "Totals Only",
            field: 'totals_only',
            width: 50,
            hide: true,
        },
        {
            headerName: "Type",
            field: 'type',
            width: 50,
            hide: true,
        },
        {
            headerName: "Media Type",
            field: 'media_type',
            width: 50,
            hide: true,
        },
        {
            headerName: "Imp Ord",
            field: 'impressions_ordered',
            width: 200,
             hide: true,
        },
        {
            headerName: "Imp Inv",
            field: 'impressions_invoiced',
            width: 200,
            hide: true,
        },
        {
            headerName: "Commission",
            field: 'commission',
            width: 200,
            hide: true,
        },
        {
            headerName: "spot_static",
            field: 'spot_static',
            width: 150,
            hide: true,
        },
        {
            headerName: "Attachments",
            field: 'attachments',
            width: 100,
            hide: false,
        },
        {
            headerName: "Order#",
            field: 'order_num',
            width: 80,
        },
        {
            headerName: "Original Ref. #",
            field: 'old_reference_number',
            width: 200,
            cellRenderer: function(params) {
                var html = '';
                if (typeof params.data !== 'undefined' && params.data["line_through"] === 1 && params.data["multi_market"] === 1)
                    html = "  <span style='text-decoration: line-through; text-align: left; color: #B7432C'><b>" + params.value + "</b></span> ";
                else if (typeof params.data !== 'undefined' && params.data["line_through"] === 1)
                    html = "  <span style='text-decoration: line-through; text-align: left'>" + params.value + "</span> ";
                else if (typeof params.data !== 'undefined' && params.data["multi_market"] === 1)
                    html = "  <span style='color: #B7432C; text-align: left'><b>" + params.value + "</b></span> ";
                else
                    html = "  <span style='text-align: left'>" + params.value + "</span> ";
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                this.eGui = tempDiv.firstElementChild;
                return this.eGui;
            },
        },
        {
            headerName: "Revision#",
            field: 'revision_num',
            width: 100,
        },
        {
            headerName: "Zone",
            field: 'inv_zone',
            width: 100,
            hide: true,
        },
    ];
    var columnOrderDetailsVeri = [
        {
            headerName: "Line #",
            field: 'line_number',
            width: 60,
        },
        {
            headerName: "Media",
            field: 'media',
            width: 100,
        },
        {
            headerName: "Time Period",
            field: 'time_period',
            width: 150,
        },  {
            headerName: "Days",
            field: 'days',
            width: 80,
        }, {
            headerName: "Daypart",
            field: 'daypart',
            width: 80,
        },
        {
            headerName: "Length",
            field: 'length',
            width: 80,
        },
        {
            headerName: "Program",
            field: 'program',
            width: 150,
        },
        {
            headerName: "Gross Rate",
            field: 'gross_cpa',
            width: 100,
            cellRenderer: function (params) {
                if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                    return 'TR';
                else
                    return params.data.gross_cpa;
            },
            cellClassRules : {
                'ag-cell-color-background': function (params) {
                    if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                        return true;
                    return false;
                }
            },
        },
        {
            headerName: "Net Rate",
            field: 'net_cpa',
            width: 100,
            cellRenderer: function (params) {
                if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                    return 'TR';
                else
                    return params.data.net_cpa;
            },
            cellClassRules : {
                'ag-cell-color-background': function (params) {
                    if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                        return true;
                    return false;
                }
            },
        },
        {
            headerName: "tiered",
            field: 'tiered',
            width: 80,
            hide: true,
        },
    ];

    var columnsNewItemDef = [
        //{
            // headerName: "Adding    Invoice    Items",
            // children: [
                {
                    headerName: "Date",
                    field: 'date',
                    width: 120,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: DateCellEditor,
                },{
                    headerName: "Day",
                    field: 'dow',
                    width: 80,
                }, {
                    headerName: "Time",
                    field: 'time',
                    width: 120,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: TimeCellEditor,
                    comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                        if (valueA.includes('PM') && valueB.includes('AM')) {
                            return 1;
                        } else if (valueA.includes('AM') && valueB.includes('PM')) {
                            return -1;
                        } else {
                            var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                            var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                            var arr1 = timeA.split(':');
                            var arr2 = timeB.split(':');

                            if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                                return 0;
                            else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                                return 1;
                            else
                                return -1;
                        }
                    }
                }, {
                    headerName: "Type",
                    field: 'type',
                    width: 120,
                    editable: true,
                    hide: true,
                }, {
                    headerName: "Length",
                    field: 'length',
                    width: 120,
                    editable: true,
                    cellRenderer: IntegerFormatRenderer,
                    cellEditor: IntegerCellEditor,
                }, {
                    headerName: "Rate",
                    field: 'rate',
                    width: 120,
                    editable: true,
                    cellRenderer: CurrencyFormatRenderer,
                    cellEditor: CurrencyCellEditor,
                }, {
                    headerName: "Commercial ID",
                    field: 'commercial_id',
                    width: 120,
                    editable: true,
                    cellEditor: StringCellEditor,
                }, {
                    headerName: "Network",
                    field: 'network',
                    width: 120,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: StringCellEditor,

                }, {
                    headerName: "Remarks",
                    field: 'remarks',
                    width: 300,
                    editable: true,
                    cellEditor: StringCellEditor
                }
        //     ]
        // }
    ];

    var gridNewItemOptions = {
        columnDefs: columnsNewItemDef,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        stopEditingWhenGridLosesFocus: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuItemsInvoice,

        onCellValueChanged: function (e) {
            changes_in_grid_global = true;
            if(e.colDef.field === 'rate'){
                updateTotals(e);
            }

            if(e.colDef.field === 'date'){
                var weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
                var a = new Date(e.node.data.date);
                e.node.data.dow = weekday[a.getDay()];
                e.api.refreshCells([e.node], ['dow']);
            }
        },
        onCellEditingStopped: function (e) {
            editing_row = false;
            if(e.colDef.field === 'date') {
                if (e.node.data.date != 'Invalid date' && e.node.data.date != '') {
                    var start = moment($("#campaign_flight_date_start").val()).format('MM/DD/YYYY');
                    var end = moment($("#campaign_flight_date_end").val()).format('MM/DD/YYYY');
                    var date = moment(e.node.data.date).format('MM/DD/YYYY');
                    if ((moment(start).isBefore(date) && moment(date).isBefore(end)) || (moment(date).isSame(start) || moment(date).isSame(end))) {
                    }
                    else {
                        swal({
                                title: "Warning!",
                                text: 'Spot ran outside of campaign flight dates!',
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "OK",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {

                            });
                    }
                }
                else {
                    e.node.data.date= '00/00/0000';
                    e.api.refreshCells([e.node], ['date']);
                }
            }
            if(e.colDef.field === 'remarks') {
            }
        },
        onCellClicked: function (e) {
        },
        onCellEditingStarted: function (e) {
            editing_row=true;
        },
    };

    ///Copied full TimeCellEditor
    function TimeCellEditor() {
    }

    TimeCellEditor.prototype.init = function (params) {
        console.log('get in Time CellEditor');
        console.log(params);
        this.eInput = document.createElement('input');
        if (typeof params.value == 'undefined') {
            params.value = '';
        }
        this.tabbed = false;
        $(this.eInput).mask('ABBBC', {
            'translation': {
                A: {pattern: /\d/},
                B: {pattern: /\d/, optional: true},
                C: {pattern: /a|A|p|P/}
            },
            "oncomplete": function () {
                $(this).attr('data-completed', 'true');
            },
            "onincomplete": function () {
                $(this).attr('data-completed', 'false');
            },
            showMaskOnHover: false
        });

        loop_start = moment().hour(0).minute(0).second(0);
        var current_value= params.value;

        /// If a "printable key" is pressed.
        if (params.charPress !== null) {
            number = parseInt(params.charPress);
            // If a number, set that value.
            if (!isNaN(number)) {
                this.eInput.value = number;
                $(this.eInput).attr('data-completed', 'true');
            } else {
                if (params.value !== '') {
                    $(this.eInput).attr('data-completed', 'true');
                } else {
                    $(this.eInput).attr('data-completed', 'false');
                }
                if(params.charPress === "+" && params.value.indexOf("A")){
                    this.eInput.value = params.value.replace('A','P');
                }else if(params.charPress === "-" && params.value.indexOf("P")){
                    this.eInput.value = params.value.replace('P','A');
                }else
                    this.eInput.value = params.value;
            }
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress == 8) || (params.keyPress == 46)) {
                this.eInput.value = '';
                $(this.eInput).attr('data-completed', 'false');
                // Otherwise set the params value.
            } else {
                if (params.value !== '') {
                    current_value=  moment(current_value, 'h:mmA');

                    //  input.val(current_value.format('hmmA').substring(0, current_value.format('hmmA').length - 1));
                    this.eInput.value= current_value.format('hmmA').substring(0, current_value.format('hmmA').length - 1);

                    $(this.eInput).attr('data-completed', 'true');
                }
                this.eInput.value = params.value;
                if (params.keyPress == null) {
                    this.tabbed = true;
                }
            }
        }
        $(this.eInput).bind('keyup', function (e) {
            var key = e.which || e.keyCode;
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                return true;
            }

            if (key == 8) {
                return true;
            }


        });
        $(this.eInput).bind('change', function (e) {
            result = grid_time_period_range_change(this);

            if (result !== false) {
                grid_time_period_range_set(this, result);
            } else {
                $(this.eInput).val('');
            }

            e.preventDefault();
        });

    };
    function grid_time_period_range_change(select) {
        container = $(select);
        var start =  $(select).val();

        if (start !== '')  {
            start = moment(start, 'h:mm A');

            return [start];
        }

        return false;
    }
    function grid_time_period_range_set(select, result) {
        container = $(select).closest('.grid-popup-container');
        str_start = result[0].format('h:mmA').substring(0, result[0].format('h:mmA').length - 1);

        $(select).val(str_start);

    }
    function grid_time_period_parse(part) {
        var currentCell = grid_in_procces.api.getFocusedCell();
        console.log('focus cellll');
        console.log(currentCell);
        console.log('part ...... ', part);
        var p, time, time_int;
        var moment_obj = moment().hour(0).minute(0).second(0);

        if ((part.indexOf('a') >= 0) || (part.indexOf('A') >= 0)) {
            p = 'a';
        }

        if ((part.indexOf('p') >= 0) || (part.indexOf('P') >= 0)) {
            p = 'p';
        }
        if(p !='p' && p != 'a'){
            var currentCell = grid_in_procces.api.getFocusedCell();
            if(currentCell.rowIndex > 0){
                var index= currentCell.rowIndex - 1;
                var previewsCell ='';
                grid_in_procces.api.forEachNode(function (node) {
                    if(node.rowIndex== index){
                        previewsCell= node;
                        var previws= node.data.time;
                        if(previws.indexOf('P') >= 0)
                            p='p';
                        if(previws.indexOf('A') >= 0)
                            p='a';
                        console.log('previws ......', previws);
                        console.log('previws p ......', p);
                    }
                });

            }
        }


        time = part.toLowerCase().replace(p, '').replace(':','');
        time_int = parseInt(time);
        console.log('time ......', time);

        // First check the length of the string, then parse if given proper values.
        if (time.length == 1) {
            if (p == 'p') {
                moment_obj.hour(time_int + 12);
            } else {
                moment_obj.hour(time_int);
            }
        } else if (time.length == 2) {
            if ((time_int > 9) && (time_int < 13)) {
                if (p == 'p') {
                    if (time_int !== 12) {
                        moment_obj.hour(time_int + 12);
                    } else {
                        moment_obj.hour(12);
                    }
                } else {
                    if (time_int !== 12) {
                        moment_obj.hour(time_int);
                    } else {
                        moment_obj.hour(0);
                    }
                }
            } else {
                if (p == 'p') {
                    moment_obj.hour(parseInt(time[0]) + 12).minute(parseInt(time[1] + '0'));
                } else {
                    moment_obj.hour(parseInt(time[0])).minute(parseInt(time[1] + '0'));
                }
            }
        } else if (time.length == 3) {
            if (p == 'p') {
                moment_obj.hour(parseInt(time[0]) + 12).minute(parseInt(time[1] + time[2]));
            } else {
                moment_obj.hour(parseInt(time[0])).minute(parseInt(time[1] + time[2]));
            }
        } else if (time.length == 4) {
            temp = parseInt(time[0]);

            if (temp > 2) {
                return false;
            }

            if (p == 'p') {
                console.log('get in to p = p', p);
                if (parseInt(time[0] + time[1]) !== 12) {
                    console.log('get in to p = p', time);
                    console.log('get in to p = p time', parseInt(time[0] + time[1]));
                    if(parseInt(time[0] + time[1]) < 12)
                        moment_obj.hour(parseInt(time[0] + time[1]) + 12).minute(parseInt(time[2] + time[3]));
                    else
                         moment_obj.hour(parseInt(time[0] + time[1])).minute(parseInt(time[2] + time[3]));
                } else {
                    moment_obj.hour(12).minute(parseInt(time[2] + time[3]));
                }
            } else {
                if (parseInt(time[0] + time[1]) !== 12) {
                    moment_obj.hour(parseInt(time[0] + time[1])).minute(parseInt(time[2] + time[3]));
                } else {
                    moment_obj.hour(0).minute(parseInt(time[2] + time[3]));
                }

            }
        }

        return moment_obj;
    }

    TimeCellEditor.prototype.getGui = function () {
        if (this.tabbed == true) {
            console.log('getGui');
            $(this.eInput).addClass('ws-tabbed-input');
            $(this.eInput).setCursorPosition(0);
        }
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && (key > 36 ) && (key < 41)) {
                e.stopPropagation();
                return true;
            }else if(key === 107){
                $(this).val($(this).val().replace('P','').replace('A',''))
                $(this).val($(this).val() + 'P')
            }else if(key === 109){
                $(this).val($(this).val().replace('P','').replace('A',''))
                $(this).val($(this).val() + 'A')
            }
        });

        return this.eInput;

    };

    TimeCellEditor.prototype.afterGuiAttached = function () {
        this.eInput.focus();
        if (this.tabbed) {
            console.log('afterGuiAttached');
            $(this.eInput).setCursorPosition(0);
            $(this.eInput).select();
        }
    };

    TimeCellEditor.prototype.getValue = function () {
        if ($(this.eInput).attr('data-completed') == 'true') {
            var moment_start = grid_time_period_parse($(this.eInput).val());
            if ((moment_start == false)) {
                return '00:00';
            }
            var str_start = moment_start.format('h:mmA').substring(0, moment_start.format('h:mmA').length - 1);
            $(this.eInput).val(str_start) ;
            return this.eInput.value;

        } else {
            return '00:00';
        }

    };

    TimeCellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
        $(this.eInput).inputmask('remove');
    };

    TimeCellEditor.prototype.isPopup = function () {
        return false;
    };

    $('#newItemsGrid').on('keydown', function(evt) {
        var focus = gridNewItemOptions.api.getFocusedCell();
        if(((editing_row || focus.column.colId=='dow') && evt.key === 'Enter') || (evt.keyCode === 9 && create_new_row_from_tab) ) {
            var currentCell = gridNewItemOptions.api.getFocusedCell();
            var finalRowIndex= gridNewItemOptions.api.getModel().rowsToDisplay.length -1;
            if (currentCell.rowIndex === finalRowIndex && currentCell.column.colId == 'remarks') {
                create_new_row_from_tab = false;
                var node;
                gridNewItemOptions.api.forEachNode(function (nodex) {
                    if(nodex.rowIndex==finalRowIndex) {
                        console.log('get int ' + finalRowIndex);
                        node = nodex;
                    }
                });
                var new_line = $.extend({}, node['data']);
                new_line.int_id = '-';
                var new_index = finalRowIndex + 1;
                //gridNewItemOptions.api.updateRowData({add: [new_line], addIndex: new_index});
                gridNewItemOptions.api.updateRowData({add: [new_line], addIndex: new_index});
                gridNewItemOptions.api.ensureColumnVisible('date')
                gridNewItemOptions.api.ensureIndexVisible( new_index);
                gridNewItemOptions.api.setFocusedCell( new_index, 'date', null);
                gridNewItemOptions.api.startEditingCell({
                    rowIndex:  new_index,
                    colKey: 'date'
                });
                updateTotals(gridNewItemOptions);
            }
            else {
                gridNewItemOptions.api.stopEditing();
                gridNewItemOptions.api.clearFocusedCell();
                if (currentCell.column.colId == 'date')
                    var next = 'time';
                if (currentCell.column.colId == 'dow')
                    var next = 'time';
                if (currentCell.column.colId == 'time')
                    var next = 'length';
                if (currentCell.column.colId == 'length')
                    var next = 'rate';
                if (currentCell.column.colId == 'rate')
                    var next = 'commercial_id';
                if (currentCell.column.colId == 'commercial_id')
                    var next = 'network';
                if (currentCell.column.colId == 'network')
                    var next = 'remarks';
                if (currentCell.column.colId == 'remarks')
                    var next = 'date';

                gridNewItemOptions.api.ensureColumnVisible(next)

                if (currentCell.column.colId != 'remarks') {
                    gridNewItemOptions.api.setFocusedCell(currentCell.rowIndex, next, null);
                    gridNewItemOptions.api.startEditingCell({
                        rowIndex: currentCell.rowIndex,
                        colKey: next
                    });
                }
                else {
                    gridNewItemOptions.api.setFocusedCell(currentCell.rowIndex + 1, next, null);
                    gridNewItemOptions.api.startEditingCell({
                        rowIndex: currentCell.rowIndex + 1,
                        colKey: next
                    });
                }
            }
            create_new_row_from_tab = false;
            return false;
        }else if(focus.column.colId=='remarks' && focus.rowIndex == (gridNewItemOptions.api.getModel().rowsToDisplay.length -1)){
            create_new_row_from_tab = true;
        }
    });

    function getContextMenuItemsInvoice(params) {
        var result = [
            {
                name: 'New Line',
                icon: '<i class="fa fa-plus fa-fw"></i>',
                action: function() {
                    var index= gridNewItemOptions.api.getModel().rowsToDisplay.length;
                    /*gridNewItemOptions.api.insertItemsAtIndex(index, [{
                        int_id: "-",
                        date: "00/00/0000",
                        dow: "",
                        time: "00:00",
                        type: "",
                        length: 0,
                        rate: '$0.00',
                        remarks: ""
                    }]);*/
                    gridNewItemOptions.api.updateRowData({add: [{
                            int_id: "-",
                            date: "00/00/0000",
                            dow: "",
                            time: "00:00",
                            type: "",
                            length: 0,
                            rate: '$0.00',
                            remarks: "",
                            commercial_id: "",
                            network: '',
                            remarks: ""

                        }], addIndex: index});
                    //gridNewItemOptions.api.ensureIndexVisible(0);
                    gridNewItemOptions.api.ensureIndexVisible(index);
                    gridNewItemOptions.api.clearFocusedCell();
                    gridNewItemOptions.api.setFocusedCell(index, 'date', null);

                    global_notification('info', 'Inserted 1 row.');
                },
                cssClasses: ['redFont', 'bold']
            },
            {
                name: 'Duplicate Line',
                icon: '<i class="fa fa-clone fa-fw"></i>',
                action: function() {
                    console.log(params);
                    var node = params.node;
                    var grid = $(params.api.gridCore.eGridDiv).closest('#newItemsGrid');
                    var gridOptions = $(grid).data('gridOptions');
                    var new_line = $.extend({}, node['data']);
                    new_line.int_id = '-';
                    var new_index = node.rowIndex + 1;
                    gridNewItemOptions.api.updateRowData({add: [new_line], addIndex: new_index});
                    gridNewItemOptions.api.ensureIndexVisible(node.rowIndex);
                    gridNewItemOptions.api.clearFocusedCell();
                    updateTotals(gridNewItemOptions);
                    global_notification('info', 'Duplicated 1 row.');

                },
                cssClasses: ['redFont', 'bold']
            },
            //  'copy',
            // 'paste',
            'separator',
        ];

        return result;
    }

    var gridInvOrdOptions = {
        columnDefs: columnInvOrdDefs,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuInvoiceOrder,

        onSelectionChanged: function (e) {
            var sel = gridInvOrdOptions.api.getSelectedNodes();
            if(sel.length > 0){
                if(sel[0].data.totals_only==1) {
                    $('#invoice-verif').css('display', 'none');
                    $('#invoice-report-arvhived').css('display', 'none');
                    // $('#invoice-export-arvhived').css('display', 'none');
                    $('#invoice-total-report').css('display', 'inline');
                    if(show_archived == false)
                        $('#invoice-total-archive').css('display', 'inline');
                    if(show_archived == true) {
                        $('#invoice-export-arvhived').css('display', 'inline');
                        $('#invoice-activate').css('display', 'inline');
                    }
                }
                if(sel[0].data.totals_only==0) {
                    if(show_archived == false) {
                        $('#invoice-verif').css('display', 'inline');
                        $('#invoice-report-arvhived').css('display', 'none');
                        $('#invoice-export-arvhived').css('display', 'none');
                        $('#invoice-activate').css('display', 'none');
                        if(sel[0].data.matched_saved == 1)
                            $('#invoice-total-archive').css('display', 'inline');
                        else
                            $('#invoice-total-archive').css('display', 'none');
                    }
                    else {
                        $('#invoice-report-arvhived').css('display', 'inline');
                        $('#invoice-export-arvhived').css('display', 'inline');
                        $('#invoice-activate').css('display', 'inline');
                        $('#invoice-total-archive').css('display', 'none');
                    }
                    $('#invoice-total-report').css('display', 'none');
                }
            }
        },
        onCellContextMenu: function (e) {
            //right click event
        },
    };

    function getContextMenuInvoiceOrder(params) {
        if(show_archived == false) {
            var result = [
                {
                    name: 'Copy Invoice',
                    icon: '<i class="fa fa-clone fa-fw"></i>',
                    disabled: params.node['data']['inv_num'] !== "" ? false : true,
                    action: function () {
                        var node = params.node;
                        invoice_to_copy = $.extend({}, node['data']);
                    },
                    cssClasses: ['redFont', 'bold']
                },

                {
                    name: 'Paste Invoice',
                    icon: '<i class="ti-clipboard"></i>',
                    disabled: invoice_to_copy !== '' ? false : true,
                    action: function () {
                        $('#loading_saving').css("display", "block");
                        var node = params.node;
                        var line = $.extend({}, node['data']);
                        line['attachments'] = 'No';

                        $.ajax({
                            type: 'GET',
                            url: '/invoices/copy_invoice/to_order/' + line.order_num + '/' + line.revision_num + '/' + invoice_to_copy.inv_id + '/' + line.month_year,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#loading_saving').css("display", "none");
                                global_notification('success', 'Invoice copied...');
                                var camp = $("#campaign_searchm option:selected").val();
                                var ven = $("#order_search_selectm option:selected").val();
                                displayOrdersInvoices(global_way_to_search_manual_invoices);
                                app_invoices_table.draw();
                            },
                            error: function (xhr) {
                                hide_loader();
                                debug(xhr.responseText);
                                $('#loading_saving').css("display", "none");
                            }
                        });

                    },
                    cssClasses: ['redFont', 'bold']
                },
                {
                    name: 'Delete Invoice',
                    disabled: params.node['data']['inv_num'] === "" || params.node['data']['inv_status'] === 'Archived' || params.node['data']['inv_status'] === 'Completed' ? true : false,
                    icon: '<i class="fa fa-trash-o"></i>',
                    action: function () {
                        swal({
                                title: "Warning!",
                                text: 'Are you sure to delete?',
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "OK",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                $('#loading_saving').css("display", "block");
                                var node = params.node;
                                var line = $.extend({}, node['data']);

                                $.ajax({
                                    type: 'GET',
                                    url: '/invoices/delete_manual_invoice/from_order/' + line.inv_id,
                                    dataType: 'json',
                                    encode: true,
                                    success: function (data) {
                                        $('#loading_saving').css("display", "none");
                                        global_notification('success', 'Invoice deleted...');
                                        var camp = $("#campaign_searchm option:selected").val();
                                        var ven = $("#order_search_selectm option:selected").val();
                                        displayOrdersInvoices(global_way_to_search_manual_invoices);
                                    },
                                    error: function (xhr) {
                                        hide_loader();
                                        debug(xhr.responseText);
                                        $('#loading_saving').css("display", "none");
                                    }
                                });
                            });

                    },
                    cssClasses: ['redFont', 'bold']
                },
                // {
                //     name: 'Invoice Header',
                //     disabled: false,
                //     icon: '<i class="ti-credit-card"></i>',
                //     action: function () {
                //         $('#invoice-header').click();
                //     },
                //     cssClasses: ['redFont', 'bold']
                // },
                {
                    name: 'Invoice Entry',
                    disabled: false,
                    icon: '<i class="fa fa-money fa-fw"></i>',
                    action: function () {
                        $('#invoice-entry').click();
                    },
                    cssClasses: ['redFont', 'bold']
                },
                /*{
                    name: 'Item Verification',
                    disabled: false,
                    icon: '<i class="ti-check"></i>',
                    action: function () {
                        $('#invoice-verif').click();
                    },
                    cssClasses: ['redFont', 'bold']
                },*/
                {
                    name: 'Order Details',
                    disabled: false,
                    icon: '<i class="fa fa-shopping-cart"></i>',
                    action: function () {
                        $('#order-details').click();
                    },
                    cssClasses: ['redFont', 'bold']
                },
                {
                    name: 'Invoice Attachments',
                    disabled: params.node['data']['inv_num'] !== "" ? false : true,
                    icon: '<i class="fa fa-paperclip"></i>',
                    action: function () {
                        $('#update_attachments_invoice_status').attr('data-invoice-id', params.node.data['inv_id']);
                        $('#update_attachments_invoice_status').attr('data-invoice-update', true);
                        get_manual_invoice_attachments(params.node.data);
                    },
                    cssClasses: ['redFont', 'bold']
                },
                /*{
                    name: 'Schedule Match',
                    disabled: (params.node['data']['inv_num'] !== "" && params.node['data']['type']=='no_broadcast') ? false : true,
                    icon: '<i class="ti-download"></i>',
                    action: function () {
                        $('#invoice-total-report').click();
                    },
                    cssClasses: ['redFont', 'bold']
                },
                {
                    name: 'Archive',
                    disabled: ((params.node['data']['inv_num'] !== "" && params.node['data']['type']=='no_broadcast') || (params.node['data']['matched_saved'] !== "" && params.node['data']['type']=='broadcast'))? false : true,
                    icon: '<i class="ti-archive"></i>',
                    action: function () {
                        $('#invoice-total-archive').click();
                    },
                    cssClasses: ['redFont', 'bold']
                },*/

                // 'copy',
                //'paste',
                'separator',
            ];
        }
        else
            var result = [];

        return result;
    }

    $("#manual_invoice").on('click', function(){
        manual_invoice= 0;
        manual_grid_ready=true;
        multiple_match=false;
        manual_or_imported=0;
        data_zone_inv= false;
        $('#invoice-report-arvhived').css('display', 'none');
        $('#invoice-export-arvhived').css('display', 'none');
        $('#invoice-activate').css('display', 'none');
        $('#copy-invoice').css('display', 'none');
        $('#invoice-verif').css('display', 'none');
        $('#advertiser_searchm').val("");
        $('#advertiser_searchm').select2({
            placeholder: "Select one ..."
        });
        $('#campaign_searchm').html('');
        $('#campaign_searchm').select2({
            placeholder: "Select one ...",
        });
        $('#order_search_selectm').select2({
            placeholder: "Select one ...",
        });
        $('#only_archived').prop('checked', false);
        $('#only_in_proccess').prop('checked', true);
        var html='';
        html+='<option></option>';
        // for(var i in markets_search) {
        //     if (markets_search[i]['type'] == 'dma')
        //         var tpe = 'DMA';
        //     else if (markets_search[i]['type'] == 'msa')
        //         var tpe = 'MSA';
        //     else if (markets_search[i]['type'] == '')
        //         var tpe = 'CUSTOM';
        //     else
        //         var tpe = 'NATIONAL';
        //
        //     html += ' <option value="'+markets_search[i]['id']+'" title="'+markets_search[i]['name']+'">'+tpe+'-'+markets_search[i]['name']+'</option>';
        // }

        $('#order_search_selectm').html(html);
        $('#orders-invoices').html('');
        gridInvOrdOptions.rowData = [];
        var gridMatchDiv = document.querySelector('#orders-invoices');
        var g4 = new agGrid.Grid(gridMatchDiv, gridInvOrdOptions);
        $("#invoiceEntry").modal("show");
    });


    $('#advertiser_searchm').on('change', function(e){
        // $('#display_campaign_sm').css("display", "none");
        // $('#display_order_sm').css("display", "none");
        $('#loading_loadingm').css("display", "block");
        var adv= $("#advertiser_searchm option:selected").val();

        $.ajax({
            type: 'GET',
            url: '/invoices/search_campaign/' + adv,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': '', 'title': ''});
                $.each(data.campaigns, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name, 'title': value.name});
                });

                advertisers.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
                var adv_new= $('#campaign_searchm');
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select one...",
                });
                // var advertisers = [];
                // advertisers.push({'id': '', 'text': '', 'title': ''});
                // $.each(data.markets, function (index, value) {
                //     if (value.type == 'dma')
                //         var tpe = 'DMA';
                //     else if (value.type == 'msa')
                //         var tpe = 'MSA';
                //     else if (value.type == '')
                //         var tpe = 'CUSTOM';
                //     else
                //         var tpe = 'NATIONAL';
                //     var texto=tpe+'-'+value.name;
                //     advertisers.push({'id': value.id, 'text':texto , 'title': value.name});
                // });
                //
                // advertisers.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
                // var adv_new= $('#order_search_selectm');
                // adv_new.html('').select2({
                //     'data': advertisers,
                //     placeholder: "Select one...",
                // });
                $('#display_campaign_sm').css("display", "block");
                $('#loading_loadingm').css("display", "none");
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                $('#loading_loadingm').css("display", "none");
            }
        });
    });

    $('#campaign_searchm').on('change', function(e) {
        //  $('#display_order_sm').css("display", "none");
        $('#loading_loadingm').css("display", "block");
        var camp = $("#campaign_searchm option:selected").val();
        $.ajax({
            type: 'GET',
            url: '/invoices/search_order_market/tab/' + camp,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data, function (index, value) {
                    if (value.type == 'dma')
                        var tpe = 'DMA';
                    else if (value.type == 'msa')
                        var tpe = 'MSA';
                    else if (value.type == '')
                        var tpe = 'CUSTOM';
                    else
                        var tpe = 'NATIONAL';
                    var texto = tpe + '-' + value.name;
                    advertisers.push({'id': value.id, 'text': texto});
                });

                advertisers.sort(function (a, b) {
                    if (a.text > b.text) {
                        return 1;
                    }
                    if (a.text < b.text) {
                        return -1;
                    }
                    return 0;
                });
                var adv_new = $('#order_search_selectm');
                if ($(adv_new).data('select2')) {
                    adv_new.select2('destroy');
                }
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select one..."
                });
                //   $('#display_order_sm').css("display", "block");
                $('#loading_loadingm').css("display", "none");
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                $('#loading_loadingm').css("display", "none");
            }
        });
    });

    var showManualInvoicesButtons = function () {
        if($("input:radio[name=manual_invoice_type]:checked").attr('value')== 'archived') {
            show_archived = true;
            $('#invoice-verif').css('display', 'none');
            $('#copy-invoice').css('display', 'none');
            $('#invoice-total-archive').css('display', 'none');
            $('#invoice-total-report').css('display', 'none');
            $('#invoice-report-arvhived').css('display', 'none');
            $('#invoice-export-arvhived').css('display', 'none');
            $('#invoice-activate').css('display', 'none');
        }
        else {
            show_archived = false;
            $('#invoice-verif').css('display', 'none');
            $('#copy-invoice').css('display', 'inline');
            $('#invoice-report-arvhived').css('display', 'none');
            $('#invoice-export-arvhived').css('display', 'none');
            $('#invoice-total-archive').css('display', 'none');
            $('#invoice-total-report').css('display', 'none');
            $('#invoice-activate').css('display', 'none');
        }
    }

    var displayOrdersInvoices = function(search_type ) {
        var sel = typeof gridInvOrdOptions.api.getSelectedNodes()[0] !== 'undefined' ? gridInvOrdOptions.api.getSelectedNodes()[0] : '';
        console.log('sel_x_sel ', sel);
        show_archived = false;
        $('#invoice-verif').css('display', 'none');
        $('#copy-invoice').css('display', 'inline');
        $('#invoice-report-arvhived').css('display', 'none');
        $('#invoice-export-arvhived').css('display', 'none');
        $('#invoice-total-archive').css('display', 'none');
        $('#invoice-total-report').css('display', 'none');
        $('#invoice-activate').css('display', 'none');
        var only_recent = false;
        $('.invoice_check_order_recent_manual_invoice input[type=checkbox]').each(function () {
            if (this.checked)
                only_recent = true;
        });

        if(search_type === 1) {
            var params = {
                campaign: $("#campaign_searchm option:selected").val(),
                advertiser: $("#advertiser_searchm option:selected").val(),
                market: $("#order_search_selectm option:selected").val(),
                type: 'in_proccess',
                only_recent_order: only_recent,
                search_type: 1
            };
        }else {
            var params = {
                orders: global_way_to_search_manual_invoices_orders,
                type: 'in_proccess',
                only_recent_order: only_recent,
                search_type: 2
            };
        }
        if (search_type === null && $("#order_search_selectm").val().length == 0 && $("#advertiser_searchm").val().length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one search parameter.');
            $('#generalWarningModal').modal('show');
        } else {
            show_overlay_loader($('#invoiceEntry .modal-content'));
            $('#loading_loadingm').css("display", "block");
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/orders_manual_invoices/tab/',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (response) {
                    console.log('response', response);
                    var data = response['data'];
                    if (data.length === 0)
                        global_notification("warning", "No Orders were returned matching your parameters...");
                    else {
                        var lines = [];
                        for (var i in data) {
                            var row = {
                                bottom_line: data[i].bottom_line,
                                station: data[i].station_name,
                                order_num: data[i].id,
                                reference_number: data[i].reference_number,
                                old_reference_number: data[i].old_reference_number,
                                revision_num: data[i].revision_number,
                                revision_fd: data[i].flight_dates,
                                revision_market: data[i].market_name,
                                revision_month: data[i].revision_month,
                                month_year: data[i].month_year,
                                created: data[i].created,
                                spots: parseFloat(data[i].order_spots).toFixed(),
                                gross_cpa: parseFloat(data[i].order_gross).toFixed(2),
                                net_cpa: parseFloat(data[i].order_net).toFixed(2),
                                inv_num: data[i].inv_number,
                                inv_id: data[i].inv_id,
                                inv_date: data[i].inv_date,
                                inv_zone: data[i].inv_zone,
                                inv_month: data[i].invoice_month,
                                spots_inv: data[i].total_spots,
                                schedule: parseFloat(data[i].total_gross).toFixed(2),
                                matched_saved: data[i].matched_saved,
                                totals_only: data[i].total_only,
                                type: data[i].type,
                                camp_id: data[i].camp_id,
                                camp_name: data[i].camp_name,
                                media_type: data[i].media_type,
                                impressions_ordered: typeof data[i].impressions_ordered !== 'undefined' ? data[i].impressions_ordered : 0,
                                impressions_invoiced: typeof data[i].impressions_invoiced !== 'undefined' ? data[i].impressions_invoiced : 0,
                                inv_status: data[i].status,
                                commission: data[i].commission,
                                spot_static: (typeof data[i].spot_static !== 'undefined' && data[i].spot_static === 1) ? true : false,
                                camp_start: data[i].camp_start,
                                camp_end: data[i].camp_end,
                                inv_due_date: data[i].inv_due_date,
                                line_through: data[i].line_through,
                                multi_market: data[i].multi_market,
                                inv_comments : data[i].inv_comments,
                                attachments : data[i].attachments,
                                bookend : typeof data[i].bookend !== 'undefined' ? data[i].bookend : 0,
                            };
                            lines.push(row);
                        }
                        console.log('lines_lines', lines);
                        var orderBy = [ 'reference_number', 'month_year'];
                        var sorted = multisort(lines, orderBy)
                        var filters = gridInvOrdOptions.api.getFilterModel();
                        $('#orders-invoices').html("");
                        console.log('lines_lines sorted', sorted);
                        gridInvOrdOptions.rowData =  sorted.filter( elem => elem.spots > 0 || elem.gross_cpa > 0);
                        var gridMatchDiv = document.querySelector('#orders-invoices');
                        var g4 = new agGrid.Grid(gridMatchDiv, gridInvOrdOptions);
                        $('#invoice-verif').prop('disabled', false);
                        gridInvOrdOptions.api.setFilterModel(filters);
                        if (sel !== '') {
                            var index = sel.data.order_num + '-' + sel.data.month_year + '-' + sel.data.inv_id;
                            console.log('sel_x_sel ', index);
                            gridInvOrdOptions.api.forEachNode(function (node) {
                                var dd = node.data.order_num + '-' + node.data.month_year + '-' + node.data.inv_id;
                                if (dd === index)
                                    node.setSelected(true);
                            });
                        }
                    }
                    hide_overlay_loader($('#invoiceEntry .modal-content'));
                    $('#loading_loadingm').css("display", "none");
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                    $('#loading_loadingm').css("display", "none");
                    hide_overlay_loader($('#invoiceEntry .modal-content'));
                }
            });
        }
    };

    var updateTotals = function(e){
        var spots = 0;
        var rate = 0;
        e.api.forEachNode(function (node) {
            spots++;
            if(!isNaN(parseFloat(node.data.rate)))
                rate += parseFloat(node.data.rate);
        });

        //Filling the Totals Invoiced
        $('#items_inv_spots_total').val(parseInt(totals_invoice_array_global.ads) + parseInt(spots)) ;
        var tt_gross = parseFloat(totals_invoice_array_global.gross) + parseFloat(rate);

        $('#items_inv_gross_total').val(parseFloat(tt_gross).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        })) ;

        $("#items_inv_spots").val(spots);
        $("#items_inv_rate").val(rate.toFixed(2));


    };

    $("#inv_save").on("click", function(){
        if($("#inv_number").val() !== "" && $("#inv_date").val() !== "" && $("#inv_month").val() !== ""){
            $('#loading_header_save').css("display", "block");
            var sel = gridInvOrdOptions.api.getSelectedNodes();
            var disp = sel[0].data.inv_id;
            var status = $('#inv_add_new').attr('disabled');
            if((sel[0].data.inv_status === '' || sel[0].data.inv_status === 'Active') || (disp === "" || status === 'disabled')) {
                var to = 0;
                if ($('#totals_only').is(':checked'))
                    to = 1;
                var params = {
                    order_id: sel[0].data.order_num,
                    inv_id: sel[0].data.inv_id,
                    inv_num: $("#inv_number").val(),
                    inv_date: $("#inv_date").val(),
                    inv_month: $("#inv_month").val(),
                    fiscal_date: $("#inv_fiscal_date").val(),
                    comments: $("#inv_comments").val(),
                    campaign: sel[0].data.camp_id,
                    advertiser: $("#advertiser_searchm option:selected").val(),
                    total_only: to,
                };

                let invoiceUpdatedata = sel[0].data
                invoiceUpdatedata['inv_num'] = $("#inv_number").val()
                invoiceUpdatedata['inv_date'] = moment($("#inv_date").val()).format("MM/DD/YYYY")
                if (disp === "" || status === 'disabled') {
                    $.ajax({
                        type: 'POST',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        url: '/invoices/save-header-new',
                        data: JSON.stringify(params),
                        contentType: "application/json",
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            console.log('headerdata', data);
                            if (typeof data.error !== 'undefined') {
                                swal({
                                        title: "Oops!",
                                        text: data.error,
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            } else {
                                global_notification("success", "Invoice header " + $("#inv_number").val().toUpperCase() + " inserted!");
                                $("#invoiceHeader").modal("hide");

                                var camp = $("#campaign_searchm option:selected").val();
                                var ven = $("#order_search_selectm option:selected").val();
                                if (status !== 'disabled') {
                                    if (typeof data['invoice'] !== "undefined" && typeof data['invoice']['id'] !== "undefined" && !isNaN(data['invoice']['id'])) {
                                        invoiceUpdatedata["inv_id"] = data['invoice']['id'];
                                        invoiceUpdatedata["totals_only"] = data['invoice']['total_only'];
                                        gridInvOrdOptions.api.updateRowData({update: [invoiceUpdatedata]});
                                        gridInvOrdOptions.api.deselectAll()
                                        showManualInvoicesButtons()
                                    } else
                                        displayOrdersInvoices(global_way_to_search_manual_invoices);
                                } else
                                    displayOrdersInvoices(global_way_to_search_manual_invoices);

                            }
                            $('#loading_header_save').css("display", "none");
                            app_invoices_table.draw();
                        },
                        error: function (xhr) {
                            $('#loading_header_save').css("display", "none");
                            debug(xhr.responseText);
                        }
                    });
                } else {

                    $.ajax({
                        type: 'POST',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        url: '/invoices/save-header-edit',
                        data: JSON.stringify(params),
                        contentType: "application/json",
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            if (typeof data.error !== 'undefined') {
                                swal({
                                        title: "Oops!",
                                        text: data.error,
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            } else {
                                $('#loading_header_save').css("display", "none");
                                global_notification("success", "Invoice header " + $("#inv_number").val().toUpperCase() + " updated!");
                                $("#invoiceHeader").modal("hide");

                                var camp = $("#campaign_searchm option:selected").val();
                                var ven = $("#order_search_selectm option:selected").val();
                                gridInvOrdOptions.api.updateRowData({update: [invoiceUpdatedata]});
                                gridInvOrdOptions.api.deselectAll()
                            }
                            app_invoices_table.draw();
                        },
                        error: function (xhr) {
                            $('#loading_header_save').css("display", "none");
                            debug(xhr.responseText);
                        }
                    });
                }
            }
            else{
                $('#generalWarningModalDiv').html(sel[0].data.inv_status + ' invoices cannot be modified. To modify this invoice please activate it first.');
                $('#generalWarningModal').modal('show');
            }
        }else{
            swal({
                    title: "Oops!",
                    text: "Please complete all required fields ...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
    });

    $("#inv_add_new").on("click", function(){
        $("#inv_number").val("");
        $("#inv_date").val("");
        //$("#inv_month").val("");
        $("#inv_fiscal_date").val("");
        $("#inv_comments").val("");
        $("#inv_add_new").attr('disabled', "disabled");
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            var invo= sel[0];
            if(invo.data.type == 'broadcast'){
                $('.div_totals_only input').prop('checked', false);
                $('.div_totals_only input').prop('disabled', false);
            }
            else{
                $('.div_totals_only input').prop('checked', true);
                $('.div_totals_only input').prop('disabled', true);
            }
        }
        else {
            $('.div_totals_only input').prop('checked', false);
            $('.div_totals_only input').prop('disabled', false);
        }
        $("#total_spots").val(0);
        $("#total_gross").val('0.00');

        $("#unres_items").val(0);
        $("#unres_gross").val('0.00');
        $("#header_new_inv").show();
    });

    $("#inv_add_item").on("click", function(){
        var index= gridNewItemOptions.api.getModel().rowsToDisplay.length;
        if(typeof gridNewItemOptions.api.getFocusedCell() !== 'undefined' && gridNewItemOptions.api.getFocusedCell() !== null){
            console.log(gridNewItemOptions.api);
            console.log(gridNewItemOptions.api.getFocusedCell());
            var rowIndex= gridNewItemOptions.api.getFocusedCell().rowIndex;
            var selectedNodes = gridNewItemOptions.api.getSelectedNodes();

        }

        gridNewItemOptions.api.stopEditing(true);

        gridNewItemOptions.api.updateRowData({add: [{
                int_id: "-",
                date: "00/00/0000",
                dow: "",
                time: "00:00",
                type: "",
                length: 0,
                rate: '$0.00',
                remarks: "",
                commercial_id: "",
                network: '',
                remarks: ""

            }], addIndex: index});
        gridNewItemOptions.api.ensureColumnVisible('date')
        gridNewItemOptions.api.ensureIndexVisible(index);
        gridNewItemOptions.api.setFocusedCell(index, 'date', null);
    });

    $("#inv_remove_items").on("click", function(){
        var selectedNodes = gridNewItemOptions.api.getSelectedNodes();
        for(var i in selectedNodes)
            if(selectedNodes[i].data.int_id !== "-")
                if(deletedItems.indexOf(selectedNodes[i].data.int_id) === -1)
                    deletedItems.push(selectedNodes[i].data.int_id);
        gridNewItemOptions.api.removeItems(selectedNodes);
        //var rr = gridNewItemOptions.api.updateRowData({remove: selectedNodes});
        gridNewItemOptions.api.refreshView();
        updateTotals(gridNewItemOptions);
        global_notification("success", "Removed " + selectedNodes.length + " rows!");
    });

    $('.close_invoice_entry').on('click', function () {
        if(changes_in_total_only_global === false && changes_in_grid_global === false)
            close_invoice_entry_modal();
        else{
            swal({
                    title: "Warning",
                    text: "You have pending changes. Are you sure you want to navigate away?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm)
                        close_invoice_entry_modal()
                });
        }
    });
    function close_invoice_entry_modal(){
        $("#invoiceItemsNew").modal("hide");
        var camp = $("#campaign_searchm option:selected").val();
        var ven = $("#order_search_selectm option:selected").val();
        displayOrdersInvoices(global_way_to_search_manual_invoices);
    }

    $("#inv_save_items").on("click", function() {
        if ($('#inv_number_new').val() !== '' && $('#inv_date_new').val() !== "") {
            show_overlay_loader('#invoiceItemsNew');
            var sel = gridInvOrdOptions.api.getSelectedNodes()[0];
            var params = {
                inv_number: $('#inv_number_new').val(),
                inv_due_date: $('#inv_fiscal_date_new').val(),
                inv_date: $('#inv_date_new').val(),
                inv_zone: $('#inv_zone_new').val(),
                inv_id: sel.data.inv_id,
                inv_month: sel.data.month_year,
                inv_camp: sel.data.camp_id,
                rev_id: sel.data.order_num,
                lines: [],
                delete: deletedItems,
                cable: sel.data.cable,
                inv_comments: $('#inv_comments').val(),
            };
            gridNewItemOptions.api.forEachNode(function (node) {
                if (node.data.rate === "")
                    node.data.rate = 0
                if (node.data.date !== "" && node.data.time !== "" && node.data.length !== "" && node.data.rate !== "")
                    params.lines.push(node.data);
            });
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/save-lines',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    changes_in_total_only_global = false;
                    changes_in_grid_global = false
                    console.log('data_data', data);
                    if (data.duplicated === true) {
                        hide_overlay_loader('#invoiceItemsNew');
                        $('#generalWarningModalDiv').html(sel.data.station +' already has an Invoice with this number. Please change the Invoice Number before saving.');
                        $('#generalWarningModal').modal('show');
                    } else {
                        var x = 0;
                        if (data.news.length > 0) {
                            gridNewItemOptions.api.forEachNode(function (node) {
                                console.log(node);
                                console.log(node.data['int_id']);
                                console.log(node.data['int_id'] == '-');
                                if (node.data['int_id'] == '-') {
                                    node.data['int_id'] = data.news[x];
                                    console.log(data.news[x]);
                                    gridNewItemOptions.api.refreshCells([node], ['int_id']);
                                    x++;
                                }
                            });
                        }
                        deletedItems = [];
                        if (sel.data.inv_id === '') {
                            sel.data.inv_id = data.invoice.id;
                            sel.data.inv_date = data.invoice.date;
                            sel.data.inv_due_date = data.invoice.fiscal_date;
                            sel.data.inv_num = data.invoice.invoice_num;
                            gridInvOrdOptions.api.refreshCells({
                                rowNodes: [sel],
                                columns: ['inv_id', 'inv_num','inv_date', 'inv_due_date'],
                                force: true
                            });
                        }
                        app_invoices_table.draw();
                        global_notification("success", "Items inserted!");
                        hide_overlay_loader('#invoiceItemsNew');
                    }
                },
                error: function (xhr) {
                    hide_overlay_loader('#invoiceItemsNew');
                    debug(xhr.responseText);
                }
            });
        } else {
            $('#generalWarningModalDiv').html('Invoice Number and Invoice Date are required.');
            $('#generalWarningModal').modal('show');
        }
    });

    //Weekly breakout Report  Archived Manual
    $('#weekly_breakout_archived_manual').on('click', function () {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            sel = sel[0];
            var inv_id = sel.data.inv_id;
            var link = document.createElement('a');
            link.href = "/invoices/manual/reconciliation/weekly_report/" + inv_id + "/download";
            $(link).attr('target', '_blank');
            link.click();
        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }

    });
    //Rotation Analysis Archived Manual
    $('#rotation_analysis_archived_manual').on('click', function () {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            sel = sel[0];
            var inv_id = sel.data.inv_id;
            $('#rec_manual').val(inv_id);
            $('#InvoiceRotationAnalysisManualTemp').modal('show');
        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }
    });
    //Spot Pattern Archived Manual
    $('#spot_rotation_archived_manual').on('click',  function () {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            sel = sel[0];
            var rec_id = sel.data.inv_id;
            var type = 'manual';
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var lines = [];
                    $('#rec_number').val(rec_id);
                    $('#rec_type').val('manual');

                    $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' + data.camp.name);
                    $('#InfoOrder').html('<b>Order No: </b> ' + '  ' + data.order.reference_number);
                    $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' + data.invoice.invoice_num);
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station.name);
                    for (var ind in data.lines) {
                        var row = {
                            line_id: data.lines[ind]['id'],
                            line: data.lines[ind]['order_line'],
                            start_time: data.lines[ind]['start_time'],
                            end_time: data.lines[ind]['end_time'],
                            days: data.lines[ind]['days'],
                            spot_matches: data.lines[ind]['spot'],
                        }
                        lines.push(row);
                    }
                    $('#orderLinesSpotRotGridGrid').html('');
                    orderLinesSpotRotGrid.rowData = lines;
                    var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                    var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);

                    $('#OrderLinesSpot').modal('show');

                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }
    });

    //Print Inv-Sche mtach
    $('#inv_sche_match').on('click', function () {
        $('#agency_sel_main').select2({
            minimumResultsForSearch: 10,
            placeholder: 'Select one....',
            //'allowClear':  true,
        });
        var html = '';
        for(var ind in ws_secondary_agency_general)
            html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
        $('#agency_sel_main').html(html);


        $('#sche_id').val($(this).val());
        $('#schey_print_options').multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'> </div>",
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values){
                this.qs1.cache();
            },
            afterDeselect: function(values){
                this.qs1.cache();
            }
        });
        //       alert(manual_or_imported);

        if(manual_or_imported == 0) {
            $('#print_invo_schedule_options_fomr').attr('action', '/invoices/manual/reconciliation/download');
            $('#InvScheOptionsPrint').modal('show');
        }
        else {
            $('#print_invo_schedule_options_fomr').attr('action', '/invoices/reconciliation/download');
            $("#loading_match").show();
            var invoice_id= $(this).val();
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getTemp/' + invoice_id,
                //  data: data,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $("#loading_match").hide();
                    if(data== 0)
                        global_notification('warning', 'Please Save Match first...');
                    else {
                        $('#sche_id').val(data);
                        $('#InvScheOptionsPrint').modal('show');
                    }
                },
                error: function(xhr){
                    debug(xhr.responseText);
                    $("#loading_match").hide();
                }
            });
        }


    });

    $('#app-invoices-table').on('click', '.invoice_change_order_revision_manual', function () {
        show_loader();
        var inv_id = $(this).attr('data-id');
        var total_only = $(this).attr('data-totals-only');

        $.ajax({
            type: 'GET',
            url: '/invoices/get/revisions/manual/list/to_edit/' + inv_id,
            dataType: 'json',
            encode: true,
            success: function (response) {
                $('#to_edit_or_manual_invo_hidden').val(inv_id);
                $('#to_edit_or_manual_invo_hidden_total_only').val(total_only);
                var market = '';
                if (response.current_order.market_type == '')
                    market = 'Custom - ' + response.current_order.market_name;
                else if (response.current_order.market_type == 'msa' || response.current_order.market_type == 'dma')
                    market = response.current_order.market_type.toUpperCase() + ' - ' + response.current_order.market_name;
                else
                    market = 'National - ' + response.current_order.market_name;
                var html = '';
                html += ' <div class="col-md-12" style="color: #f15925;  font-size: 16px"><b>Current Order: </b></div>';

                html += '                            <div style="margin-top: 1%; margin-left: 1%" class="col-md-12">';
                html += '                            <div class="col-md-3"><span><b> Order Ref #</b> </span> </div>';
                html += '                            <div class="col-md-1"><span><b>Order Rev </b> </span> </div>';
                html += '                            <div class="col-md-3"><span><b>Market </b> </span> </div>';
                html += '                            <div class="col-md-3"><span><b>Flight Dates </b> </span> </div>';
                html += '                            <div class="col-md-2"><span><b>Created at </b> </span> </div>';
                html += '                            </div>';

                html += '                        <div style="margin-top: 1%; margin-left: 1%" class="col-md-12">' +
                    '                            <div class="col-md-3"> ' + response.current_order.reference_number + '</div>' +
                    '                            <div class="col-md-1">#' + response.current_order.revision_number + ' </div>' +
                    '                            <div class="col-md-3">' + market + ' </div>' +
                    '                            <div class="col-md-3">' + response.current_order.fd + ' </div>' +
                    '                            <div class="col-md-2"> ' + response.current_order.created_at_string + ' </div>' +
                    '                            </div>';
                $('#div_to_fill').html(html);

                var html = '';
                html += ' <div class="col-md-12" style="color: #f15925; ; font-size: 16px"><b>Available Orders: </b></div>' +
                    '                            <div style="margin-top: 1%; margin-left: 1%" class="col-md-4"><span><b>Order Ref #: </b> </span> ' + response.order_newest.reference_number + '</div>';

                html += '                            <div style="margin-top: 1%; margin-left: 1%" class="col-md-12">';
                html += '                            <div class="col-md-1"><span><b> </b> </span> </div>';
                html += '                            <div class="col-md-2"><span><b>Order Rev </b> </span> </div>';
                html += '                            <div class="col-md-3"><span><b>Market </b> </span> </div>';
                html += '                            <div class="col-md-3"><span><b>Flight Dates </b> </span> </div>';
                html += '                            <div class="col-md-3"><span><b>Created at </b> </span> </div>';
                html += '                            </div>';

                for (var ind in response.revisions) {
                    console.log('revisions')
                    var rev = response.revisions[ind];
                    var color = (ind % 2 !== 0) ? 'white' : '#F7FAFC';
                    var border = (ind % 2 !== 0) ? '1px solid white' : '1px solid lightgrey';
                    var margin = (ind == 0) ? '1%' : '0%';
                    var checked = (ind == 0) ? 'checked' : '';

                    html += '                            <div class="col-md-12" style="margin-top:' + margin + '; margin-left: 1%; background-color: ' + color + '; border-top: ' + border + '; border-bottom: ' + border + '">';
                    html += '                            <div class="col-md-1">'
                    html += "                             <div class='radio radio-primary'>" +
                        "                               <input  " + checked + " type='radio' id ='rev_to_change_" + rev.id + "' name='sel_order_update_manual_invoice' value='" + rev.id + "'><label for='rev_to_change_" + rev.id + "'> </label></div>";
                    html += '                            </div>';
                    html += '                            <div class="col-md-2" style="margin-top: 1%"> #' + rev.revision_number + '</div>';
                    html += '                            <div class="col-md-3" style="margin-top: 1%" >' + rev.market_name + '</div>';
                    html += '                            <div class="col-md-3" style="margin-top: 1%">' + rev.fd + '</div>';
                    html += '                            <div class="col-md-3" style="margin-top: 1%">' + rev.created_at_string + '</div>';
                    html += '                            </div>';
                }

                $('#div_to_fill_2').html(html);

                $('#manualInvEditOR').modal('show');
                console.log('response ', response);
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });

    $('#edit-manual-inv-or').on('click', function() {
        var inv_id  = $('#to_edit_or_manual_invo_hidden').val();
        var tt  = $('#to_edit_or_manual_invo_hidden_total_only').val();
        var text = '';
        if(tt == 0 || tt == false)
            text = "This action will delete the current Match.  Are you sure to update?";
        else
            text = "Are you sure to update?.";
        $('#editInvoiceDiv').html(text);
        var sel = $("input:radio[name=sel_order_update_manual_invoice]:checked").attr('value');
        $('#editImportedConfirmed').hide();
        $('#editManualConfirmed').show();
        $('#editManualConfirmed').attr('data-value', sel);
        $('#editManualConfirmed').attr('data-inv', inv_id);
        $('#generalWarningModalEditInvoice').modal('show');

    });
    function editManualConfirmed() {
        show_overlay_loader($("#manualInvEditOR .modal-content"));
        var sel = $('#editManualConfirmed').attr('data-value');
        var inv_id = $('#editManualConfirmed').attr('data-inv');
        $.ajax({
            type: 'GET',
            url: '/invoices/manual/update/order_revision/inv_id/' + inv_id + '/new_or_rev/' + sel,
            dataType: 'json',
            encode: true,
            success: function (response) {
                hide_overlay_loader($("#manualInvEditOR .modal-content"));
                global_notification('success', 'Order changed successfully')
                $('#manualInvEditOR').modal('hide');
                location.reload();

            },
            error: function (xhr) {
                hide_overlay_loader($("#manualInvEditOR .modal-content"));
                debug(xhr.responseText);
            }
        });
    }

    $('#app-invoices-table').on('click', '.invoice_print_manual_sh_table', function () {
        manual_or_imported = 0;
        $('#inv_sche_match').val($(this).attr('data-id'));
        $('#inv_sche_match').click();

    });
    //Move to completed
    $('#app-invoices-table-archived').on('click', '.invoice_move_to_complete', function () {
       show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/move/to/completed/individual/' + $(this).attr('data-id')+ '/'+ $(this).attr('data_completed'),
            //  data: data,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var type =  $('.invoices_filters').attr('data-value');
                var url = "/invoices/archivated?view_type=" + type;
                $('#app-invoices-table-archived').DataTable().ajax.url(url).load();
                hide_loader();
            },
            error: function(xhr){
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });
    $('#app-invoices-table').on('click', '.invoice_print_imported_sh_table', function () {
        manual_or_imported = 1;
        $('#inv_sche_match').val($(this).attr('data-id'));
        $('#inv_sche_match').click();
    });
    $('#app-invoices-table').on('change', '.input_checkbook_invo', function () {
        var selected = [];
        var mmm = false;
        var man = false;
        var imp = false;
        var all_imported = true;
        var all_manual = true;
        $('.invoices_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selected.push($(this).val());
                if ($(this).val().toString().indexOf('m_') !== -1)
                    man = true;
                else
                    imp = true;
                if ($(this).val().toString().indexOf('m_') !== -1 && $(this).attr('data-total-only') == 1) {
                    all_imported = false;
                    all_manual = false;
                }
                else if ($(this).val().toString().indexOf('m_') !== -1)
                    all_imported = false;
                else
                    all_manual = false;

                // if (mmm == false) {
                //     var row = app_invoices_table.row($(this).attr('data-row')).data();
                //     console.log('cccccccccccccccccccccccc');
                //     console.log($(this).attr('data-row'));
                //     console.log(row);
                //     if (row.multiple_match > 0 || row.match_id > 0)
                //         mmm = true;
                // }
            }
        });
        console.log('all_imported ...', all_imported);
        console.log('all_manual ...', all_manual);
        // if (man === true)
        //     $('#multiple_match').attr('disabled', 'disabled');
        // else
        //     $('#multiple_match').attr('disabled', false);
        if(selected.length > 1 && (all_imported === true || all_manual === true) ) {
            $('#multiple_match').attr('disabled', false);
            if(all_imported === true)
                  $('#multiple_match').attr('data-invoice-type', 'imported');
            else
                $('#multiple_match').attr('data-invoice-type', 'manual');
        }
        else
            $('#multiple_match').attr('disabled', 'disabled');

        if (mmm == false)
            $('#delete_multiple_invo').attr('disabled', false);
        else
            $('#delete_multiple_invo').attr('disabled', 'disabled');
    });
    //Print Inv-Sche mtach Imported Archived
    $('#app-invoices-table-archived').on('click', '.print_rec_archivated', function () {
        invoice_manual_multiple_match = false;
        var row = app_invoices_table_archived.row($(this).attr('row-id')).data();
        if (row.multiple_match > 0) {
            $('.confirm-see-multiple-archive').val(row.multiple_match);
            $('.cancel-see-multiple-archive').val($(this).attr('data-id'));
            $('#selectMatchTypeArchive').modal('show');
        } else {
            $('#sche_id_arch').val($(this).attr('data-id'));
            $('#manual_or_imported_hidden_archi').val(1);
            $('#sche_print_options_arch').multiSelect({
                selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#InvScheOptionsPrintArchivated').modal('show');
        }
    });

    $('#app-invoices-table-archived').on('click', '.print_rec_archivated_man', function () {
        if($(this).attr('data-multiple-match') > 0){
            invoice_manual_multiple_match = true;
            $('.confirm-see-multiple-archive-manual').val($(this).attr('data-multiple-match'));
            $('.cancel-see-multiple-archive-manual').val($(this).attr('data-id'));
            $('#selectMatchTypeArchiveManual').modal('show');
        }else {
            invoice_manual_multiple_match = false;
            var row = app_invoices_table_archived.row($(this).attr('row-id')).data();
            $('#sche_id_arch').val($(this).attr('data-id'));
            $('#manual_or_imported_hidden_archi').val(0);
            $('#sche_print_options_arch').multiSelect({
                selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'> </div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                },
                afterDeselect: function (values) {
                    this.qs1.cache();
                }
            });
            $('#InvScheOptionsPrintArchivated').modal('show');
        }
    });

    //Print Inv-Sche mtach Manual Archived
    $('#inv_sche_match_archived_manual').on('click', function () {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            sel = sel[0];
            var inv_id = sel.data.inv_id;
            $('#sche_id').val(inv_id);
            $('#schey_print_options').multiSelect({
                selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div class='' style='height: 38px;'> </div>",
                afterInit: function(ms){
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function(e){
                            if (e.which === 40){
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function(values){
                    this.qs1.cache();
                },
                afterDeselect: function(values){
                    this.qs1.cache();
                }
            });

            $('#print_invo_schedule_options_fomr').attr('action', '/invoices/manual/reconciliation/download');
            $('#InvScheOptionsPrint').modal('show');
        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }

    });
    //Invoice Status Report
    $('#invoice_status_tm').on('click', function () {
        if($(this).parent().parent().attr('invoice-type') == 0) {
            var campaign_id = $("#campaign_searchm option:selected").val();
            if (campaign_id !== '') {
                var link = document.createElement('a');
                link.href = '/download/invoices/status_report/' + campaign_id + '/download';
                $(link).attr('target', '_blank');
                link.click();
            }
            else {
                $('#generalWarningModalDiv').html('Please select a campaign.');
                $('#generalWarningModal').modal('show');
            }
        }
        else{
            $("#loading_match").show();
            var invoice_id= $(this).val();
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getInv/' + invoice_id,
                //  data: data,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $("#loading_match").hide();
                    var link = document.createElement('a');
                    link.href = '/download/invoices/status_report/' + data.campaign_id + '/download';
                    $(link).attr('target', '_blank');
                    link.click();
                },
                error: function(xhr){
                    debug(xhr.responseText);
                    $("#loading_match").hide();
                }
            });
        }

    });

    //Weekly Breakout Report
    $('#show_weekly_breakout_button').on('click', function (){
        var selectedItems = [];
        $('.show_only_missed_div input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var show = selectedItems.length > 0 ? 1 : 0;
        var link = document.createElement('a');
        var id  = $(this).attr('data-id');

        // if($(this).attr('data-type') === 'multiple_imported' || $(this).attr('data-type') === 'multiple_manual')
        //     id = $('#weekly_breakout_multiple').val() !== '' ? $('#weekly_breakout_multiple').val() : id;
        // else if($(this).attr('data-type') === 'imported' || $(this).attr('data-type') === 'manual')
        //     id = $('#weekly_breakout').val() !== '' ? $('#weekly_breakout').val() : id;

        link.href = $(this).attr('data-url') + show +'/' + id + "/download";
        $(link).attr('target', '_blank');
        $('#showWeeklyModal').modal('hide');
        link.click();
    });

    function show_weeklyModal(url, id, type){
      $('#show_weekly_breakout_button').attr('data-url', url);
      $('#show_weekly_breakout_button').attr('data-id', id);
      $('#show_weekly_breakout_button').attr('data-type', type);
      $('#showWeeklyModal').modal('show');
    }

    $('#weekly_breakout').on('click', function () {
        var id=  $(this).val();
        var link = document.createElement('a');
        if(manual_or_imported  == 0)
            show_weeklyModal("/invoices/manual/reconciliation/weekly_report/", id, "manual");
        else {
            var invoice_id= $(this).val();
            $("#loading_match").show();
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getTemp/' + invoice_id,
                // data: data,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $("#loading_match").hide();
                    if(data == 0)
                        global_notification('warning', 'Please Save Match first...');
                    else
                        show_weeklyModal("/invoices/reconciliation/weekly_report/",  data, 'imported');

                },
                error: function(xhr){
                    debug(xhr.responseText);
                }
            });
        }

    });
    //Rotation Analysis
    $('#rotation_analysis').on('click',  function () {
        if(manual_or_imported  == 0) {
            $('#agency_sel_rot_manual').select2({
                minimumResultsForSearch: 10,
                placeholder: 'Select one....',
                //'allowClear':  true,
            });
            var html = '';
            for(var ind in ws_secondary_agency_general)
                html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
            $('#agency_sel_rot_manual').html(html);

            $('#rec_manual').val($(this).val());
            $('#InvoiceRotationAnalysisManualTemp').modal('show');
        }
        else {
            var invoice_id= $(this).val();
            $('#rec_manual').val($(this).val());
            $("#loading_match").show();
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getTemp/' + invoice_id,
                // data: data,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $("#loading_match").hide();
                    if(data== 0)
                        global_notification('warning', 'Please Save Match first...');
                    else {
                        $('#agency_sel_rot_imported').select2({
                            minimumResultsForSearch: 10,
                            placeholder: 'Select one....',
                            //'allowClear':  true,
                        });
                        var html = '';
                        for(var ind in ws_secondary_agency_general)
                            html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                        $('#agency_sel_rot_imported').html(html);

                        $('#InvoiceRotationAnalysisManualTemp').modal('show');
                        $('#rec_standar').val(data);
                        $('#send_rotation_analysis_standar').show();
                        $('#send_rotation_analysis_standar_multiple').hide();
                        $('#InvoiceRotationAnalysisStandarTemp').modal('show');
                    }
                },
                error: function(xhr){
                    debug(xhr.responseText);
                }
            });

        }

    });
    $('#send_rotation_analysis_manual').on('click', function () {
        var invoice = 'manual' + $('#rec_manual').val();
        var separation = $('#separationmanual').val();
        var agency_selected = $('#agency_sel_rot_manual option:selected').val();
        var flag = '';
        $('.option_rotation_check_manual input[type=checkbox]').each(function () {
            if ($(this).prop('checked') == true) {
                if (flag == '') {
                    if ($(this).val() == 'horizontal')
                        flag = 'horitonzal';
                    else
                        flag = 'vertical';
                } else {
                    if ($(this).val() == 'horizontal')
                        flag += '_horitonzal';
                    else
                        flag += '_vertical';
                }
            }
        });
        var orientation = $("input:radio[name=orientation_type_rotation_manual]:checked").attr('value');
        if (flag !== '') {
            var link = document.createElement('a');
            link.href = '/download/invoices/rotation_analysis/min/' + separation + '/options/' + flag + '/orientation/' + orientation + '/inv/' + invoice + '/agency_selected/' + agency_selected + '/download';
            $(link).attr('target', '_blank');
            link.click();
            $('#InvoiceRotationAnalysisManualTemp').modal('hide');
        } else global_notification('warning', 'Please check at least one flag option...');

    });
    $('#send_rotation_analysis_standar').on('click', function () {
        var invoice=  'imported'+ $('#rec_standar').val();
        var separation= $('#separation').val();
        var flag='';
        var agency_selected = $('#agency_sel_rot_imported option:selected').val();
        $('.option_rotation_check input[type=checkbox]').each(function () {
            if($(this).prop('checked')== true){
                if(flag=='') {
                    if ($(this).val() == 'horizontal')
                        flag = 'horitonzal';
                    else
                        flag = 'vertical';
                }
                else{
                    if ($(this).val() == 'horizontal')
                        flag += '_horitonzal';
                    else
                        flag += '_vertical';
                }
            }
        });
        var orientation = $("input:radio[name=orientation_type_rotation_sta]:checked").attr('value');
        if(flag!='') {
            if(separation =='' )
                global_notification('warning', 'Please type a separation minutes for spots...');
            else {
                var link = document.createElement('a');
                link.href = '/download/invoices/rotation_analysis/min/' + separation + '/options/' + flag + '/orientation/' +orientation + '/inv/' + invoice + '/agency_selected/' + agency_selected +'/download';
                $(link).attr('target', '_blank');
                link.click();
            }
        }
        else global_notification('warning', 'Please check at least one flag option...');

    });

    //Spot Rotation  Manual
    var columnOrderDetailsRotationSpot = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Order Line",
            field: 'line',
            width: 100,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Start Time",
            field: 'start_time',
            width: 150,
            cellStyle: {'text-align': "right"},
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':');
                    var arr2 = timeB.split(':');

                    if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        },  {
            headerName: "End Time",
            field: 'end_time',
            width: 150,
            cellStyle: {'text-align': "right"},
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':');
                    var arr2 = timeB.split(':');

                    if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        }, {
            headerName: "Days",
            field: 'days',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Spot Matched",
            field: 'spot_matches',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Line Id",
            field: 'line_id',
            width: 100,
            hide: true,
            cellStyle: {'text-align': "right" }
        },

    ];
    var orderLinesSpotRotGrid = {
        columnDefs: columnOrderDetailsRotationSpot,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        //   groupSelectsChildren: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        }
    };
    $('#spot_rotation').on('click',  function () {
        show_overlay_loader($('#saveMachtModal .modal-content'));
        if (manual_or_imported == 0) {
            console.log("spot_rotation click 1");
            var rec_id = $(this).val();
            var type = 'manual';
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var lines = [];
                    $('#rec_number').val(rec_id);
                    $('#rec_type').val('manual');
                    $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' + data.camp);
                    $('#InfoOrder').html('<b>Order No: </b> ' + '  ' + data.order);
                    $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' + data.invoice_number);
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station);

                    for (var ind in data.lines) {
                        var row = {
                            line_id: data.lines[ind]['id'],
                            line: data.lines[ind]['order_line'],
                            start_time: data.lines[ind]['start_time'],
                            end_time: data.lines[ind]['end_time'],
                            days: data.lines[ind]['days'],
                            spot_matches: data.lines[ind]['spot'],
                        }
                        lines.push(row);
                    }
                    $('#orderLinesSpotRotGridGrid').html('');
                    orderLinesSpotRotGrid.rowData = lines;
                    var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                    var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                    hide_loader();
                    $('#spot_rotation_create').show();
                    $('#spot_rotation_create_multiple').hide();
                    $('#agency_sel_spot').select2({
                        minimumResultsForSearch: 10,
                        placeholder: 'Select one....',
                        //'allowClear':  true,
                    });
                    var html = '';
                    for(var ind in ws_secondary_agency_general)
                        html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                    $('#agency_sel_spot').html(html);

                    $('#OrderLinesSpot').modal('show');
                   hide_overlay_loader($('#saveMachtModal .modal-content'));
                },
                error: function (xhr) {
                    hide_overlay_loader($('#saveMachtModal .modal-content'));
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }else {
            var invoice_id = $(this).val();
            console.log("spot_rotation click 2");
            $("#loading_match").show();
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getTemp/' + invoice_id,
                //  data: data,
                dataType: 'json',
                encode: true,
                success: function (response) {
                    $("#loading_match").hide();
                    if (response == 0) {
                        global_notification('warning', 'Please Save Match first...');
                        hide_overlay_loader($('#saveMachtModal .modal-content'));
                    }else {
                        var rec_id = response;
                        var type = 'imported';
                        $('#rec_number').val(rec_id);
                        $('#rec_type').val(type);
                        $.ajax({
                            type: 'GET',
                            url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#rec_number').val(rec_id);
                                $('#rec_type').val('imported');
                                $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' + data.camp);
                                $('#InfoOrder').html('<b>Order No: </b> ' + '  ' + data.order);
                                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' + data.invoice_number);
                                $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station);
                                var lines = [];
                                for (var ind in data.lines) {
                                    var row = {
                                        line_id: data.lines[ind]['id'],
                                        line: data.lines[ind]['id'],
                                        start_time: data.lines[ind]['start_time'],
                                        end_time: data.lines[ind]['end_time'],
                                        days: data.lines[ind]['days'],
                                        spot_matches: data.lines[ind]['spot'],
                                    }
                                    lines.push(row);
                                }
                                $('#orderLinesSpotRotGridGrid').html('');
                                orderLinesSpotRotGrid.rowData = lines;
                                var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                                hide_overlay_loader('#saveMachtModal');
                                $('#spot_rotation_create').show();
                                $('#spot_rotation_create_multiple').hide();
                                $('#agency_sel_spot').select2({
                                    minimumResultsForSearch: 10,
                                    placeholder: 'Select one....',
                                    //'allowClear':  true,
                                });
                                var html = '';
                                for(var ind in ws_secondary_agency_general)
                                    html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                                $('#agency_sel_spot').html(html);

                                $('#OrderLinesSpot').modal('show');
                                hide_overlay_loader($('#saveMachtModal .modal-content'));
                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#saveMachtModal .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                },
                error: function (xhr) {
                    hide_overlay_loader($('#saveMachtModal .modal-content'));
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#spot_rotation_create').on('click', function(){
        var selectedNodes= orderLinesSpotRotGrid.api.getSelectedNodes();
        if(selectedNodes.length > 0) {
            show_loader();
            var params = {
                orientation : $("input:radio[name=orientation_type_spot_pattern_manual]:checked").attr('value'),
                match_id :  $('#rec_number').val(),
                invoice_type :  $('#rec_type').val(),
                lines_selected :  [],
                multiple :  false,
                agency_selected: $('#agency_sel_spot option:selected').val(),
            };
            for(var i in selectedNodes)
                params.lines_selected.push(selectedNodes[i].data.line);

            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/save/spotPattern/report',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var url = '/invoices/reconciliation/spotPatternNew/' + data.id + '/download';
                    window.open(url);
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_loader();
                }
            });

            //
            // var orient=  $("input:radio[name=orientation_type_spot_pattern_manual]:checked").attr('value');
            // var link = document.createElement('a');
            // link.href = '/invoices/reconciliation/spotRotationGraphTwo/orientation/'+ orient +'/' + $('#rec_number').val()+ '/' + lines_selected+ '/' + $('#rec_type').val()+ '/download';
            // console.log(link.href);
            // $(link).attr('target', '_blank');
            // link.click();

        }
        else
            global_notification('warning', 'Please select at leats one line ...');


    });

    //spot rotacion multiple
    $('#spot_rotation_multiple').on('click', function () {
        var match_m_id= $(this).val();
        show_overlay_loader($('#saveMachtModal .modal-content'));
        if(invoice_manual_multiple_match === false)
            var url = '/invoices/reconciliation/getOrderLines/rec/multiple/' + match_m_id;
        else
            var url = '/invoices/reconciliation/getOrderLines/rec/multiple/manual/' + match_m_id;
        console.log('url  ', url);
        $.ajax({
            type: 'GET',
            url: url ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('data ^^^^^^^^^^^^^^^^^^^^^^^^^^');
                console.log(data);
                $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' +data.camp.name);
                $('#InfoOrder').html('<b>Order No: </b> ' + '  ' +data.order.reference_number);
                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ------' );
                if(invoice_manual_multiple_match === false)
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station.name);
                else
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station);
                var lines=[];
                for(var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['id'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#orderLinesSpotRotGridGrid').html('');
                orderLinesSpotRotGrid.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                hide_loader();
                $('#spot_rotation_create').hide();
                $('#spot_rotation_create_multiple').val(match_m_id);
                $('#spot_rotation_create_multiple').show();
                $('#agency_sel_spot').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                    //'allowClear':  true,
                });
                var html = '';
                for(var ind in ws_secondary_agency_general)
                    html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                $('#agency_sel_spot').html(html);
                $('#OrderLinesSpot').modal('show');
                hide_overlay_loader($('#saveMachtModal .modal-content'));
            },
            error: function (xhr) {
                hide_overlay_loader($('#saveMachtModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });
    $('#spot_rotation_create_multiple').on('click', function(){
        var selectedNodes= orderLinesSpotRotGrid.api.getSelectedNodes();
        if(selectedNodes.length > 0) {
            show_loader();
            var params = {
                orientation : $("input:radio[name=orientation_type_spot_pattern_manual]:checked").attr('value'),
                match_id :  $(this).val(),
                invoice_type :  (invoice_manual_multiple_match === false) ? 'imported' : 'manual',
                lines_selected :  [],
                multiple :  true,
                agency_selected: $('#agency_sel_spot option:selected').val(),
            };
            for(var i in selectedNodes)
                params.lines_selected.push(selectedNodes[i].data.line);

            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/save/spotPattern/report',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var url = '/invoices/reconciliation/spotPatternNew/' + data.id + '/download';
                    window.open(url);
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_loader();
                }
            });

        }
        else
            global_notification('warning', 'Please select at leats one line ...');


    });

    function searchManaualInvOrder(inv_id, order_id, mult_match, row_id){
        $('#use_ordered_net_rate').attr('checked', false)
        mult_match = app_invoices_table.cell(row_id, 15).data();
        $('#row_id_to_change').val(row_id);
        $('#check_as_button_line').prop('checked', false);
        if(reset_filters_grid === true) {
            filter__array_to_keep = {};
            filter__array_to_keep_no_match = {};
        }
        reset_filters_grid  = true;
        inv_manual_id_rematch = inv_id;
        order_manual_id_rematch = order_id;
        mult_match_manual_id_rematch = mult_match;
        manual_grid_ready = true;
        if(mult_match > 0){
            $('#selectMatchTypeManual').modal('show');
            $('.confirm-see-multiple-manual').val(mult_match);
            $('.cancel-see-multiple-manual').val(mult_match);
            $('#inv-number-manual-to-see').val(inv_id);
            $('#order-rev-id-manual-to-see').val(order_id);
        }
        else {
            invoice_manual_multiple_match = false;
            manual_or_imported = 0;
            saved_data = true;
            array_manual_invoice_no_match_id = [];
            invoice_maul_select_all = 'manual';
            editing_row_imported_invo = false;
            $('#report_parents').attr('invoice-type', 0);
            $('#reports_temp').show();
            $('#reports_temp_multiple').hide();

            $('#order-details-verif').attr('data-order-id', order_id + '^^' + inv_id);
            $('#inv_sche_match').val(inv_id);
            $('#weekly_breakout').val(inv_id);
            $('#rotation_analysis').val(inv_id);
            $('#spot_rotation').val(inv_id);

            if (inv_id !== "") {
                $("#loading_loadingm").css("display", "block");
                init_progress_loader(2, "This operation could take a few seconds. Please wait ...");
                var rules = [];
                $('#rules_content input:checked').each(function () {
                    rules.push($(this).val());
                });

                var arr = {
                    'order_id': order_id,
                    'inv_id': inv_id,
                    'rules': rules
                };
                console.log(arr);
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    url: '/invoices/manual_match',
                    data: JSON.stringify(arr),
                    contentType: "application/json",
                    dataType: 'json',
                    encode: true,
                    success: function (data) {
                        if(data.invoice.bottom_line == 1)
                            $('#check_as_button_line').prop('checked', true);

                        console.log('data ', data);
                        $('#unmatchedrows').html('');
                        initializegridUnmatchOptions(true);

                        match_result = data;
                        $("#order_id").val(data.order_id);
                        $("#invoice_id").val(data.invoice_id);

                        $("#min_max_range_form #min_before_program").val(data.min_before_program)
                        $("#min_max_range_form #min_after_program").val(data.min_after_program)

                        $("#match_fdates").html(moment(match_result.invoice.month).format('MMM YYYY'));
                        var st = parseInt(data.order.trade) === 1 ? match_result.vendor.name + ' - Trade' : match_result.vendor.name;
                        if(typeof data.zone !== 'undefined' && data.zone !== false && match_result.invoice.invoice_num !== 'Multiple' && match_result.invoice.invoice_num !== 'multiple')
                            $("#match_station").html(st +' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Zone: '+ data.zone);
                        else
                            $("#match_station").html(st);
                        $("#match_inv_number_s").html(match_result.invoice.invoice_num);

                        $("#unmatchedrows").html("");
                        $("#orderlines").html("");

                        $("#saveMachtModal").modal('show');
                        $("#loading_loadingm").css("display", "none");
                        data_zone_inv = false;
                        drawManualNoMatchLines();
                        drawBuyLines();

                        $("#sel-order-line").hide();
                        $("#sel-line-matches").hide();
                        $("#orderlines").show();
                        $("#hide-matches").hide();
                        $("#display-matches").show();
                        $("#save-revised").show();
                        $("#save-revised-imported").hide();
                        // save_automatic = setInterval(callSave, 30000);
                        close_progress_loader();
                    },
                    error: function (xhr) {
                       // console.log("asdasdasdasd");
                        debug(xhr.responseText);
                        $("#loading_loadingm").css("display", "none");
                        close_progress_loader();
                    }
                });
            }
        }
    }

    $("#invoice-verif").on("click", function(){
        saved_data = true;
        array_manual_invoice_no_match_id=[];
        invoice_maul_select_all='manual';
        editing_row_imported_invo = false;
        $('#report_parents').attr('invoice-type', 0);
        $('#reports_temp').show();
        $('#reports_temp_multiple').hide();
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0){
            $('#hide_columns a').each(function () {
                if($(this).hasClass('hidden-column'))
                    $(this).removeClass('hidden-column');
            });
            sel = sel[0];
            var order_id = sel.data.order_num;
            $('#order-details-verif').attr('data-order-id', order_id+'^^'+sel.data.inv_id);
            var inv_id = sel.data.inv_id;

            $('#inv_sche_match').val(inv_id);
            $('#weekly_breakout').val(inv_id);
            $('#rotation_analysis').val(inv_id);
            $('#spot_rotation').val(inv_id);

            if(inv_id !== "") {
                $("#loading_loadingm").css("display", "block");
                init_progress_loader(2 , "This operation could take a few seconds. Please wait ...");
                var rules = [];
                $('#rules_content input:checked').each(function () {
                    rules.push($(this).val());
                });

                var arr = {
                    'order_id': order_id,
                    'inv_id': inv_id,
                    'rules': rules
                };
                console.log(arr);
                $.ajax({
                    type: 'POST',
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    url: '/invoices/manual_match',
                    data: JSON.stringify(arr),
                    contentType: "application/json",
                    dataType: 'json',
                    encode: true,
                    success: function (data) {
                        console.log(data);
                        $('#unmatchedrows').html('');
                        initializegridUnmatchOptions(true);

                        match_result = data;
                        $("#order_id").val(data.order_id);
                        $("#invoice_id").val(data.invoice_id);

                        $("#min_max_range_form #min_before_program").val(data.min_before_program)
                        $("#min_max_range_form #min_after_program").val(data.min_after_program)

                        $("#match_fdates").html(moment(match_result.invoice.month).format('MMM YYYY'));
                        var st = parseInt(data.order.trade) === 1 ? match_result.vendor.name + ' - Trade' : match_result.vendor.name;
                        if(typeof data.zone !== 'undefined' && data.zone !== false && match_result.invoice.invoice_num !== 'Multiple' && match_result.invoice.invoice_num !== 'multiple')
                            $("#match_station").html(st +' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Zone: '+ data.zone);
                        else
                            $("#match_station").html(st);
                        $("#match_inv_number_s").html(match_result.invoice.invoice_num);

                        $("#unmatchedrows").html("");
                        $("#orderlines").html("");

                        $("#saveMachtModal").modal('show');
                        $("#loading_loadingm").css("display", "none");

                        drawManualNoMatchLines();
                        drawBuyLines();

                        $("#sel-order-line").hide();
                        $("#sel-line-matches").hide();
                        $("#orderlines").show();
                        $("#hide-matches").hide();
                        $("#display-matches").show();
                        $("#save-revised").show();
                        $("#save-revised-imported").hide();
                        close_progress_loader();
                    },
                    error: function (xhr) {
                        debug(xhr.responseText);
                        $("#loading_loadingm").css("display", "none");
                        close_progress_loader();
                    }
                });
            }else{
                swal({
                        title: "Oops!",
                        text: "Please insert Invoice Header before entry items ...",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }

        }else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }
    });

    $("#total_spots_invoiced_totals_only").on('keyup', function(e){
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8 || e.keyCode == 46){
            var spot_diference= parseInt($("#total_spots_ordered_totals_only").val() - $(this).val());
            $('#total_spots_diference_totals_only').val(spot_diference);

            //Filling the Totals Invoiced
            var ads = $(this).val();
            ads = !isNaN(parseInt(ads)) ? parseInt(ads) : 0;
            $('#total_invoiced_ads_to').val(parseInt(totals_invoice_array_global.ads) + parseInt(ads)) ;
        }
    });
    $("#total_gross_invoiced_totals_only").on('keyup', function(e){
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8 || e.keyCode == 46){
            var xx= parseFloat($("#total_gross_invoiced_totals_only").val().replace(/,/g, ''));
            xx = isNaN(parseFloat(xx)) ? 0 : parseFloat(xx);
            var gross_diference= parseFloat($("#total_gross_ordered_totals_only").val() - xx);
            $('#total_gross_diference_totals_only').val(gross_diference.toFixed(2));

            //Change Net Fields
            var com = gridInvOrdOptions.api.getSelectedNodes()[0].data.commission;
            var gross = parseFloat($("#total_gross_invoiced_totals_only").val().replace(/,/g, ''));
            gross = isNaN(parseFloat(gross)) ? 0 : parseFloat(gross);
            var net = gross - ((gross * com) / 100);
            net = parseFloat(Number(Math.round(net + 'e2') + 'e-2') );
            $("#total_net_invoiced_totals_only").val(net.toFixed(2) );

            var xx= parseFloat($("#total_net_ordered_totals_only").val().replace(/,/g, ''));
            xx = isNaN(parseFloat(xx)) ? 0 : parseFloat(xx);
            var net_diference = parseFloat(xx - net);
            $('#total_net_diference_totals_only').val(net_diference.toFixed(2));


            //Filling the Totals Invoiced
            var tt_gross = parseFloat(totals_invoice_array_global.gross) + parseFloat(gross);
            $('#total_invoiced_gross_to').val(parseFloat(tt_gross).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;


            var tt_net = tt_gross - ((tt_gross * totals_invoice_array_global.com) / 100);
            tt_net = parseFloat(Number(Math.round(tt_net + 'e2') + 'e-2'));
            $('#total_invoiced_net_to').val(parseFloat(tt_net).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;
        }
    });
    $("#total_impressions_invoiced_totals_only").on('keyup', function(e){
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8 || e.keyCode == 46){
            var xx= (isNaN(parseFloat($("#total_impressions_invoiced_totals_only").val().replace(',', ''))))?0:parseFloat($("#total_impressions_invoiced_totals_only").val().replace(',', ''));
            var gross_diference= parseInt($("#total_impressions_ordered_totals_only").val() - xx);
            $('#total_impressions_diference_totals_only').val(gross_diference);
        }
    });
    $("#total_net_invoiced_totals_only").on('keyup', function(e){
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8 || e.keyCode == 46){
            var xx= parseFloat($("#total_net_invoiced_totals_only").val().replace(/,/g, ''));
            xx = isNaN(parseFloat(xx)) ? 0 : parseFloat(xx);
            var gross_diference= parseFloat($("#total_net_ordered_totals_only").val() - xx);
            $('#total_net_diference_totals_only').val(gross_diference.toFixed(2));


            //Change Net Fields
            var com = gridInvOrdOptions.api.getSelectedNodes()[0].data.commission;
            var net = parseFloat($("#total_net_invoiced_totals_only").val().replace(/,/g, ''));
            net = isNaN(parseFloat(net)) ? 0 : parseFloat(net);
            com = 100 - com;
            var gross = (net * 100) / com;
            gross = parseFloat(Number(Math.round(gross + 'e2') + 'e-2') );
            $("#total_gross_invoiced_totals_only").val(gross.toFixed(2) );

            var xx= parseFloat($("#total_gross_ordered_totals_only").val().replace(/,/g, ''));
            xx = isNaN(parseFloat(xx)) ? 0 : parseFloat(xx);

            var net = parseFloat($("#total_gross_invoiced_totals_only").val().replace(/,/g, ''));
            net = isNaN(parseFloat(net)) ? 0 : parseFloat(net);
            var net_diference = parseFloat(xx - net);
            $('#total_gross_diference_totals_only').val(net_diference.toFixed(2));

            //Filling the Totals Invoiced
            var tt_gross = parseFloat(totals_invoice_array_global.gross) + parseFloat(gross);
            $('#total_invoiced_gross_to').val(parseFloat(tt_gross).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;


            var tt_net = tt_gross - ((tt_gross * totals_invoice_array_global.com) / 100);
            tt_net = parseFloat(Number(Math.round(tt_net + 'e2') + 'e-2'));
            $('#total_invoiced_net_to').val(parseFloat(tt_net).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;
        }
    });


    $('#submit_invoice_entry_totals_only').on('click', function() {
        if ($('#inv_number_new').val() !== '' && $('#inv_date_new').val() !== "") {
            show_overlay_loader($('#invoiceItemsNew .modal-content'));
            var sel = gridInvOrdOptions.api.getSelectedNodes()[0];
            var params = {
                inv_number: $('#inv_number_new').val(),
                inv_comments:  $('#inv_comments').val(),
                inv_due_date: $('#inv_fiscal_date_new').val(),
                inv_date: $('#inv_date_new').val(),
                inv_zone: $('#inv_zone_new').val(),
                inv_id: sel.data.inv_id,
                inv_month: sel.data.month_year,
                inv_camp: sel.data.camp_id,
                rev_id: sel.data.order_num,
                total_gross: $("#total_gross_invoiced_totals_only").val(),
                total_spots: $("#total_spots_invoiced_totals_only").val(),
                total_impressions: $("#total_impressions_invoiced_totals_only").val(),
                bottom_line: $('.check_as_button_line_div input').is(':checked'),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: "/invoices/entries/totals-only/save-items",
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    changes_in_total_only_global = false;
                    changes_in_grid_global = false;
                    if (data.duplicated === true) {
                        $('#generalWarningModalDiv').html(sel.data.station +' already has an Invoice with this number. Please change the Invoice Number before saving.');
                        $('#generalWarningModal').modal('show');
                    } else {
                        $('#invoiceItemsNew').modal('hide');
                        var camp = $("#campaign_searchm option:selected").val();
                        var ven = $("#order_search_selectm option:selected").val();
                        displayOrdersInvoices(global_way_to_search_manual_invoices);
                        app_invoices_table.draw();
                    }
                    hide_overlay_loader($('#invoiceItemsNew .modal-content'));
                },
                error: function (xhr) {
                    hide_overlay_loader($('#invoiceItemsNew .modal-content'));
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        } else {
            $('#generalWarningModalDiv').html('Invoice Number and Invoice Date are required.');
            $('#generalWarningModal').modal('show');
        }
    });
    var columnsInvoiceEntryDetails = [
        {
            headerName: "Media Type",
            field: 'media_type',
            width: 80,
            editable: true,
            cellRenderer: StringFormatRenderer,
        },{
            headerName: "Date",
            field: 'date',
            width: 240,
        }, {
            headerName: "Station",
            field: 'station',
            width: 120,
            cellRenderer: StringFormatRenderer,
        }, {
            headerName: "Gross Cost",
            field: 'gross_cost',
            width: 120,
            cellRenderer: CurrencyFormatRenderer,
        }, {
            headerName: "Net Cost",
            field: 'net_cost',
            width: 80,
            cellRenderer: CurrencyFormatRenderer,
        }, {
            headerName: "Impression (000)",
            field: 'impressions',
            width: 120,
            cellRenderer: FloatFormatRenderer
        }, {
            headerName: "Ad Count",
            field: 'ad_count',
            width: 80,
            cellRenderer: IntegerFormatRenderer
        }
    ];
    function invoiceEntryDetailsPinnedInfo(params) {
        console.log('pinnedTopRowData: ', params);
        return [{
            media_type: '',
            date: '',
            station: '',
            gross_cost: '',
            net_cost: '',
            impressions: '',
            ad_count: ''
        }];
    }
    var gridInvoiceEntryDetails = {
        columnDefs: columnsInvoiceEntryDetails,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,
        defaultToolPanel: '',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        stopEditingWhenGridLosesFocus: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        // pinnedTopRowData: invoiceEntryDetailsPinnedInfo(params),
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: false,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        }
    };

    $('#invoice_entry_details').on('click', function () {
        $('#invoiceEntryDetails').html('');
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            show_overlay_loader($('#InvoEntryTotalsOnly .modal-content'));
            sel = sel[0];
            var params = {order_revision_id: sel.data.order_num, month: sel.data.month_year};
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/invoices/reconciliation/entry/details',
                dataType: "json",
                contentType: "application/json",
                success: function (dataX) {
                    let totalCost = 0;
                    let cost = 0;
                    let costNet = 0;
                    let totalAds = 0;
                    for (let i = 0; i < dataX.data.length; i++) {
                        if(dataX.data[i]['ad_count'] > 0) {
                            dataX.data[i]['station'] = sel.data.station;
                            totalCost += dataX.data[i]['gross_cost'] * (dataX.data[i]['ad_count'] === 0 ? 1 : dataX.data[i]['ad_count']);
                            cost += dataX.data[i]['gross_cost'];
                            costNet += dataX.data[i]['net_cost'];
                            totalAds += dataX.data[i]['ad_count'];
                        }
                    }
                    console.log('totalCost: ', totalCost);
                    gridInvoiceEntryDetails.rowData = dataX.data;
                    gridInvoiceEntryDetails.rowData = dataX.data.filter( elem => elem.ad_count > 0 );

                    var gridMatchDiv = document.querySelector('#invoiceEntryDetails');
                    var g4 = new agGrid.Grid(gridMatchDiv, gridInvoiceEntryDetails);
                    gridInvoiceEntryDetails.api.setPinnedTopRowData([{
                        media_type: '',
                        date: '',
                        station: '',
                        gross_cost: parseFloat(cost).toFixed(2),
                        net_cost: parseFloat(costNet).toFixed(2),
                        impressions: '',
                        ad_count: totalAds
                    }]);
                    // $('#invoiceEntryDetailsTotalCostText').text('$' + parseFloat(totalCost).toFixed(2));
                    $('#invoiceEntryDetailsModal').modal('show');
                    hide_overlay_loader($('#InvoEntryTotalsOnly .modal-content'));
                },
                error: function (xhr) {
                    debug(xhr.responseText);
                    hide_overlay_loader($('#InvoEntryTotalsOnly .modal-content'));
                }
            });
        }
    });
    var totals_invoice_array_global = {};
    var changes_in_total_only_global = false;
    var changes_in_grid_global = false;
    $('#invoiceItemsNew input').on('change', function(){
        changes_in_total_only_global = true;
    });

    $("#invoice-entry").on("click", function(){
        changes_in_total_only_global = false;
        changes_in_grid_global = false;
        var sel = typeof gridInvOrdOptions.api.getSelectedNodes()[0] !== 'undefined' ? gridInvOrdOptions.api.getSelectedNodes()[0] : [];
        if(typeof sel.data !== 'undefined') {
            $('#inv_new_take_selected').val(false);
            $("#inv_date_new").inputmask('mm/dd/yyyy', {
                "oncomplete": function () {
                    $(this).attr('data-completed', 'true');
                },
                "onincomplete": function () {
                    $(this).attr('data-completed', 'false');
                },
                showMaskOnHover: false
            });
            $("#inv_fiscal_date_new").inputmask('mm/dd/yyyy', {
                "oncomplete": function () {
                    $(this).attr('data-completed', 'true');
                },
                "onincomplete": function () {
                    $(this).attr('data-completed', 'false');
                },
                showMaskOnHover: false
            });

            //fill info inputs
            $('#items_market').val(sel.data.revision_market);
            $('#items_order_num').val(sel.data.old_reference_number +'       (Rev#: '+sel.data.revision_num+')');
            $('#items_order_num').removeClass('inv-text-decoration-class');
            $('#items_order_num').removeClass('inv-multi_market-class');
            if ( sel.data["line_through"] === 1)
                $('#items_order_num').addClass('inv-text-decoration-class');
            if (sel.data["multi_market"] === 1)
                $('#items_order_num').addClass('inv-multi_market-class');

            $('#items_station').val(sel.data.station);
            $('#items_month').val(sel.data.revision_month);

            $('#campaign_flight_date_start').val(sel.data.camp_start);
            $('#campaign_flight_date_end').val(sel.data.camp_end);
            var status = (sel.data.inv_status === "Archived") ? 'Yes <i style="margin-left:1%; text-decoration: bold" data-toggle="tooltip" data-animation="" class=" ti-help-alt tooltip-init" title="Archived invoices cannot be modified. To modify this invoice please activate it first"></i>' : 'No';
            $('.invoice_entry_archived_div').html('<h5><b>Archived: </b> ' + status + '  </h5>');

            totals_invoice_array_global = {ads: 0, gross: 0, com: sel.data.commission};
            gridInvOrdOptions.api.forEachNode(function (node) {
                console.log('node_node', node);
                if (parseInt(node.data.inv_id) !== parseInt(sel.data.inv_id) && parseInt(node.data.order_num) === parseInt(sel.data.order_num) && node.data.month_year === sel.data.month_year && node.data.revision_market === sel.data.revision_market) {
                    totals_invoice_array_global.ads += !isNaN(parseInt(node.data.spots_inv)) ? parseInt(node.data.spots_inv) : 0;
                    totals_invoice_array_global.gross += !isNaN(parseInt(node.data.schedule)) ? parseInt(node.data.schedule) : 0;
                }
            });
            //Filling editable inputs and show/hide bottom buttons
            if (sel.data.inv_id !== '') {
                $('#inv_number_new').val(sel.data.inv_num);
                $('#inv_zone_new').val(sel.data.inv_zone);
                $('#inv_comments').val(sel.data.inv_comments);
                $('#inv_date_new').val(moment(sel.data.inv_date).format('Y-MM-DD'));
                $('#inv_fiscal_date_new').val(moment(sel.data.inv_due_date).format('Y-MM-DD'));
                $('#inv_add_new_new').show();
            } else {
                $('#inv_number_new').val('');
                $('#inv_comments').val('');
                $('#inv_date_new').val('');
                $('#inv_zone_new').val('');
                $('#inv_number_new').val('');
                $('#inv_add_new_new').hide();
            }

            //Fill totals only button
            if (sel.data.totals_only === 1 || sel.data.type === "no_broadcast") {
                $('.div_totals_only input').prop('checked', true);
                $('.div_totals_only input').prop('disabled', true);
            } else if (sel.data.inv_id === '' && sel.data.type === "broadcast") {
                $('.div_totals_only input').prop('checked', false);
                $('.div_totals_only input').prop('disabled', false);
            } else {
                $('.div_totals_only input').prop('checked', false);
                $('.div_totals_only input').prop('disabled', true);
            }
            change_totals_only(sel);
            if (sel.data.media_type === 'tv')
                gridNewItemOptions.columnDefs[7].editable = true;
            else
                gridNewItemOptions.columnDefs[7].editable = false;
            console.log('data grid', gridNewItemOptions.columnDefs);
            //Filling the lines
            if (sel.data.inv_id !== '') {
                if (sel.data.totals_only !== 1 ) {
                    $('.check_as_button_line_div input').prop('checked', false);
                    $.ajax({
                        type: 'GET',
                        url: '/invoices/get-invoice-lines/invoice/' + sel.data.inv_id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            console.log('data:', data);
                            console.log('se data:', sel.data);
                            var spots = 0;
                            var rate = 0;
                            gridNewItemOptions.rowData = [];
                            for (var i in data.lines) {
                                var aux = data.lines[i].run_date.split("-");
                                gridNewItemOptions.rowData.push({
                                    int_id: data.lines[i].id,
                                    date: aux[1] + "/" + aux[2] + "/" + aux[0],
                                    dow: data.lines[i].day_of_week,
                                    time: data.lines[i].run_time.replace(' ', '').replace('M', ''),
                                    type: data.lines[i].type,
                                    length: data.lines[i].length,
                                    rate: data.lines[i].rate,
                                    remarks: data.lines[i].remarks,
                                    commercial_id: data.lines[i].commercial_id,
                                    network: data.lines[i].network !== null ? data.lines[i].network : '',
                                    cable: data.lines[i].cable,
                                });
                                spots++;
                                rate += (!isNaN(parseFloat(data.lines[i].rate))) ? parseFloat(data.lines[i].rate) : 0;
                            }

                            $("#items_inv_spots").val(spots);
                            $("#items_inv_rate").val(rate.toFixed(2));

                            $('#newItemsGrid').html("");
                            var gridMatchDiv = document.querySelector('#newItemsGrid');
                            var g4 = new agGrid.Grid(gridMatchDiv, gridNewItemOptions);

                        },
                        error: function (xhr) {
                            hide_loader();
                            debug(xhr.responseText);
                        }
                    });
                } else {
                    if (sel.data.bottom_line === 1)
                        $('.check_as_button_line_div input').prop('checked', true);
                    else
                        $('.check_as_button_line_div input').prop('checked', false);

                    //Filling current invoice data (bottom div)
                    $("#total_spots_invoiced_totals_only").val(sel.data.spots_inv);
                    $("#total_gross_invoiced_totals_only").val(sel.data.schedule);
                    var com = sel.data.commission;
                    var gross_invoice = sel.data.schedule;
                    var net_invoice = gross_invoice - ((gross_invoice * com) / 100);
                    net_invoice = parseFloat(Number(Math.round(net_invoice + 'e2') + 'e-2'));
                    $("#total_net_invoiced_totals_only").val(net_invoice.toFixed(2));

                    var spot_diference = parseInt(sel.data.spots - sel.data.spots_inv);
                    var gross_diference = parseFloat(sel.data.gross_cpa - sel.data.schedule).toFixed(2);
                    var net_diference = parseFloat(sel.data.net_cpa - net_invoice).toFixed(2);
                    $('#total_spots_diference_totals_only').val(spot_diference);
                    $('#total_gross_diference_totals_only').val(gross_diference);
                    $('#total_net_diference_totals_only').val(net_diference);

                    if (sel.data.media_type === 'digital') {
                        $('#total_impressions_digital_only_div').show();
                        $("#total_impressions_invoiced_totals_only").val(sel.data.impressions_invoiced);
                        $("#total_impressions_ordered_totals_only").val(sel.data.impressions_ordered);
                        var imp_diference = parseInt(sel.data.impressions_ordered - sel.data.impressions_invoiced);
                        $('#total_impressions_diference_totals_only').val(imp_diference);
                    } else {
                        $('#total_impressions_digital_only_div').hide();
                        $("#total_impressions_invoiced_totals_only").val(0);
                        $("#total_impressions_ordered_totals_only").val(0);
                        $('#total_impressions_diference_totals_only').val(0);
                    }

                    //  Filling the totals when invoice is already added (top div)
                    var ads = !isNaN(parseInt(sel.data.spots_inv)) ? parseInt(sel.data.spots_inv) : 0;
                    $('#total_invoiced_ads_to').val(parseInt(totals_invoice_array_global.ads) + parseInt(ads));

                    var gross = !isNaN(parseFloat(sel.data.schedule)) ? parseFloat(sel.data.schedule) : 0;
                    var tt_gross = parseFloat(totals_invoice_array_global.gross) + parseFloat(gross);
                    $('#total_invoiced_gross_to').val(parseFloat(tt_gross).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }));

                    var tt_net = tt_gross - ((tt_gross * totals_invoice_array_global.com) / 100);
                    tt_net = parseFloat(Number(Math.round(tt_net + 'e2') + 'e-2'));
                    $('#total_invoiced_net_to').val(parseFloat(tt_net).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }));

                }
            }
            else{
                $("#total_spots_invoiced_totals_only").val(0);
                $("#total_gross_invoiced_totals_only").val(0.0);
                $("#total_net_invoiced_totals_only").val(0.0);
                if(sel.data.type === "no_broadcast")
                    $('.check_as_button_line_div input').prop('checked', true);
            }
            $('#invoiceItemsNew').modal({backdrop: 'static', keyboard: false})
            $('#invoiceItemsNew').modal('show');
        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }

    });

    $('#totals_only').on('change', function (){
        var sel = typeof gridInvOrdOptions.api.getSelectedNodes()[0] !== 'undefined' ? gridInvOrdOptions.api.getSelectedNodes()[0] : [];
        change_totals_only(sel);
    });
    function show_invoice_entry_button(sel){
        $('#invoice_entry_details').hide();
        $('#invoice_entry_details').attr('disabled', false)
        $('#submit_invoice_entry_totals_only').hide();
        $('#submit_invoice_entry_totals_only').attr('disabled', false)
        $('#inv_save_items').attr('disabled', false)
        $('#inv_add_item').hide();
        $('#inv_remove_items').hide();
        $('#inv_save_items').hide();
        $('#inv_add_new').hide();
        if(sel.data.type === "no_broadcast" )
            $('#invoice_entry_details').show();

        if((/*sel.data.totals_only === 1 ||  sel.data.type === "no_broadcast" ||*/ $('#totals_only').is(':checked')) ) {
            $('#submit_invoice_entry_totals_only').show();
            if(sel.data.inv_status === "Archived")
                $('#submit_invoice_entry_totals_only').attr('disabled', true);
        }

        if((/*sel.data.totals_only === 0 &&*/ !$('#totals_only').is(':checked')) ) {
            $('#inv_add_item').show();
            $('#inv_remove_items').show();
            $('#inv_save_items').show();
            if(sel.data.inv_status === "Archived")
                $('#inv_save_items').attr('disabled', true)
        }
        if(sel.data.inv_id !== '')
            $('#inv_add_new').show();

    }
    function change_totals_only(sel){
        show_invoice_entry_button(sel);
        console.log('sel_sel change_totals_only', sel.data);
        if ($('#totals_only').is(':checked')) {
            if(enviroment_bk === true && parseInt(sel.data.bookend) === 1){
                $('#check_as_button_line_new').prop('checked', true);
                $('#check_as_button_line_new').prop('disabled', 'disabled');
            }
            $('#broadcast_info_div').hide();
            $('#no_broadcast_info_div').show();
            $('#newItemsGrid_div').hide();
            $('#newItemnsInvTotalsOnlyDIv').show();

            //Filling the Totals Invoiced Non-Broadcast
            var ads = !isNaN(parseInt(sel.data.spots_inv)) ? parseInt(sel.data.spots_inv) : 0;
            $('#total_invoiced_ads_to').val(parseInt(totals_invoice_array_global.ads) + parseInt(ads)) ;
            var gross = !isNaN(parseFloat(sel.data.schedule)) ? parseFloat(sel.data.schedule) : 0;
            var tt_gross = parseFloat(totals_invoice_array_global.gross) + parseFloat(gross);
            $('#total_invoiced_gross_to').val(parseFloat(tt_gross).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;
            var tt_net = tt_gross - ((tt_gross * totals_invoice_array_global.com) / 100);
            tt_net = parseFloat(Number(Math.round(tt_net + 'e2') + 'e-2'));
            $('#total_invoiced_net_to').val(parseFloat(tt_net).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;

            //filling main div for totals only values
            $("#total_spots_ordered_totals_only").val(sel.data.spots);
            $("#total_gross_ordered_totals_only").val(sel.data.gross_cpa);
            $("#total_net_ordered_totals_only").val(sel.data.net_cpa);
            $('#total_spots_diference_totals_only').val(0);
            $('#total_gross_diference_totals_only').val(0);
            $('#total_net_diference_totals_only').val(0);
            if(sel.data.media_type === 'digital') {
                $('#total_impressions_digital_only_div').show();
                $("#total_impressions_invoiced_totals_only").val(0);
                $("#total_impressions_ordered_totals_only").val(sel.data.impressions_ordered);
                $('#total_impressions_diference_totals_only').val(0);
            }
            else {
                $('#total_impressions_digital_only_div').hide();
                $('#total_impressions_invoiced_totals_only').val(0);
                $('#total_impressions_ordered_totals_only').val(0);
                $('#total_impressions_diference_totals_only').val(0);
            }
            $('.newItemsGrid_div').hide();
            $('.newItemnsInvTotalsOnlyDIv').show();
            $('.invoice_totals_only_commissions').html('<h5><b>Commission: ' + parseFloat(Number(Math.round(sel.data.commission + 'e2') + 'e-2')) + '%</b></h5>');
            $('.invoice_totals_only_commissions').show();
            $('.check_as_button_line_div').show();
            $('.div_totals_only').attr('style', '');
            $('.enter_invoice_line_or_totals_div').html('<h4>Enter Invoice Totals</h4>');


        }
        else{
            if(enviroment_bk === true && parseInt(sel.data.bookend) === 1){
                $('#check_as_button_line_new').prop('checked', false);
                $('#check_as_button_line_new').prop('disabled', false);
            }

            grid_in_procces = gridNewItemOptions;
            $('#broadcast_info_div').show();
            $('#no_broadcast_info_div').hide();
            $('#newItemsGrid_div').show();
            $('#newItemnsInvTotalsOnlyDIv').hide();
            //Filling the totals for Broadcast
            $("#items_order_spots").val(sel.data.spots);
            $("#items_order_rate").val(sel.data.gross_cpa);
            $("#items_inv_spots").val(sel.data.spots_inv);
            $("#items_inv_rate").val(sel.data.schedule);
            var ads = !isNaN(parseInt(sel.data.spots_inv)) ? parseInt(sel.data.spots_inv) : 0;
            $('#items_inv_spots_total').val(parseInt(totals_invoice_array_global.ads) + parseInt(ads)) ;

            var gross = !isNaN(parseFloat(sel.data.schedule)) ? parseFloat(sel.data.schedule) : 0;
            var tt_gross = parseFloat(totals_invoice_array_global.gross) + parseFloat(gross);
            $('#items_inv_gross_total').val(parseFloat(tt_gross).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            })) ;
            //initializing the grid
            gridNewItemOptions.rowData = [];
            $('#newItemsGrid').html("");
            var gridMatchDiv = document.querySelector('#newItemsGrid');
            var g4 = new agGrid.Grid(gridMatchDiv, gridNewItemOptions);
            $('.newItemsGrid_div').show();
            $('.newItemnsInvTotalsOnlyDIv').hide();
            $('.invoice_totals_only_commissions').html('');
            $('.invoice_totals_only_commissions').hide();
            $('.check_as_button_line_div').hide();
            $('.div_totals_only').attr('style', 'margin-bottom: 1%');
            $('.enter_invoice_line_or_totals_div').html('<h4>Enter Invoice Lines</h4>');
        }
    }

    var add_new_invoice_sel_array = [];
    $('#inv_add_new_new').on('click', function (){
        if(changes_in_total_only_global === false && changes_in_grid_global === false)
            add_new_invoice_function();
        else {
            swal({
                    title: "Warning",
                    text: "You have pending changes. Are you sure you want to navigate away?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm)
                        add_new_invoice_function()
                });
        }
    });
    function add_new_invoice_function(){
        changes_in_total_only_global = false;
        changes_in_grid_global = false;
        var sel = gridInvOrdOptions.api.getSelectedNodes()[0];
        var totals = {};
        if(sel.data.type === "no_broadcast") {
            $('#totals_only').attr('checked', true);
            $('#totals_only').prop('disabled', true);
            $('.check_as_button_line_div input').prop('checked', false);
            $('.check_as_button_line_div').show();
            $('.invoice_totals_only_commissions').show();
            $('#submit_invoice_entry_totals_only').prop('disabled', false);
            totals = {
                total_invoiced_ads_to : $('#total_invoiced_ads_to').val(),
                total_invoiced_gross_to : $('#total_invoiced_gross_to').val(),
                total_invoiced_net_to : $('#total_invoiced_net_to').val(),
            }
        }
        else {
            $('#totals_only').attr('checked', false);
            $('#totals_only').prop('disabled', false);
            $('.check_as_button_line_div').hide();
            $('.invoice_totals_only_commissions').hide();
            $('#inv_save_items').prop('disabled', false);
            totals = {
                items_inv_spots : $('#items_inv_spots_total').val(),
                items_inv_gross_total : $('#items_inv_gross_total').val(),
            }
        }

        $('#inv_number_new').val('');
        $('#inv_comments').val('');
        $('#inv_date_new').val('');
        $('#inv_zone_new').val('');
        $('#inv_fiscal_date_new').val('');
        $('#total_spots_invoiced_totals_only').val(0);
        $('#total_impressions_digital_only_div').val(0);
        $('#total_gross_invoiced_totals_only').val(0);
        $('#total_net_invoiced_totals_only').val(0);

        //add a new row to the MAIN grid
        var new_line = $.extend({}, sel['data']);
        new_line.inv_id = '';
        new_line.inv_num = '';
        new_line.inv_due_date = '';
        new_line.inv_date = '';
        new_line.matched_saved = 0;
        new_line.bottom_line = 0;
        new_line.impressions_invoiced = 0;
        new_line.inv_status = "Active";
        new_line.matched_saved = 0;
        new_line.spots_inv = 0;
        new_line.spot_static = false;
        new_line.schedule = 0;
        new_line.attachments = 'No';
        new_line.totals_only = $('#totals_only').is(':checked') ? 1 : 0;
        new_line.int_id = '-';
        var index = gridInvOrdOptions.api.getModel().rowsToDisplay.length;
        var new_index = index + 1;
        gridInvOrdOptions.api.updateRowData({add: [new_line], addIndex: new_index});
        gridInvOrdOptions.api.ensureIndexVisible(sel.rowIndex);
        gridInvOrdOptions.api.clearFocusedCell();
        gridInvOrdOptions.api.setFocusedCell(new_index, 'reference_number', null);

        gridInvOrdOptions.api.forEachNode(function (node) {
            if(node.data.int_id === '-' ) {
                node.setSelected(true);
                change_totals_only(node);
            }
        });
        $('.invoice_entry_archived_div').html('<h5><b>Archived: </b> No </h5>');
        if(sel.data.type === "no_broadcast") {
            $('.check_as_button_line_div input').prop('checked', false);
            $('.check_as_button_line_div').show();
            $('.invoice_totals_only_commissions').show();
            $('#total_invoiced_ads_to').val(totals.total_invoiced_ads_to);
            $('#total_invoiced_gross_to').val(totals.total_invoiced_gross_to);
            $('#total_invoiced_net_to').val(totals.total_invoiced_net_to);
        }
        else {
            $('.check_as_button_line_div').hide();
            $('.invoice_totals_only_commissions').hide();
            $('#items_inv_spots_total').val(totals.items_inv_spots)
            $('#items_inv_gross_total').val(totals.items_inv_gross_total)
        }
        $('#inv_add_new_new').hide();
    }
    $("#save-revised").on("click", function() {
        var bk = false;
        if(enviroment_bk === true && !$('#check_as_button_line').is(':checked')) {
            for (var line_id in match_result['match']) {
                for (var week_id in match_result['match'][line_id]) {
                    for (var ind in match_result['match'][line_id][week_id]) {
                        if (typeof match_result['match'][line_id][week_id][ind]['bookend'] !== 'undefined' && parseInt(match_result['match'][line_id][week_id][ind]['bookend']) === 1) {
                            bk = true;
                            console.log('enviroment_bk_enviroment_bk_ ', bk)
                            break;
                        }
                    }
                    if (bk === true)
                        break
                }
                if (bk === true)
                    break
            }
        }
        console.log('enviroment_bk_enviroment_bk_ ', bk)
        if(bk === true){
            swal({
                    title: "Warning!",
                    text: "This Invoice contains Bookend Spots, \n it will be save like BLI (WMJ Users Only).",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $('#check_as_button_line').prop('checked', true)
                        call_save_manual(false);
                    }
                });
        }
        else
            call_save_manual(false);
    });
    //save match imported invoices
    $("#save-revised-imported").on("click", function() {
        var bk = false;
        if(enviroment_bk === true && !$('#check_as_button_line').is(':checked')) {
            for (var line_id in match_result['match']) {
                for (var week_id in match_result['match'][line_id]) {
                    for (var ind in match_result['match'][line_id][week_id]) {
                        if (typeof match_result['match'][line_id][week_id][ind]['bookend'] !== 'undefined' && parseInt(match_result['match'][line_id][week_id][ind]['bookend']) === 1) {
                            bk = true;
                            console.log('enviroment_bk_enviroment_bk_ ', bk)
                            break;
                        }
                    }
                    if (bk === true)
                        break
                }
                if (bk === true)
                    break
            }
        }
        console.log('enviroment_bk_enviroment_bk_ ', bk)
        if(bk === true){
            swal({
                    title: "Warning!",
                    text: "This Invoice contains Bookend Spots, \n it will be save like BLI (WMJ Users Only).",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $('#check_as_button_line').prop('checked', true)
                        call_save_imported(false);
                    }
                });
        }
        else
            call_save_imported(false);
    });

    //Copy Invoice
    $('#copy-invoice').on('click', function (e) {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            if(sel[0].data.inv_id !==''){
                $('#adv_copy_invoice').select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 5
                });
                $('#camp_copy_invoice').select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 5
                });
                $('#vendor_copy_invoice').select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 5
                });
                $('#CopyInvoiceOtherCamp').modal('show');
            }
            else {
                $('#generalWarningModalDiv').html('The selected line has no Invoice to copy.');
                $('#generalWarningModal').modal('show');
            }
        }
        else {
            $('#generalWarningModalDiv').html('Please select one Invoice.');
            $('#generalWarningModal').modal('show');
        }
    });
    $('#adv_copy_invoice').on('change', function (e) {
        var adv= $("#adv_copy_invoice option:selected").val();
        show_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));

        $.ajax({
            type: 'GET',
            url: '/invoices/search_campaign/' + adv,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': '', 'title': ''});
                $.each(data.campaigns, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name, 'title': value.name});
                });

                advertisers.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
                var adv_new= $('#camp_copy_invoice');
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select one...",
                });
                $('#vendor_copy_invoice').html('');
                hide_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                hide_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
            }
        });

    });
    $('#camp_copy_invoice').on('change', function(e){
        show_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
        var camp= $("#camp_copy_invoice option:selected").val();
        $.ajax({
            type: 'GET',
            url: '/invoices/search_order_invoice_copy/tab/' + camp,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name+'    (Order#: '+ value.reference_number+')'});
                });

                advertisers.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
                var adv_new= $('#vendor_copy_invoice');
                if ($(adv_new).data('select2')) {
                    adv_new.select2('destroy');
                }
                adv_new.html('').select2({
                    'data': advertisers,
                    placeholder: "Select one..."
                });
                hide_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));

            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                hide_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
            }
        });
    });
    $('#submit_copy_invoice').on('click', function(){
        var order= $('#vendor_copy_invoice option:selected').val();
        if(typeof order !== 'undefined' && order !== ''){
            var sel = gridInvOrdOptions.api.getSelectedNodes();
            if(sel.length > 0) {
                if (sel[0].data.inv_id !== '') {
                    show_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
                    $.ajax({
                        type: 'GET',
                        url: '/invoices/copy_invoice/another_campaign/' + order+ '/'+sel[0].data.inv_id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            hide_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
                            $('#orders-invoices').html("");
                            gridInvOrdOptions.rowData = [];
                            var gridMatchDiv = document.querySelector('#orders-invoices');
                            var g4 = new agGrid.Grid(gridMatchDiv, gridInvOrdOptions);
                            global_notification('success', 'Invoice Copied...');
                            displayOrdersInvoices(global_way_to_search_manual_invoices);
                            $('#CopyInvoiceOtherCamp').modal('hide');

                        },
                        error: function (xhr) {
                            hide_loader();
                            debug(xhr.responseText);
                            hide_overlay_loader($('#CopyInvoiceOtherCamp .modal-content'));
                        }
                    });
                }
            }
        }
        else
            global_notification('warning', 'Please select one Order...');
    });

    function scheduleMatch(id){
        $('#show_sche_match_tt_hidden').val(id);
        $('#agency_sel_tot_only').select2({
            minimumResultsForSearch: 10,
            placeholder: 'Select one....',
        });
        var html = '';
        for(var ind in ws_secondary_agency_general)
            html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
        $('#agency_sel_tot_only').html(html);
        $('#InvScheMatchTotalOnlyModal').modal('show');

        // var link = document.createElement('a');
        // link.href = "/invoices/reconciliation/schedule/totals/only/" + id + "/download";
        // $(link).attr('target', '_blank');
        // link.click();


    }
    $('#show_sche_match_tt').on('click', function(){
        var id =  $('#show_sche_match_tt_hidden').val();
        var agency_selected = $('#agency_sel_tot_only').val();
        var link = document.createElement('a');
        link.href = "/invoices/reconciliation/schedule/totals/only/" + id + "/agency_selected/"+ agency_selected +"/download";
        $(link).attr('target', '_blank');
        link.click();
    });

    //Inv Schedule Matching Totals only
    $('#invoice-total-report').on('click', function (e){
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            var id = sel[0].data.inv_id;
            var link = document.createElement('a');
            link.href = "/invoices/reconciliation/schedule/totals/only/" + id + "/download";
            $(link).attr('target', '_blank');
            link.click();
        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }

    });

    $('#invoice-total-archive').on('click', function (e) {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if (sel.length > 0) {
            swal({
                    title: "Warning!",
                    text: "Are you sure to archive? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var id = sel[0].data.inv_id;
                        show_overlay_loader($('#invoiceEntry .modal-content'));
                        $.ajax({
                            type: 'GET',
                            url: '/invoices/manual/totalsonly/archive/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                hide_overlay_loader($('#invoiceEntry .modal-content'));
                                global_notification('success', 'Invoice archived...');
                                $('#seacrh-order-invoice-manual').click();
                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#invoiceEntry .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });
                    }

                });
        } else {
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }
    });

    $('#order-details-verif').on('click', function (e) {
        var sel= $(this).attr('data-order-id');
        console.log('sel_sel_sel_sel sel ', sel);
        show_overlay_loader($('#saveMachtModal .modal-content'));
        $.ajax({
            type: 'GET',
            url: '/invoices/verification/orderdetails/' + sel ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('.podcast_sec_div').hide();
                console.log('orderdetails', data);
                $('#order_camp_detail').val(data.revision.camp_name);
                var v_name = parseInt(data.revision.trade) === 1 ? data.revision.vendor_name + ' - Trade' : data.revision.vendor_name;
                $('#order_station_detail').val(v_name);

                $('#order_number_detail').val(data.revision.reference_number);
                $('#order_number_detail').removeClass('inv-text-decoration-class');
                $('#order_number_detail').removeClass('inv-multi_market-class');
                if ( data.revision["line_through"] === 1)
                    $('#order_number_detail').addClass('inv-text-decoration-class');
                if (data.revision["multi_market"] === 1)
                    $('#order_number_detail').addClass('inv-multi_market-class');

                $('#order_revision_detail').val(data.revision.revision_number);
                $('#order_details_spots').val(data.spots);
                $('#order_detail_rate').val('$'+ data.total_cost);
                var  weeks = [];
                for(var ind in data.weeks) {
                    var index = moment(data.weeks[ind]).format('MM/DD');
                    weeks.push(index);
                    columnOrderDetailsVeri.push({
                        headerName: index,
                        field: index,
                        width: 100,
                        cellClassRules: {
                            'ag-cell-color-background': function (params) {
                                var index_x = params.colDef.field;
                                if (typeof params.data[index_x] !== 'undefined' && isNaN((params.data[index_x])))
                                    return true;
                                return false;
                            }
                        },
                        cellRenderer: function (params){
                            this.eGui = document.createElement('div');
                            $(this.eGui).css('text-align', 'center');
                            this.eGui.innerHTML  = params.value;
                            if(typeof params.value !== 'undefined') {
                                if (params.colDef.field.indexOf('/') !== -1 && typeof params.data.spot_by_day !== 'undefined') {
                                    var index = params.colDef.field;
                                    if (typeof params.data[index + '_spots_by_day'] !== 'undefined' && (params.data[index + '_spots_by_day'] === true || params.data[index + '_spots_by_day'] === 1)) {
                                        var new_value = params.value.split('  ');
                                        this.eGui.innerHTML = new_value[0];
                                        this.eGui.innerHTML += '*';
                                        this.eGui.style.fontStyle = "italic";
                                        this.eGui.style['font-weight'] = '800';
                                        this.eGui.innerHTML += typeof new_value[1] !== 'undefined' ? ('  '+ new_value[1]) : '';
                                    }
                                }
                            }
                            else
                                this.eGui.innerHTML = 0;
                            return this.eGui;
                        },
                    });
                }

                columnOrderDetailsVeri.push({
                    headerName: 'Total Spots',
                    field: 'total_spots',
                    width: 100,
                }, {
                    headerName: 'Gross Cost',
                    field: 'gross_cost',
                    width: 100,
                },{
                    headerName: 'Net Cost',
                    field: 'net_cost',
                    width: 100,
                });

                var gridOrderDetails = {
                    columnDefs: columnOrderDetailsVeri,
                    defaultColDef: {
                        suppressToolPanel: true
                    },
                    toolPanelSuppressValues: true,defaultToolPanel: '',
                    rowSelection: 'single',
                    suppressRowClickSelection: false,
                    enableColResize: true,
                    //suppressMenuColumnPanel: true,
                    suppressTouch: true,
                    headerHeight: 20,
                    suppressDragLeaveHidesColumns: true,
                    enableCellChangeFlash: true,
                    rowHeight: 20,
                    suppressRowHoverClass: true,
                    suppressParentsInRowNodes: true,
                    toolPanelSuppressValues: true,
                    toolPanelSuppressRowGroups: true,
                    groupUseEntireRow: false,
                    groupDefaultExpanded: 1,
                    marryChildren: true,
                    suppressAggFuncInHeader: true,
                    enableFilter: true,
                    enableSorting: true,
                    animateRows: true,
                    icons: {
                        groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                        groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                        menu: '<i class="fa fa-bars fa-lg"/>',
                        sortAscending: '<i class="fa fa-caret-down"/>',
                        sortDescending: '<i class="fa fa-caret-up"/>',
                        columnMoveMove: '<i class="fa fa-arrows"></i>',
                        columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                        columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                        columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                        columnMoveHide: '<i class="fa fa-remove"/>'
                    }
                };
                var lines =[];

                if(typeof(data.values['Radio']) !== 'undefined'){
                    for(var ind in data.values['Radio']){
                        var row = {
                            media: 'Radio',
                            time_period: data.values['Radio'][ind].time_period,
                            days: data.values['Radio'][ind].days,
                            daypart: data.values['Radio'][ind].daypart,
                            gross_cpa: data.values['Radio'][ind].gross_cpa,
                            net_cpa: data.values['Radio'][ind].net_cpa,
                            total_spots: data.values['Radio'][ind].total_spot,
                            gross_cost: data.values['Radio'][ind].gross_cost,
                            net_cost: data.values['Radio'][ind].net_cost,
                            length: data.values['Radio'][ind].length,
                            tiered: data.values['Radio'][ind].tiered,
                            spot_by_day: data.values['Radio'][ind].spot_by_day,
                            program: data.values['Radio'][ind].program,
                            line_number: typeof match_result['olines'][data.values['Radio'][ind].order_line_id] !== 'undefined' ? match_result['olines'][data.values['Radio'][ind].order_line_id].line_number : 0,
                        }
                        for(var x in weeks){
                            var d= weeks[x];
                            row[d] = data.values['Radio'][ind][d];
                            if(typeof data.values['Radio'][ind][d+'_spots_by_day'] !== 'undefined')
                                row[d+'_spots_by_day'] = data.values['Radio'][ind][d+'_spots_by_day'] = true;
                        }
                        lines.push(row);
                    }
                }
                if(typeof(data.values['Television']) !== 'undefined') {
                    for (var ind in data.values['Television']) {
                        var row = {
                            media: 'Television',
                            time_period: data.values['Television'][ind].time_period,
                            days: data.values['Television'][ind].days,
                            daypart: data.values['Television'][ind].daypart,
                            gross_cpa: data.values['Television'][ind].gross_cpa,
                            net_cpa: data.values['Television'][ind].net_cpa,
                            total_spots: data.values['Television'][ind].total_spot,
                            gross_cost: data.values['Television'][ind].gross_cost,
                            net_cost: data.values['Television'][ind].net_cost,
                            length: data.values['Television'][ind].length,
                            tiered: data.values['Television'][ind].tiered,
                            spot_by_day: data.values['Television'][ind].spot_by_day,
                            program: data.values['Television'][ind].program,
                            line_number: typeof match_result['olines'][data.values['Television'][ind].order_line_id] !== 'undefined' ? match_result['olines'][data.values['Television'][ind].order_line_id].line_number : 0,
                        }
                        for(var x in weeks){
                            var d= weeks[x];
                            row[d] = data.values['Television'][ind][d];
                            if(typeof data.values['Television'][ind][d+'_spots_by_day'] !== 'undefined')
                                row[d+'_spots_by_day'] = data.values['Television'][ind][d+'_spots_by_day'] = true;
                        }
                        lines.push(row);
                    }
                }
                $('#orderDetailsGridGrid').html('');
                gridOrderDetails.rowData = lines;
                var gridDet = document.querySelector('#orderDetailsGridGrid');
                var g4 = new agGrid.Grid(gridDet, gridOrderDetails);
                hide_overlay_loader($('#saveMachtModal .modal-content'));
                $('#OrderItems').modal('show');

                columnOrderDetailsVeri = [
                    {
                        headerName: "Line #",
                        field: 'line_number',
                        width: 60,
                    }, {
                        headerName: "Media",
                        field: 'media',
                        width: 100,
                    },
                    {
                        headerName: "Time Period",
                        field: 'time_period',
                        width: 150,
                    },  {
                        headerName: "Days",
                        field: 'days',
                        width: 80,
                    }, {
                        headerName: "Daypart",
                        field: 'daypart',
                        width: 80,
                    }, {
                        headerName: "Length",
                        field: 'length',
                        width: 80,
                    },
                    {
                        headerName: "Program",
                        field: 'program',
                        width: 150,
                    },
                    {
                        headerName: "Gross Rate",
                        field: 'gross_cpa',
                        width: 100,
                    }, {
                        headerName: "Net Rate",
                        field: 'net_cpa',
                        width: 100,
                    },
                ];
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_overlay_loader($('#saveMachtModal .modal-content'));

            }
        });

    });
    $('#order-details').on('click', function (e) {
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            show_overlay_loader($('#invoiceEntry .modal-content'));
            sel = sel[0];
            var order_id = sel.data.order_num;
            var revision_number= sel.data.revision_num;
            var market_selected= $('#order_search_selectm option:selected').val();
            var month_selected = sel.data.revision_month;

            $.ajax({
                type: 'GET',
                url: '/invoices/Manually/orderdetails/' + order_id + '/' + month_selected +'/' + ((typeof market_selected !== 'undefined') ? market_selected : ""),
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('data', data);
                    $('#order_camp_detail').val(data.campaign.name);
                    $('#order_station_detail').val(data.vendor_name);
                   // $('#order_number_detail').val(sel.data.reference_number);

                    $('#order_number_detail').val(sel.data.old_reference_number +'       (Rev#: '+sel.data.revision_num+')');
                    $('#order_number_detail').removeClass('inv-text-decoration-class');
                    $('#order_number_detail').removeClass('inv-multi_market-class');
                    if ( sel.data["line_through"] === 1)
                        $('#order_number_detail').addClass('inv-text-decoration-class');
                    if (sel.data["multi_market"] === 1)
                        $('#order_number_detail').addClass('inv-multi_market-class');

                    $('#order_revision_detail').val(sel.data.revision_num);
                    $('#order_details_spots').val(data.spots);
                    $('#order_detail_rate').val('$'+ data.total_cost);
                    var  columnOrderDetails = {
                        Radio: [
                            {
                                headerName: "Media",
                                field: 'media',
                                width: 100,
                            },
                            {
                                headerName: "Time Period",
                                field: 'time_period',
                                width: 150,
                            }, {
                                headerName: "Days",
                                field: 'days',
                                width: 80,
                            }, {
                                headerName: "Daypart",
                                field: 'daypart',
                                width: 80,
                            }, {
                                headerName: "Length",
                                field: 'length',
                                width: 80,
                            },
                            {
                                headerName: "Gross Rate",
                                field: 'gross_cpa',
                                width: 100,
                                cellRenderer: function (params) {
                                    if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                                        return 'TR';
                                    else
                                        return params.data.gross_cpa;
                                },
                                cellClassRules : {
                                    'ag-cell-color-background': function (params) {
                                        if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                                            return true;
                                        return false;
                                    }
                                },
                            }, {
                                headerName: "Net Rate",
                                field: 'net_cpa',
                                width: 100,
                                cellRenderer: function (params) {
                                    if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                                        return 'TR';
                                    else
                                        return params.data.net_cpa;
                                },
                                cellClassRules : {
                                    'ag-cell-color-background': function (params) {
                                        if (typeof params.data['tiered'] !== 'undefined' && params.data['tiered'] === 1)
                                            return true;
                                        return false;
                                    }
                                },
                            },
                        ],
                        Digital:[
                            {
                                headerName: "Media",
                                field: 'media',
                                width: 100,
                            },
                            {
                                headerName: "Date",
                                field: 'date',
                                width: 180,
                            }, {
                                headerName: "IMPRESSIONS",
                                field: 'impressions',
                                width: 100,
                            }, {
                                headerName: "Gross Cost",
                                field: 'gross_cost',
                                width: 100,
                            }, {
                                headerName: "Net Cost",
                                field: 'net_cost',
                                width: 100,
                            },
                            {
                                headerName: "Ad Count",
                                field: 'ad_count',
                                width: 100,
                            },
                        ],
                        OOH:[
                            {
                                headerName: "Media",
                                field: 'media',
                                width: 100,
                            },
                            {
                                headerName: "Date",
                                field: 'date',
                                width: 160,
                            }, {
                                headerName: "Gross Rate",
                                field: 'gross_rate',
                                width: 100,
                            }, {
                                headerName: "Net Rate",
                                field: 'net_rate',
                                width: 100,
                            },
                            {
                                headerName: "IMP(00)",
                                field: 'impressions',
                                width: 100,
                            }, {
                                headerName: "# of Unit",
                                field: 'ad_count',
                                width: 100,
                            },
                            {
                                headerName: "Gross Cost",
                                field: 'gross_cost',
                                width: 100,
                            }, {
                                headerName: "Net Cost",
                                field: 'net_cost',
                                width: 100,
                            },
                        ],
                        Print:[
                            {
                                headerName: "Media",
                                field: 'media',
                                width: 100,
                            },
                            {
                                headerName: "Date",
                                field: 'date',
                                width: 160,
                            }, {
                                headerName: "Gross Rate",
                                field: 'gross_rate',
                                width: 100,
                            }, {
                                headerName: "Net Rate",
                                field: 'net_rate',
                                width: 100,
                            },
                            {
                                headerName: "IMP(00)",
                                field: 'impressions',
                                width: 100,
                            }, {
                                headerName: "Ad Count",
                                field: 'ad_count',
                                width: 100,
                            },
                            {
                                headerName: "Gross Cost",
                                field: 'gross_cost',
                                width: 100,
                            }, {
                                headerName: "Net Cost",
                                field: 'net_cost',
                                width: 100,
                            },
                        ],
                    };
                    var  weeks = [];
                    var podcast_added = '';
                    if(data.media_type === 'Radio' && typeof(data.values['Radio']) !== 'undefined') {
                        for (var ind in data.weeks) {
                            var index = moment(data.weeks[ind]).format('MM/DD');
                            weeks.push(index);
                            columnOrderDetails['Radio'].push({
                                headerName: index,
                                field: index,
                                width: 100,
                                cellClassRules: {
                                    'ag-cell-color-background': function (params) {
                                        var index_x = params.colDef.field;
                                        if (typeof params.data[index_x] !== 'undefined' && isNaN((params.data[index_x])))
                                            return true;
                                        return false;
                                    }
                                },
                                cellRenderer: function (params){
                                    console.log('params ', params);
                                    this.eGui = document.createElement('div');
                                    $(this.eGui).css('text-align', 'center');
                                    this.eGui.innerHTML  = params.value;
                                    if(typeof params.value !== 'undefined') {
                                        if (params.colDef.field.indexOf('/') !== -1 && typeof params.data.spot_by_day !== 'undefined') {
                                            var index = params.colDef.field;
                                            if (typeof params.data[index + '_spots_by_day'] !== 'undefined' && (params.data[index + '_spots_by_day'] === true || params.data[index + '_spots_by_day'] === 1)) {
                                                var new_value = params.value.split('  ');
                                                this.eGui.innerHTML = new_value[0];
                                                this.eGui.innerHTML += '*';
                                                this.eGui.style.fontStyle = "italic";
                                                this.eGui.style['font-weight'] = '800';
                                                this.eGui.innerHTML += typeof new_value[1] !== 'undefined' ? ('  '+ new_value[1]) : '';
                                            }
                                        }
                                    }
                                    else
                                      this.eGui.innerHTML = 0;
                                    return this.eGui;
                                },
                            });

                        }
                        columnOrderDetails['Radio'].push({
                                headerName: 'Total Spots',
                                field: 'total_spots',
                                width: 100,
                            }, {
                                headerName: 'Gross Cost',
                                field: 'gross_cost',
                                width: 100,
                            }, {
                                headerName: 'Net Cost',
                                field: 'net_cost',
                                width: 100,
                            },
                            {
                                headerName: 'Tiered',
                                field: 'tiered',
                                width: 100,
                                hide: true
                            },
                        );

                    }
                    else if(data.media_type === 'Television' && typeof(data.values['Television']) !== 'undefined'){
                        for (var ind in data.weeks) {
                            var index = moment(data.weeks[ind]).format('MM/DD');
                            weeks.push(index);
                            columnOrderDetails['Radio'].push({
                                headerName: index,
                                field: index,
                                width: 100,
                                cellClassRules: {
                                    'ag-cell-color-background': function (params) {
                                        var index_x = params.colDef.field;
                                        if (typeof params.data[index_x] !== 'undefined' && isNaN((params.data[index_x])))
                                            return true;
                                        return false;
                                    }
                                },
                                cellRenderer: function (params){
                                    console.log('params ', params);
                                    this.eGui = document.createElement('div');
                                    $(this.eGui).css('text-align', 'center');
                                    this.eGui.innerHTML  = params.value;
                                    if(typeof params.value !== 'undefined') {
                                        if (params.colDef.field.indexOf('/') !== -1 && typeof params.data.spot_by_day !== 'undefined') {
                                            var index = params.colDef.field;
                                            if (typeof params.data[index + '_spots_by_day'] !== 'undefined' && (params.data[index + '_spots_by_day'] === true || params.data[index + '_spots_by_day'] === 1)) {
                                                var new_value = params.value.split('  ');
                                                this.eGui.innerHTML = new_value[0];
                                                this.eGui.innerHTML += '*';
                                                this.eGui.style.fontStyle = "italic";
                                                this.eGui.style['font-weight'] = '800';
                                                this.eGui.innerHTML += typeof new_value[1] !== 'undefined' ? ('  '+ new_value[1]) : '';
                                            }
                                        }
                                    }
                                    else
                                        this.eGui.innerHTML = 0;
                                    return this.eGui;
                                },
                            });

                        }
                        columnOrderDetails['Radio'].push({
                            headerName: 'Total Spots',
                            field: 'total_spots',
                            width: 100,
                        }, {
                            headerName: 'Gross Cost',
                            field: 'gross_cost',
                            width: 100,
                        },{
                            headerName: 'Net Cost',
                            field: 'net_cost',
                            width: 100,
                        });
                    }
                    else if(data.media_type === 'Podcast' && typeof data.values['Podcast Baked-In'] !== 'undefined'){
                        for (var ind in data.weeks) {
                            var index = moment(data.weeks[ind]).format('MM/DD');
                            weeks.push(index);
                            columnOrderDetails['Radio'].push({
                                headerName: index,
                                field: index,
                                width: 100,
                                cellClassRules: {
                                    'ag-cell-color-background': function (params) {
                                        var index_x = params.colDef.field;
                                        if (typeof params.data[index_x] !== 'undefined' && isNaN((params.data[index_x])))
                                            return true;
                                        return false;
                                    }
                                },
                                cellRenderer: function (params){
                                    console.log('params ', params);
                                    this.eGui = document.createElement('div');
                                    $(this.eGui).css('text-align', 'center');
                                    this.eGui.innerHTML  = params.value;
                                    if(typeof params.value !== 'undefined') {
                                        if (params.colDef.field.indexOf('/') !== -1 && typeof params.data.spot_by_day !== 'undefined') {
                                            var index = params.colDef.field;
                                            if (typeof params.data[index + '_spots_by_day'] !== 'undefined' && (params.data[index + '_spots_by_day'] === true || params.data[index + '_spots_by_day'] === 1)) {
                                                var new_value = params.value.split('  ');
                                                this.eGui.innerHTML = new_value[0];
                                                this.eGui.innerHTML += '*';
                                                this.eGui.style.fontStyle = "italic";
                                                this.eGui.style['font-weight'] = '800';
                                                this.eGui.innerHTML += typeof new_value[1] !== 'undefined' ? ('  '+ new_value[1]) : '';
                                            }
                                        }
                                    }
                                    else
                                        this.eGui.innerHTML = 0;
                                    return this.eGui;
                                },
                            });

                        }
                        columnOrderDetails['Radio'].push({
                            headerName: 'Total Spots',
                            field: 'total_spots',
                            width: 100,
                        }, {
                            headerName: 'Gross Cost',
                            field: 'gross_cost',
                            width: 100,
                        },{
                            headerName: 'Net Cost',
                            field: 'net_cost',
                            width: 100,
                        });
                    }

                    var colDef = '';
                    var colDefSecondary = '';
                    if(data.media_type === 'Podcast')
                        colDef = typeof data.values['Podcast Baked-In'] !== 'undefined' ? columnOrderDetails['Radio'] : columnOrderDetails['Digital'];
                    else if(data.media_type === 'Radio' || data.media_type === 'Television')
                        colDef = columnOrderDetails['Radio'];
                    else if(data.media_type === 'Digital')
                        colDef = columnOrderDetails['Digital'];
                    else if(data.media_type === 'OOH' || data.media_type === 'OTT')
                        colDef = columnOrderDetails['OOH'];
                    else
                        colDef = columnOrderDetails['Print'];
                    var gridOrderDetails = {
                        columnDefs: colDef,
                        defaultColDef: {
                            suppressToolPanel: true
                        },
                        toolPanelSuppressValues: true,defaultToolPanel: '',
                        rowSelection: 'single',
                        suppressRowClickSelection: false,
                        enableColResize: true,
                        //suppressMenuColumnPanel: true,
                        suppressTouch: true,
                        headerHeight: 20,
                        suppressDragLeaveHidesColumns: true,
                        enableCellChangeFlash: true,
                        rowHeight: 20,
                        suppressRowHoverClass: true,
                        suppressParentsInRowNodes: true,
                        toolPanelSuppressValues: true,
                        toolPanelSuppressRowGroups: true,
                        groupUseEntireRow: false,
                        groupDefaultExpanded: 1,
                        marryChildren: true,
                        suppressAggFuncInHeader: true,
                        enableFilter: true,
                        enableSorting: true,
                        animateRows: true,
                        icons: {
                            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                            menu: '<i class="fa fa-bars fa-lg"/>',
                            sortAscending: '<i class="fa fa-caret-down"/>',
                            sortDescending: '<i class="fa fa-caret-up"/>',
                            columnMoveMove: '<i class="fa fa-arrows"></i>',
                            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                            columnMoveHide: '<i class="fa fa-remove"/>'
                        },
                        getContextMenuItems : data.media_type === 'Radio' || data.media_type === 'Television' || data.media_type === 'Podcast Baked-In' || data.media_type === 'Podcast Dynamic' ? '' : getContextMenuItemsOrderDetails,
                    };
                    var lines = [];
                    var lines_sec = [];
                    if(data.media_type === 'Radio' && typeof(data.values['Radio']) !== 'undefined'){
                        for(var ind in data.values['Radio']){
                            var row = {
                                media: 'Radio',
                                time_period: data.values['Radio'][ind].time_period,
                                days: data.values['Radio'][ind].days,
                                daypart: data.values['Radio'][ind].daypart,
                                gross_cpa: data.values['Radio'][ind].gross_cpa,
                                net_cpa: data.values['Radio'][ind].net_cpa,
                                total_spots: data.values['Radio'][ind].total_spot,
                                gross_cost: data.values['Radio'][ind].gross_cost,
                                net_cost: data.values['Radio'][ind].net_cost,
                                length: data.values['Radio'][ind].length,
                                tiered: data.values['Radio'][ind].tiered,
                                spot_by_day: data.values['Radio'][ind].spot_by_day,
                                rev_id: data.revision.id,
                            }
                            for(var x in weeks){
                                var d= weeks[x];
                                console.log('var week', d)
                                row[d] = data.values['Radio'][ind][d];
                                if(typeof data.values['Radio'][ind][d+'_spots_by_day'] !== 'undefined')
                                    row[d+'_spots_by_day'] = data.values['Radio'][ind][d+'_spots_by_day'] = true;
                            }

                            lines.push(row);
                        }
                        console.log('lines Radio', lines)
                    }
                    else if(data.media_type === 'Television' && typeof(data.values['Television']) !== 'undefined') {
                        for (var ind in data.values['Television']) {
                            var row = {
                                media: 'Television',
                                time_period: data.values['Television'][ind].time_period,
                                days: data.values['Television'][ind].days,
                                daypart: data.values['Television'][ind].daypart,
                                gross_cpa: data.values['Television'][ind].gross_cpa,
                                net_cpa: data.values['Television'][ind].net_cpa,
                                total_spots: data.values['Television'][ind].total_spot,
                                gross_cost: data.values['Television'][ind].gross_cost,
                                net_cost: data.values['Television'][ind].net_cost,
                                length: data.values['Television'][ind].length,
                                tiered: data.values['Television'][ind].tiered,
                                spot_by_day: data.values['Television'][ind].spot_by_day,
                                rev_id: data.revision.id,
                            }
                            for(var x in weeks){
                                var d= weeks[x];
                                row[d] = data.values['Television'][ind][d];
                                if(typeof data.values['Television'][ind][d+'_spots_by_day'] !== 'undefined')
                                    row[d+'_spots_by_day'] = data.values['Television'][ind][d+'_spots_by_day'] = true;
                            }
                            lines.push(row);
                        }
                        console.log('lines Television', lines)
                    }
                    else if(data.media_type === 'Podcast') {
                        if(typeof data.values['Podcast Baked-In'] !== 'undefined') {
                            for (var ind in data.values['Podcast Baked-In']) {
                                var row = {
                                    media: 'Podcast Baked-In',
                                    time_period: data.values['Podcast Baked-In'][ind].time_period,
                                    days: data.values['Podcast Baked-In'][ind].days,
                                    daypart: data.values['Podcast Baked-In'][ind].daypart,
                                    gross_cpa: data.values['Podcast Baked-In'][ind].gross_cpa,
                                    net_cpa: data.values['Podcast Baked-In'][ind].net_cpa,
                                    total_spots: data.values['Podcast Baked-In'][ind].total_spot,
                                    gross_cost: data.values['Podcast Baked-In'][ind].gross_cost,
                                    net_cost: data.values['Podcast Baked-In'][ind].net_cost,
                                    length: data.values['Podcast Baked-In'][ind].length,
                                    tiered: data.values['Podcast Baked-In'][ind].tiered,
                                    spot_by_day: data.values['Podcast Baked-In'][ind].spot_by_day,
                                    rev_id: data.revision.id,
                                }
                                for (var x in weeks) {
                                    var d = weeks[x];
                                    row[d] = data.values['Podcast Baked-In'][ind][d];
                                    if (typeof data.values['Podcast Baked-In'][ind][d + '_spots_by_day'] !== 'undefined')
                                        row[d + '_spots_by_day'] = data.values['Podcast Baked-In'][ind][d + '_spots_by_day'] = true;
                                }
                                lines.push(row);
                            }
                        }
                        if(typeof data.values['Podcast Dynamic'] !== 'undefined') {
                            colDefSecondary = columnOrderDetails['Digital'];
                            for (var ind in data.values['Podcast Dynamic']) {
                                var dt = data.values['Podcast Dynamic'][ind].date;
                                if(moment(data.values['Podcast Dynamic'][ind].date_end).isValid() && data.values['Podcast Dynamic'][ind].date_end !== null && data.values['Podcast Dynamic'][ind].date_end !== '0000-00-00')
                                    dt += ' - ' + moment(data.values['Podcast Dynamic'][ind].date_end).format('MM/DD/YYYY') ;

                                var row = {
                                    media: 'Podcast Dynamic',
                                    date: dt,
                                    ad_count: data.values['Podcast Dynamic'][ind].ad_count,
                                    gross_cost: data.values['Podcast Dynamic'][ind].total_cost,
                                    net_cost: data.values['Podcast Dynamic'][ind].net_cost,
                                    impressions: data.values['Podcast Dynamic'][ind].impressions,
                                    rev_id: data.revision.id,
                                    lineable_type: data.values['Podcast Dynamic'][ind].lineable_type,
                                    lineable_id: data.values['Podcast Dynamic'][ind].lineable_id,
                                    order_line_id: data.values['Podcast Dynamic'][ind].order_line_id,
                                    campaign_id: data.campaign.id,
                                }
                                if(typeof data.values['Podcast Baked-In'] !== 'undefined')
                                    lines_sec.push(row);
                                else
                                    lines.push(row);
                                console.log('podcast_dynamic lines', lines);
                                console.log('podcast_dynamic lines_sec', lines_sec);
                            }
                        }
                    }
                    else if((data.media_type === 'OOH' && typeof(data.values['OOH']) !== 'undefined') || (data.media_type === 'OTT' && typeof(data.values['OTT']) !== 'undefined')) {
                        if(data.media_type === 'OOH' ) {
                            for (var ind in data.values['OOH']) {
                                var dt = data.values['OOH'][ind].date;
                                if(moment(data.values['OOH'][ind].date_end).isValid() && data.values['OOH'][ind].date_end !== null && data.values['OOH'][ind].date_end !== '0000-00-00')
                                    dt += ' - ' + moment(data.values['OOH'][ind].date_end).format('MM/DD/YYYY') ;
                                var row = {
                                    media: 'OOH',
                                    date: dt,
                                    ad_count: data.values['OOH'][ind].ad_count,
                                    gross_cost: data.values['OOH'][ind].total_cost,
                                    net_rate: data.values['OOH'][ind].net_cpa,
                                    gross_rate: data.values['OOH'][ind].gross_cpa,
                                    net_cost: data.values['OOH'][ind].net_cost,
                                    impressions: data.values['OOH'][ind].impressions,
                                    rev_id: data.revision.id,
                                    lineable_type: data.values['OOH'][ind].lineable_type,
                                    lineable_id: data.values['OOH'][ind].lineable_id,
                                    order_line_id: data.values['OOH'][ind].order_line_id,
                                    campaign_id: data.campaign.id,
                                }
                                lines.push(row);
                            }
                        }
                        else{
                            for (var ind in data.values['OTT']) {
                                var dt = data.values['OTT'][ind].date;
                                if(moment(data.values['OTT'][ind].date_end).isValid() && data.values['OTT'][ind].date_end !== null && data.values['OTT'][ind].date_end !== '0000-00-00')
                                    dt += ' - ' + moment(data.values['OTT'][ind].date_end).format('MM/DD/YYYY') ;
                                var row = {
                                    media: 'OTT JamLoop',
                                    date: dt,
                                    ad_count: data.values['OTT'][ind].ad_count,
                                    gross_cost: data.values['OTT'][ind].total_cost,
                                    net_rate: data.values['OTT'][ind].net_cpa,
                                    gross_rate: data.values['OTT'][ind].gross_cpa,
                                    net_cost: data.values['OTT'][ind].net_cost,
                                    impressions: data.values['OTT'][ind].impressions,
                                    rev_id: data.revision.id,
                                    lineable_type: data.values['OTT'][ind].lineable_type,
                                    lineable_id: data.values['OTT'][ind].lineable_id,
                                    order_line_id: data.values['OTT'][ind].order_line_id,
                                    campaign_id: data.campaign.id,
                                }
                                lines.push(row);
                            }
                        }
                    }
                    else{
                        for (var ind in data.values[data.media_type]) {
                            console.log('date_date', data.values[data.media_type][ind].date_end);
                            console.log('date_date valid', moment(data.values[data.media_type][ind].date_end).isValid());
                            var dt = data.values[data.media_type][ind].date;
                              if(moment(data.values[data.media_type][ind].date_end).isValid() && data.values[data.media_type][ind].date_end !== null && data.values[data.media_type][ind].date_end !== '0000-00-00')
                                  dt += ' - ' + moment(data.values[data.media_type][ind].date_end).format('MM/DD/YYYY') ;

                              var row = {
                                media: data.media_type,
                                date: dt,
                                ad_count: data.values[data.media_type][ind].ad_count,
                                gross_cost: data.values[data.media_type][ind].total_cost,
                                net_cost: data.values[data.media_type][ind].net_cost,
                                net_rate: data.values[data.media_type][ind].net_cpa,
                                gross_rate: data.values[data.media_type][ind].gross_cpa,
                                impressions: data.values[data.media_type][ind].impressions,
                                rev_id: data.revision.id,
                                lineable_type: data.values[data.media_type][ind].lineable_type,
                                lineable_id: data.values[data.media_type][ind].lineable_id,
                                order_line_id: data.values[data.media_type][ind].order_line_id,
                                campaign_id: data.campaign.id,
                            }
                            lines.push(row);
                        }
                    }

                    $('#orderDetailsGridGrid').html('');
                    gridOrderDetails.rowData = lines;
                    var gridDet = document.querySelector('#orderDetailsGridGrid');
                    var g4 = new agGrid.Grid(gridDet, gridOrderDetails);

                    var gridOrderDetailsSec = {
                        columnDefs: colDefSecondary,
                        defaultColDef: {
                            suppressToolPanel: true
                        },
                        toolPanelSuppressValues: true,defaultToolPanel: '',
                        rowSelection: 'single',
                        suppressRowClickSelection: false,
                        enableColResize: true,
                        //suppressMenuColumnPanel: true,
                        suppressTouch: true,
                        headerHeight: 20,
                        suppressDragLeaveHidesColumns: true,
                        enableCellChangeFlash: true,
                        rowHeight: 20,
                        suppressRowHoverClass: true,
                        suppressParentsInRowNodes: true,
                        toolPanelSuppressValues: true,
                        toolPanelSuppressRowGroups: true,
                        groupUseEntireRow: false,
                        groupDefaultExpanded: 1,
                        marryChildren: true,
                        suppressAggFuncInHeader: true,
                        enableFilter: true,
                        enableSorting: true,
                        animateRows: true,
                        icons: {
                            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                            menu: '<i class="fa fa-bars fa-lg"/>',
                            sortAscending: '<i class="fa fa-caret-down"/>',
                            sortDescending: '<i class="fa fa-caret-up"/>',
                            columnMoveMove: '<i class="fa fa-arrows"></i>',
                            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                            columnMoveHide: '<i class="fa fa-remove"/>'
                        },
                        getContextMenuItems : data.media_type === 'Radio' || data.media_type === 'Television' || data.media_type === 'Podcast Baked-In' || data.media_type === 'Podcast Dynamic' ? '' : getContextMenuItemsOrderDetails,
                    };
                    if(lines_sec.length > 0){
                        $('.podcast_sec_div').show();
                        $('#orderDetailsGridGridSec').html('');
                        gridOrderDetailsSec.rowData = lines_sec;
                        var gridDetSec = document.querySelector('#orderDetailsGridGridSec');
                        var g4Sec = new agGrid.Grid(gridDetSec, gridOrderDetailsSec);
                    }
                    else
                        $('.podcast_sec_div').hide();

                    hide_overlay_loader('#newOrderLineModal');
                    hide_overlay_loader($('#invoiceEntry .modal-content'));
                    $('#OrderItems').modal('show');

                    function getContextMenuItemsOrderDetails(params){
                        var result = [
                            {
                                name: 'New Line',
                                icon: '<i class="fa fa-plus fa-fw"></i>',
                                //disabled: ( (params.node.rowPinned !== 'bottom') && (params.node.rowPinned !== 'top') ) ? false : true,
                                action: function() {
                                    var node = params.node;
                                    new_order_line_no_broadcast('new', node);
                                },
                                cssClasses: ['redFont', 'bold']
                            },
                            {
                                name: 'Edit Line',
                                icon: '<i class="fa fa-pencil-square"></i>',
                               // disabled: ( (params.node.rowPinned !== 'bottom') && (params.node.rowPinned !== 'top') ) ? false : true,
                                action: function() {
                                    var node = params.node;
                                    new_order_line_no_broadcast('edit', node);
                                },
                                cssClasses: ['redFont', 'bold']
                            },
                            'separator',
                        ];

                        return result;
                    }

                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_overlay_loader($('#invoiceEntry .modal-content'));

                }
            });

        }
        else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }
    });

    var fd_start_nbr_global = '';
    var fd_end_nbr_global = '';
    var ws_media_flight_dates_global = '';
    var wsHiatus_global = '';
    function new_order_line_no_broadcast(function_type, current_node){
        console.log('current_node',current_node )
        global_revise_order_change = false;
        $('#editOrderNewLines').hide();
        $('#saveOrderNewLines').hide();

        if(current_node.data.lineable_type === 'App\\Entities\\LinePrint')
            $('#addNewBonusLine').attr('media', 'print')
        else if(current_node.data.lineable_type === 'App\\Entities\\LineOOH')
            $('#addNewBonusLine').attr('media', 'ooh')
        else if(current_node.data.lineable_type === 'App\\Entities\\LineOther')
            $('#addNewBonusLine').attr('media', 'other')
        else if(current_node.data.lineable_type === 'App\\Entities\\LineOTT')
             $('#addNewBonusLine').attr('media', 'ott')
        else if(current_node.data.lineable_type === 'App\\Entities\\LineMail')
            $('#addNewBonusLine').attr('media', 'mail')
        else if(current_node.data.lineable_type === 'App\\Entities\\LineDigital')
            $('#addNewBonusLine').attr('media', 'digital')

        if(function_type === 'edit'){
            $('#addNewBonusLine').hide();
            $('#removeNewBonusLine').hide();
            $('#saveOrderNewLinesNoBr').hide();
            $('#editOrderNewLinesNoBr').show();
        }
        else{
            $('#addNewBonusLine').show();
            $('#removeNewBonusLine').show();
            $('#saveOrderNewLinesNoBr').show();
            $('#editOrderNewLinesNoBr').hide();
        }
        var params = {
            rev_id: current_node.data.rev_id,
            lineable_type: current_node.data.lineable_type,
            campaign_id: current_node.data.campaign_id,
            order_line_id : current_node.data.order_line_id,
            lineable_id : current_node.data.lineable_id,
        };
        $('#addNewBonusLine').attr('rev_id', current_node.data.rev_id);
        $('#addNewBonusLine').attr('campaign_id', current_node.data.campaign_id);

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/edit_add/order/line/get_no_broadcast_data',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                console.log('response', response)
                fd_start_nbr_global = moment(response.camp.start).format('MM/DD/YYYY')
                fd_end_nbr_global = moment(response.camp.end).format('MM/DD/YYYY')
                ws_media_flight_dates_global = response.fd;
                newOrderLineColumnDef = [
                    {
                        headerName: "Media",
                        field: 'media',
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Date',
                        headerTooltip: 'Date',
                        field: 'date_print_mail',
                        editable: true,
                        cellEditor: DateCellEditor,
                        cellRenderer: StringFormatRenderer,
                        filter: 'string',
                        hide: true,
                    },
                    {
                        headerName: 'Date',
                        headerTooltip: 'Single or Date Range',
                        field: 'date_range',
                        editable:  true,
                        cellEditor: DateRangeCellEditor,
                        cellEditorParams: {
                            date_start: response.camp.start,
                            date_end: response.camp.end,
                        },
                        cellRenderer: StringFormatRenderer,
                        hide: true,
                    },
                    {
                        headerName: "Time Period",
                        width: 100,
                        editable: true,
                        field: 'time_period',
                        cellEditor: TimePeriodCellEditorInvoice,
                        cellRenderer: StringFormatRenderer,
                        hide: true,
                    },
                    {
                        headerName: "Days Of Week",
                        field: 'dow',
                        width: 100,
                        cellEditor: DOWCellEditorInvoice,
                        cellRenderer: StringFormatRenderer,
                        editable: true,
                        hide: true,
                    },
                    {
                        headerName: "Daypart",
                        field: 'day_part',
                        width: 100,
                        cellRenderer: UppercaseFormatRendererInvoice,
                        cellEditor: StringCellEditor,
                        cellEditorParams: {
                            string_max: 3
                        },
                        editable: true,
                        hide: true,
                    },
                    {
                        headerName: "Length",
                        field: 'length',
                        width: 80,
                        editable: true,
                        cellRenderer: IntegerFormatRenderer,
                        cellEditor: IntegerCellEditor,
                        hide: true,
                    },
                    {
                        headerName: "Commission",
                        field: 'digital_commission',
                        width: 100,
                        cellEditor: FloatCellEditor,
                        cellRenderer: FloatFormatRenderer,
                        pinnedRowCellRenderer: BlankFormatRenderer,
                        hide: true,
                        editable: true,
                    },
                    {
                        headerName: "Gross Rate",
                        field: 'gross_cpa',
                        filter: 'number',
                        width: 100,
                        cellStyle: {'text-align': "left"},
                        pinnedRowCellRenderer: BlankFormatRenderer,
                        cellRenderer: CurrencyFormatRenderer,
                        cellEditor: CurrencyCellEditor,
                        cellEditorParams: {
                            'commission': response.cam_co
                        },
                        editable: true,
                        hide: true,

                    },
                    {
                        headerName: 'Net Rate',
                        headerTooltip: 'Net Cost per Ad',
                        field: 'net_cpa',
                        editable: false,
                        cellRenderer: CurrencyFormatRenderer,
                        cellEditor: CurrencyCellEditor,
                        cellEditorParams: {
                            'commission': response.cam_co
                        },
                        pinnedRowCellRenderer: BlankFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: "Ad Count",
                        field: 'ad_count',
                        width: 100,
                        editable:  true,
                        cellEditor: IntegerCellEditor,
                        cellRenderer: IntegerFormatRenderer,
                        hide: true,
                    },
                    {
                        headerName: 'Impressions',
                        headerTooltip: 'Impressions',
                        field: 'impressions',
                        editable: true,
                        cellEditor: Float3CellEditor,
                        cellRenderer: Float3FormatRenderer,
                        pinnedRowCellRenderer: BlankFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Type',
                        headerTooltip: 'Direct or Electronic Mail',
                        field: 'mail_type',
                        editable: true,
                        cellEditor: SelectCellEditor,
                        cellEditorParams: {
                            values: ['Email', 'Postal', 'Shared']
                        },
                        cellRenderer: StringFormatRenderer,
                        suppressFilter: true,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Type',
                        headerTooltip: 'Custom Vendor Type',
                        field: 'custom_type',
                        filter: 'text',
                        editable: true,
                        cellEditor: StringCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Format',
                        headerTooltip: 'Format',
                        field: 'format',
                        editable: true,
                        cellEditor: StringCellEditor,
                        cellRenderer: UppercaseFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Material Due',
                        headerTooltip: 'Material Due',
                        field: 'material_due',
                        editable:  true,
                        cellEditor: BlobCellEditor,
                        cellRenderer: StringFormatRenderer,
                        cellEditorParams: {
                            string_max: 200
                        },
                        suppressFilter: true,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Space Due',
                        headerTooltip: 'Space Due',
                        field: 'space_due',
                        cellEditor: BlobCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                        editable:  true,
                    },
                    {
                        headerName: 'Address',
                        headerTooltip: 'Address',
                        field: 'ooh_address',
                        editable: true,
                        cellEditor: BlobCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                        cellEditorParams: {
                            string_max: 600
                        },
                    },
                    {
                        headerName: 'Face',
                        headerTooltip: 'Facing Direction',
                        field: 'ooh_direction',
                        editable: true,
                        filter: 'text',
                        cellEditor: SelectCellEditor,
                        cellEditorParams: {
                            values: ['N', 'E', 'S', 'W']
                        },
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Unit',
                        headerTooltip: 'Ad Unit',
                        filter: 'text',
                        field: 'print_ad_unit',
                        editable: true,
                        cellEditor: StringCellEditor,
                        cellRenderer: StringFormatRenderer,
                        cellEditorParams: {
                            string_max: 100
                        },
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Color',
                        headerTooltip: 'Ad Color',
                        filter: 'text',
                        field: 'print_ad_color',
                        editable: true,
                        cellEditor: StringCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Size',
                        headerTooltip: 'Ad Size',
                        filter: 'text',
                        field: 'print_ad_size',
                        editable: true,
                        cellEditor: StringCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'File Format',
                        headerTooltip: 'File Format',
                        filter: 'text',
                        field: 'file_format',
                        editable: true,
                        cellEditor: SelectCellEditor,
                        cellEditorParams: {
                            values: ['JPEG', 'PNG', 'RAW', 'BMP', 'PDF', 'GIF']
                        },
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'File Size',
                        headerTooltip: 'File Size',
                        filter: 'text',
                        field: 'file_size',
                        cellEditor: StringCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                        editable: true,
                    },
                    {
                        headerName: 'Space Closing',
                        headerTooltip: 'Space Closing Date',
                        field: 'space_closing',
                        editable: true,
                        cellEditor: DateCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Material Closing',
                        headerTooltip: 'Material Closing Date',
                        field: 'material_closing',
                        editable: true,
                        cellEditor: DateCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Iss./Vol.',
                        headerTooltip: 'Issue or Volume Number',
                        filter: 'text',
                        field: 'print_issue',
                        editable: true,
                        cellEditor: StringCellEditor,
                        cellRenderer: StringFormatRenderer,
                        width: 100,
                        hide: true,
                    },
                    {
                        headerName: 'Comments',
                        headerTooltip: 'Comments',
                        field: 'comments',
                        editable: true,
                        cellEditor: BlobCellEditor,
                        cellRenderer: StringFormatRenderer,
                        pinnedRowCellRenderer: BlankFormatRenderer,
                        floatingCellEditor: BlankFormatRenderer,
                        width: 150,
                        hide: true,
                    },
                    {
                        headerName: "Gross Cost",
                        field: 'gross_cost',
                        width: 100,
                        cellRenderer: CurrencyFormatRenderer,
                        cellEditor: CurrencyCellEditor,
                        editable: true,
                        hide: true,
                    }, {
                        headerName: "Net Cost",
                        field: 'net_cost',
                        width: 100,
                        cellRenderer: CurrencyFormatRenderer,
                        cellEditor: CurrencyCellEditor,
                        hide: true,
                    },

                ];
                newOrderLineGrid.rowData = [];
                newOrderLineGrid.columnDefs = newOrderLineColumnDef;
                var col_to_show = [];
                if(response.media === 'ooh')
                    col_to_show = ['ad_count', 'comments', 'date_range', 'digital_commission','gross_cpa', 'net_cpa', 'impressions', 'format', 'ooh_address', 'ooh_direction'];
                else if(response.media === 'other')
                    col_to_show = ['ad_count', 'comments', 'date_range', 'gross_cpa', 'net_cpa', 'impressions', 'format', 'custom_type','material_due', 'space_due'];
                else if(response.media === 'digital')
                    col_to_show = ['ad_count', 'comments', 'date_range', 'digital_commission','impressions',  'format', 'material_due', 'file_size', 'file_format', 'space_due', 'gross_cost', 'net_cost' ];
                else if(response.media === 'ott')
                    col_to_show = ['ad_count', 'comments', 'date_range', 'time_period', 'dows', 'day_part', 'length','gross_cpa', 'net_cpa', 'impressions' ];
                else if(response.media === 'mail')
                    col_to_show = ['ad_count', 'comments', 'date_print_mail', 'mail_type', 'gross_cpa', 'net_cpa', 'impressions',  'format', 'material_due', 'space_due' ];
                else if(response.media === 'print')
                    col_to_show = ['ad_count', 'comments', 'date_print_mail','gross_cpa', 'net_cpa', 'impressions', 'format', 'print_ad_color', 'print_ad_size', 'file_size','file_format', 'space_closing', 'material_closing', 'print_issue'];

                if(function_type === 'edit'){
                    var row = [];
                    var line =  response.line;
                    console.log('response.line', line);
                    var dow ='';
                    dow += (line.m === 1)? 'M' : '-';
                    dow += (line.t === 1)? 'T' : '-';
                    dow += (line.w === 1)? 'W' : '-';
                    dow += (line.r === 1)? 'R' : '-';
                    dow += (line.f === 1)? 'F' : '-';
                    dow += (line.s === 1)? 'S' : '-';
                    dow += (line.u === 1)? 'U' : '-';

                    var start = moment('2021-01-01 ' + line.start_time).format('h:mmA');
                    start = start.replace('M', '');
                    var end = moment('2021-01-01 ' + line.end_time).format('h:mmA');
                    end = end.replace('M', '');
                    var com = typeof line.digital_commission !== 'undefined' ? line.digital_commission : response.cam_co;
                    var date = moment(line.start).format('MM/DD/YYYY') ;
                    if(moment(line.end).isValid() && line.end !== null && line.end !== '0000-00-00')
                        date += ' - ' + moment(line.end).format('MM/DD/YYYY') ;
                    console.log('response.line date', date);
                    var gi = 0;
                    var cpm = 0;
                    var cost = 0;
                    if(response.media === 'digital') {
                        cost = !isNaN(parseFloat(line.total_cost)) ? line.total_cost : 0;
                        // gi = !isNaN(parseFloat(line.impressions)) && !isNaN(parseInt(line.ad_count)) ? line.impressions *  line.ad_count: 0;
                        // cpm = !isNaN(parseFloat(line.total_cost)) && typeof line.impressions !== 'undefined' && !isNaN(parseFloat(line.impressions)) && (line.impressions / 1000 > 0) ? line.total_cost / (line.impressions / 1000) : 0;
                    }else {
                       // gi = !isNaN(parseFloat(line.impressions)) && !isNaN(parseInt(line.ad_count)) ? line.impressions *  line.ad_count: 0;
                        cost = !isNaN(parseFloat(line.cost)) && !isNaN(parseInt(line.ad_count)) ? line.cost * line.ad_count : 0;
                       // cpm = !isNaN(parseFloat(line.cost)) && typeof line.impressions !== 'undefined' && !isNaN(parseFloat(line.impressions)) && (line.impressions > 0) ? line.cost / (line.impressions) : 0;
                    }

                    row.push({
                        'rev_id' : current_node.data.rev_id,
                        'media' : response.media,
                        'camp_id' : response.camp.id,
                        'date_range' : date,
                        'date_print_mail' : date,
                        'time_period' : start + '-' + end,
                        'dow' : dow,
                        'length' : typeof line.length !== 'undefined' ? ':'+ line.length : '',
                        'day_part' : typeof line.daypart !== 'undefined' ? line.daypart : '',
                        'network' : typeof line.network === 'undefined' ? '' : line.network,
                        'ad_count' : !isNaN(parseInt(line.ad_count)) ? line.ad_count : 0,
                        'gross_cpa' : !isNaN(parseFloat(line.cost)) ? line.cost : 0,
                        'net_cpa' : !isNaN(parseFloat(line.cost))? line.cost * (1 - (com / 100)) : 0,
                        'gross_cost' : cost,
                        'net_cost' : cost * (1 - (com / 100)) ,
                        'impressions' : !isNaN(parseFloat(line.impressions)) ? line.impressions : 0,
                        'comments': line.comments,
                        'lineable_id': line.id,
                        'lineable_type': current_node.data.lineable_type,
                        'digital_commission': com,
                        //'digital_impressions': !isNaN(parseFloat(line.impressions)) ? line.impressions : 0,
                        'format': typeof line.format !== 'undefined' ? line.format : '',
                        'file_format': typeof line.file_format !== 'undefined' ? line.file_format : '',
                        'material_due': typeof line.material_due !== 'undefined' ? line.material_due : '',
                        'space_due': typeof line.space_due !== 'undefined' ? line.space_due : '',
                        'print_issue': typeof line.issue !== 'undefined' ? line.issue : '',
                        'space_closing': typeof line.space_closing !== 'undefined' && moment(line.space_closing).isValid() ? moment(line.space_closing).format('MM/DD/YYYY') : '',
                        'material_closing': typeof line.material_closing !== 'undefined' && moment(line.material_closing).isValid() ? moment(line.material_closing).format('MM/DD/YYYY') : '',
                        'print_ad_size': typeof line.ad_size !== 'undefined' ? line.ad_size : '',
                        'print_ad_color': typeof line.ad_color !== 'undefined' ? line.ad_color : '',
                        'file_size': typeof line.file_size !== 'undefined' ? line.file_size : '',
                        'mail_type': typeof line.type !== 'undefined' ? line.type : '',
                        'ooh_address': typeof line.ooh_address !== 'undefined' ? line.ooh_address : '',
                        'ooh_direction': typeof line.ooh_direction !== 'undefined' ? line.ooh_direction : '',
                        'custom_type': typeof line.type !== 'undefined' ? line.type : '',
                       // 'cpm': !isNaN(parseFloat(cpm)) ? cpm : 0,
                       // 'gi': !isNaN(parseFloat(gi)) ? gi : 0,
                    });
                    console.log('current_node row', row);
                    newOrderLineGrid.rowData = row;
                }

                wsHiatus_global = ws_hiatus(ws_media_flight_dates_global, response.camp);
                function ws_hiatus(weeks, ws_campaign_obj) {
                    var startCopy = moment(ws_campaign_obj.start);
                    var startCamp = moment(ws_campaign_obj.start).format('YYYY-MM-DD');
                    startCopy = startCopy.startOf('isoweek');
                    var end = moment(ws_campaign_obj.end);
                    end = end.endOf('isoweek');
                    var allWeeks = [];
                    while (startCopy.isBefore(end)) {
                        allWeeks.push(startCopy.clone());
                        if(ws_campaign_obj.interval === 'd')
                            startCopy.add(1, 'days');
                        else
                            startCopy.add(7, 'days');
                    }
                    console.log('allWeeks ', allWeeks);
                    var hiatus = [];
                    for (var j in allWeeks) {
                        var b = false;
                        for (var i in weeks) {
                            if (!b && (allWeeks[j].format('YYYY-MM-DD') === weeks[i].start || allWeeks[j].format('YYYY-MM-DD') <= startCamp)) {
                                b = true;
                                // console.log('true ', allWeeks[j].format('YYYY-MM-DD') + ' ' + weeks[i].start);
                            } else {
                                // console.log('false ', allWeeks[j].format('YYYY-MM-DD') + ' ' + weeks[i].start);
                            }
                        }
                        if(!b)
                            hiatus.push({
                                start: allWeeks[j].clone(),
                                end: (ws_campaign_obj.interval === 'd' ? allWeeks[j].clone() : allWeeks[j].clone().add(6, 'days'))
                            });
                    }
                    console.log('hiatus ', hiatus);
                    return hiatus;
                }

                $('#newOrderLineGriddiv').html("");
                var newOrderLineGridDiv = document.querySelector('#newOrderLineGriddiv');
                var g5 = new agGrid.Grid(newOrderLineGridDiv, newOrderLineGrid);

                $('.vendor_bonus_div').html('<b>Vendor:</b> '+ $("#order_station_detail").val() +'' );
                $('.order_bonus_div').html('<b>Order:</b> '+ $("#order_number_detail").val() +'' );


                newOrderLineGrid.rowData = [];
               // newOrderLineGrid.columnApi.setColumnsVisible(col_to_hide, false);
                newOrderLineGrid.columnApi.setColumnsVisible(col_to_show, true);
                $('#showEntireFD').hide();
                $('#newOrderLineModal').modal({backdrop: 'static', keyboard: false})
                $('#newOrderLineModal').draggable({
                    handle: ".modal-header"
                });
                console.log('current_node', current_node);

                $('#newOrderLineModal').modal('show');

                },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });

    }
    function UppercaseFormatRenderer() {
    }

    UppercaseFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                //console.log(' params.value ',  params.value );
                if (typeof params.value !== 'undefined' && params.value !== null && params.value !== '' && params.value !== -1) {
                    if(typeof params.node !== 'undefined' && typeof params.node.data.ad_type !== 'undefined' && params.column.colDef.field === 'program')
                        this.eGui.innerHTML = params.value;
                    else
                        this.eGui.innerHTML = typeof params.value === 'string' ? params.value.toUpperCase() : '';
                } else {
                    this.eGui.innerHTML = '';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '';
        }
    };

    UppercaseFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function Float3FormatRenderer() {
    }

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }


    Float3FormatRenderer.prototype.init = function (params) {

        var val=0;
        this.eGui = document.createElement('div');
        $(this.eGui).attr("id", makeid());

        $(this.eGui).css('text-align', 'center');
        if (typeof params.value !== 'undefined') {
            if (params.node.rowPinned !== 'bottom') {
                if(params.colDef.field === 'net_reach')
                    val = parseFloat(params.value).toFixed(0);
                else {
                    console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& line 27');
                    console.log(params.value);
                    new_val= params.value.toString().split('.');
                    console.log(' new_val[1]');
                    console.log(new_val);
                    if(typeof new_val[1] !== 'undefined'){
                        console.log(new_val[1].length);
                        if(new_val[1].length >= 3 && parseInt(new_val[1][2]) > 0)
                            val = parseFloat(params.value).toFixed(3);
                        else if(new_val[1].length >= 3 && parseInt(new_val[1][2])== 0 && parseInt(new_val[1][1]) > 0)
                            val = parseFloat(params.value).toFixed(2);
                        else if(new_val[1].length == 2 &&  parseInt(new_val[1][1]) > 0)
                            val = parseFloat(params.value).toFixed(2);
                        else if(new_val[1].length == 2 )
                            val = parseFloat(params.value).toFixed(1);
                        else
                            val =  parseFloat(params.value).toFixed(1);
                    }
                    else
                        val = parseFloat(params.value).toFixed(1);
                }
                if (isNaN(val)) {
                    if(params.colDef.field === 'net_reach')
                        this.eGui.innerHTML = '0';
                    else
                        this.eGui.innerHTML = '0.0';
                } else {
                    this.eGui.innerHTML = val;
                }
            } else {
                this.eGui.innerHTML = '';
            }
        } else {
            this.eGui.innerHTML = '0.0';
        }

        this.eGui.style.color = "black";
        this.eGui.style.fontStyle = "normal";

    };

    Float3FormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    function Float3CellEditor() {
    }

    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };

    Float3CellEditor.prototype.init = function (params) {
        this.tabbed = false;
        this.eInput = document.createElement('input');
        var el;
        if (params.column.colDef.field === 'rating') {
            el = new AutoNumeric(this.eInput,
                {
                    decimalPlaces: 3,
                    minimumValue: 0,
                    maximumValue: 100,
                    selectOnFocus: false,
                    caretPositionOnFocus: null,
                    digitGroupSeparator: ',',
                    digitalGroupSpacing: '3',
                    decimalCharacter: '.',
                    allowDecimalPadding: true,
                    showOnlyNumbersOnFocus: true,
                    showWarnings: false,
                });
            /*if (params.column.colDef.field === 'rating' && typeof params.value === 'number') {
                this.eInput.style.fontStyle = 'italic';
            }*/
        } else if(params.column.colDef.field.indexOf("dial_position") !== -1 || params.column.colDef.field.indexOf("impression") !== -1 || params.column.colDef.field === 'reach' || params.column.colDef.field === 'frequency' || params.column.colDef.field === 'grp' || params.column.colDef.field.indexOf("gi") !== -1)
        {
            el = new AutoNumeric(this.eInput,
                {
                    decimalPlaces: 3,
                    minimumValue: 0,
                    selectOnFocus: false,
                    caretPositionOnFocus: null,
                    digitGroupSeparator: ',',
                    digitalGroupSpacing: '3',
                    decimalCharacter: '.',
                    allowDecimalPadding: true,
                    showOnlyNumbersOnFocus: true,
                    showWarnings: false,
                });
        } else {
            el = new AutoNumeric(this.eInput,
                {
                    decimalPlaces: 3,
                    minimumValue: 0,
                    selectOnFocus: false,
                    caretPositionOnFocus: null,
                    digitGroupSeparator: ',',
                    digitalGroupSpacing: '3',
                    decimalCharacter: '.',
                    allowDecimalPadding: true,
                    showOnlyNumbersOnFocus: true,
                    showWarnings: false,
                });
        }

        if (params.charPress === null) {
            console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
            this.tabbed = true;
        }
        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            var vv = parseFloat((params.charPress === ".") ? 0 : params.charPress);
            if(!isNaN(vv))
                el.set((params.charPress === ".") ? "0." : params.charPress);
            console.log("round1");
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress === 8) || (params.keyPress === 46)) {
                el.set(parseFloat(0));
                console.log("round0");
                // Otherwise set the params value.
            } else {
                if (params.column.colDef.field === 'rating' || params.column.colDef.field.indexOf("impression") !== -1 || params.column.colDef.field === 'reach' || params.column.colDef.field === 'frequency' || params.column.colDef.field === 'grp' || params.column.colDef.field.indexOf("gi") !== -1) {
                    el.set(parseFloat(params.value).toFixed(3));
                    console.log("round11:" + parseFloat(params.value).toFixed(3));
                } else {
                    console.log("round22");
                    el.set(parseFloat(params.value).toFixed(3));
                }
                if (params.charPress === null) {
                    console.log("???????????????????????????????");
                    this.tabbed = true;
                }
            }
        }
        console.log("INPUT INIT");
    };

    Float3CellEditor.prototype.getGui = function () {
        if (this.tabbed === true) {
            $(this.eInput).addClass('ws-tabbed-input');
        }
        return this.eInput;
    };

    Float3CellEditor.prototype.afterGuiAttached = function () {
        $(this.eInput).bind('keydown', function (e) {
            value_flag = -1;
            if(typeof value_flag_demo_analisis !== "undefined")
                value_flag_demo_analisis = -1
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                console.log("KD1");
                e.stopPropagation();
                return true;
            } else {
                if(parseFloat(this.value) <= 0){
                    console.log("keycode2");
                    /*console.log(e);
                    this.value = "." + e.originalEvent.key;*/
                }else{
                    console.log("keycode3");
                }
            }
            // Ignore commas.
            if(key === 188){
                console.log("KD4");
                e.preventDefault();
                return true;
            }
        });
        $(this.eInput).css('text-align', 'right');
        console.log("FOCUS9");
        this.eInput.focus();
        if (this.tabbed === true) {
            console.log("TABBED");
            $(this.eInput).select();
        }else{
            if($(this.eInput).val() == "0.0")
                $(this.eInput).setCursorPosition(2);
            else
                $(this.eInput).setCursorPosition(1);
        }
    };

    Float3CellEditor.prototype.getValue = function () {
        return this.eInput.value.replace(',', '');
    };

    Float3CellEditor.prototype.destroy = function () {
        $(this.eInput).unbind('keydown');
    };

    Float3CellEditor.prototype.isPopup = function () {
        return false;
    };

    function BlobCellEditor() {
    }

    BlobCellEditor.prototype.init = function (params) {
        if (params.node.rowPinned == 'top') {
            this.eInput = document.createElement('hidden');
        }
        else
            this.eInput = document.createElement('textarea');
        if (params.charPress !== null) {
            this.eInput.value = params.charPress;
        } else {
            if (params.value !== undefined) {
                this.eInput.value = params.value;
            } else {
                this.eInput.value = '';
            }
        }

        // If a max length is defined in the colDef, set the HTML attribute.
        if (typeof params.column.colDef.cellEditorParams !== 'undefined' && params.node.rowPinned !== 'top') {
            if (typeof params.column.colDef.cellEditorParams.string_max !== 'undefined') {
                $(this.eInput).attr('maxlength', params.column.colDef.cellEditorParams.string_max);
            }
        }
    };

    BlobCellEditor.prototype.getGui = function () {
        return this.eInput;
    };

    BlobCellEditor.prototype.afterGuiAttached = function () {
        // Ensure that the arrow keys are not propagated.
        $(this.eInput).bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let "Enter" through for textarea.
            if (key == 13 || (!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                e.stopPropagation();
                return true;
            }
        });
        this.eInput.focus();
        // $(this.eInput).select();
    };

    BlobCellEditor.prototype.getValue = function () {
        return this.eInput.value;
    };

    BlobCellEditor.prototype.destroy = function () {
        // Unbind inputs.
        $(this.eInput).unbind('keydown');
    };

    BlobCellEditor.prototype.isPopup = function () {
        return true;
    };
    function DateRangeCellEditor() {
    }

    DateRangeCellEditor.prototype.init = function (params) {
        this.eDiv = document.createElement('div');
        div = $(this.eDiv);
        div.addClass('grid-popup-container').addClass('grid_date_range_container');
        div.html('<div class="row"><div class="col-lg-12 text-center date_range_output"><div class="pull-left tooltip_div"><i class="fa fa-question-circle fa-fw" data-toggle="tooltip" data-placement="bottom" title=""></i></div><input readonly/><div class="pull-right"><i class="fa fa-times fa-fw grid-popup-close"></i></div></div><div class="col-lg-12 text-center"><div class="grid-input date_range_input date_range_shorthand"><input class="start"/><input class="end"/><i class="fa fa-ellipsis-h fa-fw grid-input-icon"></i></div><div class="col-lg-12 grid-popup-container-alert hidden"><div class="alert alert-warning" role="alert"></div></div></div></div>');
        this.eInput = div.find('.date_range_output input')[0];
        this.api = params.api;
        this.tabbed = false;


        if (params.column.colId === 'date_range') {
            var current_media = $(params.api.gridCore.eGridDiv).closest('.worksheet-panel').attr('data-media-container');
            if (current_media === 'print') {
                div.find('i.fa-question-circle').attr('title', "Enter the run date, drop date, cover date or date range for the ad(s) you are placing.");
            } else if (current_media === 'digital') {
                div.find('i.fa-question-circle').attr('title', "Enter the date range for your the digital ads you are placing.");
            } else if (current_media === 'ooh') {
                div.find('i.fa-question-circle').attr('title', "Enter the date or date range the out-of-home display will be viewed.");
            } else if (current_media === 'mail') {
                div.find('i.fa-question-circle').attr('title', "Enter the date(s) the ad will be mailed.");
            } else if (current_media === 'other') {
                div.find('i.fa-question-circle').attr('title', "Enter the date(s) for the occurrence.");
            }
        }

        var flight_start = moment(params.column.colDef.cellEditorParams.date_start, 'YYYY-MM-DD HH:mm:ss');
        var flight_end = moment(params.column.colDef.cellEditorParams.date_end, 'YYYY-MM-DD HH:mm:ss');
        fd_start_nbr_global = moment(fd_start_nbr_global, 'MM/DD/YYYY');
        fd_end_nbr_global = moment(fd_end_nbr_global, 'MM/DD/YYYY');
        // console.log('fligth dates campaigns');
        // console.log(fd_start_nbr);
        // console.log(fd_end_nbr);

        var allWeeks = [];
        for (var w in ws_media_flight_dates_global) {
            allWeeks.push(moment(ws_media_flight_dates_global[w]['start'], 'MM/DD/YYYY'));
        }
        console.log('fd_start_nbr_global', fd_start_nbr_global);
        console.log('fd_start_nbr_global fd_end_nbr_global', fd_end_nbr_global);
        console.log('fd_start_nbr_global ws_media_flight_dates_global', ws_media_flight_dates_global);
        console.log('fd_start_nbr_global allWeeks', allWeeks);

        var grid_api = this.api;
        div.find('.grid-popup-close').bind('click', function () {
            grid_api.stopEditing();
        });

        var ws_date_range_start_value = ws_date_range_end_value = false;

        start_input = div.find('.date_range_shorthand input.start')[0];
        $(start_input).inputmask('mm/dd/yyyy',
            {
                "oncomplete": function () {
                    ws_date_range_start_value = true;
                    if (ws_date_range_end_value) {
                        values = ws_daterange_moment(this);
                        var tt= values[1]._isValid;
                        // Check that the value is in range.
                        if(tt=== true) {
                            if ((values[0].isBefore(values[1]) || values[0].isSame(values[1])) &&
                                (values[0].isSameOrAfter(fd_start_nbr_global) && values[1].isSameOrBefore(fd_end_nbr_global))) {
                                if(ws_has_hiatus_within(values)){
                                    ws_daterange_invalid_output(this, 'The dates you entered include dates that are on hiatus. Please modify your date range.');
                                }else {
                                    ws_daterange_complete_output(this, values);
                                }
                            } else if (!(values[0].isBefore(values[1]) || values[0].isSame(values[1]))) {
                                ws_daterange_invalid_output(this, 'Not a valid date range.');
                            } else {
                                ws_daterange_invalid_output(this, 'Inputted dates are outside of the defined Flight Dates.');
                            }
                        }
                        else{
                            if (values[0].isSameOrAfter(fd_start_nbr_global) && values[0].isSameOrBefore(fd_end_nbr_global)) {
                                if(ws_has_hiatus_within(values)){
                                    ws_daterange_invalid_output(this, 'The dates you entered include dates that are on hiatus. Please modify your date range.');
                                }else {
                                    ws_daterange_complete_output(this, values);
                                }
                            } else {
                                ws_daterange_invalid_output(this, 'Inputted date is outside of the defined Flight Dates.');
                            }
                        }

                    } else {
                        value = ws_daterange_moment(this);
                        if (value[0].isSameOrAfter(fd_start_nbr_global) && value[0].isSameOrBefore(fd_end_nbr_global)) {
                            if(ws_has_hiatus_within(value)){
                                ws_daterange_invalid_output(this, 'The dates you entered include dates that are on hiatus. Please modify your date range.');
                            }else {
                                ws_daterange_complete_output(this, value);
                            }
                        } else {
                            ws_daterange_invalid_output(this, 'Inputted date is outside of the defined Flight Dates.');
                        }
                    }
                },
                onincomplete: function () {
                    ws_daterange_clear_output(this);
                    ws_date_range_start_value = false;
                },
                showMaskOnHover: false
            });

        $(start_input).on('keyup', function () {
            // Set the output if the start is completed to support single dates.
            if (!$(this).inputmask("isComplete")) {
                $(this).closest('.grid-popup-container').find('.date_range_output input').val('');
            }
        });

        end_input = div.find('.date_range_shorthand input.end')[0];

        $(end_input).inputmask('mm/dd/yyyy',
            {
                "oncomplete": function () {
                    ws_date_range_end_value = true;
                    if (ws_date_range_start_value) {
                        values = ws_daterange_moment(this);
                        //  var month_start=values[0].format("M");
                        // var month_end=values[1].format("M");

                        var friday = moment(values[0]);
                        friday.add(6, 'days');
                        var month_start = friday.format("YYYY-MM");

                        var friday_end = moment(values[1]);
                        friday_end.add(6, 'days');
                        var month_end = friday_end.format("YYYY-MM");

                        // if (month_start !== month_end) {
                        //     console.log('I get in');
                        //     ws_daterange_invalid_output(this, 'Date range must be in the same broadcast month.');
                        // }
                        /*else*/ if ((values[0].isBefore(values[1]) || values[0].isSame(values[1])) &&
                            (values[0].isSameOrAfter(fd_start_nbr_global) && values[1].isSameOrBefore(fd_end_nbr_global))) {
                            if(ws_has_hiatus_within(values)){
                                ws_daterange_invalid_output(this, 'The dates you entered include dates that are on hiatus. Please modify your date range.');
                            }else {
                                ws_daterange_complete_output(this, values);
                            }
                        }
                        else if (!(values[0].isBefore(values[1]) || values[0].isSame(values[1]))) {
                            ws_daterange_invalid_output(this, 'Not a valid date range.');
                        }
                        else {
                            ws_daterange_invalid_output(this, 'Inputted dates are outside of the defined Flight Dates.');
                        }
                    } else {
                        ws_daterange_clear_output(this);
                        $(this).prev().focus();
                    }
                },
                onincomplete: function () {
                    if (ws_date_range_start_value == true) {
                        value = ws_daterange_moment(this);
                        if (value[0].isSameOrAfter(fd_start_nbr_global) && value[0].isSameOrBefore(fd_end_nbr_global)) {
                            if(ws_has_hiatus_within(value)){
                                ws_daterange_invalid_output(this, 'The dates you entered include dates that are on hiatus. Please modify your date range.');
                            }else {
                                ws_daterange_complete_output(this, value);
                            }
                        } else {
                            ws_daterange_clear_output(this);
                        }
                    }
//                        ws_daterange_clear_output(this);
                    ws_date_range_end_value = false;
                },
                showMaskOnHover: false
            });

        $(end_input).on('keyup', function () {
            if (!$(this).inputmask("isComplete")) {
                // Start must be completed for end to be valid.
                if (ws_date_range_start_value == true) {
                    value = ws_daterange_moment(this);
                    if (value[0].isSameOrAfter(fd_start_nbr_global) && value[0].isSameOrBefore(fd_end_nbr_global)) {
                        if(ws_has_hiatus_within(value)){
                            ws_daterange_invalid_output(this, 'The dates you entered include dates that are on hiatus. Please modify your date range.');
                        }else {
                            ws_daterange_complete_output(this, value);
                        }
                    } else {
                        ws_daterange_clear_output(this);
                    }
                } else {
                    $(this).closest('.grid-popup-container').find('.date_range_output input').val('');
                }
            }
        });

        if ((params.value !== '') && (typeof params.value !== 'undefined')) {
            if (params.value.indexOf('-') > -1) {
                current_value = params.value.split(' - ');
                current_value[0] = moment(current_value[0], 'MM/DD/YYYY');
                current_value[1] = moment(current_value[1], 'MM/DD/YYYY');
            } else {
                current_value = [];
                current_value[0] = moment(params.value, 'MM/DD/YYYY');
                current_value[1] = null;
            }
        } else {
            current_value = [];
            current_value[0] = current_value[1] = '';
        }

        // If a "printable key" is pressed.
        if (params.charPress !== null) {
            number = parseInt(params.charPress);
            // If a number, set that value.
            if (!isNaN(number)) {
                div.find('input.start').val(number);
                if (current_value[1] !== null && typeof current_value[1] !== 'undefined' && current_value[1] !== "") {
                    div.find('input.end').val(current_value[1].format('MM/DD/YYYY'));
                    ws_date_range_end_value = true;
                } else {
                    ws_date_range_end_value = false;
                }

                $(this.eInput).val('');
                ws_date_range_start_value = false;

                // Otherwise set the params value.
            } else {
                div.find('input.start').val(current_value[0].format('MM/DD/YYYY'));
                if (current_value[1] !== null && typeof current_value[1] !== 'undefined' && current_value[1] !== "") {
                    div.find('input.end').val(current_value[1].format('MM/DD/YYYY'));
                    ws_date_range_end_value = true;
                } else {
                    ws_date_range_end_value = false;
                }
                $(this.eInput).val(params.value);
            }
        } else {
            // Remove value on delete/backspace
            if ((params.keyPress == 8) || (params.keyPress == 46)) {
                div.find('input.start').val('');
                div.find('input.end').val('');
                $(this.eInput).val('');
                ws_date_range_start_value = false;
                ws_date_range_end_value = false;
                // Otherwise set the params value.
            } else {
                if (current_value[0] !== '') {
                    div.find('input.start').val(current_value[0].format('MM/DD/YYYY'));
                } else {
                    div.find('input.start').val('');
                }

                if ((current_value[1] !== '') && (current_value[1] !== null && typeof current_value[1] !== 'undefined' && current_value[1] !== "")) {
                    div.find('input.end').val(current_value[1].format('MM/DD/YYYY'));
                } else {
                    div.find('input.end').val('');
                }

                $(this.eInput).val(params.value);
                if (params.value !== '') {
                    if ((current_value[1] !== '')) {
                        ws_date_range_start_value = true;
                        ws_date_range_end_value = true;
                    } else {
                        ws_date_range_start_value = false;
                        ws_date_range_end_value = false;
                    }
                } else {
                    ws_date_range_start_value = false;
                    ws_date_range_end_value = false;
                }

                if (params.keyPress == null) {
                    this.tabbed = true;
                }
            }
        }
    };

    DateRangeCellEditor.prototype.getGui = function () {
        $(this.eDiv).find('input.start, input.end').bind('keydown', function (e) {
            var key = e.which || e.keyCode;
            // Let arrow keys through
            if ((!e.shiftKey) && ((key === 37 ) || (key === 39))) {
                e.stopPropagation();
                return true;
            }
            // If tab on first input, then go to the next input. If last input, allow default.
            if (key == 9) {
                if ($(this).hasClass('start')) {
                    e.stopPropagation();
                    return true;
                }
            }
        });
        return this.eDiv;
    };

    DateRangeCellEditor.prototype.afterGuiAttached = function () {
        $(this.eDiv).find('.date_range_shorthand input.start').focus();
        if (this.tabbed) {
            $(this.eDiv).find('.date_range_shorthand input.start').select();
        }
        init_tooltips();
    };

    DateRangeCellEditor.prototype.getValue = function () {
        return this.eInput.value;
    };

    DateRangeCellEditor.prototype.destroy = function () {
        div = $(this.eDiv);
        div.find('.grid-popup-close').unbind('click');
        div.find('input.start, input.end').unbind('keydown');
        $('[data-toggle="tooltip"]').tooltip('destroy');

    };

    DateRangeCellEditor.prototype.isPopup = function () {
        return true;
    };

    function ws_daterange_moment(input) {
        start = $(input).parent().find('input.start').val();
        end = $(input).parent().find('input.end').val();
        if (ws_date_range_end_value == true) {
            start = moment($(input).parent().find('input.start').val(), 'MM/DD/YYYY');
            end = moment($(input).parent().find('input.end').val(), 'MM/DD/YYYY');
        } else {
            start = moment($(input).parent().find('input.start').val(), 'MM/DD/YYYY');
            end = null;
        }

        return [start, end];
    };

    function ws_has_hiatus_within(values) {
       return false;
        // var b = false;
        // if (values[0].isValid()) {
        //     values[0] = moment(values[0]);
        //     for (var i in wsHiatus_global)
        //         if(!b && (values[0].isSameOrAfter(wsHiatus_global[i].start) && values[0].isSameOrBefore(wsHiatus_global[i].end)))
        //             b = true;
        // }
        // if (!b && values[1].isValid()) {
        //     values[1] = moment(values[1])/*.format('YYYY-MM-DD HH:mm:ss');*/
        //     for (var i in wsHiatus_global)
        //         if(!b && (values[1].isSameOrAfter(wsHiatus_global[i].start) && values[1].isSameOrBefore(wsHiatus_global[i].end)))
        //             b = true;
        // }
        // console.log("ws_has_hiatus_within wsHiatus_global", wsHiatus_global)
        // console.log("ws_has_hiatus_within v", b)
        // return b;
    }

    function ws_daterange_clear_output(input) {
        container = $(input).closest('.grid_date_range_container');
        container.find('.date_range_output input').val('');
        container.find('.grid-input-icon').addClass('fa-ellipsis-h').removeClass('fa-times').removeClass('fa-check');
        $(this.eInput).val('');
        ws_toggle_popup_editor_alert(container);
    };

    function ws_daterange_invalid_output(input, message) {
        container = $(input).closest('.grid_date_range_container');
        container.find('.date_range_output input').val('');
        container.find('.grid-input-icon').removeClass('fa-ellipsis-h').addClass('fa-times').removeClass('fa-check');
        ws_toggle_popup_editor_alert(container, message);
    };

    function ws_daterange_complete_output(input, values) {
        container = $(input).closest('.grid_date_range_container');
        output = container.find('.date_range_output input');

        if(values[1] !== null){
            if (values[1].isValid()) {
                output.val(values[0].format('MM/DD/YYYY') + ' - ' + values[1].format('MM/DD/YYYY'));
            } else {
                output.val(values[0].format('MM/DD/YYYY'));
            }
        }else{
            output.val(values[0].format('MM/DD/YYYY'));
        }

        container.find('.grid-input-icon').removeClass('fa-ellipsis-h').removeClass('fa-times').addClass('fa-check');
        ws_toggle_popup_editor_alert(container);
    };

    var ws_toggle_popup_editor_alert = function (container, message) {
        var msg_container = $(container).find('.grid-popup-container-alert');

        if (typeof message !== 'undefined') {
            $(msg_container).find('.alert').html(message);
            $(msg_container).removeClass('hidden').addClass('show');
            $(container).css('height', ($(container).height() + 40 ) + 'px');
        } else {
            ws_popup_editor_open = false;
            $(msg_container).find('.alert').html('');
            $(msg_container).addClass('hidden').removeClass('show');
            $(container).css('height', "");
        }
    };

    $("#invoice-header").on("click", function(){
        if(show_archived== true){
            $('#inv_add_new').css('display', 'none');
            $('#inv_save').css('display', 'none');
        }
        else{
            $('#inv_add_new').css('display', 'inline');
            $('#inv_save').css('display', 'inline');
        }

        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0){
            sel = sel[0];
            var order_id = sel.data.order_num;
            var inv_id = sel.data.inv_id;

            $("#adv_header").val($("#advertiser_searchm option:selected").text());
            $("#camp_header").val(sel.data.camp_name);
            $("#station_header").val(sel.data.station);

            if(inv_id !== ""){
                //show invoice
                $('#loading_loadingm').css("display", "block");
                $.ajax({
                    type: 'GET',
                    url: '/invoices/show-header/invoice/' + inv_id,
                    dataType: 'json',
                    encode: true,
                    success: function (data) {
                        console.log(data);
                        if(data.invoice.total_only==0 ) {
                            $('.div_totals_only input').prop('checked', false);
                            $('.div_totals_only input').prop('disabled', true);
                        }
                        else {
                            if(data.invoice.type=='broadcast') {
                                $('.div_totals_only input').prop('checked', true);
                                $('.div_totals_only input').prop('disabled', false);
                            }
                            else{
                                $('.div_totals_only input').prop('checked', true);
                                $('.div_totals_only input').prop('disabled', true);
                            }
                        }

                        $("#inv_number").val(data.invoice.invoice_num);
                        $("#inv_date").inputmask('mm/dd/yyyy', {
                            "oncomplete": function () {
                                $(this).attr('data-completed', 'true');
                            },
                            "onincomplete": function () {
                                $(this).attr('data-completed', 'false');
                            },
                            showMaskOnHover: false
                        });
                        var aux = data.invoice.date.split("-");
                        $("#inv_date").val(data.invoice.date);
                        $("#inv_month").val(moment( sel.data.month_year).format('MM/YYYY'));
                        $("#inv_month").attr('disabled', true);
                        $("#min_before_program").val(data.invoice.min_before_program);
                        $("#min_after_program").val(data.invoice.min_after_program);
                        $("#inv_fiscal_date").inputmask('mm/dd/yyyy', {
                            "oncomplete": function () {
                                $(this).attr('data-completed', 'true');
                            },
                            "onincomplete": function () {
                                $(this).attr('data-completed', 'false');
                            },
                            showMaskOnHover: false
                        });
                        aux = data.invoice.fiscal_date.split("-");
                        if(data.invoice.fiscal_date !== '1000-10-10')
                            $("#inv_fiscal_date").val(data.invoice.fiscal_date);
                        else
                            $("#inv_fiscal_date").val('');
                        $("#inv_comments").val(data.invoice.comments);

                        if( data.invoice.total_only == 1){
                            var spots = sel.data.spots_inv;
                            var trate = sel.data.schedule;

                            var order_spots =  isNaN(sel.data.spots) ? 0 : sel.data.spots;
                            var order_rate =  isNaN(parseFloat(sel.data.gross_cpa)) ? 0 : sel.data.gross_cpa;

                            $("#total_spots").val(spots);
                            $("#total_gross").val(!isNaN(parseFloat(trate).toFixed(2)) ? parseFloat(trate).toFixed(2) : 0);

                            $("#unres_items").val(0);
                            $("#unres_gross").val('0.00');
                        }
                        else{
                            var spots = data.lines.length;
                            var trate = 0;
                            for(var i in data.lines){
                                trate += data.lines[i].rate;
                            }
                            $("#total_spots").val(spots);
                            $("#total_gross").val(!isNaN(parseFloat(trate).toFixed(2)) ? parseFloat(trate).toFixed(2) : 0);

                            var unres = spots - data.res_items.length;
                            var tunrate = 0;
                            for(var i in data.res_items){
                                if(data.res_items[i] !== null && typeof data.res_items[i] !== "undefined")
                                    tunrate += data.res_items[i].rate;
                            }
                            $("#unres_items").val(unres);
                            $("#unres_gross").val(!isNaN(parseFloat(trate - tunrate).toFixed(2)) ? parseFloat(trate - tunrate).toFixed(2) : 0);
                        }



                        $("#inv_add_new").removeAttr('disabled');
                        $("#header_new_inv").hide();
                        $("#invoiceHeader").modal("show");
                        $('#loading_loadingm').css("display", "none");
                    },
                    error: function (xhr) {
                        hide_loader();
                        debug(xhr.responseText);
                        $('#loading_loadingm').css("display", "none");
                    }
                });
            }else{
                $("#inv_number").val("");
                $("#inv_date").inputmask('mm/dd/yyyy', {
                    "oncomplete": function () {
                        $(this).attr('data-completed', 'true');
                    },
                    "onincomplete": function () {
                        $(this).attr('data-completed', 'false');
                    },
                    showMaskOnHover: false
                });
                $("#inv_date").val("");

                $("#inv_fiscal_date").inputmask('mm/dd/yyyy', {
                    "oncomplete": function () {
                        $(this).attr('data-completed', 'true');
                    },
                    "onincomplete": function () {
                        $(this).attr('data-completed', 'false');
                    },
                    showMaskOnHover: false
                });
                $("#inv_fiscal_date").val("");

                $("#inv_comments").val("");
                $("#inv_add_new").attr('disabled', "disabled");
                $("#header_new_inv").show();
                $("#inv_month").val(moment( sel.data.month_year).format('MM/YYYY'));
                $("#inv_month").attr('disabled', true);
                $("#invoiceHeader").modal("show");
                if(sel.data.type=='no_broadcast'){
                    $('.div_totals_only input').prop('checked', true);
                    $('.div_totals_only input').prop('disabled', true);
                }
                else {
                    $('.div_totals_only input').prop('checked', false);
                    $('.div_totals_only input').prop('disabled', false);
                }
            }
        }else{
            $('#generalWarningModalDiv').html('Select the order line first.');
            $('#generalWarningModal').modal('show');
        }
    });
    $('#seacrh-order-invoice-manual').on('click', function(){
        $('#orders-invoices').html("");
        gridInvOrdOptions.rowData = [];
        var gridMatchDiv = document.querySelector('#orders-invoices');
        var g4 = new agGrid.Grid(gridMatchDiv, gridInvOrdOptions);
        global_way_to_search_manual_invoices = 1;
        displayOrdersInvoices(global_way_to_search_manual_invoices);
    });
    $('#reset-order-invoice-manual').on('click', function(){
        var adv_html=  $('#advertiser_searchm').html();
        $('#advertiser_searchm').html('');
        $('#advertiser_searchm').html(adv_html);
        $('#campaign_searchm').html('');
        $('#order_search_selectm').html('');
        var html='';
        html+='<option></option>';
        // for(var i in markets_search) {
        //     if (markets_search[i]['type'] == 'dma')
        //         var tpe = 'DMA';
        //     else if (markets_search[i]['type'] == 'msa')
        //         var tpe = 'MSA';
        //     else if (markets_search[i]['type'] == '')
        //         var tpe = 'CUSTOM';
        //     else
        //         var tpe = 'NATIONAL';
        //
        //     html += ' <option value="'+markets_search[i]['id']+'" title="'+markets_search[i]['name']+'">'+tpe+'-'+markets_search[i]['name']+'</option>';
        // }
        $('#only_archived').prop('checked', false);
        $('#only_in_proccess').prop('checked', true);

        $('#order_search_selectm').html(html);
        $('#orders-invoices').html("");
        gridInvOrdOptions.rowData = [];
        var gridMatchDiv = document.querySelector('#orders-invoices');
        var g4 = new agGrid.Grid(gridMatchDiv, gridInvOrdOptions);

    });

    $('#order_search_select').on('change', function(e){
        $('#loading_loading').css("display", "block");
        show_overlay_loader($('#searchOrdenToMach .modal-content'));

        multiple_match=false;
        var camp= $("#camp_current_invo_serach_id").val();
        var ven= $("#order_search_select option:selected").val();
        var id = $('#xx_id').val();

        $.ajax({
            type: 'GET',
            url: '/invoices/orders_revisons/tab/' + ven + '/' + camp ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                html = "";
                if(data.rev > 0){
                    for(var order_id in data.ordersr){
                        var deco = '';
                        var title = '';
                        if(data.ordersr[order_id][0]['line-through'] === 1 && data.ordersr[order_id][0].multiple_market === 1){
                            deco = "text-decoration: line-through; cursor:pointer; color: #B7432C";
                            title = "This Order is no longer current, but is still attached to the invoice.\nThis Order has multiple markets."
                        }
                        else if(data.ordersr[order_id][0]['line-through'] === 1) {
                            deco = "text-decoration: line-through; cursor:pointer" ;
                            title = "This Order is no longer current, but is still attached to the invoice.";
                        }
                        else if(data.ordersr[order_id][0]['multiple_market']=== 1) {
                            deco = "color:#B7432C ; cursor:pointer" ;
                            title = "This Order has multiple markets.";
                        }
                        var trade =  parseInt(data.ordersr[order_id][0]['trade']) === 1 ? data.ordersr[order_id][0]['reference_number'] + ' - Trade' : data.ordersr[order_id][0]['reference_number'];
                        html += "<tr>";
                        html += "<td><span style='"+ deco +"' title='"+ title +"'> Order (#" + trade + ") </td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "</tr>";
                        for(var ind in data.ordersr[order_id]){
                            var value1 = data.ordersr[order_id][ind];
                            if (!isNaN(parseInt(value1['market_id']))){
                                var market = '';
                                if(value1['market_type'] == 'msa' || value1['market_type'] == 'dma')
                                    market += value1['market_type'].toUpperCase() +'- '+value1['market_name'];
                                else if(value1['market_type'] == '')
                                    market +=  'Custom - '+value1['market_name'];
                                else
                                    market +=   value1['market_name']
                            }
                            else
                                var market = '---------';

                            var tooltip = '';
                            if(typeof value1.rev_order_number !== 'undefined' && value1.rev_order_number !== null && value1.rev_order_number.indexOf('-'))
                                tooltip = '<b><i style="cursor: pointer;" data-toggle="tooltip" data-animation="" data-html="true" class="ti-help-alt tooltip-init" title="Order #: '+ value1.rev_order_number +'"> </i></b>';

                            html += "<tr>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'><div class='radio radio-primary'>" +
                                "<input type='radio' name='sel_order' id='sel_order_" + value1['id'] + "_" + id + "'><label for='sel_order_" + value1['id'] + "_" + id + "'> </label></div></td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + data.camps['name'] + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + value1['revision_number'] + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + market + " " + tooltip + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + value1['date_start'] + " - " + value1['date_end'] + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + "" + ((value1['wv_name'] != null) ? value1['wv_name'] : "") + " #" + value1['wv_number'] + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + data.vendor_name + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'>" +  moment(value1['created_at']).format('MMM DD, Y h:mA') + "</td>";
                            html += "<td style='padding-bottom: 0%; padding-top: 0%'></td>";
                            html += "</tr>";
                        }
                    }
                }
                else {
                    html += "<tr>";
                    html+= "<td colspan='7'> No Order available to match</td></tr>";
                    if($('#match-invoice-order').css('display') !== 'none'){}
                       // $('#match-invoice-order').attr('disabled', true);
                    else
                        $('#match-invoice-order-multiple').attr('disabled', true);
                }
                $('#loading_loading').css("display", "none");

                modal1.find('#app-orders-search-table-station tbody').html(html);
                //  modal1.addClass('slideInUp');
                //  modal1.modal('show');

                $('#app-orders-search-table-station tr').click(function() {
                    $(this).children('td').children('div').children('input').prop('checked', true);
                    $('#app-orders-search-table-station tr').removeClass('selected');
                    $(this).toggleClass('selected');
                });
                hide_overlay_loader($('#searchOrdenToMach .modal-content'));

            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                $('#loading_loading').css("display", "none");
                hide_overlay_loader($('#searchOrdenToMach .modal-content'));
            }
        });
    });

    var open_match_window = function (input, num = '') {
        //  event.stopPropagation();
        show_loader();
        //  var id = $(input).parent().parent().parent().parent().parent().parent().attr('data-invoice-id');
        init_progress_loader(2, 'Looking for orders to match. Please wait ...');
        manual_or_imported =1;
        saved_data_global = true;
        var id= input;
        $('#xx_id').val(id);

        $.ajax({
            type: 'GET',
            url: '/invoices/orders/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#match-invoice-order').show();
                $('#match-invoice-order-multiple').hide();
                multiple_match = false;

                $('#match_inv_num_prev').html(num);
                //modal1.find('.modal-body').html(data.view);
                console.log("invoicejs");
                console.log(data);
                var html = "";
                if(data.rev > 0){
                    var checked_tx = false;
                    var cont = 0;
                    for(var order_id in data.ordersr){
                        var deco = '';
                        var title = '';
                        if(data.ordersr[order_id][0]['line-through'] === 1 && data.ordersr[order_id][0].multiple_market === 1){
                            deco = "text-decoration: line-through; cursor:pointer; color: #B7432C";
                            title = "This Order is no longer current, but is still attached to the invoice.\nThis Order has multiple markets."
                        }
                        else if(data.ordersr[order_id][0]['line-through'] === 1) {
                            deco = "text-decoration: line-through; cursor:pointer" ;
                            title = "This Order is no longer current, but is still attached to the invoice.";
                        }
                        else if(data.ordersr[order_id][0]['multiple_market']=== 1) {
                            deco = "color:#B7432C ; cursor:pointer" ;
                            title = "This Order has multiple markets.";
                        }
                       var check = (deco === '' && checked_tx === false)  ? 'checked' : '';
                       var trade =  parseInt(data.ordersr[order_id][0]['trade']) === 1 ? data.ordersr[order_id][0]['reference_number'] + ' - Trade' : data.ordersr[order_id][0]['reference_number'];
                       html += "<tr>";
                       html += "<td> <span style=' "+deco+" ' title='" + title + "'>Order (#" + trade + ") </span></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "<td></td>";
                       html += "</tr>";
                       for(var ind in data.ordersr[order_id]){
                           var len = parseInt(data.ordersr[order_id].length) - parseInt(1);
                           check = (cont === 0 && parseInt(ind) === parseInt(len) && checked_tx === false) || check === 'checked' ? 'checked' : '';
                           var value1 = data.ordersr[order_id][ind];
                           if (!isNaN(parseInt(value1['market_id']))){
                               var market = '';
                               if(value1['market_type'] == 'msa' || value1['market_type'] == 'dma')
                                   market += value1['market_type'].toUpperCase() +'- '+value1['market_name'];
                               else if(value1['market_type'] == '')
                                   market +=  'Custom - '+value1['market_name'];
                               else
                                   market +=   value1['market_name']
                           }
                           else
                               var market = '---------';
                           var tooltip = '';
                           if(typeof value1.rev_order_number !== 'undefined' && value1.rev_order_number !== null && value1.rev_order_number.indexOf('-'))
                                tooltip = '<b><i style="cursor: pointer;" data-toggle="tooltip" data-animation="" data-html="true" class="ti-help-alt tooltip-init" title="Order #: '+ value1.rev_order_number +'"> </i></b>';

                           var text_matched = (typeof value1['rev_matched'] !== 'undefined' && value1['rev_matched'] === 1) ? 'Current Match' : '';
                           var checked = (typeof value1['rev_matched'] !== 'undefined' && value1['rev_matched'] === 1) || check === 'checked' ? 'checked' : '';
                           checked_tx = (typeof value1['rev_matched'] !== 'undefined' && value1['rev_matched'] === 1) || checked_tx === true ? true : false;
                           html += "<tr>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'><div class='radio radio-primary'>" +
                               "<input type='radio' name='sel_order' id='sel_order_" + value1['id'] + "_" + id + "' "+ checked +"><label style='color: #f15925' for='sel_order_" + value1['id'] + "_" + id + "'>"+ text_matched +" </label></div> </td>";

                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + data.camps['name'] + "</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + value1['revision_number'] + "</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + market + " "+ tooltip +"</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + value1['date_start'] + " - " + value1['date_end'] + "</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + "" + ((value1['wv_name'] != null) ? value1['wv_name'] : "") + " #" + value1['wv_number'] + "</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" + data.vendor_name + "</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'>" +  moment(value1['created_at']).format('MMM DD, Y h:mA') + "</td>";
                           html += "<td style='padding-bottom: 0%; padding-top: 0%'></td>";
                           html += "</tr>";
                       }
                       cont++;
                   }
                }
                else {
                    html += "<tr>";
                    html += "<td colspan='7'> No Order available to match</td></tr>";
                }

                var vendors_search = [];
                vendors_search.push({'id': '', 'text': ''});
                $.each(data.search, function (index, value) {
                    vendors_search.push({'id': value.id, 'text': value.name});
                });

                vendors_search.sort(function (a, b) {
                    if (a.text > b.text) {
                        return 1;
                    }
                    if (a.text < b.text) {
                        return -1;
                    }
                    return 0;
                });
                var adv_new = $('#order_search_select');
                if ($(adv_new).data('select2')) {
                    adv_new.select2('destroy');
                }
                adv_new.html('').select2({
                    'data': vendors_search,
                    placeholder: "Select one..."
                });
                $('#camp_current_invo_serach_id').val(data.camps['id']);

                modal1.find('#app-orders-search-table tbody').html(html);
                modal1.addClass('slideInUp');
                modal1.modal('show');

                $('#app-orders-search-table tr').click(function () {
                    $(this).children('td').children('div').children('input').prop('checked', true);


                    $('#app-orders-search-table tr').removeClass('selected');
                    $(this).toggleClass('selected');


                });
                hide_loader();
                close_progress_loader();
            },
            error: function (xhr) {
                console.log(xhr);
                hide_loader();
                close_progress_loader();
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                }
                else if (xhr.status === 504) {
                    global_notification('warning', "Sorry our server is running a little slow at the moment.");
                }
                else {
                    ajax_error();
                    debug(xhr.responseText);
                }
            }
        });
        // hide_loader();

    };

    $('.edit_rulesok').on('click', function (event1) {
        event1.stopPropagation();


        show_loader();
        var id = $(this).parent().parent().parent().parent().parent().parent().attr('data-invoice-id');
        $('#id_invoice_hidden').val(id);

        $.ajax({
            type: 'GET',
            url: '/invoices/rules/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                html = "";

                if(typeof data.rules != 'undefined'){
                    html += " <tr>";
                    html += '<td><div class="checkbox checkbox-danger">' +
                        ' <input id="rule1" name="rules[]" checked="" type="checkbox" value="run">' +
                        ' <label for="rule1">Ran</label></div></td>' +
                        ' <td><div class="checkbox checkbox-danger"> ' +
                        ' <input  name="rules[]" id="rule2" checked="" type="checkbox" value="station"> ' +
                        ' <label for="rule2">Station</label> </div> </td>' +
                        ' <td><div class="checkbox checkbox-danger">" ' +
                        ' <input type="checkbox" name="rules[]" id="rule3" checked="" value="network"> ' +
                        '<label for="rule3">Network</label> </div></td> ' +
                        '  </tr> ';

                    html += "<tr>";

                    html += "<td> <div class='checkbox checkbox-danger'>" +
                        "<input type='checkbox' name='rules[]' id='rule4' checked='' value='week'> " +
                        " <label for='rule4'>Week</label>" +
                        "</div></td>" +
                        "<td> <div class='checkbox checkbox-danger'>" +
                        " <input type='checkbox' name='rules[]' id='rule7' checked='' value='length'> " +
                        "<label for='rule7'>Length</label>" +
                        "</div></td>" +
                        " <td><div class='checkbox checkbox-danger'>" +
                        " <input type='checkbox' name='rules[]' id='rule8' checked='' value='cost'> " +
                        " <label for='rule8'>Cost</label>" +
                        " </div></td>" +
                        "</tr>";



                    html += "<tr>";
                    html += "<td> <div class='checkbox checkbox-danger'>" +
                        "<input type='checkbox' name='rules[]' id='rule5' checked='' value='time_period'>  " +
                        "<label for='rule5'>Specified time period</label>" +
                        "</div></td>" +
                        "<td> <div class='checkbox checkbox-danger'>" +
                        " <input type='checkbox' name='rules[]' id='rule6' checked='' value='day'> " +
                        "<label for='rule6'>Day of the week</label> " +
                        " </div></td>" +
                        "<td></td>" +
                        "</tr>";

                }
                list.find('tbody').html(html);
                if(data.rules.run == 0)
                    $("#rule1").attr("checked", false);
                if(data.rules.run_station == 0)
                    $("#rule2").attr("checked", false);
                if(data.rules.run_network == 0)
                    $("#rule3").attr("checked", false);
                if(data.rules.run_week == 0)
                    $("#rule4").attr("checked", false);

                if(data.rules.run_time == 0)
                    $("#rule5").attr("checked", false);


                if(data.rules.run_day == 0)
                    $("#rule6").attr("checked", false);

                if(data.rules.add_length == 0)
                    $("#rule7").attr("checked", false);


                if(data.rules.add_cost == 0)
                    $("#rule8").attr("checked", false);
                list.modal('show');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
            }
        });
        hide_loader();
    });


    $('#app-invoices-table').on('click', '.order-button-search', function () {
        to_print_report_invoce_type = 'imported';
        manual_grid_ready = false;
        $('#row_id_to_change').val($(this).attr('row-id'));
        invoice_manual_multiple_match = false;
        var row= app_invoices_table.row( $(this).attr('row-id') ).data();
        $('#inv_preview_num').html('Inv No: ' + row.invoice_number);
        if(parseInt($(this).attr('data-match_type')) === 1)
            $('#use_ordered_net_rate').attr('checked', true)
        else
            $('#use_ordered_net_rate').attr('checked', false)

        if(row.multiple_match > 0){
            $('#inv_sche_match_multiple').val(row.multiple_match);
            $('#weekly_breakout_multiple').val(row.multiple_match);
            $('#rotation_analysis_multiple').val(row.multiple_match);
            $('#spot_rotation_multiple').val(row.multiple_match);

            $('.confirm-see-multiple').val(row.multiple_match);
            $('.cancel-see-multiple').val(row.id);
            $('.cancel-see-multiple').attr('data-invoice-num', row.invoice_number);
            $('#selectMatchType').modal('show');
        }
        else
            open_match_window($(this).attr('data-invoice-id'), $(this).attr('data-invoice-num'));
    });
    $('.cancel-see-multiple').on('click', function () {
        multiple_match=false;
        $('#reports_temp').show();
        $('#reports_temp_multiple').hide();
        $('#selectMatchType').modal('hide');
        console.log($(this).val());
        open_match_window($(this).val(), $(this).attr('data-invoice-num'));
    });

    $('#app-invoices-table').on('click',  '.invoice_delete',function () {
        if($(this).attr('disabled') !== 'disabled') {
            $('#hidden_id_to_delete').val($(this).attr('data-id'));
            $('#hidden_row_to_delete').val($(this).attr('data-row'));
            $('#hidden_type_to_delete').val('imported');
            $('#delete_invoice_bt').show();
            $('#delete_invoiceMultiple').hide();
            $('#generalWarningModalDeleteInvoice').modal('show');
        }
    });

    $('#app-invoices-table').on('click',  '.invoice_delete_manual',function () {
        if($(this).attr('disabled') !== 'disabled') {
           // delete_invoice_manual($(this).attr('data-row'), $(this).attr('data-id'));
            $('#hidden_id_to_delete').val($(this).attr('data-id'));
            $('#hidden_row_to_delete').val($(this).attr('data-row'));
            $('#hidden_type_to_delete').val('manual');
            $('#delete_invoice_bt').show();
            $('#delete_invoiceMultiple').hide();
            $('#generalWarningModalDeleteInvoice').modal('show');
        }
    });

    //Edit Imported Invoice Campaign
    $('#app-invoices-table').on('click', '.invoice_change_camp', function () {
        show_loader();
        $('#invoice_change_campaign_inv_id').val($(this).attr('data-id'));
        $('#inv_change_adv').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#inv_change_camp').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $.ajax({
            type: 'GET',
            url: '/invoices/get/advertisers/campaigns',
            dataType: 'json',
            encode: true,
            success: function (data) {
                var advertisers = [];
                advertisers.push({'id': '', 'text': ''});
                $.each(data.advertisers, function (index, value) {
                    advertisers.push({'id': value.id, 'text': value.name});
                });
                if ($('#inv_change_adv').data('select2'))
                    $('#inv_change_adv').select2('destroy');

                $('#inv_change_adv').html('').select2({
                    'data': advertisers,
                    placeholder: "Select one..."
                });
                var campaigns = [];
                campaigns.push({'id': '', 'text': ''});

                if ($('#inv_change_camp').data('select2'))
                    $('#inv_change_camp').select2('destroy');

                $('#inv_change_camp').html('').select2({
                    'data': campaigns,
                    placeholder: "Select one..."
                });

                $('#InvoiceChangeCampaign').modal('show');

                $('#inv_change_adv').on('change', function () {
                    console.log('Change  ', $('#inv_change_adv option:selected').val());
                    var campaigns = [];
                    campaigns.push({'id': '', 'text': ''});
                    if (typeof data.campaigns[$('#inv_change_adv option:selected').val()] !== 'undefined') {
                        $.each(data.campaigns[$('#inv_change_adv option:selected').val()], function (index, value) {
                            campaigns.push({'id': value.id, 'text': value.name});
                        });
                        campaigns.sort(function (a, b) {
                            if (a.text > b.text) {
                                return 1;
                            }
                            if (a.text < b.text) {
                                return -1;
                            }
                            return 0;
                        });
                    }
                    if ($('#inv_change_camp').data('select2'))
                        $('#inv_change_camp').select2('destroy');

                    $('#inv_change_camp').html('').select2({
                        'data': campaigns,
                        placeholder: "Select one..."
                    });

                });
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });
    $('#edit_invoice').on('click', function(){
        if($('#inv_change_camp option:selected').val() == ''){
            $('#generalWarningModalDiv').html('Please select a campaign.');
            $('#generalWarningModal').modal('show');
        }
        else{
            $('#editImportedConfirmed').show();
            $('#editManualConfirmed').hide();
            $('#editInvoiceDiv').html('Are you sure to update the selected invoice?');
            $('#generalWarningModalEditInvoice').modal('show');
        }
    });
    //Edit Imported Invoices Lines
    var columnsInvImportedLines = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
               {
                    headerName: "Detail Id",
                    field: 'detail_id',
                    width: 120,
                    editable: false,
                    hide: true,
                },{
                    headerName: "Inv. Line Number",
                    field: 'line_number',
                    width: 120,
                    editable: false,
                }, {
                    headerName: "Invoice Id",
                    field: 'invoice_id',
                    width: 120,
                    editable: false,
                    hide: true,
                },{
                    headerName: "Date",
                    field: 'date',
                    width: 120,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: DateCellEditor,
                },{
                    headerName: "Day",
                    field: 'dow',
                    width: 80,
                }, {
                    headerName: "Time",
                    field: 'time',
                    width: 120,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: TimeCellEditor,
                    comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                        if (valueA.includes('PM') && valueB.includes('AM')) {
                            return 1;
                        } else if (valueA.includes('AM') && valueB.includes('PM')) {
                            return -1;
                        } else {
                            var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                            var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                            var arr1 = timeA.split(':');
                            var arr2 = timeB.split(':');

                            if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                                return 0;
                            else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                                return 1;
                            else
                                return -1;
                        }
                    }
                }, {
                    headerName: "Length",
                    field: 'length',
                    width: 80,
                    editable: true,
                    cellRenderer: IntegerFormatRenderer,
                    cellEditor: IntegerCellEditor,
                }, {
                    headerName: "Rate",
                    field: 'rate',
                    width: 120,
                    editable: true,
                    cellRenderer: CurrencyFormatRenderer,
                    cellEditor: CurrencyCellEditor,
                },
                {
                    headerName: "Network",
                    field: 'network',
                    width: 150,
                    editable: true,
                    cellEditor: StringCellEditor,
                    cellEditor: StringCellEditor,
                },{
                    headerName: "Commercial ID",
                    field: 'commercial_id',
                    width: 200,
                    editable: true,
                    cellStyle: {'text-align': "right"},
                    cellEditor: StringCellEditor,
                },
                    {
                    headerName: "Comments",
                    field: 'comments',
                    width: 300,
                    editable: true,
                    cellRenderer: StringFormatRenderer,
                    cellEditor: StringCellEditor,

                },
                {
                    headerName: "Remarks",
                    field: 'remarks',
                    width: 300,
                    editable: true,
                    cellEditor: StringCellEditor,
                    cellEditor: StringCellEditor,
                }

    ];
    var editing_row_imp_inv = false;
    var editing_row_imp_inv_array = [];
    var remove_row_imp_inv_array = [];
    var grid_in_procces = '';
    var gridInvImportedLines = {
        columnDefs: columnsInvImportedLines,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true, defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: false,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        stopEditingWhenGridLosesFocus: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        getContextMenuItems: getContextMenuItemsInvoice,
        onCellValueChanged: function (e) {
            if (e.colDef.field === 'date') {
                var weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                var a = new Date(e.node.data.date);
                e.node.data.dow = weekday[a.getDay()];
                e.api.refreshCells([e.node], ['dow']);
            }
            if(e.colDef.field === 'rate')
                updateImportedInvoiceTotals();
            if(editing_row_imp_inv_array.indexOf(e.node.data.detail_id) === -1)
                editing_row_imp_inv_array.push(e.node.data.detail_id);
            editing_row_imp_inv = true;
        },
        onCellEditingStopped: function (e) {
            if (e.colDef.field === 'date') {
                if (e.node.data.date != 'Invalid date' && e.node.data.date != '') {
                    var start = moment($("#fd_start_edit_inv").val()).format('MM/DD/YYYY');
                    var end = moment($("#fd_end_edit_inv").val()).format('MM/DD/YYYY');
                    var date = moment(e.node.data.date).format('MM/DD/YYYY');
                    if ((moment(start).isBefore(date) && moment(date).isBefore(end)) || (moment(date).isSame(start) || moment(date).isSame(end))) {
                    } else {
                        swal({
                                title: "Warning!",
                                text: 'Spot ran outside of campaign flight dates!',
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "OK",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {

                            });
                    }
                } else {
                    e.node.data.date = '00/00/0000';
                    e.api.refreshCells([e.node], ['date']);
                }
            }
        },

    };
    var invoice_in_question = '';
    $('#inv_imported_select_all_items').on('click', function (){
        gridInvImportedLines.api.selectAllFiltered();
    });
    $('#inv_imported_deselect_all_items').on('click', function (){
        gridInvImportedLines.api.deselectAllFiltered();
    });
    $('#app-invoices-table').on('click', '.invoice_change_lines', function () {
        show_loader();
        var inv_id = parseInt($(this).attr('data-id'));
        console.log('this_this ', $(this).attr('data-id'))
        console.log('this_this inv_id',inv_id)
        inv_selected_to_update_datatable.push($(this).attr('data-row'))
        $('#imported_invoice_edit_hidden').val(inv_id);
        $.ajax({
            type: 'GET',
            url: '/invoices/get/all/lines/'+ inv_id,
            dataType: 'json',
            encode: true,
            success: function (response) {
                editing_row_imp_inv = false;
                invoice_in_question = response.invoice;
                invoice_in_question['commission'] =  (invoice_in_question.inv_media_type == "R" || invoice_in_question.inv_media_type == "X") ? invoice_in_question.radio_com : invoice_in_question.tv_com;
                editing_row_imp_inv_array = [];
                remove_row_imp_inv_array = [];
                $('#inv_imported_edit_number').val(invoice_in_question.invoice_number);
                $("#fd_start_edit_inv").val(response.invoice.camp_start);
                $("#fd_end_edit_inv").val(response.invoice.camp_end);
                gridInvImportedLines.rowData = [];
                gridInvImportedLines.rowData = response.data;
                $('#invoiceImportedEditGridDiv').html('');
                var gridMatchDiv = document.querySelector('#invoiceImportedEditGridDiv');
                var g4 = new agGrid.Grid(gridMatchDiv, gridInvImportedLines);
                if((invoice_in_question.inv_media_type == "LC" || invoice_in_question.inv_media_type == "C"))
                    gridInvImportedLines.columnApi.setColumnsVisible(['network'], true);
                else
                    gridInvImportedLines.columnApi.setColumnsVisible(['network'], false);
                updateImportedInvoiceTotals();
                grid_in_procces = gridInvImportedLines;
                $('#editImportedInvoice').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });
    $('#inv_imported_save_items').on('click', function() {
        show_overlay_loader($('#editImportedInvoice'));
        var gross = $('#inv_imported_edit_gross').val().replace('$', '');
        gross = gross.replace(/,/g, '') ;
        var net = $('#inv_imported_edit_net').val().replace('$', '');
        net = net.replace(/,/g, '') ;
        var params = {
            invoices_lines: [],
            deleted_lines: [],
            invoice_id: $('#imported_invoice_edit_hidden').val(),
            spots: $('#inv_imported_edit_spots').val(),
            gross: gross,
            net: net,
            commission: invoice_in_question['commission'],
            sche_line:  invoice_in_question['line_number'],
            invoice_number: $('#inv_imported_edit_number').val(),
        };
        console.log('params_params_params ', params);
        for (var ind in remove_row_imp_inv_array)
            params.deleted_lines.push(remove_row_imp_inv_array[ind]);

        var date = 0;
        gridInvImportedLines.api.forEachNode(function (node) {
            if (editing_row_imp_inv_array.indexOf(node.data.detail_id) !== -1 && node.data.detail_id !== 0) {
                params.invoices_lines.push(node.data);
                if(!moment(node.data.date).isValid())
                    date++
            }
            else if(node.data.detail_id === 0){
                if(!moment(node.data.date).isValid())
                    date++
                params.invoices_lines.push(node.data);
            }
        });

       if(date > 0){
            if(date === 1)
              var text = 'One of the Invoice line has Invalid Date. Please check it before save.';
            else
              var text = date +' of the Invoice lines has Invalid Date. Please check it before save.';
            hide_overlay_loader($('#editImportedInvoice'));
            swal({
                    title: "Warning",
                    text:  text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Ok",
                    closeOnConfirm: true,
                    closeOnCancel: true,
                    cancelButtonText: "Close",
                },
                function (isConfirm) {
            });
        }
        else {
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/invoices/imported/edit/lines/save',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var response = typeof data.data !== 'undefined' ? data.data : data;
                    console.log('data_data_data', data);
                    if(data.inv_number > 0){
                        hide_overlay_loader($('#editImportedInvoice'));
                        swal({
                                title: "Warning",
                                text:  "Invoice Number already exist. Please change the Invoice Number before saving.",
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Ok",
                                closeOnConfirm: true,
                                closeOnCancel: true,
                                cancelButtonText: "Close",
                            },
                            function (isConfirm) {
                            });
                    }
                    else {
                        editing_row_imp_inv_array = [];
                        remove_row_imp_inv_array = [];
                        var ind = 0;
                        var nodes_to_update = [];
                        gridInvImportedLines.api.forEachNode(function (node) {
                            console.log('node.data', node.data);
                            console.log('node.data response', ind, response);
                            if (node.data.detail_id === 0) {
                                node.data.detail_id = response[ind];
                                ind++;
                                nodes_to_update.push(node);
                            }
                        });
                        gridInvImportedLines.api.refreshCells({
                            rowNodes: nodes_to_update,
                            columns: ['detail_id'],
                            force: true
                        });
                        app_invoices_table.cell(inv_selected_to_update_datatable[0], 2).data($('#inv_imported_edit_number').val());
                        hide_overlay_loader($('#editImportedInvoice'));
                        global_notification('success', "Items saved!");
                    }
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_overlay_loader($('#editImportedInvoice'));
                }
            });
        }
    });
    $('#inv_imported_remove_items').on('click', function(){
        editing_row_imp_inv = true;
        var selectedNodes = gridInvImportedLines.api.getSelectedNodes();
        for(var i in selectedNodes)
            if(remove_row_imp_inv_array.indexOf(selectedNodes[i].data.detail_id) === -1)
                remove_row_imp_inv_array.push(selectedNodes[i].data.detail_id);
        gridInvImportedLines.api.removeItems(selectedNodes);
        gridInvImportedLines.api.refreshView();
        updateImportedInvoiceTotals();
        global_notification("success", "Removed " + selectedNodes.length + " rows!");
    });
    function updateImportedInvoiceTotals() {
        var spots = 0;
        var gross = 0;
        gridInvImportedLines.api.forEachNode(function (node) {
           spots ++;
           gross += !isNaN(parseFloat(node.data.rate)) ? parseFloat(node.data.rate) : 0 ;
        });
        var net = gross * (1 - (invoice_in_question['commission'] / 100));
        $('#inv_imported_edit_spots').val(spots);
        $('#inv_imported_edit_gross').val(parseFloat(gross).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }));
        $('#inv_imported_edit_net').val(parseFloat(net).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        }));
    }
    $('#inv_imported_add_items').on('click', function(){
        var index= gridInvImportedLines.api.getModel().rowsToDisplay.length;
        gridInvImportedLines.api.stopEditing(true);
        var ln = parseInt(invoice_in_question.line_number) + parseInt(1);
        gridInvImportedLines.api.updateRowData({add: [{
                detail_id: 0,
                line_number: 'LINE NO. '+ ln,
                invoice_id: invoice_in_question.id,
                date: "00/00/0000",
                dow: "",
                time: "00:00",
                length: 0,
                rate: 0,
                commercial_id: "",
                comments: "",
                network: "",
                remarks: "",

            }], addIndex: index});
        gridInvImportedLines.api.ensureColumnVisible('date')
        gridInvImportedLines.api.ensureIndexVisible(index);
        gridInvImportedLines.api.setFocusedCell(index, 'date', null);
        updateImportedInvoiceTotals();
    });

    function editImportedConfirmed(){
        show_overlay_loader($('#InvoiceChangeCampaign .modal-content'));
        var params = {
            invoice_id:  $('#invoice_change_campaign_inv_id').val(),
            advertiser_id:  $('#inv_change_adv option:selected').val(),
            campaign_id:  $('#inv_change_camp option:selected').val(),
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/edit/advertiser/campaigns',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                global_notification('success', 'Invoice updated...')
                location.reload();
                hide_overlay_loader($('#InvoiceChangeCampaign .modal-content'));
            },
            error: function (xhr) {
                ajax_error();
                hide_overlay_loader($('#InvoiceChangeCampaign .modal-content'));
                debug(xhr.responseText);
            }
        });
    }
    $('.close_imported_invoice_entry').on('click', function(){
        inv_selected_to_update_datatable = [];
    });

    //split invoice
    $('#app-invoices-table').on('click', '.invoice_split',function () {
        $('#start_period_date').val($(this).attr("data-start-date"));
        $('#end_period_date').val($(this).attr("data-end-date"));
        $('#final_period_date').val($(this).attr("data-end-date"));
        $('#invoice_ident').val($(this).attr("data-row"));
        $('.div-periods').html('');
        $('.div-periods').css('display', 'none');
        $('#send_split_invoice').attr('disabled', true);
        $('#InvoiceSplit').modal('show');
    });
    //crate periods
    $('#add_period').on('click', function () {
        if($('#period_numbers').val() == 0) {
            $('#generalWarningModalDiv').html('Please select the number of Invoices you want to create.');
            $('#generalWarningModal').modal('show');
        }else {
            $('.div-periods').html('');
            var periods = parseInt($('#period_numbers').val()) + 1;
            var i = 1;
            var html = '';
            while (i < periods) {
                var dis = '';
                if (i > 1)
                    dis = 'disabled';
                html += '<div class="form-group col-md-11 div-periods-'+i+'" style="margin-left: 2%"> ' +
                    '<h5 for="period_date_' + i + '"> Flight Dates Invoice# ' + i + '</h5>' +
                    '<input class="form-control full-width period_date_class" '+dis+' name="period_date_' + i + '" id="period_date_' + i + '" data-number="' + i + '" data-show="0">' +
                    '</div>';
                i++;
            }

            $('.div-periods').append(html);
            $('.div-periods').show();
            AddEventTrigger();
        }
    });

    var AddEventTrigger=  function (){
        $('.div-periods .div-periods-1').unbind();
        var start= moment($('#start_period_date').val());
        var end= moment($('#end_period_date').val());
        var input = $(".div-periods").find("#period_date_1");

        if (input.data('daterangepicker')) {
            input.data('daterangepicker').remove();
        }
        input.daterangepicker({
            "showWeekNumbers": true,
            "autoApply ":false,
            "linkedCalendars": false,
            "autoUpdateInput": false,
            "startDate": start,
            "minDate": start,
            "endDate": end,
            "maxDate": end,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('')

        $('.div-periods').on('apply.daterangepicker', '.period_date_class',function (ev, picker) {
            console.log('picker');
            console.log(picker);
            $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
            $('#send_split_invoice').attr('disabled', false);
            var period = $(this).val().split('-');
            var start = period[0];
            var end = period[1];
            var id_number = $(this).attr('data-number');
            var start_next = moment(end).add(1, 'days');
            var next= parseInt($('#period_numbers').val()) - id_number;
            if(start_next.isAfter(moment($('#final_period_date').val()) ) && parseInt(next) > 0){
                swal({
                        title: "Warning",
                        text: "No available dates for next(s) "+next+" Invoices..",
                        type: "warning",
                        // showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Ok",
                        // cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                    });
            }
            else {
                $('.div-periods .period_date_class').each(function (index, item) {
                    if (id_number < $(item).attr('data-number')) {
                        $(item).html('');
                        if (parseInt(id_number) + 1 == $(item).attr('data-number')) {
                            if ($(item).data('daterangepicker'))
                                $(item).data('daterangepicker').remove();
                            $(item).attr('data-show', 1);
                            $(item).daterangepicker({
                                "showWeekNumbers": true,
                                "autoApply": false,
                                "autoUpdateInput": false,
                                "linkedCalendars": false,
                                "startDate": start_next,
                                "minDate": start_next,
                                "endDate": moment($('#final_period_date').val()).format('MM/DD/YYYY'),
                                "maxDate": moment($('#final_period_date').val()).format('MM/DD/YYYY'),
                                "locale": {
                                    "format": "MM/DD/YYYY",
                                    "separator": " - ",
                                    "applyLabel": "Apply",
                                    "cancelLabel": "Cancel",
                                    "fromLabel": "From",
                                    "toLabel": "To",
                                    "customRangeLabel": "Custom",
                                    "weekLabel": "#",
                                    "daysOfWeek": [
                                        "U",
                                        "M",
                                        "T",
                                        "W",
                                        "R",
                                        "F",
                                        "S"
                                    ],
                                    "firstDay": 1
                                }
                            }).val('')
                            $(item).attr('disabled', false);

                        } else {
                            if ($(item).data('daterangepicker'))
                                $(item).data('daterangepicker').remove();
                            $(item).html('');
                            $(item).attr('disabled', true);
                        }
                    }
                });
            }
        });

    };

    //send periods invoice split
    $('#send_split_invoice').on('click', function () {
       $('#generalWarningModalSplitInvoice').modal('show');
    });

    function splitConfirmed(){
        show_overlay_loader($("#InvoiceSplit"));
        var array= $('#invoice_split_form').serializeArray();
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: array,
            url: '/invoices/invoice_split',
            dataType: "json",
            encode: true,
            success: function (data) {
                global_notification('success', 'Invoice splited.');
                $("#InvoiceSplit").modal('hide');
                window.location.href= data;
                hide_overlay_loader($("#InvoiceSplit"));
            },
            error: function (xhr) {
                hide_overlay_loader($("#InvoiceSplit"));
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }
    //change invoice status manual
    $('#app-invoices-table').on('click',  '.change_invoice_status',function () {
        $('#invoice_change_status_id').val($(this).attr('data-id'));
        $('#invoice_change_status_row_id').val($(this).attr('row-id'));
        $('#new_status').select2({});
        $('#ChangeStatusModal').modal('show');
    });

    $('#send_invoice_new_status').on('click',function () {
        var id= $('#invoice_change_status_id').val();
        $('#ChangeStatusModal').modal('hide');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/change_status/' + id+ '/status/'+ $('#new_status option:selected').val(),
            dataType: 'json',
            encode: true,
            success: function (data) {
                global_notification('success', 'Invoice status changed...');
                hide_loader();
                app_invoices_table.cell($('#invoice_change_status_row_id').val(),11).data($('#new_status option:selected').val());
                app_invoices_table.draw();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

    $('#app-invoices-table').on('click',  '.invoice_preview',function () {
        show_loader();
        var id = $(this).parent().parent().parent().parent().parent().attr('data-invoice-id');
        $('#export_invoice_pdf').attr('data-invoice-id', id);

        $.ajax({
            type: 'GET',
            url: '/invoices/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                modal.find('.modal-body').html(data.view);
                modal.addClass('slideInUp');
                modal.modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });

    });

    $('#app-invoices-table').on('click',  '.invoice_preview_manual',function () {
        show_loader();
        var id = $(this).parent().parent().parent().parent().parent().attr('data-invoice-id').toString().split('m_')[1];
        $('#export_invoice_pdf').attr('data-invoice-id', $(this).parent().parent().parent().parent().parent().attr('data-invoice-id'));

        $.ajax({
            type: 'GET',
            url: '/manual/invoices/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                modal.find('.modal-body').html(data.view);
                modal.addClass('slideInUp');
                modal.modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });

    });

    $('#app-invoices-table-archived').on('click',  '.invoice_preview',function () {
        show_loader();
        var id = $(this).parent().parent().parent().parent().parent().attr('data-invoice-id');
        $('#export_invoice_pdf').attr('data-invoice-id', id);

        $.ajax({
            type: 'GET',
            url: '/invoices/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                modal.find('.modal-body').html(data.view);
                modal.addClass('slideInUp');
                modal.modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });
    $('#app-invoices-table-archived').on('click',  '.invoice_preview_manual',function () {
        show_loader();
        var id = $(this).parent().parent().parent().parent().parent().attr('data-invoice-id').toString().split('m_')[1];
        $('#export_invoice_pdf').attr('data-invoice-id', $(this).parent().parent().parent().parent().parent().attr('data-invoice-id'));

        $.ajax({
            type: 'GET',
            url: '/manual/invoices/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                modal.find('.modal-body').html(data.view);
                modal.addClass('slideInUp');
                modal.modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

    $('#app-invoices-table-archived').on('click', '.weekly_breakout_archivated', function () {
        invoice_manual_multiple_match = false;
        var row= app_invoices_table_archived.row($(this).attr('row-id')).data();
        if(row.multiple_match > 0){
            $('.confirm-see-multiple-archive-weekly').val(row.multiple_match);
            $('.cancel-see-multiple-archive-weekly').val($(this).attr('data-id'));
            $('#selectMatchTypeArchiveWeekly').modal('show');
        }
        else {
            var id = $(this).attr('data-id');
            // var link = document.createElement('a');
            // link.href = "/invoices/reconciliation/weekly_report/" + id + "/download";
            // $(link).attr('target', '_blank');
            // link.click();
            show_weeklyModal("/invoices/reconciliation/weekly_report/", id, "imported");
        }
    });
    $('#app-invoices-table-archived').on('click', '.weekly_breakout_archivated_man', function () {
        if($(this).attr('data-multiple-match') > 0){
            $('.confirm-see-multiple-archive-weekly-manual').val($(this).attr('data-multiple-match'));
            $('.cancel-see-multiple-archive-weekly-manual').val($(this).attr('data-id'));
            $('#selectMatchTypeArchiveWeeklyManual').modal('show');
        }else {
            invoice_manual_multiple_match = false;
            var row = app_invoices_table_archived.row($(this).attr('row-id')).data();
            var id = $(this).attr('data-id').toString().split('m_')[1];
            // var link = document.createElement('a');
            // link.href = "/invoices/manual/reconciliation/weekly_report/" + id + "/download";
            // $(link).attr('target', '_blank');
            // link.click();
            show_weeklyModal("/invoices/manual/reconciliation/weekly_report/", id, "manual");
        }
    });

    $('#app-invoices-table-archived').on('click', '.rotation_analysis_archivated', function () {
        var row= app_invoices_table_archived.row( $(this).attr('row-id') ).data();
        invoice_manual_multiple_match = false;
        if(row.multiple_match > 0){
            $('.confirm-see-multiple-archive-rotation').val(row.multiple_match);
            $('.cancel-see-multiple-archive-rotation').val(row.id);
            $('#rec_standar').val($(this).attr('data-id'));
            $('#selectMatchTypeArchiveRotAn').modal('show');
        }
        else {
            $('#send_rotation_analysis_standar').show();
            $('#send_rotation_analysis_standar_multiple').hide();
            $('#rec_standar').val($(this).attr('data-id'));
            $('#rec_manual').val($(this).attr('data-id').toString().split('m_')[1]);
            $('#rec_manual').val($(this).val().toString().split('m_')[1]);
            $('#agency_sel_rot_imported').select2({
                minimumResultsForSearch: 10,
                placeholder: 'Select one....',
                //'allowClear':  true,
            });
            var html = '';
            for(var ind in ws_secondary_agency_general)
                html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
            $('#agency_sel_rot_imported').html(html);
            $('#InvoiceRotationAnalysisStandarTemp').modal('show');
        }
    });
    $('#app-invoices-table-archived').on('click', '.rotation_analysis_archivated_man', function () {
        if ($(this).attr('data-multiple-match') > 0) {
            $('.confirm-see-multiple-archive-rotation-manual').val($(this).attr('data-multiple-match'));
            $('.cancel-see-multiple-archive-rotation-manual').val($(this).attr('data-id'));
            $('#selectMatchTypeArchiveRotAnManual').modal('show');
        } else {
            invoice_manual_multiple_match = false;
            if($(this).attr('data-id') !== '')
                 $('#rec_manual').val($(this).attr('data-id').toString().split('m_')[1]);
            else
                 $('#rec_manual').val($(this).val().toString().split('m_')[1]);
            $('#agency_sel_rot_manual').select2({
                minimumResultsForSearch: 10,
                placeholder: 'Select one....',
                //'allowClear':  true,
            });
            var html = '';
            for(var ind in ws_secondary_agency_general)
                html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
            $('#agency_sel_rot_manual').html(html);
            $('#InvoiceRotationAnalysisManualTemp').modal('show');
        }
    });

    //Activate invoice archived reconciled
    $('#app-invoices-table-archived').on('click', '.invoice_active_reconciled', function () {
        var id = $(this).attr('data-id');
        $('#act_invoice_id_hidden').val(id);
        $('#keep_saved_match').show();
        $('#clear_saved_match').show();
        $('#yes_activate_bt').hide();
        $('#activateReconciledInvoiceDiv').html('This invoice has been reconciled. Do you want to keep the saved match?');
        $('#activateReconciledInvoice').modal('show');
    });
    $('#keep_saved_match').on('click', function(){
        active_reconciled_invoice(1);
    });
    $('#clear_saved_match').on('click', function(){
        active_reconciled_invoice(0);
    });
    var active_reconciled_invoice = function(keep){
        show_overlay_loader($("#activateReconciledInvoice .modal-content"));
        var  id= $('#act_invoice_id_hidden').val();
        $.ajax({
            type: 'GET',
            url: '/invoices/activate_invoice/reconciled/' + id+'/' + keep,
            dataType: 'json',
            encode: true,
            success: function (data) {
                hide_loader();
                global_notification('success', 'Invoices activated.');
                window.location.href= data.redirect;
                hide_overlay_loader($("#activateReconciledInvoice .modal-content"));

            },
            error: function (xhr) {
                hide_overlay_loader($("#activateReconciledInvoice .modal-content"));
                ajax_error();
                debug(xhr.responseText);
            }
        });
    };

    //Activate invoice
    $('#app-invoices-table-archived').on('click', '.invoice_active', function () {
        var id = $(this).attr('data-id');
        $('#keep_saved_match').hide();
        $('#clear_saved_match').hide();
        $('#yes_activate_bt').show();
        $('#act_invoice_id_hidden').val(id);
        $('#activateReconciledInvoiceDiv').html('Are you sure to activate?');
        $('#activateReconciledInvoice').modal('show');
    });
    function activeNoMatchedInv(){
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/activate_invoice/' +  $('#act_invoice_id_hidden').val(),
            dataType: 'json',
            encode: true,
            success: function (data) {
                app_invoices_table_archived.draw();
                app_invoices_table.draw();
                hide_loader();
                global_notification('success', 'Invoices activated.');
                $('#activateReconciledInvoice').modal('hide');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    $('#test_bb').on('click', function () {
        var html='';
        gridInvExportInfo.api.forEachNode(function (node) {
            console.log(node);
            html+= node.data.vendor+ "\t" + node.data.invoice_number+ "\t";
            html+= node.data.date+ "\t"+ node.data.month+ "\t";
            var invoice_gross=node.data.invoice_gross.split('$');
            if(typeof invoice_gross[1] !=='undefined')
                html+= invoice_gross[1];
            else
                html+= invoice_gross[0];
            html+= "\t"+ node.data.order_number + "\t"+ node.data.line_number + "\t" + node.data.num_spots + "\t";

            var spot_rate=node.data.spot_rate.split('$');
            if(typeof spot_rate[1] !=='undefined')
                html+= spot_rate[1]+ "\t";
            else
                html+= spot_rate[0]+ "\t";

            var spot_rate=node.data.agency_comision.split('%');
            html+= spot_rate[0]+ "\t";

            var total_net=node.data.total_net.split('$');
            if(typeof total_net[1] !=='undefined')
                html+= total_net[1];
            else
                html+= total_net[0];

            html+="\r\n";

        });
        //  var url = 'data:application/txt,charset=utf-8,' + encodeURIComponent(html);
        // location.href=url;

        /*var file = new Blob([html], {type: 'data:application/VPA,charset=utf-8'});
        var url= URL.createObjectURL(file);
        location.href=url;*/
        saveFile("PayableFormatFile.VAP", "data:attachment/text", html);
        save_exported_date('Clients & Profits');

    });
    $('#vpa_exp_multiple').on('click', function () {
        var url= $(this).attr('data-url');
        var selectedItems = [];
        inv_selected_to_update_datatable = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked) {
                selectedItems.push($(this).val());
                inv_selected_to_update_datatable.push($(this).attr('data-row'));
            }
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else {
            $('#test_bb').show();
            $('#test_bb_manual').hide();
            // var id = $(this).attr('data-id');
            $('#InvoiceExportInfo').modal({backdrop: 'static', keyboard: false})
            $('#InvoiceExportInfo').modal('show');
            show_overlay_loader($('#InvoiceExportInfo .modal-content'));
            var params = {
                //  invoice_id: id,
                invoices: selectedItems,
                type: 'imported',
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (data_all) {
                    var lines = [];
                    console.log(data_all);
                    if(typeof data_all['imported'] !== 'undefined') {
                        var data = data_all['imported'];
                        for (var i in data['manual']) {
                            for (var x in data['manual'][i]['rows']) {
                                var xxx = data['manual'][i];
                                var li = data['manual'][i]['rows'][x];
                                var row = {
                                    vendor: xxx.vendor,
                                    invoice_number: xxx.invoice_number,
                                    date: moment(xxx.invoice_date).format('MM/DD/YY'),
                                    month: moment(xxx.month).format('M'),
                                    order_number: xxx.order_number,
                                    invoice_gross: '$' + xxx.total_invoice,
                                    line_number: li.line_number,
                                    num_spots: li.num_spots,
                                    spot_rate: '$' + li.spot_rate,
                                    total_net: '$' + li.total_net,
                                    agency_comision: xxx.comission + '%',
                                };
                                lines.push(row);
                            }
                        }
                        for (var i in data['imported']) {
                            for (var x in data['imported'][i]['rows']) {
                                var xxx = data['imported'][i];
                                var li = data['imported'][i]['rows'][x];
                                var row = {
                                    vendor: xxx.vendor,
                                    invoice_number: xxx.invoice_number,
                                    date: moment(xxx.invoice_date).format('MM/DD/YY'),
                                    month: moment(xxx.month).format('M'),
                                    order_number: xxx.order_number,
                                    invoice_gross: '$' + xxx.total_invoice,
                                    line_number: li.line_number,
                                    num_spots: li.num_spots,
                                    spot_rate: '$' + li.spot_rate,
                                    total_net: '$' + li.total_net,
                                    agency_comision: xxx.comission + '%',
                                };
                                lines.push(row);
                            }
                        }
                    }

                    if(typeof data_all['manual'] !== 'undefined') {
                        var data = data_all['manual'];
                        for(var ind in data) {
                            console.log(data[ind]);
                            for (var i in data[ind]['manual']) {
                                for (var x in data[ind]['manual'][i]['rows']) {
                                    var xxx = data[ind]['manual'][i];
                                    var li = data[ind]['manual'][i]['rows'][x];
                                    var row = {
                                        vendor: xxx.vendor,
                                        invoice_number: xxx.invoice_number,
                                        date: moment(xxx.invoice_date).format('MM/DD/YY'),
                                        month: moment(xxx.month).format('M'),
                                        order_number: xxx.order_number,
                                        invoice_gross: '$' + xxx.total_invoice,
                                        line_number: li.line_number,
                                        num_spots: li.num_spots,
                                        spot_rate: '$' + li.spot_rate,
                                        total_net: '$' + li.total_net,
                                        agency_comision: xxx.comission + '%',
                                    };
                                    lines.push(row);
                                }
                            }
                        }
                    }

                    $('#invoiceExportInfoGrid').html("");
                    gridInvExportInfo.rowData = lines;
                    var gridMatchDiv = document.querySelector('#invoiceExportInfoGrid');
                    var g4 = new agGrid.Grid(gridMatchDiv, gridInvExportInfo);

                    hide_overlay_loader($('#InvoiceExportInfo .modal-content'));

                },
                error: function (xhr) {
                    hide_overlay_loader($('#InvoiceExportInfoTBY .modal-content'));
                    debug(xhr.responseText);
                }
            });
        }
    });

    var columnOrderDetailsRotationSpotArchived = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "Order Line",
            field: 'line',
            width: 100,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Start Time",
            field: 'start_time',
            width: 150,
            cellStyle: {'text-align': "right"},
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':');
                    var arr2 = timeB.split(':');

                    if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        },  {
            headerName: "End Time",
            field: 'end_time',
            width: 150,
            cellStyle: {'text-align': "right"},
            comparator: function(valueA, valueB, nodeA, nodeB, isInverted) {
                if (valueA.includes('PM') && valueB.includes('AM')) {
                    return 1;
                } else if (valueA.includes('AM') && valueB.includes('PM')) {
                    return -1;
                } else {
                    var timeA = valueA.includes('AM') ? valueA.split('AM')[0] : valueA.split('PM')[0];
                    var timeB = valueB.includes('AM') ? valueB.split('AM')[0] : valueB.split('PM')[0];
                    var arr1 = timeA.split(':');
                    var arr2 = timeB.split(':');

                    if (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) === parseInt(arr2[1]))
                        return 0;
                    else if (parseInt(arr1[0]) > parseInt(arr2[0]) || (parseInt(arr1[0]) === parseInt(arr2[0]) && parseInt(arr1[1]) > parseInt(arr2[1])))
                        return 1;
                    else
                        return -1;
                }
            }
        }, {
            headerName: "Days",
            field: 'days',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Spot Matched",
            field: 'spot_matches',
            width: 150,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Line Id",
            field: 'line_id',
            width: 100,
            hide: true,
            cellStyle: {'text-align': "right" }
        },

    ];
    var orderLinesSpotRotGridArchived = {
        columnDefs: columnOrderDetailsRotationSpotArchived,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        }
    };
    $('#app-invoices-table-archived').on('click', '.spot_rotation_archivated', function () {
        var row= app_invoices_table_archived.row( $(this).attr('row-id') ).data();
        if(row.multiple_match > 0){
            $('.confirm-see-multiple-archive-spot-rotation').val(row.multiple_match);
            $('.cancel-see-multiple-archive-spot-rotation').val(row.match_id);
            $('#spot_rotation_create_archived_multiple').val(row.multiple_match);
            $('#rec_standar').val($(this).attr('data-id'));
            $('#selectMatchTypeArchiveSpotRota').modal('show');
        }else {
            show_loader();
            var rec_id = $(this).attr('data-id');
            var type = 'imported';
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var lines = [];
                    $('#rec_number_archived').val(rec_id);
                    $('#rec_type_archived').val('imported');

                    $('#InfoCam_archived').html('<b>Campaign: </b>  ' + '  ' + data.camp.name);
                    $('#InfoOrder_archived').html('<b>Order No: </b> ' + '  ' + data.order.reference_number);
                    $('#InfoInvoice_archived').html('<b>Inv. No: </b> ' + '  ' + data.invoice.invoice_num);
                    $('#InfoStation_archived').html('<b>Station: </b> ' + '  ' + data.station.name);
                    for (var ind in data.lines) {
                        var row = {
                            line_id: data.lines[ind]['id'],
                            line: data.lines[ind]['order_line'],
                            start_time: data.lines[ind]['start_time'],
                            end_time: data.lines[ind]['end_time'],
                            days: data.lines[ind]['days'],
                            spot_matches: data.lines[ind]['spot'],
                        }
                        lines.push(row);
                    }
                    $('#orderLinesSpotRotGridGridArchived').html('');
                    orderLinesSpotRotGridArchived.rowData = lines;
                    var gridDet = document.querySelector('#orderLinesSpotRotGridGridArchived');
                    var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGridArchived);

                    $('#agency_sel_spot_archivated').select2({
                        minimumResultsForSearch: 10,
                        placeholder: 'Select one....',
                        //'allowClear':  true,
                    });
                    var html = '';
                    for(var ind in ws_secondary_agency_general)
                        html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                    $('#agency_sel_spot_archivated').html(html);
                    hide_loader();
                    $('#spot_rotation_create_archived').show();
                    $('#spot_rotation_create_archived_multiple').hide();
                    $('#OrderLinesSpotArchived').modal('show');

                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });
    $('#app-invoices-table-archived').on('click', '.spot_rotation_archivated_man', function () {
        if ($(this).attr('data-multiple-match') > 0) {
            $('.confirm-see-multiple-archive-spot-rotation-manual').val($(this).attr('data-multiple-match'));
            $('.cancel-see-multiple-archive-spot-rotation-manual').val($(this).attr('data-id').toString().split('m_')[1]);
            $('#selectMatchTypeArchiveSpotRotaManual').modal('show');
        }
        else{
            show_loader()
            invoice_manual_multiple_match = false;
            var rec_id = $(this).attr('data-id').toString().split('m_')[1];
            $('#rec_number').val(rec_id);
            $('#spot_rotation_create').val(rec_id);
            var type = 'manual';
            $.ajax({
                type: 'GET',
                url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var lines = [];
                    $('#rec_number').val(rec_id);
                    $('#rec_type').val('manual');
                    $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' + data.camp);
                    $('#InfoOrder').html('<b>Order No: </b> ' + '  ' + data.order);
                    $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' + data.invoice_number);
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station);
                    for (var ind in data.lines) {
                        var row = {
                            line_id: data.lines[ind]['id'],
                            line: data.lines[ind]['order_line'],
                            start_time: data.lines[ind]['start_time'],
                            end_time: data.lines[ind]['end_time'],
                            days: data.lines[ind]['days'],
                            spot_matches: data.lines[ind]['spot'],
                        }
                        lines.push(row);
                    }
                    $('#spot_rotation_create').show();
                    $('#spot_rotation_create_multiple').hide();
                    $('#orderLinesSpotRotGridGrid').html('');
                    orderLinesSpotRotGrid.rowData = lines;
                    var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                    var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                    $('#agency_sel_spot_archivated').select2({
                        minimumResultsForSearch: 10,
                        placeholder: 'Select one....',
                        //'allowClear':  true,
                    });
                    var html = '';
                    for(var ind in ws_secondary_agency_general)
                        html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                    $('#agency_sel_spot').html(html);
                    hide_loader();
                    $('#OrderLinesSpot').modal('show');
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('.confirm-see-multiple-archive-spot-rotation-manual').on('click', function(){
        $('#spot_rotation_create_multiple').val($(this).val());
        $('#spot_rotation_create_multiple').show();
        $('#spot_rotation_create').hide();
        invoice_manual_multiple_match = true;
        var match_m_id= $(this).val();
        show_overlay_loader($('#selectMatchTypeArchiveSpotRotaManual .modal-content'));
        var url = '/invoices/reconciliation/getOrderLines/rec/multiple/manual/' + match_m_id;

        $.ajax({
            type: 'GET',
            url: url ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('data ^^^^^^^^^^^^^^^^^^^^^^^^^^');
                console.log(data);
                $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' +data.camp.name);
                $('#InfoOrder').html('<b>Order No: </b> ' + '  ' +data.order.reference_number);
                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ------' );
                if(invoice_manual_multiple_match === false)
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station.name);
                else
                    $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station);
                var lines=[];
                for(var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['id'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#orderLinesSpotRotGridGrid').html('');
                orderLinesSpotRotGrid.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                hide_loader();
                $('#spot_rotation_create').hide();
                $('#spot_rotation_create_multiple').val(match_m_id);
                $('#spot_rotation_create_multiple').show();
                $('#agency_sel_spot').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                    //'allowClear':  true,
                });
                var html = '';
                for(var ind in ws_secondary_agency_general)
                    html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                $('#agency_sel_spot').html(html);
                $('#OrderLinesSpot').modal('show');
                $('#selectMatchTypeArchiveSpotRotaManual').modal('hide');
                hide_overlay_loader($('#selectMatchTypeArchiveSpotRotaManual .modal-content'));
            },
            error: function (xhr) {
                hide_overlay_loader($('#selectMatchTypeArchiveSpotRotaManual .modal-content'));
                ajax_error();
                debug(xhr.responseText);
            }
        });

        $('#OrderLinesSpot').modal('show');
    });
    $('.cancel-see-multiple-archive-spot-rotation-manual').on('click', function(){
        show_loader()
        invoice_manual_multiple_match = false;
        var rec_id = $(this).val();
        $('#rec_number').val(rec_id);
        $('#spot_rotation_create').val(rec_id);
        var type = 'manual';
        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var lines = [];
                $('#rec_number').val(rec_id);
                $('#rec_type').val('manual');
                $('#InfoCam').html('<b>Campaign: </b>  ' + '  ' + data.camp.name);
                $('#InfoOrder').html('<b>Order No: </b> ' + '  ' + data.order.reference_number);
                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ' + data.invoice.invoice_num);
                $('#InfoStation').html('<b>Station: </b> ' + '  ' + data.station.name);
                for (var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['order_line'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#spot_rotation_create').show();
                $('#spot_rotation_create_multiple').hide();
                $('#orderLinesSpotRotGridGrid').html('');
                orderLinesSpotRotGrid.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGrid');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGrid);
                $('#agency_sel_spot').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                    //'allowClear':  true,
                });
                var html = '';
                for(var ind in ws_secondary_agency_general)
                    html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                $('#agency_sel_spot').html(html);
                hide_loader();
                $('#OrderLinesSpot').modal('show');
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

    $('.cancel-see-multiple-archive-spot-rotation').on('click', function (){
        show_loader();
        $('#spot_rotation_create_archived').show();
        $('#spot_rotation_create_archived_multiple').hide();
        var rec_id = $(this).val();
        var type = 'imported';
        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/getOrderLines/rec/' + rec_id + '/type/' + type,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var lines = [];
                $('#rec_number_archived').val(rec_id);
                $('#rec_type_archived').val('imported');

                $('#InfoCam_archived').html('<b>Campaign: </b>  ' + '  ' + data.camp);
                $('#InfoOrder_archived').html('<b>Order No: </b> ' + '  ' + data.order);
                $('#InfoInvoice_archived').html('<b>Inv. No: </b> ' + '  ' + data.invoice_number);
                $('#InfoStation_archived').html('<b>Station: </b> ' + '  ' + data.station);
                for (var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['order_line'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#orderLinesSpotRotGridGridArchived').html('');
                orderLinesSpotRotGridArchived.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGridArchived');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGridArchived);
                hide_loader();
                $('#spot_rotation_create_archived').show();
                $('#spot_rotation_create_archived_multiple').hide();
                $('#agency_sel_spot_archivated').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                    //'allowClear':  true,
                });
                var html = '';
                for(var ind in ws_secondary_agency_general)
                    html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                $('#agency_sel_spot_archivated').html(html);
                $('#OrderLinesSpotArchived').modal('show');

            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    });
    $('.confirm-see-multiple-archive-spot-rotation').on('click', function () {
        $('#selectMatchTypeArchiveSpotRota').modal('hide');
        show_loader();
        $('#spot_rotation_create_archived').hide();
        $('#spot_rotation_create_archived_multiple').show();
        var match_m_id= $(this).val();
        $.ajax({
            type: 'GET',
            url: '/invoices/reconciliation/getOrderLines/rec/multiple/' + match_m_id ,
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('data  ', data);
                $('#InfoCam_archived').html('<b>Campaign: </b>  ' + '  ' +data.camp);
                $('#InfoOrder_archived').html('<b>Order No: </b> ' + '  ' +data.order);
                $('#InfoInvoice').html('<b>Inv. No: </b> ' + '  ------' );
                $('#InfoStation_archived').html('<b>Station: </b> ' + '  ' + data.station);
                var lines=[];
                for(var ind in data.lines) {
                    var row = {
                        line_id: data.lines[ind]['id'],
                        line: data.lines[ind]['id'],
                        start_time: data.lines[ind]['start_time'],
                        end_time: data.lines[ind]['end_time'],
                        days: data.lines[ind]['days'],
                        spot_matches: data.lines[ind]['spot'],
                    }
                    lines.push(row);
                }
                $('#orderLinesSpotRotGridGridArchived').html('');
                orderLinesSpotRotGridArchived.rowData = lines;
                var gridDet = document.querySelector('#orderLinesSpotRotGridGridArchived');
                var g4 = new agGrid.Grid(gridDet, orderLinesSpotRotGridArchived);
                $('#agency_sel_spot_archivated').select2({
                    minimumResultsForSearch: 10,
                    placeholder: 'Select one....',
                    //'allowClear':  true,
                });
                var html = '';
                for(var ind in ws_secondary_agency_general)
                    html += '<option  value="'+ ws_secondary_agency_general[ind].id +'"> '+ ws_secondary_agency_general[ind].name +' </option>';
                $('#agency_sel_spot_archivated').html(html);
                hide_loader();
                $('#OrderLinesSpotArchived').modal('show');
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });
    $('#spot_rotation_create_archived_multiple').on('click', function(){
        var selectedNodes= orderLinesSpotRotGridArchived.api.getSelectedNodes();
        if(selectedNodes.length > 0) {
            show_loader();
            var params = {
                orientation: $("input:radio[name=orientation_type_spot_pattern_manual]:checked").attr('value'),
                match_id: $(this).val(),
                invoice_type: 'imported',
                lines_selected: [],
                multiple: true,
                agency_selected: $('#agency_sel_spot_archivated option:selected').val(),
            };
            for (var i in selectedNodes)
                params.lines_selected.push(selectedNodes[i].data.line);

            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/save/spotPattern/report',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var url = '/invoices/reconciliation/spotPatternNew/' + data.id + '/download';
                    window.open(url);
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_loader();
                }
            });
        }
        else
            global_notification('warning', 'Please select at least one line ...');

    });
    $('#spot_rotation_create_archived').on('click', function(){
        var selectedNodes = orderLinesSpotRotGridArchived.api.getSelectedNodes();
        if(selectedNodes.length > 0) {
            show_loader();
            var params = {
                orientation : $("input:radio[name=orientation_type_spot_pattern_archived]:checked").attr('value'),
                match_id :  $('#rec_number_archived').val(),
                invoice_type :  $('#rec_type_archived').val(),
                lines_selected :  [],
                multiple :  false,
                agency_selected: $('#agency_sel_spot_archivated option:selected').val(),
            };
            for(var i in selectedNodes)
                params.lines_selected.push(selectedNodes[i].data.line);

            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/save/spotPattern/report',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var url = '/invoices/reconciliation/spotPatternNew/' + data.id + '/download';
                    window.open(url);
                    hide_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_loader();
                }
            });



            // for(var i in selectedNodes) {
            //     if(lines_selected=='')
            //         lines_selected = selectedNodes[i].data.line ;
            //     else
            //         lines_selected =lines_selected +'_'+ selectedNodes[i].data.line;
            // }
            // var link = document.createElement('a');
            // link.href = '/invoices/reconciliation/spotRotationGraphTwo/orientation/'+orient +'/' + $('#rec_number_archived').val()+ '/' + lines_selected+ '/' + $('#rec_type_archived').val()+ '/download';
            // console.log(link.href);
            // $(link).attr('target', '_blank');
            // link.click();

        }
        else
            global_notification('warning', 'Please select a line first ...');


    });

    $('#search_imported_invoiced').on('click', function () {
        show_loader();
        var inv_number = JSON.stringify( $('#invoice-number-search').val());
        var month = $('#invoice-month-search').val();
        var fd = $('#invoice-flight-dates-search').val();
        var adv = JSON.stringify( $('#invoice-advertiser-search').val());
        var camp = JSON.stringify($('#invoice-campaign-search').val());
        var inv_type = JSON.stringify($('#invoice-type-search').val());
        var inv_status = JSON.stringify($('#invoice-status-search').val());

        $('#panel_click_invo_searc').addClass('panel-collapsed');
        $('#panel_body_search_invoice').css('display', 'none');

        var url = encodeURI("/invoices?inv_number=" + inv_number + "&adv="+ adv +"&month="+ month +"&type="+ inv_type +"&status="+ inv_status +"&camp="+ camp +"")
        $('#app-invoices-table').DataTable().ajax.url(url).load();
        hide_loader();

    });
    $('.send_form_archi').on('click', function () {
        show_loader();
        var inv_number =JSON.stringify( $('#invoice-number-search-archived-new').val());
        //var created_at = $('#invoice-created-at-search-archived').val();
        var month = $('#invoice-month-search-archived-new').val();
        var inv_type = JSON.stringify($('#invoice-type-search-archived-new').val());
       // var fd = $('#invoice-flight-dates-search-archived').val();
        var adv = JSON.stringify( $('#invoice-advertiser-search-archived-new').val());
       // var product =JSON.stringify($('#invoice-product-search-archived').val());
       // var payee = JSON.stringify($('#invoice-payees-search-archived').val());
       // var station = JSON.stringify( $('#invoice-stations-search-archived').val());
        var camp= JSON.stringify($('#invoice-campaign-search-archived-new').val());
        var filter = invoice_archived_filter_applied;

        $('#panel_click_invo_search_archived').addClass('panel-collapsed');
        $('#panel_body_search_invoice_archived').css('display', 'none');

        var url = encodeURI("/invoices/archivated?inv_number=" + inv_number + "&type="+ inv_type +"&view_type="+ filter +"&month="+ month +"&camp="+camp+"&adv="+adv+"")
        $('#app-invoices-table-archived').DataTable().ajax.url(url).load();
        hide_loader();

    });

    function init_search_buttons_both_tables(){
      // invoices search archve fiels init
        var input = $("#invoice-month-search-archived-new");

        if (input.data('datepicker')) {
            input.datepicker('remove');
        }

        input.datepicker({
            format: "mm/yyyy",
            startView: "months",
            minViewMode: "months",
            autoclose: true,
            clearBtn: true,
            orientation: "bottom"
        });
        var input = $("#invoice-flight-dates-search-archived");

        if (input.data('daterangepicker')) {
            input.data('daterangepicker').remove();
        }

        input.daterangepicker({
            "showWeekNumbers": true,
            "autoApply": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

        $('#invoice-created-at-search-archived').daterangepicker({
            "showWeekNumbers": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

        $('#invoice-number-search-archived-new').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        });

        $('#invoice-advertiser-search-archived-new').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        });

        $('#invoice-campaign-search-archived-new').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        });
        $('#invoice-stations-search-archived').select2({
            minimumResultsForSearch: Infinity,
            placeholder: "Select zero or more"
        });


        //seacrh invoices
        var input = $("#invoice-month-search");

        if (input.data('datepicker')) {
            input.datepicker('remove');
        }

        input.datepicker({
            format: "mm/yyyy",
            startView: "months",
            minViewMode: "months",
            autoclose: true,
            clearBtn: true,
            orientation: "bottom"
        });

        var input = $("#invoice-flight-dates-search");

        if (input.data('daterangepicker')) {
            input.data('daterangepicker').remove();
        }

        input.daterangepicker({
            "showWeekNumbers": true,
            "autoApply": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

        $('#invoice-created-at-search').daterangepicker({
            "showWeekNumbers": true,
            "linkedCalendars": false,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');

        $('#invoice-number-search').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        });
        $('#invoice-advertiser-search').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        }).on('select2:select', function (evt) {
            searchInvFields('advertisers', 'active');
        }).on('select2:unselect', function (evt) {
            searchInvFields('advertisers', 'active');
        });
        $('#invoice-campaign-search').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        }).on('select2:select', function (evt) {
            searchInvFields('campaigns','active');
        }).on('select2:unselect', function (evt) {
            searchInvFields('campaigns','active');
        });
        $('#invoice-type-search').select2({
            minimumResultsForSearch: Infinity,
            placeholder: "Select zero or more"
        });
        $('#invoice-status-search').select2({
            minimumResultsForSearch: Infinity,
            placeholder: "Select zero or more"
        });
        $('#invoice-stations-search').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        });

        $('#invoice-advertiser-search-archived-new').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        }).on('select2:select', function (evt) {
            searchInvFields('advertisers', 'archived');
        }).on('select2:unselect', function (evt) {
            searchInvFields('advertisers', 'archived');
        });
        $('#invoice-campaign-search-archived-new').select2({
            minimumResultsForSearch: 5,
            placeholder: "Select zero or more"
        }).on('select2:select', function (evt) {
            searchInvFields('campaigns','archived');
        }).on('select2:unselect', function (evt) {
            searchInvFields('campaigns','archived');
        });
        $('#invoice-type-search-archived-new').select2({
            minimumResultsForSearch: Infinity,
            placeholder: "Select zero or more"
        });

    }
    function searchInvFields(search_type, grid_search){
        show_loader();
        if(grid_search === 'active') {
            var params = {
                advertisers: $('#invoice-advertiser-search').val(),
                campaign_selected: $('#invoice-campaign-search').val(),
                search_type: search_type,
                grid_search: grid_search,
            };
            var campaigns_selected = $('#invoice-campaign-search').val();
            var invoice_selected = $('#invoice-number-search').val();
        }
        else{
            var params = {
                advertisers: $('#invoice-advertiser-search-archived-new').val(),
                campaign_selected: $('#invoice-campaign-search-archived-new').val(),
                search_type: search_type,
                grid_search: grid_search,
            };
            var campaigns_selected = $('#invoice-campaign-search-archived-new').val();
            var invoice_selected = $('#invoice-number-search-archived-new').val();
        }

        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/invoices/general/search/search_values',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                console.log('***************************************', data  )
                if(search_type === 'advertisers') {
                    if(grid_search === 'active') {
                        $('#invoice-campaign-search').html('');
                        var html = '';
                        for (var i in data.campaigns) {
                            var selected = campaigns_selected.indexOf((data.campaigns[i].id).toString()) !== -1 ? 'selected' : '';
                            html += '<option value="' + data.campaigns[i].id + '" ' + selected + '>' + data.campaigns[i].name + '</option>';
                        }
                        $('#invoice-campaign-search').html(html);
                    }else{
                        $('#invoice-campaign-search-archived-new').html('');
                        var html = '';
                        for (var i in data.campaigns) {
                            var selected = campaigns_selected.indexOf((data.campaigns[i].id).toString()) !== -1 ? 'selected' : '';
                            html += '<option value="' + data.campaigns[i].id + '" ' + selected + '>' + data.campaigns[i].name + '</option>';
                        }
                        $('#invoice-campaign-search-archived-new').html(html);
                    }
                }
                if(grid_search === 'active') {
                    var html = '';
                    $('#invoice-number-search').html('');
                    for (var i in data.invoices) {
                        var selected = invoice_selected.indexOf((data.invoices[i].id).toString()) !== -1 ? 'selected' : '';
                        html += '<option value="' + data.invoices[i].invoice_number + '" ' + selected + '>' + data.invoices[i].invoice_number + '</option>';
                    }
                    for (var i in data.manual_invoices) {
                        var selected = invoice_selected.indexOf(data.manual_invoices[i].invoice_num) !== -1 ? 'selected' : '';
                        html += '<option value="' + data.manual_invoices[i].invoice_num + '" ' + selected + '>' + data.manual_invoices[i].invoice_num + '</option>';
                    }
                    $('#invoice-number-search').html(html);
                }
                else{
                    var html = '';
                    $('#invoice-number-search-archived-new').html('');
                    for (var i in data.invoices) {
                        var selected = invoice_selected.indexOf((data.invoices[i].id).toString()) !== -1 ? 'selected' : '';
                        html += '<option value="' + data.invoices[i].invoice_number + '" ' + selected + '>' + data.invoices[i].invoice_number + '</option>';
                    }
                    for (var i in data.manual_invoices) {
                        var selected = invoice_selected.indexOf(data.manual_invoices[i].invoice_num) !== -1 ? 'selected' : '';
                        html += '<option value="' + data.manual_invoices[i].invoice_num + '" ' + selected + '>' + data.manual_invoices[i].invoice_num + '</option>';
                    }
                    $('#invoice-number-search-archived-new').html(html);
                }
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }

    $('.setting_match_view').on('click', function() {
       if( $('#view_settings_toltip').attr('media-type') === 'tv')
           var media = 'Television/Cable';
       else
           var media = 'Radio';
        swal({
                title: "Make as my default view!",
                text: 'Are you sure you want to make this model your default column view for ' + media + '?',
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_overlay_loader($('#searchOrdenToMach'));
                    var visible = $("#orderlines").css('display');
                    var grid = (visible !== 'none') ? gridOlinesOptions : gridOSinglelinesOptions;
                    var params = {
                        type: $('#view_settings_toltip').attr('media-type'),
                        columns: [],
                        positions: grid.columnApi.getColumnState(),
                    };
                    $('#hide_columns a').each(function () {
                        if (!$(this).hasClass('hidden-column')) {
                            if ($('#view_settings_toltip').attr('media-type') === 'radio' && ($(this).attr('data-col') !== 'network' && $(this).attr('data-col') !== 'zone'))
                                params.columns.push($(this).attr('data-col'));
                            if ($('#view_settings_toltip').attr('media-type') === 'tv')
                                params.columns.push($(this).attr('data-col'));
                        }
                    });

                    $.ajax({
                        type: 'POST',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        url: '/invoices/save/columns/settings/match_modal',
                        data: JSON.stringify(params),
                        contentType: "application/json",
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            user_columns_settings[$('#view_settings_toltip').attr('media-type')] = data.user_columns_settings;
                            user_columns_settings_new[$('#view_settings_toltip').attr('media-type')] = data.user_columns_settings_new;
                            hide_overlay_loader($('#searchOrdenToMach'))
                            global_notification("success", "Settings saved...");
                        },
                        error: function (xhr) {
                            hide_overlay_loader($('#searchOrdenToMach'))
                            debug(xhr.responseText);
                        }
                    });
                }
            });
    });
    $('#invoice-activate').on('click', function(){
        var sel = gridInvOrdOptions.api.getSelectedNodes();
        if(sel.length > 0) {
            swal({
                    title: "Warning!",
                    text: "Are you sure to activate? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                        var id = sel[0].data.inv_id;
                        show_overlay_loader($('#invoiceEntry .modal-content'));
                        $.ajax({
                            type: 'GET',
                            url: '/invoices/manual/activate/function/' + id ,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                hide_overlay_loader($('#invoiceEntry .modal-content'));
                                global_notification('success', 'Invoice archived...');
                                $('#seacrh-order-invoice-manual').click();
                            },
                            error: function (xhr) {
                                hide_overlay_loader($('#invoiceEntry .modal-content'));
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });
                    }

                });
        }
        else{
            swal({
                    title: "Oops!",
                    text: "Select the invoice first ...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
    });

    $('#show_only_archived').on('click', function(){
        show_view_data_table(1);
    });
    $('#show_only_completed').on('click', function(){
        show_view_data_table(2);
    });
    $('#show_archived_completed').on('click', function(){
        show_view_data_table(3);
    });

    var invoice_archived_filter_applied = 1;
    function show_view_data_table(type) {
        if (type == 1) {
            $('.invoices_filters').html('&nbsp;Archived')
            $('.invoices_filters').attr('data-value', 1)
            $('#move_completed').html('<i class="fa fa-suitcase fa-fw" ></i> Move to Completed')
            $('#move_completed').show();
        }
        if (type == 2) {
            $('.invoices_filters').html('&nbsp;Completed')
            $('.invoices_filters').attr('data-value', 2)
            $('#move_completed').html('<i class="fa fa-suitcase fa-fw" ></i> Move to Archived')
            $('#move_completed').show();
        }
        if (type == 3) {
            $('.invoices_filters').html('&nbsp;Archived & Completed')
            $('.invoices_filters').attr('data-value', 3)
            $('#move_completed').hide();
        }
        invoice_archived_filter_applied = type;
        var url = "/invoices/archivated?view_type=" + type;
        $('#app-invoices-table-archived').DataTable().ajax.url(url).load();

    }

    $('#move_completed').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length == 0) {
            $('#generalWarningModalDiv').html('Please select at least one Invoice.');
            $('#generalWarningModal').modal('show');
        }
        else{
            show_loader();
            var params = {
                invoices: selectedItems,
                move_to: $('.invoices_filters').attr('data-value'),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    var type =  $('.invoices_filters').attr('data-value');
                    var url = "/invoices/archivated?view_type=" + type;
                    $('#app-invoices-table-archived').DataTable().ajax.url(url).load();
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });

    function save_exported_date(type){
        var url= '/invoices/save/exported/date';
        var selectedItems = [];
        $('.invoices_arch_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            invoices: selectedItems,
            accounting: type,
            workbook : invoices_exported_workbook_general,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                var time = type + ' ' + moment().format('MMM D, YYYY');
                for(var i in inv_selected_to_update_datatable)
                    app_invoices_table_archived.cell(inv_selected_to_update_datatable[i], 13).data(time);
                },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }

    $('.close_accounting_modals').on('click', function(){
        $('#InvoiceExportInfoAdvantage').modal('hide');
        $('#InvoiceExportInfo').modal('hide');
        $('#InvoiceExportInfoQuick').modal('hide');
        $('#InvoiceExportInfoWork').modal('hide');
        $('#InvoiceExportInfoWorkAPI').modal('hide');
        $('#InvoiceExportInfoWorkbook').modal('hide');
        $('#InvoiceExportInfoQuickRegular').modal('hide');
        $('#InvoiceExportInfoQuickAPIRegular').modal('hide');

        // var url = "/invoices/archivated?view_type=" + $('.invoices_filters').attr('data-value');
        // $('#app-invoices-table-archived').DataTable().ajax.url(url).load();
    });

    $('#app-invoices-table-archived').on('click', '.invoice_accounting_info', function () {
        show_loader()
        var id = $(this).attr('data-id');
        $.ajax({
            type: 'GET',
            url: '/invoices/get/QuickBookOnline/sent_together/' + id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#InvoiceSentQuickBookOnlineInfoDiv').html(data.html);
                $('#InvoiceSentQuickBookOnlineInfoTitle').html(data.title);
                $('#InvoiceSentQuickBookOnlineInfo').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });


    });


    //Manual Invoices File Attachments
    var manualInvFileColDefs = [
        {
            headerName: '',
            headerTooltip: '',
            field: 'row_select',
            pinned: 'left',
            width: 50,
            editable: false,
            cellRenderer: 'agGroupCellRenderer',
            checkboxSelection: true,
            cellRendererParams: {
                //checkbox: true
            },
            suppressFilter: true,
            suppressMovable: true,
            suppressResize: true,
            suppressNavigable: true,
            suppressSorting: true,
            required: true,
            headerClass: 'fixedHeaderCellClass'
        },
        {
            headerName: "id",
            field: 'id',
            width: 150,
            hide: true,
        },
        {
            headerName: "File Name",
            field: 'file_name',
            width: 400,
            hide: false,
        },
        {
            headerName: "File Type",
            field: 'file_type',
            width: 100,
            hide: false,
        },

        {
            headerName: "Inv id",
            field: 'inv_id',
            width: 150,
            hide: true,
        },
        {
            headerName: "Path",
            field: 'file_path',
            width: 80,
            hide: true,
        },
        {
            headerName: "Attached at",
            field: 'created_at',
            width: 200,
        },
        {
            headerName: "Attached by",
            field: 'user_name',
            width: 200,
        },
    ];
    var gridManualInvFile = {
        columnDefs: manualInvFileColDefs,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,
        defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },

    };

    function get_manual_invoice_attachments(line){
        show_overlay_loader($('#invoiceEntry .modal-content'));
        $('#inv_attachmen_list').html('Invoice #'+ line['inv_num'] +' Attachments');
        $('#inv_attachmen_list').val(line['inv_id']);
        $.ajax({
            type: 'GET',
            url: '/invoices/manual/get_attachments/' + line['inv_id'],
            dataType: 'json',
            encode: true,
            success: function (data) {
                $('#manualInvFilesGrid').html("");
                gridManualInvFile.rowData = [];
                gridManualInvFile.rowData = data;
                var gridMatchDiv = document.querySelector('#manualInvFilesGrid');
                var g4 = new agGrid.Grid(gridMatchDiv, gridManualInvFile);
                $('#InvoiceAttachments').modal({backdrop: 'static', keyboard: false})
                $('#InvoiceAttachments').modal('show');

                hide_loader();
                hide_overlay_loader($('#invoiceEntry .modal-content'));
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                $('#loading_loadingm').css("display", "none");
                hide_overlay_loader($('#invoiceEntry .modal-content'));
            }
        });
    }
    $('#import_inv_file').on('click', function (){
        var file = document.getElementById("csv_file_input").files[0];
        if (file) {
            show_overlay_loader($('#InvoiceAttachments .modal-content'));
            var exist = false;
            gridManualInvFile.api.forEachNode(function (node) {
               if(node.data.file_name === file.name)
                   exist = true;
            });

            if(exist === true) {
                swal({
                        title: "Warning!",
                        text: "This invoice already has an attachment with this name, do you wish to continue?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                      if(isConfirm === true)
                            attach_file(file);
                      else
                          hide_overlay_loader($('#InvoiceAttachments .modal-content'));
                    });
            }else
                attach_file(file);
        }else{
            swal({
                    title: "Warning!",
                    text: "Please provide the file...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }

    });
    function attach_file(file){
        show_overlay_loader($('#InvoiceAttachments .modal-content'));
        var formData = new FormData();
        formData.append('file', file);
        formData.append('inv_id', $('#inv_attachmen_list').val());
        $.ajax({
            url: '/invoices/manual/save/files',
            dataType: 'json',
            data : formData,
            type : 'POST',
            processData: false,  // tell jQuery not to process the data
            contentType: false,  // tell jQuery not to set contentType
            enctype: 'multipart/form-data',
            async: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                var index = 1;
                gridManualInvFile.api.forEachNode(function (node) {
                    index++;
                });
                var row = [];
                row['id'] = response.data.id;
                row['inv_id'] = response.data.manual_invoice_id;
                row['file_name'] = response.data.original_name;
                row['file_type'] = response.data.file_type;
                row['created_at'] = response.data.created_at_format;
                row['user_name'] = response.data.user_name;
                row['file_path'] = response.data.path;
                var rr = gridManualInvFile.api.updateRowData({add: [row]});
                gridManualInvFile.api.ensureIndexVisible(index ++ );
                global_notification("success", "File " + response.data.original_name + " attached!");
                hide_overlay_loader($('#InvoiceAttachments .modal-content'));

            },
            error: function (xhr) {
                hide_overlay_loader($('#InvoiceAttachments .modal-content'));
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }
    $('#download_inv_file').on('click', function(e){
        var selected_nodes = gridManualInvFile.api.getSelectedNodes();
        if(selected_nodes.length > 0) {
            show_overlay_loader($('#InvoiceAttachments .modal-content'));
            for (var i in selected_nodes) {
                var path = selected_nodes[i].data['file_path'];
                var a = $("<a style='display: none;'/>");
                var url = path;
                a.attr("href", url);
                a.attr("download", selected_nodes[i].data['file_name']);
                $("body").append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
            }
            hide_overlay_loader($('#InvoiceAttachments .modal-content'));
        }else{
            swal({
                    title: "Warning!",
                    text: "Select the file first ...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
    });

    $('#select_all_inv_file').on('click', function (){
        gridManualInvFile.api.selectAllFiltered();
    });
    $('#deselect_all_inv_file').on('click', function (){
        gridManualInvFile.api.deselectAllFiltered();
    });
    $('#delete_inv_file').on('click', function (){
        var selected_nodes = gridManualInvFile.api.getSelectedNodes();
        if(selected_nodes.length > 0) {
            var params = {
                lines: []
            };
            for (var i in selected_nodes)
                params.lines.push(selected_nodes[i].data.id);
            show_overlay_loader($('#InvoiceAttachments .modal-content'));
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                url: '/invoices/manual/delete/files',
                data: JSON.stringify(params),
                contentType: "application/json",
                dataType: 'json',
                encode: true,
                success: function (response) {
                    gridManualInvFile.api.removeItems(selected_nodes);
                    gridManualInvFile.api.refreshView();
                    global_notification("success", "Removed " + selected_nodes.length + " rows!");
                    hide_overlay_loader($('#InvoiceAttachments .modal-content'));
                },
                error: function (xhr) {
                    hide_overlay_loader($('#InvoiceAttachments .modal-content'));
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }else {
            swal({
                    title: "Warning!",
                    text: "Select the file first ...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
    });
    $('#app-invoices-table').on('click', '.invoice_manual_attachments_dt', function () {
        show_loader();
        var row = [];
        row['inv_id'] = $(this).attr('data-id');
        row['inv_num'] = $(this).attr('data-number');
        $('#update_attachments_invoice_status').attr('data-invoice-update', false);
        get_manual_invoice_attachments(row);
    });
    $('#app-invoices-table-archived').on('click', '.invoice_manual_attachments_dt_ar', function () {
        show_loader();
        var row = [];
        row['inv_id'] = $(this).attr('data-id');
        row['inv_num'] = $(this).attr('data-number');
        $('#update_attachments_invoice_status').attr('data-invoice-update', false);
        get_manual_invoice_attachments(row);
    });

   $('#update_attachments_invoice_status').on('click', function(){
       if($(this).attr('data-invoice-update') === true || $(this).attr('data-invoice-update') === 'true') {
           show_overlay_loader($('#InvoiceAttachments .modal-content'));
           var inv_id = $(this).attr('data-invoice-id');
           var node_t = [];
           gridInvOrdOptions.api.forEachNode(function (node) {
             if(parseInt(node.data.inv_id) === parseInt(inv_id))
                 node_t = node;
           });
           console.log('node_t ', node_t);
           node_t['data']['attachments'] = gridManualInvFile.api.getDisplayedRowCount() > 0 ? 'Yes' : 'No';
           console.log('node_t ', node_t);
           var rr = gridInvOrdOptions.api.refreshCells({rowNodes: [node_t], columns: ['attachments'], force: true});
           hide_overlay_loader($('#InvoiceAttachments .modal-content'));
       }
       $('#InvoiceAttachments').modal('hide');
   });

   //Hide Show Invoice Data Table
    $('.invoices_table_hide_show a').bind('click', function (e) {
        console.log("click");
        var attr = $(this).attr('data-hidden');
        if ($(this).hasClass('hidden-column') ) {
            app_invoices_table.columns(attr).visible(true);
            $(this).removeClass('hidden-column');
            $(this).css('background-color', 'white');
        } else {
            app_invoices_table.columns(attr).visible(false);
            $(this).addClass('hidden-column');
            $(this).css('background-color', '#CCCCCC');

        }

        e.stopPropagation();
    });
    //Hide Show Invoice Data Table Archived
    $('.invoices_table_hide_show_archived a').bind('click', function (e) {
        console.log("click");
        var attr = $(this).attr('data-hidden');
        if ($(this).hasClass('hidden-column') ) {
            app_invoices_table_archived.columns(attr).visible(true);
            $(this).removeClass('hidden-column');
            $(this).css('background-color', 'white');
        } else {
            app_invoices_table_archived.columns(attr).visible(false);
            $(this).addClass('hidden-column');
            $(this).css('background-color', '#CCCCCC');

        }
        e.stopPropagation();
    });

    $('#search_manual_inv_by_order').on('click', function(){
        $('#date_range_to_search').daterangepicker({
          //  "showWeekNumbers": true,
            // "autoApply ":true,
            // "linkedCalendars": false,
            // "autoUpdateInput": true,
           //  "startDate": ,
             //"minDate": start,
            // "endDate": end,
            // "maxDate": end,
            "locale": {
                "format": "MM/DD/YYYY",
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "#",
                "daysOfWeek": [
                    "U",
                    "M",
                    "T",
                    "W",
                    "R",
                    "F",
                    "S"
                ],
                "firstDay": 1
            }
        }).val('');
        $('#orders_to_search_manual_invoices').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: '<div style="height: 38px;"><input type="button" class="btn btn-default m-r-5 btn-sm select_all_orders_m" value="Select All" id="">&nbsp;'+ "<input type='button' class='btn btn-default m-r-5 btn-sm deselect_all_orders_m' value='Deselect All' id=''>" +'</div>',
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        $('#orders_to_search_manual_invoices').html('');
        $("#orders_to_search_manual_invoices").multiSelect('refresh');
        $('#searchManualInvByOrderNumber').modal({backdrop: 'static', keyboard: false})
        $('#searchManualInvByOrderNumber').modal('show');
    });

    $('#populate_orders_by_date_rante').on('click', function(){
        if($('#date_range_to_search').val() !== '') {
            show_overlay_loader($('#searchManualInvByOrderNumber'));
            var start = moment($('#date_range_to_search').val().split(' - ')[0]).format('YYYY-MM-DD');
            var end = moment($('#date_range_to_search').val().split(' - ')[1]).format('YYYY-MM-DD');
            $.ajax({
                type: 'GET',
                url: '/invoices/search/orders/by/date_range/' + start + '/' + end,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html = '';
                    for (var camp_id in data)
                        for (var vend_id in data[camp_id])
                            html += '<option value="' + data[camp_id][vend_id][0].order_id + '"> ' + data[camp_id][vend_id][0].reference_number + ' </option>'
                    $('#orders_to_search_manual_invoices').html(html);
                    $("#orders_to_search_manual_invoices").multiSelect('refresh');
                    $('#search_by_orders_selected').prop('disabled', false);

                    $(".select_all_orders_m").on("click", function(){
                        $('#orders_to_search_manual_invoices').multiSelect("select_all");
                    });
                    $(".deselect_all_orders_m").on("click", function(){
                        $('#orders_to_search_manual_invoices').multiSelect("deselect_all");
                    });

                    hide_overlay_loader($('#searchManualInvByOrderNumber'));
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_overlay_loader($('#searchManualInvByOrderNumber'));
                }
            });
        }else{
            swal({
                    title: 'Warning',
                    text: 'Please select a date Range First.',
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                    }
                });
        }
    });

    var global_way_to_search_manual_invoices = null;
    var global_way_to_search_manual_invoices_orders = [];

    $('#search_by_orders_selected').on('click', function(){
        if($("#orders_to_search_manual_invoices").val().length > 0) {
            $('#orders-invoices').html("");
            gridInvOrdOptions.rowData = [];
            var gridMatchDiv = document.querySelector('#orders-invoices');
            var g4 = new agGrid.Grid(gridMatchDiv, gridInvOrdOptions);
            global_way_to_search_manual_invoices = 2;
            global_way_to_search_manual_invoices_orders = $("#orders_to_search_manual_invoices").val();
            $('#searchManualInvByOrderNumber').modal('hide');
            displayOrdersInvoices(global_way_to_search_manual_invoices);
        }
         else{
            swal({
                    title: 'Warning',
                    text: 'Please select at least on Order Number.',
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm){
                    }
                });
        }

       // $('#searchManualInvByOrderNumber').modal('hide');
    });

    $('#multiple-edit-avails').on('click', function (){
        var selectedNodes = gridUnmatchOptions.api.getSelectedNodes();
        if(selectedNodes.length === 0)
            swal({
                    title: 'Warning',
                    text: 'Please select at least one Unmatched Spot...',
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        else
             $('#multipleEditInvSpots').modal('show');
    });
    $('#update_inv_approved_rates').on('click', function (){
        var new_approved_rates = $('#new_approved_rates').val();
        var selectedNodes = gridUnmatchOptions.api.getSelectedNodes();
        swal({
                title: 'Warning',
                text: 'Would you like to edit the selected unmatched Invoice Spots?',
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, edit",
                cancelButtonText: "Cancel",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if(isConfirm){
                    $.each(selectedNodes, function (index, value) {
                        value.data.apvd_rate = new_approved_rates;
                        value.setData(value.data);
                        var node = value;
                        editing_row_imported_invo = true;
                        array_imp_all_cell_edited[node.data.id] = [];
                        array_imp_all_cell_edited[node.data.id] = node.data;

                        var node_id = parseInt(node.data.id);
                        for (var ind in match_result.no_match){
                            if( match_result.no_match[ind] !== null && typeof match_result.no_match[ind].id !== 'undefined') {
                                if (parseInt(match_result.no_match[ind].id) === parseInt(node.data.id)) {
                                    if(typeof match_result.no_match[ind]['approved_rate'] !== 'undefined')
                                        match_result.no_match[ind]['approved_rate'] = node.data.apvd_rate;
                                    if(typeof match_result.no_match[ind]['apvd_rate'] !== 'undefined')
                                        match_result.no_match[ind]['apvd_rate'] = node.data.apvd_rate;
                                }
                            }
                        }
                    });
                    $('#multipleEditInvSpots').modal('hide');
                }
            });


    });

    //Show invoices under Acrhived Campaigns
    var gridInvUnderArchivedCampColumnDef = [

        {
            headerName: "Invoice Number",
            field: 'inv_number',
            width: 160,
            cellStyle: {'text-align': "left"},
            cssClasses: ['redFont', 'bold']
        },
        {
            headerName: "Inv. Month",
            field: 'inv_month',
            width: 120,
            cellStyle: {'text-align': "right"}
        },
        {
            headerName: "Inv. Status",
            field: 'inv_status',
            width: 180,
            cellStyle: {'text-align': "right" }
        },
        {
            headerName: "Inv. Type",
            field: 'inv_type',
            width: 120,
            cellStyle: {'text-align': "right" }
        },
        {
            headerName: "Advertiser",
            field: 'adv_name',
            width: 220,
            cellStyle: {'text-align': "right" }
        },
        {
            headerName: "Campaign",
            field: 'camp_name',
            width: 220,
            cellStyle: {'text-align': "right" }
        },

    ];
    var gridInvUnderArchivedCamp = {
        columnDefs: gridInvUnderArchivedCampColumnDef,
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        //   groupSelectsChildren: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        }
    };
    $('#archived_camp_invoices').on('click', function (){
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/invoices/search/under/archived_campaigns',
            dataType: 'json',
            encode: true,
            success: function (data) {
                gridInvUnderArchivedCamp.rowData = [];
                gridInvUnderArchivedCamp.rowData = data;
                $('#invoiceUnderArchivedCampaignGrid').html("");
                var gridInvUnderArchivedCampD = document.querySelector('#invoiceUnderArchivedCampaignGrid');
                var g5 = new agGrid.Grid(gridInvUnderArchivedCampD, gridInvUnderArchivedCamp);

                $('#ArchivedCampaignInvModal').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    });
}

$("#save_rules").on("click", function (e) {

  var id =  $('#id_invoice_hidden').val();

 var rules=[];

    $("input[name='rules[]']:checked").each(function(){
        rules.push($(this).val());
    });

$.ajax({
      type: 'GET',
      url: 'invoices/updaterules/' + id + '/' + rules,
      dataType: 'json',
      encode: true,
      success: function (data) {

              global_notification('success', "Match Rules edited...");
              list.modal('hide');

      },
      error: function (xhr) {
          ajax_error();
      }
  });

  hide_loader();
});
